import { F as ac } from "./configurationTypes-Du2oglVt.js";
import { A as LD, C as MD, T as ND } from "./configurationTypes-Du2oglVt.js";
import { ConversionDataType as UD } from "@repo/core";
var tD = /* @__PURE__ */ ((M) => (M.Manual = "Manual", M.OnStart = "OnStart", M.OnQuit = "OnQuit", M.OnEnd = "OnEnd", M))(tD || {});
function yE(M) {
  return Object.assign(
    {},
    ...M.map((j) => {
      if (j.key)
        return {
          [j.key]: dT(j)
        };
    })
  );
}
function dT(M) {
  if (M.type === ac.Asset)
    return M.asset;
  if (M.type === ac.DateRange) {
    const j = M.value?.split(",");
    if (!j || j.length !== 2 || !j[0] || !j[1]) return;
    try {
      return {
        start: new Date(j[0]),
        end: new Date(j[1])
      };
    } catch {
      return;
    }
  }
  if (M.type === ac.ConversionConfiguration)
    return M.conversionConfiguration;
  if (M.type !== ac.List && M.type !== ac.Object) {
    if (M.value === void 0)
      return;
    if (M.type === ac.Number)
      try {
        const j = Number.parseFloat(M.value);
        return Number.isNaN(j) ? void 0 : j;
      } catch {
        return;
      }
    else if (M.type === ac.Boolean)
      return M.value === "true";
    return M.value;
  }
  if (M.listValues)
    return M.listValues.map(dT);
  if (M.objectValues)
    return { ...yE(M.objectValues), schema: M.schema ?? void 0 };
}
function RD(M) {
  return yE(M);
}
function TD(M) {
  return yE(M.fields);
}
function Xm(M, j) {
  const D = {
    ...M,
    items: void 0,
    fields: void 0
  };
  return M.items !== void 0 && M.items !== null && (D.items = Xm(j[M.items], j)), M.fields !== void 0 && M.fields !== null && (D.fields = M.fields.map((Be) => Xm(j[Be], j))), D;
}
function nD(M) {
  const j = {
    ...M,
    fields: [],
    customSchemas: M.customSchemas?.map((Be) => ({
      ...Be,
      fields: Be.fields?.map((ht) => Xm(M.fields[ht], M.fields))
    }))
  }, D = [];
  if (M.fields.forEach((Be) => {
    Be.root && D.push(Xm(Be, M.fields));
  }), M.fields.length > 0 && D.length === 0)
    throw new Error(
      "Failed to map ThemeVersionConfiguration GraphQL type to Resource type. Please ensure you've selected the `root` field on ThemeConfigurationSchemaField"
    );
  return j.fields = D, j;
}
function wD(M) {
  return {
    ...M,
    configurationSchema: nD(M.configurationSchema)
  };
}
function mE(M, j) {
  const D = {
    ...M,
    listValues: void 0,
    objectValues: void 0
  };
  return M.listValues !== void 0 && M.listValues !== null && (D.listValues = M.listValues.map((Be) => mE(j[Be], j))), M.objectValues !== void 0 && M.objectValues !== null && (D.objectValues = M.objectValues.map((Be) => mE(j[Be], j))), D;
}
function xD(M) {
  const j = {
    ...M,
    name: M.name ?? "",
    fields: []
  }, D = [];
  if (M.fields.forEach((Be) => {
    Be.root && D.push(mE(Be, M.fields));
  }), M.fields.length > 0 && D.length === 0)
    throw new Error(
      "Failed to map ThemeInstallConfiguration GraphQL type to Resource type. Please ensure you've selected the `root` field on ThemeInstallConfigurationField"
    );
  return j.fields = D, j;
}
var Qm = { exports: {} }, Kp = {}, Wm = { exports: {} }, mt = {};
var ZR;
function rD() {
  if (ZR) return mt;
  ZR = 1;
  var M = /* @__PURE__ */ Symbol.for("react.element"), j = /* @__PURE__ */ Symbol.for("react.portal"), D = /* @__PURE__ */ Symbol.for("react.fragment"), Be = /* @__PURE__ */ Symbol.for("react.strict_mode"), ht = /* @__PURE__ */ Symbol.for("react.profiler"), _t = /* @__PURE__ */ Symbol.for("react.provider"), S = /* @__PURE__ */ Symbol.for("react.context"), Pt = /* @__PURE__ */ Symbol.for("react.forward_ref"), de = /* @__PURE__ */ Symbol.for("react.suspense"), ve = /* @__PURE__ */ Symbol.for("react.memo"), ut = /* @__PURE__ */ Symbol.for("react.lazy"), ee = Symbol.iterator;
  function Ce(_) {
    return _ === null || typeof _ != "object" ? null : (_ = ee && _[ee] || _["@@iterator"], typeof _ == "function" ? _ : null);
  }
  var ue = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, Ye = Object.assign, yt = {};
  function dt(_, B, je) {
    this.props = _, this.context = B, this.refs = yt, this.updater = je || ue;
  }
  dt.prototype.isReactComponent = {}, dt.prototype.setState = function(_, B) {
    if (typeof _ != "object" && typeof _ != "function" && _ != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, _, B, "setState");
  }, dt.prototype.forceUpdate = function(_) {
    this.updater.enqueueForceUpdate(this, _, "forceUpdate");
  };
  function cn() {
  }
  cn.prototype = dt.prototype;
  function ft(_, B, je) {
    this.props = _, this.context = B, this.refs = yt, this.updater = je || ue;
  }
  var Qe = ft.prototype = new cn();
  Qe.constructor = ft, Ye(Qe, dt.prototype), Qe.isPureReactComponent = !0;
  var pt = Array.isArray, be = Object.prototype.hasOwnProperty, ot = { current: null }, Fe = { key: !0, ref: !0, __self: !0, __source: !0 };
  function rn(_, B, je) {
    var Ue, rt = {}, Je = null, Ke = null;
    if (B != null) for (Ue in B.ref !== void 0 && (Ke = B.ref), B.key !== void 0 && (Je = "" + B.key), B) be.call(B, Ue) && !Fe.hasOwnProperty(Ue) && (rt[Ue] = B[Ue]);
    var et = arguments.length - 2;
    if (et === 1) rt.children = je;
    else if (1 < et) {
      for (var at = Array(et), Vt = 0; Vt < et; Vt++) at[Vt] = arguments[Vt + 2];
      rt.children = at;
    }
    if (_ && _.defaultProps) for (Ue in et = _.defaultProps, et) rt[Ue] === void 0 && (rt[Ue] = et[Ue]);
    return { $$typeof: M, type: _, key: Je, ref: Ke, props: rt, _owner: ot.current };
  }
  function Ft(_, B) {
    return { $$typeof: M, type: _.type, key: B, ref: _.ref, props: _.props, _owner: _._owner };
  }
  function Kt(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === M;
  }
  function an(_) {
    var B = { "=": "=0", ":": "=2" };
    return "$" + _.replace(/[=:]/g, function(je) {
      return B[je];
    });
  }
  var wt = /\/+/g;
  function ke(_, B) {
    return typeof _ == "object" && _ !== null && _.key != null ? an("" + _.key) : B.toString(36);
  }
  function Ut(_, B, je, Ue, rt) {
    var Je = typeof _;
    (Je === "undefined" || Je === "boolean") && (_ = null);
    var Ke = !1;
    if (_ === null) Ke = !0;
    else switch (Je) {
      case "string":
      case "number":
        Ke = !0;
        break;
      case "object":
        switch (_.$$typeof) {
          case M:
          case j:
            Ke = !0;
        }
    }
    if (Ke) return Ke = _, rt = rt(Ke), _ = Ue === "" ? "." + ke(Ke, 0) : Ue, pt(rt) ? (je = "", _ != null && (je = _.replace(wt, "$&/") + "/"), Ut(rt, B, je, "", function(Vt) {
      return Vt;
    })) : rt != null && (Kt(rt) && (rt = Ft(rt, je + (!rt.key || Ke && Ke.key === rt.key ? "" : ("" + rt.key).replace(wt, "$&/") + "/") + _)), B.push(rt)), 1;
    if (Ke = 0, Ue = Ue === "" ? "." : Ue + ":", pt(_)) for (var et = 0; et < _.length; et++) {
      Je = _[et];
      var at = Ue + ke(Je, et);
      Ke += Ut(Je, B, je, at, rt);
    }
    else if (at = Ce(_), typeof at == "function") for (_ = at.call(_), et = 0; !(Je = _.next()).done; ) Je = Je.value, at = Ue + ke(Je, et++), Ke += Ut(Je, B, je, at, rt);
    else if (Je === "object") throw B = String(_), Error("Objects are not valid as a React child (found: " + (B === "[object Object]" ? "object with keys {" + Object.keys(_).join(", ") + "}" : B) + "). If you meant to render a collection of children, use an array instead.");
    return Ke;
  }
  function xt(_, B, je) {
    if (_ == null) return _;
    var Ue = [], rt = 0;
    return Ut(_, Ue, "", "", function(Je) {
      return B.call(je, Je, rt++);
    }), Ue;
  }
  function Dt(_) {
    if (_._status === -1) {
      var B = _._result;
      B = B(), B.then(function(je) {
        (_._status === 0 || _._status === -1) && (_._status = 1, _._result = je);
      }, function(je) {
        (_._status === 0 || _._status === -1) && (_._status = 2, _._result = je);
      }), _._status === -1 && (_._status = 0, _._result = B);
    }
    if (_._status === 1) return _._result.default;
    throw _._result;
  }
  var Ee = { current: null }, Z = { transition: null }, Re = { ReactCurrentDispatcher: Ee, ReactCurrentBatchConfig: Z, ReactCurrentOwner: ot };
  function ne() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return mt.Children = { map: xt, forEach: function(_, B, je) {
    xt(_, function() {
      B.apply(this, arguments);
    }, je);
  }, count: function(_) {
    var B = 0;
    return xt(_, function() {
      B++;
    }), B;
  }, toArray: function(_) {
    return xt(_, function(B) {
      return B;
    }) || [];
  }, only: function(_) {
    if (!Kt(_)) throw Error("React.Children.only expected to receive a single React element child.");
    return _;
  } }, mt.Component = dt, mt.Fragment = D, mt.Profiler = ht, mt.PureComponent = ft, mt.StrictMode = Be, mt.Suspense = de, mt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Re, mt.act = ne, mt.cloneElement = function(_, B, je) {
    if (_ == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + _ + ".");
    var Ue = Ye({}, _.props), rt = _.key, Je = _.ref, Ke = _._owner;
    if (B != null) {
      if (B.ref !== void 0 && (Je = B.ref, Ke = ot.current), B.key !== void 0 && (rt = "" + B.key), _.type && _.type.defaultProps) var et = _.type.defaultProps;
      for (at in B) be.call(B, at) && !Fe.hasOwnProperty(at) && (Ue[at] = B[at] === void 0 && et !== void 0 ? et[at] : B[at]);
    }
    var at = arguments.length - 2;
    if (at === 1) Ue.children = je;
    else if (1 < at) {
      et = Array(at);
      for (var Vt = 0; Vt < at; Vt++) et[Vt] = arguments[Vt + 2];
      Ue.children = et;
    }
    return { $$typeof: M, type: _.type, key: rt, ref: Je, props: Ue, _owner: Ke };
  }, mt.createContext = function(_) {
    return _ = { $$typeof: S, _currentValue: _, _currentValue2: _, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, _.Provider = { $$typeof: _t, _context: _ }, _.Consumer = _;
  }, mt.createElement = rn, mt.createFactory = function(_) {
    var B = rn.bind(null, _);
    return B.type = _, B;
  }, mt.createRef = function() {
    return { current: null };
  }, mt.forwardRef = function(_) {
    return { $$typeof: Pt, render: _ };
  }, mt.isValidElement = Kt, mt.lazy = function(_) {
    return { $$typeof: ut, _payload: { _status: -1, _result: _ }, _init: Dt };
  }, mt.memo = function(_, B) {
    return { $$typeof: ve, type: _, compare: B === void 0 ? null : B };
  }, mt.startTransition = function(_) {
    var B = Z.transition;
    Z.transition = {};
    try {
      _();
    } finally {
      Z.transition = B;
    }
  }, mt.unstable_act = ne, mt.useCallback = function(_, B) {
    return Ee.current.useCallback(_, B);
  }, mt.useContext = function(_) {
    return Ee.current.useContext(_);
  }, mt.useDebugValue = function() {
  }, mt.useDeferredValue = function(_) {
    return Ee.current.useDeferredValue(_);
  }, mt.useEffect = function(_, B) {
    return Ee.current.useEffect(_, B);
  }, mt.useId = function() {
    return Ee.current.useId();
  }, mt.useImperativeHandle = function(_, B, je) {
    return Ee.current.useImperativeHandle(_, B, je);
  }, mt.useInsertionEffect = function(_, B) {
    return Ee.current.useInsertionEffect(_, B);
  }, mt.useLayoutEffect = function(_, B) {
    return Ee.current.useLayoutEffect(_, B);
  }, mt.useMemo = function(_, B) {
    return Ee.current.useMemo(_, B);
  }, mt.useReducer = function(_, B, je) {
    return Ee.current.useReducer(_, B, je);
  }, mt.useRef = function(_) {
    return Ee.current.useRef(_);
  }, mt.useState = function(_) {
    return Ee.current.useState(_);
  }, mt.useSyncExternalStore = function(_, B, je) {
    return Ee.current.useSyncExternalStore(_, B, je);
  }, mt.useTransition = function() {
    return Ee.current.useTransition();
  }, mt.version = "18.3.1", mt;
}
var Jp = { exports: {} };
Jp.exports;
var JR;
function aD() {
  return JR || (JR = 1, (function(M, j) {
    process.env.NODE_ENV !== "production" && (function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var D = "18.3.1", Be = /* @__PURE__ */ Symbol.for("react.element"), ht = /* @__PURE__ */ Symbol.for("react.portal"), _t = /* @__PURE__ */ Symbol.for("react.fragment"), S = /* @__PURE__ */ Symbol.for("react.strict_mode"), Pt = /* @__PURE__ */ Symbol.for("react.profiler"), de = /* @__PURE__ */ Symbol.for("react.provider"), ve = /* @__PURE__ */ Symbol.for("react.context"), ut = /* @__PURE__ */ Symbol.for("react.forward_ref"), ee = /* @__PURE__ */ Symbol.for("react.suspense"), Ce = /* @__PURE__ */ Symbol.for("react.suspense_list"), ue = /* @__PURE__ */ Symbol.for("react.memo"), Ye = /* @__PURE__ */ Symbol.for("react.lazy"), yt = /* @__PURE__ */ Symbol.for("react.offscreen"), dt = Symbol.iterator, cn = "@@iterator";
      function ft(h) {
        if (h === null || typeof h != "object")
          return null;
        var C = dt && h[dt] || h[cn];
        return typeof C == "function" ? C : null;
      }
      var Qe = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, pt = {
        transition: null
      }, be = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, ot = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Fe = {}, rn = null;
      function Ft(h) {
        rn = h;
      }
      Fe.setExtraStackFrame = function(h) {
        rn = h;
      }, Fe.getCurrentStack = null, Fe.getStackAddendum = function() {
        var h = "";
        rn && (h += rn);
        var C = Fe.getCurrentStack;
        return C && (h += C() || ""), h;
      };
      var Kt = !1, an = !1, wt = !1, ke = !1, Ut = !1, xt = {
        ReactCurrentDispatcher: Qe,
        ReactCurrentBatchConfig: pt,
        ReactCurrentOwner: ot
      };
      xt.ReactDebugCurrentFrame = Fe, xt.ReactCurrentActQueue = be;
      function Dt(h) {
        {
          for (var C = arguments.length, U = new Array(C > 1 ? C - 1 : 0), H = 1; H < C; H++)
            U[H - 1] = arguments[H];
          Z("warn", h, U);
        }
      }
      function Ee(h) {
        {
          for (var C = arguments.length, U = new Array(C > 1 ? C - 1 : 0), H = 1; H < C; H++)
            U[H - 1] = arguments[H];
          Z("error", h, U);
        }
      }
      function Z(h, C, U) {
        {
          var H = xt.ReactDebugCurrentFrame, K = H.getStackAddendum();
          K !== "" && (C += "%s", U = U.concat([K]));
          var Oe = U.map(function(re) {
            return String(re);
          });
          Oe.unshift("Warning: " + C), Function.prototype.apply.call(console[h], console, Oe);
        }
      }
      var Re = {};
      function ne(h, C) {
        {
          var U = h.constructor, H = U && (U.displayName || U.name) || "ReactClass", K = H + "." + C;
          if (Re[K])
            return;
          Ee("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", C, H), Re[K] = !0;
        }
      }
      var _ = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(h) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(h, C, U) {
          ne(h, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(h, C, U, H) {
          ne(h, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(h, C, U, H) {
          ne(h, "setState");
        }
      }, B = Object.assign, je = {};
      Object.freeze(je);
      function Ue(h, C, U) {
        this.props = h, this.context = C, this.refs = je, this.updater = U || _;
      }
      Ue.prototype.isReactComponent = {}, Ue.prototype.setState = function(h, C) {
        if (typeof h != "object" && typeof h != "function" && h != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, h, C, "setState");
      }, Ue.prototype.forceUpdate = function(h) {
        this.updater.enqueueForceUpdate(this, h, "forceUpdate");
      };
      {
        var rt = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, Je = function(h, C) {
          Object.defineProperty(Ue.prototype, h, {
            get: function() {
              Dt("%s(...) is deprecated in plain JavaScript React classes. %s", C[0], C[1]);
            }
          });
        };
        for (var Ke in rt)
          rt.hasOwnProperty(Ke) && Je(Ke, rt[Ke]);
      }
      function et() {
      }
      et.prototype = Ue.prototype;
      function at(h, C, U) {
        this.props = h, this.context = C, this.refs = je, this.updater = U || _;
      }
      var Vt = at.prototype = new et();
      Vt.constructor = at, B(Vt, Ue.prototype), Vt.isPureReactComponent = !0;
      function kn() {
        var h = {
          current: null
        };
        return Object.seal(h), h;
      }
      var wr = Array.isArray;
      function En(h) {
        return wr(h);
      }
      function tr(h) {
        {
          var C = typeof Symbol == "function" && Symbol.toStringTag, U = C && h[Symbol.toStringTag] || h.constructor.name || "Object";
          return U;
        }
      }
      function Vn(h) {
        try {
          return Pn(h), !1;
        } catch {
          return !0;
        }
      }
      function Pn(h) {
        return "" + h;
      }
      function $r(h) {
        if (Vn(h))
          return Ee("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tr(h)), Pn(h);
      }
      function oi(h, C, U) {
        var H = h.displayName;
        if (H)
          return H;
        var K = C.displayName || C.name || "";
        return K !== "" ? U + "(" + K + ")" : U;
      }
      function ua(h) {
        return h.displayName || "Context";
      }
      function Gn(h) {
        if (h == null)
          return null;
        if (typeof h.tag == "number" && Ee("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
          return h.displayName || h.name || null;
        if (typeof h == "string")
          return h;
        switch (h) {
          case _t:
            return "Fragment";
          case ht:
            return "Portal";
          case Pt:
            return "Profiler";
          case S:
            return "StrictMode";
          case ee:
            return "Suspense";
          case Ce:
            return "SuspenseList";
        }
        if (typeof h == "object")
          switch (h.$$typeof) {
            case ve:
              var C = h;
              return ua(C) + ".Consumer";
            case de:
              var U = h;
              return ua(U._context) + ".Provider";
            case ut:
              return oi(h, h.render, "ForwardRef");
            case ue:
              var H = h.displayName || null;
              return H !== null ? H : Gn(h.type) || "Memo";
            case Ye: {
              var K = h, Oe = K._payload, re = K._init;
              try {
                return Gn(re(Oe));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Cn = Object.prototype.hasOwnProperty, Bn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, yr, $a, On;
      On = {};
      function gr(h) {
        if (Cn.call(h, "ref")) {
          var C = Object.getOwnPropertyDescriptor(h, "ref").get;
          if (C && C.isReactWarning)
            return !1;
        }
        return h.ref !== void 0;
      }
      function oa(h) {
        if (Cn.call(h, "key")) {
          var C = Object.getOwnPropertyDescriptor(h, "key").get;
          if (C && C.isReactWarning)
            return !1;
        }
        return h.key !== void 0;
      }
      function Ia(h, C) {
        var U = function() {
          yr || (yr = !0, Ee("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        U.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: U,
          configurable: !0
        });
      }
      function si(h, C) {
        var U = function() {
          $a || ($a = !0, Ee("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        U.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: U,
          configurable: !0
        });
      }
      function J(h) {
        if (typeof h.ref == "string" && ot.current && h.__self && ot.current.stateNode !== h.__self) {
          var C = Gn(ot.current.type);
          On[C] || (Ee('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', C, h.ref), On[C] = !0);
        }
      }
      var Te = function(h, C, U, H, K, Oe, re) {
        var Ne = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: Be,
          // Built-in properties that belong on the element
          type: h,
          key: C,
          ref: U,
          props: re,
          // Record the component responsible for creating this element.
          _owner: Oe
        };
        return Ne._store = {}, Object.defineProperty(Ne._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ne, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: H
        }), Object.defineProperty(Ne, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: K
        }), Object.freeze && (Object.freeze(Ne.props), Object.freeze(Ne)), Ne;
      };
      function tt(h, C, U) {
        var H, K = {}, Oe = null, re = null, Ne = null, ct = null;
        if (C != null) {
          gr(C) && (re = C.ref, J(C)), oa(C) && ($r(C.key), Oe = "" + C.key), Ne = C.__self === void 0 ? null : C.__self, ct = C.__source === void 0 ? null : C.__source;
          for (H in C)
            Cn.call(C, H) && !Bn.hasOwnProperty(H) && (K[H] = C[H]);
        }
        var Tt = arguments.length - 2;
        if (Tt === 1)
          K.children = U;
        else if (Tt > 1) {
          for (var tn = Array(Tt), Yt = 0; Yt < Tt; Yt++)
            tn[Yt] = arguments[Yt + 2];
          Object.freeze && Object.freeze(tn), K.children = tn;
        }
        if (h && h.defaultProps) {
          var nt = h.defaultProps;
          for (H in nt)
            K[H] === void 0 && (K[H] = nt[H]);
        }
        if (Oe || re) {
          var Qt = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          Oe && Ia(K, Qt), re && si(K, Qt);
        }
        return Te(h, Oe, re, Ne, ct, ot.current, K);
      }
      function At(h, C) {
        var U = Te(h.type, C, h.ref, h._self, h._source, h._owner, h.props);
        return U;
      }
      function Zt(h, C, U) {
        if (h == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + h + ".");
        var H, K = B({}, h.props), Oe = h.key, re = h.ref, Ne = h._self, ct = h._source, Tt = h._owner;
        if (C != null) {
          gr(C) && (re = C.ref, Tt = ot.current), oa(C) && ($r(C.key), Oe = "" + C.key);
          var tn;
          h.type && h.type.defaultProps && (tn = h.type.defaultProps);
          for (H in C)
            Cn.call(C, H) && !Bn.hasOwnProperty(H) && (C[H] === void 0 && tn !== void 0 ? K[H] = tn[H] : K[H] = C[H]);
        }
        var Yt = arguments.length - 2;
        if (Yt === 1)
          K.children = U;
        else if (Yt > 1) {
          for (var nt = Array(Yt), Qt = 0; Qt < Yt; Qt++)
            nt[Qt] = arguments[Qt + 2];
          K.children = nt;
        }
        return Te(h.type, Oe, re, Ne, ct, Tt, K);
      }
      function pn(h) {
        return typeof h == "object" && h !== null && h.$$typeof === Be;
      }
      var ln = ".", qn = ":";
      function Jt(h) {
        var C = /[=:]/g, U = {
          "=": "=0",
          ":": "=2"
        }, H = h.replace(C, function(K) {
          return U[K];
        });
        return "$" + H;
      }
      var Bt = !1, $t = /\/+/g;
      function sa(h) {
        return h.replace($t, "$&/");
      }
      function Sr(h, C) {
        return typeof h == "object" && h !== null && h.key != null ? ($r(h.key), Jt("" + h.key)) : C.toString(36);
      }
      function Ra(h, C, U, H, K) {
        var Oe = typeof h;
        (Oe === "undefined" || Oe === "boolean") && (h = null);
        var re = !1;
        if (h === null)
          re = !0;
        else
          switch (Oe) {
            case "string":
            case "number":
              re = !0;
              break;
            case "object":
              switch (h.$$typeof) {
                case Be:
                case ht:
                  re = !0;
              }
          }
        if (re) {
          var Ne = h, ct = K(Ne), Tt = H === "" ? ln + Sr(Ne, 0) : H;
          if (En(ct)) {
            var tn = "";
            Tt != null && (tn = sa(Tt) + "/"), Ra(ct, C, tn, "", function(qf) {
              return qf;
            });
          } else ct != null && (pn(ct) && (ct.key && (!Ne || Ne.key !== ct.key) && $r(ct.key), ct = At(
            ct,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            U + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (ct.key && (!Ne || Ne.key !== ct.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              sa("" + ct.key) + "/"
            ) : "") + Tt
          )), C.push(ct));
          return 1;
        }
        var Yt, nt, Qt = 0, vn = H === "" ? ln : H + qn;
        if (En(h))
          for (var El = 0; El < h.length; El++)
            Yt = h[El], nt = vn + Sr(Yt, El), Qt += Ra(Yt, C, U, nt, K);
        else {
          var Wo = ft(h);
          if (typeof Wo == "function") {
            var Vi = h;
            Wo === Vi.entries && (Bt || Dt("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Bt = !0);
            for (var Go = Wo.call(Vi), lu, Gf = 0; !(lu = Go.next()).done; )
              Yt = lu.value, nt = vn + Sr(Yt, Gf++), Qt += Ra(Yt, C, U, nt, K);
          } else if (Oe === "object") {
            var uc = String(h);
            throw new Error("Objects are not valid as a React child (found: " + (uc === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : uc) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Qt;
      }
      function Fi(h, C, U) {
        if (h == null)
          return h;
        var H = [], K = 0;
        return Ra(h, H, "", "", function(Oe) {
          return C.call(U, Oe, K++);
        }), H;
      }
      function Kl(h) {
        var C = 0;
        return Fi(h, function() {
          C++;
        }), C;
      }
      function Zl(h, C, U) {
        Fi(h, function() {
          C.apply(this, arguments);
        }, U);
      }
      function fl(h) {
        return Fi(h, function(C) {
          return C;
        }) || [];
      }
      function dl(h) {
        if (!pn(h))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return h;
      }
      function Jl(h) {
        var C = {
          $$typeof: ve,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: h,
          _currentValue2: h,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        C.Provider = {
          $$typeof: de,
          _context: C
        };
        var U = !1, H = !1, K = !1;
        {
          var Oe = {
            $$typeof: ve,
            _context: C
          };
          Object.defineProperties(Oe, {
            Provider: {
              get: function() {
                return H || (H = !0, Ee("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), C.Provider;
              },
              set: function(re) {
                C.Provider = re;
              }
            },
            _currentValue: {
              get: function() {
                return C._currentValue;
              },
              set: function(re) {
                C._currentValue = re;
              }
            },
            _currentValue2: {
              get: function() {
                return C._currentValue2;
              },
              set: function(re) {
                C._currentValue2 = re;
              }
            },
            _threadCount: {
              get: function() {
                return C._threadCount;
              },
              set: function(re) {
                C._threadCount = re;
              }
            },
            Consumer: {
              get: function() {
                return U || (U = !0, Ee("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), C.Consumer;
              }
            },
            displayName: {
              get: function() {
                return C.displayName;
              },
              set: function(re) {
                K || (Dt("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", re), K = !0);
              }
            }
          }), C.Consumer = Oe;
        }
        return C._currentRenderer = null, C._currentRenderer2 = null, C;
      }
      var xr = -1, br = 0, nr = 1, ci = 2;
      function Ya(h) {
        if (h._status === xr) {
          var C = h._result, U = C();
          if (U.then(function(Oe) {
            if (h._status === br || h._status === xr) {
              var re = h;
              re._status = nr, re._result = Oe;
            }
          }, function(Oe) {
            if (h._status === br || h._status === xr) {
              var re = h;
              re._status = ci, re._result = Oe;
            }
          }), h._status === xr) {
            var H = h;
            H._status = br, H._result = U;
          }
        }
        if (h._status === nr) {
          var K = h._result;
          return K === void 0 && Ee(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, K), "default" in K || Ee(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, K), K.default;
        } else
          throw h._result;
      }
      function fi(h) {
        var C = {
          // We use these fields to store the result.
          _status: xr,
          _result: h
        }, U = {
          $$typeof: Ye,
          _payload: C,
          _init: Ya
        };
        {
          var H, K;
          Object.defineProperties(U, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return H;
              },
              set: function(Oe) {
                Ee("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), H = Oe, Object.defineProperty(U, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return K;
              },
              set: function(Oe) {
                Ee("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), K = Oe, Object.defineProperty(U, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return U;
      }
      function di(h) {
        h != null && h.$$typeof === ue ? Ee("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof h != "function" ? Ee("forwardRef requires a render function but was given %s.", h === null ? "null" : typeof h) : h.length !== 0 && h.length !== 2 && Ee("forwardRef render functions accept exactly two parameters: props and ref. %s", h.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), h != null && (h.defaultProps != null || h.propTypes != null) && Ee("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var C = {
          $$typeof: ut,
          render: h
        };
        {
          var U;
          Object.defineProperty(C, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return U;
            },
            set: function(H) {
              U = H, !h.name && !h.displayName && (h.displayName = H);
            }
          });
        }
        return C;
      }
      var R;
      R = /* @__PURE__ */ Symbol.for("react.module.reference");
      function I(h) {
        return !!(typeof h == "string" || typeof h == "function" || h === _t || h === Pt || Ut || h === S || h === ee || h === Ce || ke || h === yt || Kt || an || wt || typeof h == "object" && h !== null && (h.$$typeof === Ye || h.$$typeof === ue || h.$$typeof === de || h.$$typeof === ve || h.$$typeof === ut || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        h.$$typeof === R || h.getModuleId !== void 0));
      }
      function ae(h, C) {
        I(h) || Ee("memo: The first argument must be a component. Instead received: %s", h === null ? "null" : typeof h);
        var U = {
          $$typeof: ue,
          type: h,
          compare: C === void 0 ? null : C
        };
        {
          var H;
          Object.defineProperty(U, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return H;
            },
            set: function(K) {
              H = K, !h.name && !h.displayName && (h.displayName = K);
            }
          });
        }
        return U;
      }
      function he() {
        var h = Qe.current;
        return h === null && Ee(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), h;
      }
      function Ge(h) {
        var C = he();
        if (h._context !== void 0) {
          var U = h._context;
          U.Consumer === h ? Ee("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : U.Provider === h && Ee("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return C.useContext(h);
      }
      function $e(h) {
        var C = he();
        return C.useState(h);
      }
      function st(h, C, U) {
        var H = he();
        return H.useReducer(h, C, U);
      }
      function it(h) {
        var C = he();
        return C.useRef(h);
      }
      function Rn(h, C) {
        var U = he();
        return U.useEffect(h, C);
      }
      function en(h, C) {
        var U = he();
        return U.useInsertionEffect(h, C);
      }
      function un(h, C) {
        var U = he();
        return U.useLayoutEffect(h, C);
      }
      function rr(h, C) {
        var U = he();
        return U.useCallback(h, C);
      }
      function Qa(h, C) {
        var U = he();
        return U.useMemo(h, C);
      }
      function Wa(h, C, U) {
        var H = he();
        return H.useImperativeHandle(h, C, U);
      }
      function qe(h, C) {
        {
          var U = he();
          return U.useDebugValue(h, C);
        }
      }
      function Ze() {
        var h = he();
        return h.useTransition();
      }
      function Ga(h) {
        var C = he();
        return C.useDeferredValue(h);
      }
      function eu() {
        var h = he();
        return h.useId();
      }
      function tu(h, C, U) {
        var H = he();
        return H.useSyncExternalStore(h, C, U);
      }
      var pl = 0, Yu, vl, Ir, $o, _r, ic, lc;
      function Qu() {
      }
      Qu.__reactDisabledLog = !0;
      function hl() {
        {
          if (pl === 0) {
            Yu = console.log, vl = console.info, Ir = console.warn, $o = console.error, _r = console.group, ic = console.groupCollapsed, lc = console.groupEnd;
            var h = {
              configurable: !0,
              enumerable: !0,
              value: Qu,
              writable: !0
            };
            Object.defineProperties(console, {
              info: h,
              log: h,
              warn: h,
              error: h,
              group: h,
              groupCollapsed: h,
              groupEnd: h
            });
          }
          pl++;
        }
      }
      function ca() {
        {
          if (pl--, pl === 0) {
            var h = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: B({}, h, {
                value: Yu
              }),
              info: B({}, h, {
                value: vl
              }),
              warn: B({}, h, {
                value: Ir
              }),
              error: B({}, h, {
                value: $o
              }),
              group: B({}, h, {
                value: _r
              }),
              groupCollapsed: B({}, h, {
                value: ic
              }),
              groupEnd: B({}, h, {
                value: lc
              })
            });
          }
          pl < 0 && Ee("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var qa = xt.ReactCurrentDispatcher, Xa;
      function Wu(h, C, U) {
        {
          if (Xa === void 0)
            try {
              throw Error();
            } catch (K) {
              var H = K.stack.trim().match(/\n( *(at )?)/);
              Xa = H && H[1] || "";
            }
          return `
` + Xa + h;
        }
      }
      var nu = !1, ml;
      {
        var Gu = typeof WeakMap == "function" ? WeakMap : Map;
        ml = new Gu();
      }
      function qu(h, C) {
        if (!h || nu)
          return "";
        {
          var U = ml.get(h);
          if (U !== void 0)
            return U;
        }
        var H;
        nu = !0;
        var K = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Oe;
        Oe = qa.current, qa.current = null, hl();
        try {
          if (C) {
            var re = function() {
              throw Error();
            };
            if (Object.defineProperty(re.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(re, []);
              } catch (vn) {
                H = vn;
              }
              Reflect.construct(h, [], re);
            } else {
              try {
                re.call();
              } catch (vn) {
                H = vn;
              }
              h.call(re.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (vn) {
              H = vn;
            }
            h();
          }
        } catch (vn) {
          if (vn && H && typeof vn.stack == "string") {
            for (var Ne = vn.stack.split(`
`), ct = H.stack.split(`
`), Tt = Ne.length - 1, tn = ct.length - 1; Tt >= 1 && tn >= 0 && Ne[Tt] !== ct[tn]; )
              tn--;
            for (; Tt >= 1 && tn >= 0; Tt--, tn--)
              if (Ne[Tt] !== ct[tn]) {
                if (Tt !== 1 || tn !== 1)
                  do
                    if (Tt--, tn--, tn < 0 || Ne[Tt] !== ct[tn]) {
                      var Yt = `
` + Ne[Tt].replace(" at new ", " at ");
                      return h.displayName && Yt.includes("<anonymous>") && (Yt = Yt.replace("<anonymous>", h.displayName)), typeof h == "function" && ml.set(h, Yt), Yt;
                    }
                  while (Tt >= 1 && tn >= 0);
                break;
              }
          }
        } finally {
          nu = !1, qa.current = Oe, ca(), Error.prepareStackTrace = K;
        }
        var nt = h ? h.displayName || h.name : "", Qt = nt ? Wu(nt) : "";
        return typeof h == "function" && ml.set(h, Qt), Qt;
      }
      function ji(h, C, U) {
        return qu(h, !1);
      }
      function Qf(h) {
        var C = h.prototype;
        return !!(C && C.isReactComponent);
      }
      function Hi(h, C, U) {
        if (h == null)
          return "";
        if (typeof h == "function")
          return qu(h, Qf(h));
        if (typeof h == "string")
          return Wu(h);
        switch (h) {
          case ee:
            return Wu("Suspense");
          case Ce:
            return Wu("SuspenseList");
        }
        if (typeof h == "object")
          switch (h.$$typeof) {
            case ut:
              return ji(h.render);
            case ue:
              return Hi(h.type, C, U);
            case Ye: {
              var H = h, K = H._payload, Oe = H._init;
              try {
                return Hi(Oe(K), C, U);
              } catch {
              }
            }
          }
        return "";
      }
      var kt = {}, Xu = xt.ReactDebugCurrentFrame;
      function Rt(h) {
        if (h) {
          var C = h._owner, U = Hi(h.type, h._source, C ? C.type : null);
          Xu.setExtraStackFrame(U);
        } else
          Xu.setExtraStackFrame(null);
      }
      function Io(h, C, U, H, K) {
        {
          var Oe = Function.call.bind(Cn);
          for (var re in h)
            if (Oe(h, re)) {
              var Ne = void 0;
              try {
                if (typeof h[re] != "function") {
                  var ct = Error((H || "React class") + ": " + U + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ct.name = "Invariant Violation", ct;
                }
                Ne = h[re](C, re, H, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Tt) {
                Ne = Tt;
              }
              Ne && !(Ne instanceof Error) && (Rt(K), Ee("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", U, re, typeof Ne), Rt(null)), Ne instanceof Error && !(Ne.message in kt) && (kt[Ne.message] = !0, Rt(K), Ee("Failed %s type: %s", U, Ne.message), Rt(null));
            }
        }
      }
      function pi(h) {
        if (h) {
          var C = h._owner, U = Hi(h.type, h._source, C ? C.type : null);
          Ft(U);
        } else
          Ft(null);
      }
      var Pe;
      Pe = !1;
      function Ku() {
        if (ot.current) {
          var h = Gn(ot.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
      function ar(h) {
        if (h !== void 0) {
          var C = h.fileName.replace(/^.*[\\\/]/, ""), U = h.lineNumber;
          return `

Check your code at ` + C + ":" + U + ".";
        }
        return "";
      }
      function vi(h) {
        return h != null ? ar(h.__source) : "";
      }
      var Dr = {};
      function hi(h) {
        var C = Ku();
        if (!C) {
          var U = typeof h == "string" ? h : h.displayName || h.name;
          U && (C = `

Check the top-level render call using <` + U + ">.");
        }
        return C;
      }
      function on(h, C) {
        if (!(!h._store || h._store.validated || h.key != null)) {
          h._store.validated = !0;
          var U = hi(C);
          if (!Dr[U]) {
            Dr[U] = !0;
            var H = "";
            h && h._owner && h._owner !== ot.current && (H = " It was passed a child from " + Gn(h._owner.type) + "."), pi(h), Ee('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, H), pi(null);
          }
        }
      }
      function It(h, C) {
        if (typeof h == "object") {
          if (En(h))
            for (var U = 0; U < h.length; U++) {
              var H = h[U];
              pn(H) && on(H, C);
            }
          else if (pn(h))
            h._store && (h._store.validated = !0);
          else if (h) {
            var K = ft(h);
            if (typeof K == "function" && K !== h.entries)
              for (var Oe = K.call(h), re; !(re = Oe.next()).done; )
                pn(re.value) && on(re.value, C);
          }
        }
      }
      function yl(h) {
        {
          var C = h.type;
          if (C == null || typeof C == "string")
            return;
          var U;
          if (typeof C == "function")
            U = C.propTypes;
          else if (typeof C == "object" && (C.$$typeof === ut || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          C.$$typeof === ue))
            U = C.propTypes;
          else
            return;
          if (U) {
            var H = Gn(C);
            Io(U, h.props, "prop", H, h);
          } else if (C.PropTypes !== void 0 && !Pe) {
            Pe = !0;
            var K = Gn(C);
            Ee("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
          }
          typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && Ee("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function $n(h) {
        {
          for (var C = Object.keys(h.props), U = 0; U < C.length; U++) {
            var H = C[U];
            if (H !== "children" && H !== "key") {
              pi(h), Ee("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), pi(null);
              break;
            }
          }
          h.ref !== null && (pi(h), Ee("Invalid attribute `ref` supplied to `React.Fragment`."), pi(null));
        }
      }
      function kr(h, C, U) {
        var H = I(h);
        if (!H) {
          var K = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (K += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Oe = vi(C);
          Oe ? K += Oe : K += Ku();
          var re;
          h === null ? re = "null" : En(h) ? re = "array" : h !== void 0 && h.$$typeof === Be ? (re = "<" + (Gn(h.type) || "Unknown") + " />", K = " Did you accidentally export a JSX literal instead of a component?") : re = typeof h, Ee("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", re, K);
        }
        var Ne = tt.apply(this, arguments);
        if (Ne == null)
          return Ne;
        if (H)
          for (var ct = 2; ct < arguments.length; ct++)
            It(arguments[ct], h);
        return h === _t ? $n(Ne) : yl(Ne), Ne;
      }
      var Ta = !1;
      function ru(h) {
        var C = kr.bind(null, h);
        return C.type = h, Ta || (Ta = !0, Dt("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(C, "type", {
          enumerable: !1,
          get: function() {
            return Dt("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: h
            }), h;
          }
        }), C;
      }
      function Yo(h, C, U) {
        for (var H = Zt.apply(this, arguments), K = 2; K < arguments.length; K++)
          It(arguments[K], H.type);
        return yl(H), H;
      }
      function Qo(h, C) {
        var U = pt.transition;
        pt.transition = {};
        var H = pt.transition;
        pt.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          h();
        } finally {
          if (pt.transition = U, U === null && H._updatedFibers) {
            var K = H._updatedFibers.size;
            K > 10 && Dt("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), H._updatedFibers.clear();
          }
        }
      }
      var gl = !1, au = null;
      function Wf(h) {
        if (au === null)
          try {
            var C = ("require" + Math.random()).slice(0, 7), U = M && M[C];
            au = U.call(M, "timers").setImmediate;
          } catch {
            au = function(K) {
              gl === !1 && (gl = !0, typeof MessageChannel > "u" && Ee("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var Oe = new MessageChannel();
              Oe.port1.onmessage = K, Oe.port2.postMessage(void 0);
            };
          }
        return au(h);
      }
      var wa = 0, Ka = !1;
      function mi(h) {
        {
          var C = wa;
          wa++, be.current === null && (be.current = []);
          var U = be.isBatchingLegacy, H;
          try {
            if (be.isBatchingLegacy = !0, H = h(), !U && be.didScheduleLegacyUpdate) {
              var K = be.current;
              K !== null && (be.didScheduleLegacyUpdate = !1, Sl(K));
            }
          } catch (nt) {
            throw xa(C), nt;
          } finally {
            be.isBatchingLegacy = U;
          }
          if (H !== null && typeof H == "object" && typeof H.then == "function") {
            var Oe = H, re = !1, Ne = {
              then: function(nt, Qt) {
                re = !0, Oe.then(function(vn) {
                  xa(C), wa === 0 ? Zu(vn, nt, Qt) : nt(vn);
                }, function(vn) {
                  xa(C), Qt(vn);
                });
              }
            };
            return !Ka && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              re || (Ka = !0, Ee("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), Ne;
          } else {
            var ct = H;
            if (xa(C), wa === 0) {
              var Tt = be.current;
              Tt !== null && (Sl(Tt), be.current = null);
              var tn = {
                then: function(nt, Qt) {
                  be.current === null ? (be.current = [], Zu(ct, nt, Qt)) : nt(ct);
                }
              };
              return tn;
            } else {
              var Yt = {
                then: function(nt, Qt) {
                  nt(ct);
                }
              };
              return Yt;
            }
          }
        }
      }
      function xa(h) {
        h !== wa - 1 && Ee("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), wa = h;
      }
      function Zu(h, C, U) {
        {
          var H = be.current;
          if (H !== null)
            try {
              Sl(H), Wf(function() {
                H.length === 0 ? (be.current = null, C(h)) : Zu(h, C, U);
              });
            } catch (K) {
              U(K);
            }
          else
            C(h);
        }
      }
      var Ju = !1;
      function Sl(h) {
        if (!Ju) {
          Ju = !0;
          var C = 0;
          try {
            for (; C < h.length; C++) {
              var U = h[C];
              do
                U = U(!0);
              while (U !== null);
            }
            h.length = 0;
          } catch (H) {
            throw h = h.slice(C + 1), H;
          } finally {
            Ju = !1;
          }
        }
      }
      var iu = kr, eo = Yo, to = ru, Za = {
        map: Fi,
        forEach: Zl,
        count: Kl,
        toArray: fl,
        only: dl
      };
      j.Children = Za, j.Component = Ue, j.Fragment = _t, j.Profiler = Pt, j.PureComponent = at, j.StrictMode = S, j.Suspense = ee, j.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = xt, j.act = mi, j.cloneElement = eo, j.createContext = Jl, j.createElement = iu, j.createFactory = to, j.createRef = kn, j.forwardRef = di, j.isValidElement = pn, j.lazy = fi, j.memo = ae, j.startTransition = Qo, j.unstable_act = mi, j.useCallback = rr, j.useContext = Ge, j.useDebugValue = qe, j.useDeferredValue = Ga, j.useEffect = Rn, j.useId = eu, j.useImperativeHandle = Wa, j.useInsertionEffect = en, j.useLayoutEffect = un, j.useMemo = Qa, j.useReducer = st, j.useRef = it, j.useState = $e, j.useSyncExternalStore = tu, j.useTransition = Ze, j.version = D, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    })();
  })(Jp, Jp.exports)), Jp.exports;
}
var eT;
function ev() {
  return eT || (eT = 1, process.env.NODE_ENV === "production" ? Wm.exports = rD() : Wm.exports = aD()), Wm.exports;
}
var tT;
function iD() {
  if (tT) return Kp;
  tT = 1;
  var M = ev(), j = /* @__PURE__ */ Symbol.for("react.element"), D = /* @__PURE__ */ Symbol.for("react.fragment"), Be = Object.prototype.hasOwnProperty, ht = M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, _t = { key: !0, ref: !0, __self: !0, __source: !0 };
  function S(Pt, de, ve) {
    var ut, ee = {}, Ce = null, ue = null;
    ve !== void 0 && (Ce = "" + ve), de.key !== void 0 && (Ce = "" + de.key), de.ref !== void 0 && (ue = de.ref);
    for (ut in de) Be.call(de, ut) && !_t.hasOwnProperty(ut) && (ee[ut] = de[ut]);
    if (Pt && Pt.defaultProps) for (ut in de = Pt.defaultProps, de) ee[ut] === void 0 && (ee[ut] = de[ut]);
    return { $$typeof: j, type: Pt, key: Ce, ref: ue, props: ee, _owner: ht.current };
  }
  return Kp.Fragment = D, Kp.jsx = S, Kp.jsxs = S, Kp;
}
var Zp = {};
var nT;
function lD() {
  return nT || (nT = 1, process.env.NODE_ENV !== "production" && (function() {
    var M = ev(), j = /* @__PURE__ */ Symbol.for("react.element"), D = /* @__PURE__ */ Symbol.for("react.portal"), Be = /* @__PURE__ */ Symbol.for("react.fragment"), ht = /* @__PURE__ */ Symbol.for("react.strict_mode"), _t = /* @__PURE__ */ Symbol.for("react.profiler"), S = /* @__PURE__ */ Symbol.for("react.provider"), Pt = /* @__PURE__ */ Symbol.for("react.context"), de = /* @__PURE__ */ Symbol.for("react.forward_ref"), ve = /* @__PURE__ */ Symbol.for("react.suspense"), ut = /* @__PURE__ */ Symbol.for("react.suspense_list"), ee = /* @__PURE__ */ Symbol.for("react.memo"), Ce = /* @__PURE__ */ Symbol.for("react.lazy"), ue = /* @__PURE__ */ Symbol.for("react.offscreen"), Ye = Symbol.iterator, yt = "@@iterator";
    function dt(R) {
      if (R === null || typeof R != "object")
        return null;
      var I = Ye && R[Ye] || R[yt];
      return typeof I == "function" ? I : null;
    }
    var cn = M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function ft(R) {
      {
        for (var I = arguments.length, ae = new Array(I > 1 ? I - 1 : 0), he = 1; he < I; he++)
          ae[he - 1] = arguments[he];
        Qe("error", R, ae);
      }
    }
    function Qe(R, I, ae) {
      {
        var he = cn.ReactDebugCurrentFrame, Ge = he.getStackAddendum();
        Ge !== "" && (I += "%s", ae = ae.concat([Ge]));
        var $e = ae.map(function(st) {
          return String(st);
        });
        $e.unshift("Warning: " + I), Function.prototype.apply.call(console[R], console, $e);
      }
    }
    var pt = !1, be = !1, ot = !1, Fe = !1, rn = !1, Ft;
    Ft = /* @__PURE__ */ Symbol.for("react.module.reference");
    function Kt(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === Be || R === _t || rn || R === ht || R === ve || R === ut || Fe || R === ue || pt || be || ot || typeof R == "object" && R !== null && (R.$$typeof === Ce || R.$$typeof === ee || R.$$typeof === S || R.$$typeof === Pt || R.$$typeof === de || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === Ft || R.getModuleId !== void 0));
    }
    function an(R, I, ae) {
      var he = R.displayName;
      if (he)
        return he;
      var Ge = I.displayName || I.name || "";
      return Ge !== "" ? ae + "(" + Ge + ")" : ae;
    }
    function wt(R) {
      return R.displayName || "Context";
    }
    function ke(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && ft("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case Be:
          return "Fragment";
        case D:
          return "Portal";
        case _t:
          return "Profiler";
        case ht:
          return "StrictMode";
        case ve:
          return "Suspense";
        case ut:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case Pt:
            var I = R;
            return wt(I) + ".Consumer";
          case S:
            var ae = R;
            return wt(ae._context) + ".Provider";
          case de:
            return an(R, R.render, "ForwardRef");
          case ee:
            var he = R.displayName || null;
            return he !== null ? he : ke(R.type) || "Memo";
          case Ce: {
            var Ge = R, $e = Ge._payload, st = Ge._init;
            try {
              return ke(st($e));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ut = Object.assign, xt = 0, Dt, Ee, Z, Re, ne, _, B;
    function je() {
    }
    je.__reactDisabledLog = !0;
    function Ue() {
      {
        if (xt === 0) {
          Dt = console.log, Ee = console.info, Z = console.warn, Re = console.error, ne = console.group, _ = console.groupCollapsed, B = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        xt++;
      }
    }
    function rt() {
      {
        if (xt--, xt === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ut({}, R, {
              value: Dt
            }),
            info: Ut({}, R, {
              value: Ee
            }),
            warn: Ut({}, R, {
              value: Z
            }),
            error: Ut({}, R, {
              value: Re
            }),
            group: Ut({}, R, {
              value: ne
            }),
            groupCollapsed: Ut({}, R, {
              value: _
            }),
            groupEnd: Ut({}, R, {
              value: B
            })
          });
        }
        xt < 0 && ft("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Je = cn.ReactCurrentDispatcher, Ke;
    function et(R, I, ae) {
      {
        if (Ke === void 0)
          try {
            throw Error();
          } catch (Ge) {
            var he = Ge.stack.trim().match(/\n( *(at )?)/);
            Ke = he && he[1] || "";
          }
        return `
` + Ke + R;
      }
    }
    var at = !1, Vt;
    {
      var kn = typeof WeakMap == "function" ? WeakMap : Map;
      Vt = new kn();
    }
    function wr(R, I) {
      if (!R || at)
        return "";
      {
        var ae = Vt.get(R);
        if (ae !== void 0)
          return ae;
      }
      var he;
      at = !0;
      var Ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $e;
      $e = Je.current, Je.current = null, Ue();
      try {
        if (I) {
          var st = function() {
            throw Error();
          };
          if (Object.defineProperty(st.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(st, []);
            } catch (qe) {
              he = qe;
            }
            Reflect.construct(R, [], st);
          } else {
            try {
              st.call();
            } catch (qe) {
              he = qe;
            }
            R.call(st.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (qe) {
            he = qe;
          }
          R();
        }
      } catch (qe) {
        if (qe && he && typeof qe.stack == "string") {
          for (var it = qe.stack.split(`
`), Rn = he.stack.split(`
`), en = it.length - 1, un = Rn.length - 1; en >= 1 && un >= 0 && it[en] !== Rn[un]; )
            un--;
          for (; en >= 1 && un >= 0; en--, un--)
            if (it[en] !== Rn[un]) {
              if (en !== 1 || un !== 1)
                do
                  if (en--, un--, un < 0 || it[en] !== Rn[un]) {
                    var rr = `
` + it[en].replace(" at new ", " at ");
                    return R.displayName && rr.includes("<anonymous>") && (rr = rr.replace("<anonymous>", R.displayName)), typeof R == "function" && Vt.set(R, rr), rr;
                  }
                while (en >= 1 && un >= 0);
              break;
            }
        }
      } finally {
        at = !1, Je.current = $e, rt(), Error.prepareStackTrace = Ge;
      }
      var Qa = R ? R.displayName || R.name : "", Wa = Qa ? et(Qa) : "";
      return typeof R == "function" && Vt.set(R, Wa), Wa;
    }
    function En(R, I, ae) {
      return wr(R, !1);
    }
    function tr(R) {
      var I = R.prototype;
      return !!(I && I.isReactComponent);
    }
    function Vn(R, I, ae) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return wr(R, tr(R));
      if (typeof R == "string")
        return et(R);
      switch (R) {
        case ve:
          return et("Suspense");
        case ut:
          return et("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case de:
            return En(R.render);
          case ee:
            return Vn(R.type, I, ae);
          case Ce: {
            var he = R, Ge = he._payload, $e = he._init;
            try {
              return Vn($e(Ge), I, ae);
            } catch {
            }
          }
        }
      return "";
    }
    var Pn = Object.prototype.hasOwnProperty, $r = {}, oi = cn.ReactDebugCurrentFrame;
    function ua(R) {
      if (R) {
        var I = R._owner, ae = Vn(R.type, R._source, I ? I.type : null);
        oi.setExtraStackFrame(ae);
      } else
        oi.setExtraStackFrame(null);
    }
    function Gn(R, I, ae, he, Ge) {
      {
        var $e = Function.call.bind(Pn);
        for (var st in R)
          if ($e(R, st)) {
            var it = void 0;
            try {
              if (typeof R[st] != "function") {
                var Rn = Error((he || "React class") + ": " + ae + " type `" + st + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[st] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Rn.name = "Invariant Violation", Rn;
              }
              it = R[st](I, st, he, ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (en) {
              it = en;
            }
            it && !(it instanceof Error) && (ua(Ge), ft("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", he || "React class", ae, st, typeof it), ua(null)), it instanceof Error && !(it.message in $r) && ($r[it.message] = !0, ua(Ge), ft("Failed %s type: %s", ae, it.message), ua(null));
          }
      }
    }
    var Cn = Array.isArray;
    function Bn(R) {
      return Cn(R);
    }
    function yr(R) {
      {
        var I = typeof Symbol == "function" && Symbol.toStringTag, ae = I && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return ae;
      }
    }
    function $a(R) {
      try {
        return On(R), !1;
      } catch {
        return !0;
      }
    }
    function On(R) {
      return "" + R;
    }
    function gr(R) {
      if ($a(R))
        return ft("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yr(R)), On(R);
    }
    var oa = cn.ReactCurrentOwner, Ia = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, si, J;
    function Te(R) {
      if (Pn.call(R, "ref")) {
        var I = Object.getOwnPropertyDescriptor(R, "ref").get;
        if (I && I.isReactWarning)
          return !1;
      }
      return R.ref !== void 0;
    }
    function tt(R) {
      if (Pn.call(R, "key")) {
        var I = Object.getOwnPropertyDescriptor(R, "key").get;
        if (I && I.isReactWarning)
          return !1;
      }
      return R.key !== void 0;
    }
    function At(R, I) {
      typeof R.ref == "string" && oa.current;
    }
    function Zt(R, I) {
      {
        var ae = function() {
          si || (si = !0, ft("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", I));
        };
        ae.isReactWarning = !0, Object.defineProperty(R, "key", {
          get: ae,
          configurable: !0
        });
      }
    }
    function pn(R, I) {
      {
        var ae = function() {
          J || (J = !0, ft("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", I));
        };
        ae.isReactWarning = !0, Object.defineProperty(R, "ref", {
          get: ae,
          configurable: !0
        });
      }
    }
    var ln = function(R, I, ae, he, Ge, $e, st) {
      var it = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: j,
        // Built-in properties that belong on the element
        type: R,
        key: I,
        ref: ae,
        props: st,
        // Record the component responsible for creating this element.
        _owner: $e
      };
      return it._store = {}, Object.defineProperty(it._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(it, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.defineProperty(it, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ge
      }), Object.freeze && (Object.freeze(it.props), Object.freeze(it)), it;
    };
    function qn(R, I, ae, he, Ge) {
      {
        var $e, st = {}, it = null, Rn = null;
        ae !== void 0 && (gr(ae), it = "" + ae), tt(I) && (gr(I.key), it = "" + I.key), Te(I) && (Rn = I.ref, At(I, Ge));
        for ($e in I)
          Pn.call(I, $e) && !Ia.hasOwnProperty($e) && (st[$e] = I[$e]);
        if (R && R.defaultProps) {
          var en = R.defaultProps;
          for ($e in en)
            st[$e] === void 0 && (st[$e] = en[$e]);
        }
        if (it || Rn) {
          var un = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
          it && Zt(st, un), Rn && pn(st, un);
        }
        return ln(R, it, Rn, Ge, he, oa.current, st);
      }
    }
    var Jt = cn.ReactCurrentOwner, Bt = cn.ReactDebugCurrentFrame;
    function $t(R) {
      if (R) {
        var I = R._owner, ae = Vn(R.type, R._source, I ? I.type : null);
        Bt.setExtraStackFrame(ae);
      } else
        Bt.setExtraStackFrame(null);
    }
    var sa;
    sa = !1;
    function Sr(R) {
      return typeof R == "object" && R !== null && R.$$typeof === j;
    }
    function Ra() {
      {
        if (Jt.current) {
          var R = ke(Jt.current.type);
          if (R)
            return `

Check the render method of \`` + R + "`.";
        }
        return "";
      }
    }
    function Fi(R) {
      return "";
    }
    var Kl = {};
    function Zl(R) {
      {
        var I = Ra();
        if (!I) {
          var ae = typeof R == "string" ? R : R.displayName || R.name;
          ae && (I = `

Check the top-level render call using <` + ae + ">.");
        }
        return I;
      }
    }
    function fl(R, I) {
      {
        if (!R._store || R._store.validated || R.key != null)
          return;
        R._store.validated = !0;
        var ae = Zl(I);
        if (Kl[ae])
          return;
        Kl[ae] = !0;
        var he = "";
        R && R._owner && R._owner !== Jt.current && (he = " It was passed a child from " + ke(R._owner.type) + "."), $t(R), ft('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ae, he), $t(null);
      }
    }
    function dl(R, I) {
      {
        if (typeof R != "object")
          return;
        if (Bn(R))
          for (var ae = 0; ae < R.length; ae++) {
            var he = R[ae];
            Sr(he) && fl(he, I);
          }
        else if (Sr(R))
          R._store && (R._store.validated = !0);
        else if (R) {
          var Ge = dt(R);
          if (typeof Ge == "function" && Ge !== R.entries)
            for (var $e = Ge.call(R), st; !(st = $e.next()).done; )
              Sr(st.value) && fl(st.value, I);
        }
      }
    }
    function Jl(R) {
      {
        var I = R.type;
        if (I == null || typeof I == "string")
          return;
        var ae;
        if (typeof I == "function")
          ae = I.propTypes;
        else if (typeof I == "object" && (I.$$typeof === de || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        I.$$typeof === ee))
          ae = I.propTypes;
        else
          return;
        if (ae) {
          var he = ke(I);
          Gn(ae, R.props, "prop", he, R);
        } else if (I.PropTypes !== void 0 && !sa) {
          sa = !0;
          var Ge = ke(I);
          ft("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ge || "Unknown");
        }
        typeof I.getDefaultProps == "function" && !I.getDefaultProps.isReactClassApproved && ft("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xr(R) {
      {
        for (var I = Object.keys(R.props), ae = 0; ae < I.length; ae++) {
          var he = I[ae];
          if (he !== "children" && he !== "key") {
            $t(R), ft("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", he), $t(null);
            break;
          }
        }
        R.ref !== null && ($t(R), ft("Invalid attribute `ref` supplied to `React.Fragment`."), $t(null));
      }
    }
    var br = {};
    function nr(R, I, ae, he, Ge, $e) {
      {
        var st = Kt(R);
        if (!st) {
          var it = "";
          (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (it += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Rn = Fi();
          Rn ? it += Rn : it += Ra();
          var en;
          R === null ? en = "null" : Bn(R) ? en = "array" : R !== void 0 && R.$$typeof === j ? (en = "<" + (ke(R.type) || "Unknown") + " />", it = " Did you accidentally export a JSX literal instead of a component?") : en = typeof R, ft("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", en, it);
        }
        var un = qn(R, I, ae, Ge, $e);
        if (un == null)
          return un;
        if (st) {
          var rr = I.children;
          if (rr !== void 0)
            if (he)
              if (Bn(rr)) {
                for (var Qa = 0; Qa < rr.length; Qa++)
                  dl(rr[Qa], R);
                Object.freeze && Object.freeze(rr);
              } else
                ft("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              dl(rr, R);
        }
        if (Pn.call(I, "key")) {
          var Wa = ke(R), qe = Object.keys(I).filter(function(eu) {
            return eu !== "key";
          }), Ze = qe.length > 0 ? "{key: someKey, " + qe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!br[Wa + Ze]) {
            var Ga = qe.length > 0 ? "{" + qe.join(": ..., ") + ": ...}" : "{}";
            ft(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, Wa, Ga, Wa), br[Wa + Ze] = !0;
          }
        }
        return R === Be ? xr(un) : Jl(un), un;
      }
    }
    function ci(R, I, ae) {
      return nr(R, I, ae, !0);
    }
    function Ya(R, I, ae) {
      return nr(R, I, ae, !1);
    }
    var fi = Ya, di = ci;
    Zp.Fragment = Be, Zp.jsx = fi, Zp.jsxs = di;
  })()), Zp;
}
var rT;
function uD() {
  return rT || (rT = 1, process.env.NODE_ENV === "production" ? Qm.exports = iD() : Qm.exports = lD()), Qm.exports;
}
var pT = uD(), aT = ev(), Yf = {}, Gm = { exports: {} }, Pa = {}, qm = { exports: {} }, vE = {};
var iT;
function oD() {
  return iT || (iT = 1, (function(M) {
    function j(Z, Re) {
      var ne = Z.length;
      Z.push(Re);
      e: for (; 0 < ne; ) {
        var _ = ne - 1 >>> 1, B = Z[_];
        if (0 < ht(B, Re)) Z[_] = Re, Z[ne] = B, ne = _;
        else break e;
      }
    }
    function D(Z) {
      return Z.length === 0 ? null : Z[0];
    }
    function Be(Z) {
      if (Z.length === 0) return null;
      var Re = Z[0], ne = Z.pop();
      if (ne !== Re) {
        Z[0] = ne;
        e: for (var _ = 0, B = Z.length, je = B >>> 1; _ < je; ) {
          var Ue = 2 * (_ + 1) - 1, rt = Z[Ue], Je = Ue + 1, Ke = Z[Je];
          if (0 > ht(rt, ne)) Je < B && 0 > ht(Ke, rt) ? (Z[_] = Ke, Z[Je] = ne, _ = Je) : (Z[_] = rt, Z[Ue] = ne, _ = Ue);
          else if (Je < B && 0 > ht(Ke, ne)) Z[_] = Ke, Z[Je] = ne, _ = Je;
          else break e;
        }
      }
      return Re;
    }
    function ht(Z, Re) {
      var ne = Z.sortIndex - Re.sortIndex;
      return ne !== 0 ? ne : Z.id - Re.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var _t = performance;
      M.unstable_now = function() {
        return _t.now();
      };
    } else {
      var S = Date, Pt = S.now();
      M.unstable_now = function() {
        return S.now() - Pt;
      };
    }
    var de = [], ve = [], ut = 1, ee = null, Ce = 3, ue = !1, Ye = !1, yt = !1, dt = typeof setTimeout == "function" ? setTimeout : null, cn = typeof clearTimeout == "function" ? clearTimeout : null, ft = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function Qe(Z) {
      for (var Re = D(ve); Re !== null; ) {
        if (Re.callback === null) Be(ve);
        else if (Re.startTime <= Z) Be(ve), Re.sortIndex = Re.expirationTime, j(de, Re);
        else break;
        Re = D(ve);
      }
    }
    function pt(Z) {
      if (yt = !1, Qe(Z), !Ye) if (D(de) !== null) Ye = !0, Dt(be);
      else {
        var Re = D(ve);
        Re !== null && Ee(pt, Re.startTime - Z);
      }
    }
    function be(Z, Re) {
      Ye = !1, yt && (yt = !1, cn(rn), rn = -1), ue = !0;
      var ne = Ce;
      try {
        for (Qe(Re), ee = D(de); ee !== null && (!(ee.expirationTime > Re) || Z && !an()); ) {
          var _ = ee.callback;
          if (typeof _ == "function") {
            ee.callback = null, Ce = ee.priorityLevel;
            var B = _(ee.expirationTime <= Re);
            Re = M.unstable_now(), typeof B == "function" ? ee.callback = B : ee === D(de) && Be(de), Qe(Re);
          } else Be(de);
          ee = D(de);
        }
        if (ee !== null) var je = !0;
        else {
          var Ue = D(ve);
          Ue !== null && Ee(pt, Ue.startTime - Re), je = !1;
        }
        return je;
      } finally {
        ee = null, Ce = ne, ue = !1;
      }
    }
    var ot = !1, Fe = null, rn = -1, Ft = 5, Kt = -1;
    function an() {
      return !(M.unstable_now() - Kt < Ft);
    }
    function wt() {
      if (Fe !== null) {
        var Z = M.unstable_now();
        Kt = Z;
        var Re = !0;
        try {
          Re = Fe(!0, Z);
        } finally {
          Re ? ke() : (ot = !1, Fe = null);
        }
      } else ot = !1;
    }
    var ke;
    if (typeof ft == "function") ke = function() {
      ft(wt);
    };
    else if (typeof MessageChannel < "u") {
      var Ut = new MessageChannel(), xt = Ut.port2;
      Ut.port1.onmessage = wt, ke = function() {
        xt.postMessage(null);
      };
    } else ke = function() {
      dt(wt, 0);
    };
    function Dt(Z) {
      Fe = Z, ot || (ot = !0, ke());
    }
    function Ee(Z, Re) {
      rn = dt(function() {
        Z(M.unstable_now());
      }, Re);
    }
    M.unstable_IdlePriority = 5, M.unstable_ImmediatePriority = 1, M.unstable_LowPriority = 4, M.unstable_NormalPriority = 3, M.unstable_Profiling = null, M.unstable_UserBlockingPriority = 2, M.unstable_cancelCallback = function(Z) {
      Z.callback = null;
    }, M.unstable_continueExecution = function() {
      Ye || ue || (Ye = !0, Dt(be));
    }, M.unstable_forceFrameRate = function(Z) {
      0 > Z || 125 < Z ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Ft = 0 < Z ? Math.floor(1e3 / Z) : 5;
    }, M.unstable_getCurrentPriorityLevel = function() {
      return Ce;
    }, M.unstable_getFirstCallbackNode = function() {
      return D(de);
    }, M.unstable_next = function(Z) {
      switch (Ce) {
        case 1:
        case 2:
        case 3:
          var Re = 3;
          break;
        default:
          Re = Ce;
      }
      var ne = Ce;
      Ce = Re;
      try {
        return Z();
      } finally {
        Ce = ne;
      }
    }, M.unstable_pauseExecution = function() {
    }, M.unstable_requestPaint = function() {
    }, M.unstable_runWithPriority = function(Z, Re) {
      switch (Z) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Z = 3;
      }
      var ne = Ce;
      Ce = Z;
      try {
        return Re();
      } finally {
        Ce = ne;
      }
    }, M.unstable_scheduleCallback = function(Z, Re, ne) {
      var _ = M.unstable_now();
      switch (typeof ne == "object" && ne !== null ? (ne = ne.delay, ne = typeof ne == "number" && 0 < ne ? _ + ne : _) : ne = _, Z) {
        case 1:
          var B = -1;
          break;
        case 2:
          B = 250;
          break;
        case 5:
          B = 1073741823;
          break;
        case 4:
          B = 1e4;
          break;
        default:
          B = 5e3;
      }
      return B = ne + B, Z = { id: ut++, callback: Re, priorityLevel: Z, startTime: ne, expirationTime: B, sortIndex: -1 }, ne > _ ? (Z.sortIndex = ne, j(ve, Z), D(de) === null && Z === D(ve) && (yt ? (cn(rn), rn = -1) : yt = !0, Ee(pt, ne - _))) : (Z.sortIndex = B, j(de, Z), Ye || ue || (Ye = !0, Dt(be))), Z;
    }, M.unstable_shouldYield = an, M.unstable_wrapCallback = function(Z) {
      var Re = Ce;
      return function() {
        var ne = Ce;
        Ce = Re;
        try {
          return Z.apply(this, arguments);
        } finally {
          Ce = ne;
        }
      };
    };
  })(vE)), vE;
}
var hE = {};
var lT;
function sD() {
  return lT || (lT = 1, (function(M) {
    process.env.NODE_ENV !== "production" && (function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var j = !1, D = 5;
      function Be(J, Te) {
        var tt = J.length;
        J.push(Te), S(J, Te, tt);
      }
      function ht(J) {
        return J.length === 0 ? null : J[0];
      }
      function _t(J) {
        if (J.length === 0)
          return null;
        var Te = J[0], tt = J.pop();
        return tt !== Te && (J[0] = tt, Pt(J, tt, 0)), Te;
      }
      function S(J, Te, tt) {
        for (var At = tt; At > 0; ) {
          var Zt = At - 1 >>> 1, pn = J[Zt];
          if (de(pn, Te) > 0)
            J[Zt] = Te, J[At] = pn, At = Zt;
          else
            return;
        }
      }
      function Pt(J, Te, tt) {
        for (var At = tt, Zt = J.length, pn = Zt >>> 1; At < pn; ) {
          var ln = (At + 1) * 2 - 1, qn = J[ln], Jt = ln + 1, Bt = J[Jt];
          if (de(qn, Te) < 0)
            Jt < Zt && de(Bt, qn) < 0 ? (J[At] = Bt, J[Jt] = Te, At = Jt) : (J[At] = qn, J[ln] = Te, At = ln);
          else if (Jt < Zt && de(Bt, Te) < 0)
            J[At] = Bt, J[Jt] = Te, At = Jt;
          else
            return;
        }
      }
      function de(J, Te) {
        var tt = J.sortIndex - Te.sortIndex;
        return tt !== 0 ? tt : J.id - Te.id;
      }
      var ve = 1, ut = 2, ee = 3, Ce = 4, ue = 5;
      function Ye(J, Te) {
      }
      var yt = typeof performance == "object" && typeof performance.now == "function";
      if (yt) {
        var dt = performance;
        M.unstable_now = function() {
          return dt.now();
        };
      } else {
        var cn = Date, ft = cn.now();
        M.unstable_now = function() {
          return cn.now() - ft;
        };
      }
      var Qe = 1073741823, pt = -1, be = 250, ot = 5e3, Fe = 1e4, rn = Qe, Ft = [], Kt = [], an = 1, wt = null, ke = ee, Ut = !1, xt = !1, Dt = !1, Ee = typeof setTimeout == "function" ? setTimeout : null, Z = typeof clearTimeout == "function" ? clearTimeout : null, Re = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ne(J) {
        for (var Te = ht(Kt); Te !== null; ) {
          if (Te.callback === null)
            _t(Kt);
          else if (Te.startTime <= J)
            _t(Kt), Te.sortIndex = Te.expirationTime, Be(Ft, Te);
          else
            return;
          Te = ht(Kt);
        }
      }
      function _(J) {
        if (Dt = !1, ne(J), !xt)
          if (ht(Ft) !== null)
            xt = !0, On(B);
          else {
            var Te = ht(Kt);
            Te !== null && gr(_, Te.startTime - J);
          }
      }
      function B(J, Te) {
        xt = !1, Dt && (Dt = !1, oa()), Ut = !0;
        var tt = ke;
        try {
          var At;
          if (!j) return je(J, Te);
        } finally {
          wt = null, ke = tt, Ut = !1;
        }
      }
      function je(J, Te) {
        var tt = Te;
        for (ne(tt), wt = ht(Ft); wt !== null && !(wt.expirationTime > tt && (!J || oi())); ) {
          var At = wt.callback;
          if (typeof At == "function") {
            wt.callback = null, ke = wt.priorityLevel;
            var Zt = wt.expirationTime <= tt, pn = At(Zt);
            tt = M.unstable_now(), typeof pn == "function" ? wt.callback = pn : wt === ht(Ft) && _t(Ft), ne(tt);
          } else
            _t(Ft);
          wt = ht(Ft);
        }
        if (wt !== null)
          return !0;
        var ln = ht(Kt);
        return ln !== null && gr(_, ln.startTime - tt), !1;
      }
      function Ue(J, Te) {
        switch (J) {
          case ve:
          case ut:
          case ee:
          case Ce:
          case ue:
            break;
          default:
            J = ee;
        }
        var tt = ke;
        ke = J;
        try {
          return Te();
        } finally {
          ke = tt;
        }
      }
      function rt(J) {
        var Te;
        switch (ke) {
          case ve:
          case ut:
          case ee:
            Te = ee;
            break;
          default:
            Te = ke;
            break;
        }
        var tt = ke;
        ke = Te;
        try {
          return J();
        } finally {
          ke = tt;
        }
      }
      function Je(J) {
        var Te = ke;
        return function() {
          var tt = ke;
          ke = Te;
          try {
            return J.apply(this, arguments);
          } finally {
            ke = tt;
          }
        };
      }
      function Ke(J, Te, tt) {
        var At = M.unstable_now(), Zt;
        if (typeof tt == "object" && tt !== null) {
          var pn = tt.delay;
          typeof pn == "number" && pn > 0 ? Zt = At + pn : Zt = At;
        } else
          Zt = At;
        var ln;
        switch (J) {
          case ve:
            ln = pt;
            break;
          case ut:
            ln = be;
            break;
          case ue:
            ln = rn;
            break;
          case Ce:
            ln = Fe;
            break;
          case ee:
          default:
            ln = ot;
            break;
        }
        var qn = Zt + ln, Jt = {
          id: an++,
          callback: Te,
          priorityLevel: J,
          startTime: Zt,
          expirationTime: qn,
          sortIndex: -1
        };
        return Zt > At ? (Jt.sortIndex = Zt, Be(Kt, Jt), ht(Ft) === null && Jt === ht(Kt) && (Dt ? oa() : Dt = !0, gr(_, Zt - At))) : (Jt.sortIndex = qn, Be(Ft, Jt), !xt && !Ut && (xt = !0, On(B))), Jt;
      }
      function et() {
      }
      function at() {
        !xt && !Ut && (xt = !0, On(B));
      }
      function Vt() {
        return ht(Ft);
      }
      function kn(J) {
        J.callback = null;
      }
      function wr() {
        return ke;
      }
      var En = !1, tr = null, Vn = -1, Pn = D, $r = -1;
      function oi() {
        var J = M.unstable_now() - $r;
        return !(J < Pn);
      }
      function ua() {
      }
      function Gn(J) {
        if (J < 0 || J > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        J > 0 ? Pn = Math.floor(1e3 / J) : Pn = D;
      }
      var Cn = function() {
        if (tr !== null) {
          var J = M.unstable_now();
          $r = J;
          var Te = !0, tt = !0;
          try {
            tt = tr(Te, J);
          } finally {
            tt ? Bn() : (En = !1, tr = null);
          }
        } else
          En = !1;
      }, Bn;
      if (typeof Re == "function")
        Bn = function() {
          Re(Cn);
        };
      else if (typeof MessageChannel < "u") {
        var yr = new MessageChannel(), $a = yr.port2;
        yr.port1.onmessage = Cn, Bn = function() {
          $a.postMessage(null);
        };
      } else
        Bn = function() {
          Ee(Cn, 0);
        };
      function On(J) {
        tr = J, En || (En = !0, Bn());
      }
      function gr(J, Te) {
        Vn = Ee(function() {
          J(M.unstable_now());
        }, Te);
      }
      function oa() {
        Z(Vn), Vn = -1;
      }
      var Ia = ua, si = null;
      M.unstable_IdlePriority = ue, M.unstable_ImmediatePriority = ve, M.unstable_LowPriority = Ce, M.unstable_NormalPriority = ee, M.unstable_Profiling = si, M.unstable_UserBlockingPriority = ut, M.unstable_cancelCallback = kn, M.unstable_continueExecution = at, M.unstable_forceFrameRate = Gn, M.unstable_getCurrentPriorityLevel = wr, M.unstable_getFirstCallbackNode = Vt, M.unstable_next = rt, M.unstable_pauseExecution = et, M.unstable_requestPaint = Ia, M.unstable_runWithPriority = Ue, M.unstable_scheduleCallback = Ke, M.unstable_shouldYield = oi, M.unstable_wrapCallback = Je, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    })();
  })(hE)), hE;
}
var uT;
function vT() {
  return uT || (uT = 1, process.env.NODE_ENV === "production" ? qm.exports = oD() : qm.exports = sD()), qm.exports;
}
var oT;
function cD() {
  if (oT) return Pa;
  oT = 1;
  var M = ev(), j = vT();
  function D(n) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, l = 1; l < arguments.length; l++) r += "&args[]=" + encodeURIComponent(arguments[l]);
    return "Minified React error #" + n + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var Be = /* @__PURE__ */ new Set(), ht = {};
  function _t(n, r) {
    S(n, r), S(n + "Capture", r);
  }
  function S(n, r) {
    for (ht[n] = r, n = 0; n < r.length; n++) Be.add(r[n]);
  }
  var Pt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), de = Object.prototype.hasOwnProperty, ve = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ut = {}, ee = {};
  function Ce(n) {
    return de.call(ee, n) ? !0 : de.call(ut, n) ? !1 : ve.test(n) ? ee[n] = !0 : (ut[n] = !0, !1);
  }
  function ue(n, r, l, o) {
    if (l !== null && l.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return o ? !1 : l !== null ? !l.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function Ye(n, r, l, o) {
    if (r === null || typeof r > "u" || ue(n, r, l, o)) return !0;
    if (o) return !1;
    if (l !== null) switch (l.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function yt(n, r, l, o, c, d, m) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = o, this.attributeNamespace = c, this.mustUseProperty = l, this.propertyName = n, this.type = r, this.sanitizeURL = d, this.removeEmptyString = m;
  }
  var dt = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    dt[n] = new yt(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var r = n[0];
    dt[r] = new yt(r, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    dt[n] = new yt(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    dt[n] = new yt(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    dt[n] = new yt(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    dt[n] = new yt(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    dt[n] = new yt(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    dt[n] = new yt(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    dt[n] = new yt(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var cn = /[\-:]([a-z])/g;
  function ft(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var r = n.replace(
      cn,
      ft
    );
    dt[r] = new yt(r, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var r = n.replace(cn, ft);
    dt[r] = new yt(r, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var r = n.replace(cn, ft);
    dt[r] = new yt(r, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    dt[n] = new yt(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), dt.xlinkHref = new yt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    dt[n] = new yt(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function Qe(n, r, l, o) {
    var c = dt.hasOwnProperty(r) ? dt[r] : null;
    (c !== null ? c.type !== 0 : o || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (Ye(r, l, c, o) && (l = null), o || c === null ? Ce(r) && (l === null ? n.removeAttribute(r) : n.setAttribute(r, "" + l)) : c.mustUseProperty ? n[c.propertyName] = l === null ? c.type === 3 ? !1 : "" : l : (r = c.attributeName, o = c.attributeNamespace, l === null ? n.removeAttribute(r) : (c = c.type, l = c === 3 || c === 4 && l === !0 ? "" : "" + l, o ? n.setAttributeNS(o, r, l) : n.setAttribute(r, l))));
  }
  var pt = M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, be = /* @__PURE__ */ Symbol.for("react.element"), ot = /* @__PURE__ */ Symbol.for("react.portal"), Fe = /* @__PURE__ */ Symbol.for("react.fragment"), rn = /* @__PURE__ */ Symbol.for("react.strict_mode"), Ft = /* @__PURE__ */ Symbol.for("react.profiler"), Kt = /* @__PURE__ */ Symbol.for("react.provider"), an = /* @__PURE__ */ Symbol.for("react.context"), wt = /* @__PURE__ */ Symbol.for("react.forward_ref"), ke = /* @__PURE__ */ Symbol.for("react.suspense"), Ut = /* @__PURE__ */ Symbol.for("react.suspense_list"), xt = /* @__PURE__ */ Symbol.for("react.memo"), Dt = /* @__PURE__ */ Symbol.for("react.lazy"), Ee = /* @__PURE__ */ Symbol.for("react.offscreen"), Z = Symbol.iterator;
  function Re(n) {
    return n === null || typeof n != "object" ? null : (n = Z && n[Z] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var ne = Object.assign, _;
  function B(n) {
    if (_ === void 0) try {
      throw Error();
    } catch (l) {
      var r = l.stack.trim().match(/\n( *(at )?)/);
      _ = r && r[1] || "";
    }
    return `
` + _ + n;
  }
  var je = !1;
  function Ue(n, r) {
    if (!n || je) return "";
    je = !0;
    var l = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (A) {
          var o = A;
        }
        Reflect.construct(n, [], r);
      } else {
        try {
          r.call();
        } catch (A) {
          o = A;
        }
        n.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (A) {
          o = A;
        }
        n();
      }
    } catch (A) {
      if (A && o && typeof A.stack == "string") {
        for (var c = A.stack.split(`
`), d = o.stack.split(`
`), m = c.length - 1, E = d.length - 1; 1 <= m && 0 <= E && c[m] !== d[E]; ) E--;
        for (; 1 <= m && 0 <= E; m--, E--) if (c[m] !== d[E]) {
          if (m !== 1 || E !== 1)
            do
              if (m--, E--, 0 > E || c[m] !== d[E]) {
                var T = `
` + c[m].replace(" at new ", " at ");
                return n.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", n.displayName)), T;
              }
            while (1 <= m && 0 <= E);
          break;
        }
      }
    } finally {
      je = !1, Error.prepareStackTrace = l;
    }
    return (n = n ? n.displayName || n.name : "") ? B(n) : "";
  }
  function rt(n) {
    switch (n.tag) {
      case 5:
        return B(n.type);
      case 16:
        return B("Lazy");
      case 13:
        return B("Suspense");
      case 19:
        return B("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = Ue(n.type, !1), n;
      case 11:
        return n = Ue(n.type.render, !1), n;
      case 1:
        return n = Ue(n.type, !0), n;
      default:
        return "";
    }
  }
  function Je(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case Fe:
        return "Fragment";
      case ot:
        return "Portal";
      case Ft:
        return "Profiler";
      case rn:
        return "StrictMode";
      case ke:
        return "Suspense";
      case Ut:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case an:
        return (n.displayName || "Context") + ".Consumer";
      case Kt:
        return (n._context.displayName || "Context") + ".Provider";
      case wt:
        var r = n.render;
        return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case xt:
        return r = n.displayName || null, r !== null ? r : Je(n.type) || "Memo";
      case Dt:
        r = n._payload, n = n._init;
        try {
          return Je(n(r));
        } catch {
        }
    }
    return null;
  }
  function Ke(n) {
    var r = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = r.render, n = n.displayName || n.name || "", r.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Je(r);
      case 8:
        return r === rn ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function et(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function at(n) {
    var r = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function Vt(n) {
    var r = at(n) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(n.constructor.prototype, r), o = "" + n[r];
    if (!n.hasOwnProperty(r) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var c = l.get, d = l.set;
      return Object.defineProperty(n, r, { configurable: !0, get: function() {
        return c.call(this);
      }, set: function(m) {
        o = "" + m, d.call(this, m);
      } }), Object.defineProperty(n, r, { enumerable: l.enumerable }), { getValue: function() {
        return o;
      }, setValue: function(m) {
        o = "" + m;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[r];
      } };
    }
  }
  function kn(n) {
    n._valueTracker || (n._valueTracker = Vt(n));
  }
  function wr(n) {
    if (!n) return !1;
    var r = n._valueTracker;
    if (!r) return !0;
    var l = r.getValue(), o = "";
    return n && (o = at(n) ? n.checked ? "true" : "false" : n.value), n = o, n !== l ? (r.setValue(n), !0) : !1;
  }
  function En(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  function tr(n, r) {
    var l = r.checked;
    return ne({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: l ?? n._wrapperState.initialChecked });
  }
  function Vn(n, r) {
    var l = r.defaultValue == null ? "" : r.defaultValue, o = r.checked != null ? r.checked : r.defaultChecked;
    l = et(r.value != null ? r.value : l), n._wrapperState = { initialChecked: o, initialValue: l, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function Pn(n, r) {
    r = r.checked, r != null && Qe(n, "checked", r, !1);
  }
  function $r(n, r) {
    Pn(n, r);
    var l = et(r.value), o = r.type;
    if (l != null) o === "number" ? (l === 0 && n.value === "" || n.value != l) && (n.value = "" + l) : n.value !== "" + l && (n.value = "" + l);
    else if (o === "submit" || o === "reset") {
      n.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? ua(n, r.type, l) : r.hasOwnProperty("defaultValue") && ua(n, r.type, et(r.defaultValue)), r.checked == null && r.defaultChecked != null && (n.defaultChecked = !!r.defaultChecked);
  }
  function oi(n, r, l) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var o = r.type;
      if (!(o !== "submit" && o !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + n._wrapperState.initialValue, l || r === n.value || (n.value = r), n.defaultValue = r;
    }
    l = n.name, l !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, l !== "" && (n.name = l);
  }
  function ua(n, r, l) {
    (r !== "number" || En(n.ownerDocument) !== n) && (l == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + l && (n.defaultValue = "" + l));
  }
  var Gn = Array.isArray;
  function Cn(n, r, l, o) {
    if (n = n.options, r) {
      r = {};
      for (var c = 0; c < l.length; c++) r["$" + l[c]] = !0;
      for (l = 0; l < n.length; l++) c = r.hasOwnProperty("$" + n[l].value), n[l].selected !== c && (n[l].selected = c), c && o && (n[l].defaultSelected = !0);
    } else {
      for (l = "" + et(l), r = null, c = 0; c < n.length; c++) {
        if (n[c].value === l) {
          n[c].selected = !0, o && (n[c].defaultSelected = !0);
          return;
        }
        r !== null || n[c].disabled || (r = n[c]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function Bn(n, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(D(91));
    return ne({}, r, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function yr(n, r) {
    var l = r.value;
    if (l == null) {
      if (l = r.children, r = r.defaultValue, l != null) {
        if (r != null) throw Error(D(92));
        if (Gn(l)) {
          if (1 < l.length) throw Error(D(93));
          l = l[0];
        }
        r = l;
      }
      r == null && (r = ""), l = r;
    }
    n._wrapperState = { initialValue: et(l) };
  }
  function $a(n, r) {
    var l = et(r.value), o = et(r.defaultValue);
    l != null && (l = "" + l, l !== n.value && (n.value = l), r.defaultValue == null && n.defaultValue !== l && (n.defaultValue = l)), o != null && (n.defaultValue = "" + o);
  }
  function On(n) {
    var r = n.textContent;
    r === n._wrapperState.initialValue && r !== "" && r !== null && (n.value = r);
  }
  function gr(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function oa(n, r) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? gr(r) : n === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var Ia, si = (function(n) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, l, o, c) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(r, l, o, c);
      });
    } : n;
  })(function(n, r) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = r;
    else {
      for (Ia = Ia || document.createElement("div"), Ia.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Ia.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; r.firstChild; ) n.appendChild(r.firstChild);
    }
  });
  function J(n, r) {
    if (r) {
      var l = n.firstChild;
      if (l && l === n.lastChild && l.nodeType === 3) {
        l.nodeValue = r;
        return;
      }
    }
    n.textContent = r;
  }
  var Te = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, tt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Te).forEach(function(n) {
    tt.forEach(function(r) {
      r = r + n.charAt(0).toUpperCase() + n.substring(1), Te[r] = Te[n];
    });
  });
  function At(n, r, l) {
    return r == null || typeof r == "boolean" || r === "" ? "" : l || typeof r != "number" || r === 0 || Te.hasOwnProperty(n) && Te[n] ? ("" + r).trim() : r + "px";
  }
  function Zt(n, r) {
    n = n.style;
    for (var l in r) if (r.hasOwnProperty(l)) {
      var o = l.indexOf("--") === 0, c = At(l, r[l], o);
      l === "float" && (l = "cssFloat"), o ? n.setProperty(l, c) : n[l] = c;
    }
  }
  var pn = ne({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function ln(n, r) {
    if (r) {
      if (pn[n] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(D(137, n));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(D(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(D(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(D(62));
    }
  }
  function qn(n, r) {
    if (n.indexOf("-") === -1) return typeof r.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Jt = null;
  function Bt(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var $t = null, sa = null, Sr = null;
  function Ra(n) {
    if (n = _e(n)) {
      if (typeof $t != "function") throw Error(D(280));
      var r = n.stateNode;
      r && (r = hn(r), $t(n.stateNode, n.type, r));
    }
  }
  function Fi(n) {
    sa ? Sr ? Sr.push(n) : Sr = [n] : sa = n;
  }
  function Kl() {
    if (sa) {
      var n = sa, r = Sr;
      if (Sr = sa = null, Ra(n), r) for (n = 0; n < r.length; n++) Ra(r[n]);
    }
  }
  function Zl(n, r) {
    return n(r);
  }
  function fl() {
  }
  var dl = !1;
  function Jl(n, r, l) {
    if (dl) return n(r, l);
    dl = !0;
    try {
      return Zl(n, r, l);
    } finally {
      dl = !1, (sa !== null || Sr !== null) && (fl(), Kl());
    }
  }
  function xr(n, r) {
    var l = n.stateNode;
    if (l === null) return null;
    var o = hn(l);
    if (o === null) return null;
    l = o[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (o = !o.disabled) || (n = n.type, o = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !o;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (l && typeof l != "function") throw Error(D(231, r, typeof l));
    return l;
  }
  var br = !1;
  if (Pt) try {
    var nr = {};
    Object.defineProperty(nr, "passive", { get: function() {
      br = !0;
    } }), window.addEventListener("test", nr, nr), window.removeEventListener("test", nr, nr);
  } catch {
    br = !1;
  }
  function ci(n, r, l, o, c, d, m, E, T) {
    var A = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(l, A);
    } catch (W) {
      this.onError(W);
    }
  }
  var Ya = !1, fi = null, di = !1, R = null, I = { onError: function(n) {
    Ya = !0, fi = n;
  } };
  function ae(n, r, l, o, c, d, m, E, T) {
    Ya = !1, fi = null, ci.apply(I, arguments);
  }
  function he(n, r, l, o, c, d, m, E, T) {
    if (ae.apply(this, arguments), Ya) {
      if (Ya) {
        var A = fi;
        Ya = !1, fi = null;
      } else throw Error(D(198));
      di || (di = !0, R = A);
    }
  }
  function Ge(n) {
    var r = n, l = n;
    if (n.alternate) for (; r.return; ) r = r.return;
    else {
      n = r;
      do
        r = n, (r.flags & 4098) !== 0 && (l = r.return), n = r.return;
      while (n);
    }
    return r.tag === 3 ? l : null;
  }
  function $e(n) {
    if (n.tag === 13) {
      var r = n.memoizedState;
      if (r === null && (n = n.alternate, n !== null && (r = n.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function st(n) {
    if (Ge(n) !== n) throw Error(D(188));
  }
  function it(n) {
    var r = n.alternate;
    if (!r) {
      if (r = Ge(n), r === null) throw Error(D(188));
      return r !== n ? null : n;
    }
    for (var l = n, o = r; ; ) {
      var c = l.return;
      if (c === null) break;
      var d = c.alternate;
      if (d === null) {
        if (o = c.return, o !== null) {
          l = o;
          continue;
        }
        break;
      }
      if (c.child === d.child) {
        for (d = c.child; d; ) {
          if (d === l) return st(c), n;
          if (d === o) return st(c), r;
          d = d.sibling;
        }
        throw Error(D(188));
      }
      if (l.return !== o.return) l = c, o = d;
      else {
        for (var m = !1, E = c.child; E; ) {
          if (E === l) {
            m = !0, l = c, o = d;
            break;
          }
          if (E === o) {
            m = !0, o = c, l = d;
            break;
          }
          E = E.sibling;
        }
        if (!m) {
          for (E = d.child; E; ) {
            if (E === l) {
              m = !0, l = d, o = c;
              break;
            }
            if (E === o) {
              m = !0, o = d, l = c;
              break;
            }
            E = E.sibling;
          }
          if (!m) throw Error(D(189));
        }
      }
      if (l.alternate !== o) throw Error(D(190));
    }
    if (l.tag !== 3) throw Error(D(188));
    return l.stateNode.current === l ? n : r;
  }
  function Rn(n) {
    return n = it(n), n !== null ? en(n) : null;
  }
  function en(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var r = en(n);
      if (r !== null) return r;
      n = n.sibling;
    }
    return null;
  }
  var un = j.unstable_scheduleCallback, rr = j.unstable_cancelCallback, Qa = j.unstable_shouldYield, Wa = j.unstable_requestPaint, qe = j.unstable_now, Ze = j.unstable_getCurrentPriorityLevel, Ga = j.unstable_ImmediatePriority, eu = j.unstable_UserBlockingPriority, tu = j.unstable_NormalPriority, pl = j.unstable_LowPriority, Yu = j.unstable_IdlePriority, vl = null, Ir = null;
  function $o(n) {
    if (Ir && typeof Ir.onCommitFiberRoot == "function") try {
      Ir.onCommitFiberRoot(vl, n, void 0, (n.current.flags & 128) === 128);
    } catch {
    }
  }
  var _r = Math.clz32 ? Math.clz32 : Qu, ic = Math.log, lc = Math.LN2;
  function Qu(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (ic(n) / lc | 0) | 0;
  }
  var hl = 64, ca = 4194304;
  function qa(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function Xa(n, r) {
    var l = n.pendingLanes;
    if (l === 0) return 0;
    var o = 0, c = n.suspendedLanes, d = n.pingedLanes, m = l & 268435455;
    if (m !== 0) {
      var E = m & ~c;
      E !== 0 ? o = qa(E) : (d &= m, d !== 0 && (o = qa(d)));
    } else m = l & ~c, m !== 0 ? o = qa(m) : d !== 0 && (o = qa(d));
    if (o === 0) return 0;
    if (r !== 0 && r !== o && (r & c) === 0 && (c = o & -o, d = r & -r, c >= d || c === 16 && (d & 4194240) !== 0)) return r;
    if ((o & 4) !== 0 && (o |= l & 16), r = n.entangledLanes, r !== 0) for (n = n.entanglements, r &= o; 0 < r; ) l = 31 - _r(r), c = 1 << l, o |= n[l], r &= ~c;
    return o;
  }
  function Wu(n, r) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function nu(n, r) {
    for (var l = n.suspendedLanes, o = n.pingedLanes, c = n.expirationTimes, d = n.pendingLanes; 0 < d; ) {
      var m = 31 - _r(d), E = 1 << m, T = c[m];
      T === -1 ? ((E & l) === 0 || (E & o) !== 0) && (c[m] = Wu(E, r)) : T <= r && (n.expiredLanes |= E), d &= ~E;
    }
  }
  function ml(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function Gu() {
    var n = hl;
    return hl <<= 1, (hl & 4194240) === 0 && (hl = 64), n;
  }
  function qu(n) {
    for (var r = [], l = 0; 31 > l; l++) r.push(n);
    return r;
  }
  function ji(n, r, l) {
    n.pendingLanes |= r, r !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, r = 31 - _r(r), n[r] = l;
  }
  function Qf(n, r) {
    var l = n.pendingLanes & ~r;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r, r = n.entanglements;
    var o = n.eventTimes;
    for (n = n.expirationTimes; 0 < l; ) {
      var c = 31 - _r(l), d = 1 << c;
      r[c] = 0, o[c] = -1, n[c] = -1, l &= ~d;
    }
  }
  function Hi(n, r) {
    var l = n.entangledLanes |= r;
    for (n = n.entanglements; l; ) {
      var o = 31 - _r(l), c = 1 << o;
      c & r | n[o] & r && (n[o] |= r), l &= ~c;
    }
  }
  var kt = 0;
  function Xu(n) {
    return n &= -n, 1 < n ? 4 < n ? (n & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var Rt, Io, pi, Pe, Ku, ar = !1, vi = [], Dr = null, hi = null, on = null, It = /* @__PURE__ */ new Map(), yl = /* @__PURE__ */ new Map(), $n = [], kr = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Ta(n, r) {
    switch (n) {
      case "focusin":
      case "focusout":
        Dr = null;
        break;
      case "dragenter":
      case "dragleave":
        hi = null;
        break;
      case "mouseover":
      case "mouseout":
        on = null;
        break;
      case "pointerover":
      case "pointerout":
        It.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        yl.delete(r.pointerId);
    }
  }
  function ru(n, r, l, o, c, d) {
    return n === null || n.nativeEvent !== d ? (n = { blockedOn: r, domEventName: l, eventSystemFlags: o, nativeEvent: d, targetContainers: [c] }, r !== null && (r = _e(r), r !== null && Io(r)), n) : (n.eventSystemFlags |= o, r = n.targetContainers, c !== null && r.indexOf(c) === -1 && r.push(c), n);
  }
  function Yo(n, r, l, o, c) {
    switch (r) {
      case "focusin":
        return Dr = ru(Dr, n, r, l, o, c), !0;
      case "dragenter":
        return hi = ru(hi, n, r, l, o, c), !0;
      case "mouseover":
        return on = ru(on, n, r, l, o, c), !0;
      case "pointerover":
        var d = c.pointerId;
        return It.set(d, ru(It.get(d) || null, n, r, l, o, c)), !0;
      case "gotpointercapture":
        return d = c.pointerId, yl.set(d, ru(yl.get(d) || null, n, r, l, o, c)), !0;
    }
    return !1;
  }
  function Qo(n) {
    var r = du(n.target);
    if (r !== null) {
      var l = Ge(r);
      if (l !== null) {
        if (r = l.tag, r === 13) {
          if (r = $e(l), r !== null) {
            n.blockedOn = r, Ku(n.priority, function() {
              pi(l);
            });
            return;
          }
        } else if (r === 3 && l.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = l.tag === 3 ? l.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function gl(n) {
    if (n.blockedOn !== null) return !1;
    for (var r = n.targetContainers; 0 < r.length; ) {
      var l = eo(n.domEventName, n.eventSystemFlags, r[0], n.nativeEvent);
      if (l === null) {
        l = n.nativeEvent;
        var o = new l.constructor(l.type, l);
        Jt = o, l.target.dispatchEvent(o), Jt = null;
      } else return r = _e(l), r !== null && Io(r), n.blockedOn = l, !1;
      r.shift();
    }
    return !0;
  }
  function au(n, r, l) {
    gl(n) && l.delete(r);
  }
  function Wf() {
    ar = !1, Dr !== null && gl(Dr) && (Dr = null), hi !== null && gl(hi) && (hi = null), on !== null && gl(on) && (on = null), It.forEach(au), yl.forEach(au);
  }
  function wa(n, r) {
    n.blockedOn === r && (n.blockedOn = null, ar || (ar = !0, j.unstable_scheduleCallback(j.unstable_NormalPriority, Wf)));
  }
  function Ka(n) {
    function r(c) {
      return wa(c, n);
    }
    if (0 < vi.length) {
      wa(vi[0], n);
      for (var l = 1; l < vi.length; l++) {
        var o = vi[l];
        o.blockedOn === n && (o.blockedOn = null);
      }
    }
    for (Dr !== null && wa(Dr, n), hi !== null && wa(hi, n), on !== null && wa(on, n), It.forEach(r), yl.forEach(r), l = 0; l < $n.length; l++) o = $n[l], o.blockedOn === n && (o.blockedOn = null);
    for (; 0 < $n.length && (l = $n[0], l.blockedOn === null); ) Qo(l), l.blockedOn === null && $n.shift();
  }
  var mi = pt.ReactCurrentBatchConfig, xa = !0;
  function Zu(n, r, l, o) {
    var c = kt, d = mi.transition;
    mi.transition = null;
    try {
      kt = 1, Sl(n, r, l, o);
    } finally {
      kt = c, mi.transition = d;
    }
  }
  function Ju(n, r, l, o) {
    var c = kt, d = mi.transition;
    mi.transition = null;
    try {
      kt = 4, Sl(n, r, l, o);
    } finally {
      kt = c, mi.transition = d;
    }
  }
  function Sl(n, r, l, o) {
    if (xa) {
      var c = eo(n, r, l, o);
      if (c === null) gc(n, r, o, iu, l), Ta(n, o);
      else if (Yo(c, n, r, l, o)) o.stopPropagation();
      else if (Ta(n, o), r & 4 && -1 < kr.indexOf(n)) {
        for (; c !== null; ) {
          var d = _e(c);
          if (d !== null && Rt(d), d = eo(n, r, l, o), d === null && gc(n, r, o, iu, l), d === c) break;
          c = d;
        }
        c !== null && o.stopPropagation();
      } else gc(n, r, o, null, l);
    }
  }
  var iu = null;
  function eo(n, r, l, o) {
    if (iu = null, n = Bt(o), n = du(n), n !== null) if (r = Ge(n), r === null) n = null;
    else if (l = r.tag, l === 13) {
      if (n = $e(r), n !== null) return n;
      n = null;
    } else if (l === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      n = null;
    } else r !== n && (n = null);
    return iu = n, null;
  }
  function to(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Ze()) {
          case Ga:
            return 1;
          case eu:
            return 4;
          case tu:
          case pl:
            return 16;
          case Yu:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Za = null, h = null, C = null;
  function U() {
    if (C) return C;
    var n, r = h, l = r.length, o, c = "value" in Za ? Za.value : Za.textContent, d = c.length;
    for (n = 0; n < l && r[n] === c[n]; n++) ;
    var m = l - n;
    for (o = 1; o <= m && r[l - o] === c[d - o]; o++) ;
    return C = c.slice(n, 1 < o ? 1 - o : void 0);
  }
  function H(n) {
    var r = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && r === 13 && (n = 13)) : n = r, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function K() {
    return !0;
  }
  function Oe() {
    return !1;
  }
  function re(n) {
    function r(l, o, c, d, m) {
      this._reactName = l, this._targetInst = c, this.type = o, this.nativeEvent = d, this.target = m, this.currentTarget = null;
      for (var E in n) n.hasOwnProperty(E) && (l = n[E], this[E] = l ? l(d) : d[E]);
      return this.isDefaultPrevented = (d.defaultPrevented != null ? d.defaultPrevented : d.returnValue === !1) ? K : Oe, this.isPropagationStopped = Oe, this;
    }
    return ne(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var l = this.nativeEvent;
      l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = K);
    }, stopPropagation: function() {
      var l = this.nativeEvent;
      l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = K);
    }, persist: function() {
    }, isPersistent: K }), r;
  }
  var Ne = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, ct = re(Ne), Tt = ne({}, Ne, { view: 0, detail: 0 }), tn = re(Tt), Yt, nt, Qt, vn = ne({}, Tt, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Zf, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== Qt && (Qt && n.type === "mousemove" ? (Yt = n.screenX - Qt.screenX, nt = n.screenY - Qt.screenY) : nt = Yt = 0, Qt = n), Yt);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : nt;
  } }), El = re(vn), Wo = ne({}, vn, { dataTransfer: 0 }), Vi = re(Wo), Go = ne({}, Tt, { relatedTarget: 0 }), lu = re(Go), Gf = ne({}, Ne, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), uc = re(Gf), qf = ne({}, Ne, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), tv = re(qf), Xf = ne({}, Ne, { data: 0 }), Kf = re(Xf), nv = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, rv = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Zm = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Pi(n) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(n) : (n = Zm[n]) ? !!r[n] : !1;
  }
  function Zf() {
    return Pi;
  }
  var Jf = ne({}, Tt, { key: function(n) {
    if (n.key) {
      var r = nv[n.key] || n.key;
      if (r !== "Unidentified") return r;
    }
    return n.type === "keypress" ? (n = H(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? rv[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Zf, charCode: function(n) {
    return n.type === "keypress" ? H(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? H(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), ed = re(Jf), td = ne({}, vn, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), av = re(td), oc = ne({}, Tt, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Zf }), iv = re(oc), Yr = ne({}, Ne, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Bi = re(Yr), Ln = ne({}, vn, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), $i = re(Ln), nd = [9, 13, 27, 32], no = Pt && "CompositionEvent" in window, qo = null;
  Pt && "documentMode" in document && (qo = document.documentMode);
  var Xo = Pt && "TextEvent" in window && !qo, lv = Pt && (!no || qo && 8 < qo && 11 >= qo), uv = " ", sc = !1;
  function ov(n, r) {
    switch (n) {
      case "keyup":
        return nd.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function sv(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var ro = !1;
  function cv(n, r) {
    switch (n) {
      case "compositionend":
        return sv(r);
      case "keypress":
        return r.which !== 32 ? null : (sc = !0, uv);
      case "textInput":
        return n = r.data, n === uv && sc ? null : n;
      default:
        return null;
    }
  }
  function Jm(n, r) {
    if (ro) return n === "compositionend" || !no && ov(n, r) ? (n = U(), C = h = Za = null, ro = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return lv && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var ey = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function fv(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r === "input" ? !!ey[n.type] : r === "textarea";
  }
  function rd(n, r, l, o) {
    Fi(o), r = ns(r, "onChange"), 0 < r.length && (l = new ct("onChange", "change", null, l, o), n.push({ event: l, listeners: r }));
  }
  var yi = null, uu = null;
  function dv(n) {
    cu(n, 0);
  }
  function Ko(n) {
    var r = ei(n);
    if (wr(r)) return n;
  }
  function ty(n, r) {
    if (n === "change") return r;
  }
  var pv = !1;
  if (Pt) {
    var ad;
    if (Pt) {
      var id = "oninput" in document;
      if (!id) {
        var vv = document.createElement("div");
        vv.setAttribute("oninput", "return;"), id = typeof vv.oninput == "function";
      }
      ad = id;
    } else ad = !1;
    pv = ad && (!document.documentMode || 9 < document.documentMode);
  }
  function hv() {
    yi && (yi.detachEvent("onpropertychange", mv), uu = yi = null);
  }
  function mv(n) {
    if (n.propertyName === "value" && Ko(uu)) {
      var r = [];
      rd(r, uu, n, Bt(n)), Jl(dv, r);
    }
  }
  function ny(n, r, l) {
    n === "focusin" ? (hv(), yi = r, uu = l, yi.attachEvent("onpropertychange", mv)) : n === "focusout" && hv();
  }
  function yv(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return Ko(uu);
  }
  function ry(n, r) {
    if (n === "click") return Ko(r);
  }
  function gv(n, r) {
    if (n === "input" || n === "change") return Ko(r);
  }
  function ay(n, r) {
    return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
  }
  var Ja = typeof Object.is == "function" ? Object.is : ay;
  function Zo(n, r) {
    if (Ja(n, r)) return !0;
    if (typeof n != "object" || n === null || typeof r != "object" || r === null) return !1;
    var l = Object.keys(n), o = Object.keys(r);
    if (l.length !== o.length) return !1;
    for (o = 0; o < l.length; o++) {
      var c = l[o];
      if (!de.call(r, c) || !Ja(n[c], r[c])) return !1;
    }
    return !0;
  }
  function Sv(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function cc(n, r) {
    var l = Sv(n);
    n = 0;
    for (var o; l; ) {
      if (l.nodeType === 3) {
        if (o = n + l.textContent.length, n <= r && o >= r) return { node: l, offset: r - n };
        n = o;
      }
      e: {
        for (; l; ) {
          if (l.nextSibling) {
            l = l.nextSibling;
            break e;
          }
          l = l.parentNode;
        }
        l = void 0;
      }
      l = Sv(l);
    }
  }
  function Cl(n, r) {
    return n && r ? n === r ? !0 : n && n.nodeType === 3 ? !1 : r && r.nodeType === 3 ? Cl(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function Jo() {
    for (var n = window, r = En(); r instanceof n.HTMLIFrameElement; ) {
      try {
        var l = typeof r.contentWindow.location.href == "string";
      } catch {
        l = !1;
      }
      if (l) n = r.contentWindow;
      else break;
      r = En(n.document);
    }
    return r;
  }
  function fc(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
  }
  function ao(n) {
    var r = Jo(), l = n.focusedElem, o = n.selectionRange;
    if (r !== l && l && l.ownerDocument && Cl(l.ownerDocument.documentElement, l)) {
      if (o !== null && fc(l)) {
        if (r = o.start, n = o.end, n === void 0 && (n = r), "selectionStart" in l) l.selectionStart = r, l.selectionEnd = Math.min(n, l.value.length);
        else if (n = (r = l.ownerDocument || document) && r.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var c = l.textContent.length, d = Math.min(o.start, c);
          o = o.end === void 0 ? d : Math.min(o.end, c), !n.extend && d > o && (c = o, o = d, d = c), c = cc(l, d);
          var m = cc(
            l,
            o
          );
          c && m && (n.rangeCount !== 1 || n.anchorNode !== c.node || n.anchorOffset !== c.offset || n.focusNode !== m.node || n.focusOffset !== m.offset) && (r = r.createRange(), r.setStart(c.node, c.offset), n.removeAllRanges(), d > o ? (n.addRange(r), n.extend(m.node, m.offset)) : (r.setEnd(m.node, m.offset), n.addRange(r)));
        }
      }
      for (r = [], n = l; n = n.parentNode; ) n.nodeType === 1 && r.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof l.focus == "function" && l.focus(), l = 0; l < r.length; l++) n = r[l], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var iy = Pt && "documentMode" in document && 11 >= document.documentMode, io = null, ld = null, es = null, ud = !1;
  function od(n, r, l) {
    var o = l.window === l ? l.document : l.nodeType === 9 ? l : l.ownerDocument;
    ud || io == null || io !== En(o) || (o = io, "selectionStart" in o && fc(o) ? o = { start: o.selectionStart, end: o.selectionEnd } : (o = (o.ownerDocument && o.ownerDocument.defaultView || window).getSelection(), o = { anchorNode: o.anchorNode, anchorOffset: o.anchorOffset, focusNode: o.focusNode, focusOffset: o.focusOffset }), es && Zo(es, o) || (es = o, o = ns(ld, "onSelect"), 0 < o.length && (r = new ct("onSelect", "select", null, r, l), n.push({ event: r, listeners: o }), r.target = io)));
  }
  function dc(n, r) {
    var l = {};
    return l[n.toLowerCase()] = r.toLowerCase(), l["Webkit" + n] = "webkit" + r, l["Moz" + n] = "moz" + r, l;
  }
  var ou = { animationend: dc("Animation", "AnimationEnd"), animationiteration: dc("Animation", "AnimationIteration"), animationstart: dc("Animation", "AnimationStart"), transitionend: dc("Transition", "TransitionEnd") }, ir = {}, sd = {};
  Pt && (sd = document.createElement("div").style, "AnimationEvent" in window || (delete ou.animationend.animation, delete ou.animationiteration.animation, delete ou.animationstart.animation), "TransitionEvent" in window || delete ou.transitionend.transition);
  function pc(n) {
    if (ir[n]) return ir[n];
    if (!ou[n]) return n;
    var r = ou[n], l;
    for (l in r) if (r.hasOwnProperty(l) && l in sd) return ir[n] = r[l];
    return n;
  }
  var Ev = pc("animationend"), Cv = pc("animationiteration"), Rv = pc("animationstart"), Tv = pc("transitionend"), cd = /* @__PURE__ */ new Map(), vc = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ba(n, r) {
    cd.set(n, r), _t(r, [n]);
  }
  for (var fd = 0; fd < vc.length; fd++) {
    var su = vc[fd], ly = su.toLowerCase(), uy = su[0].toUpperCase() + su.slice(1);
    ba(ly, "on" + uy);
  }
  ba(Ev, "onAnimationEnd"), ba(Cv, "onAnimationIteration"), ba(Rv, "onAnimationStart"), ba("dblclick", "onDoubleClick"), ba("focusin", "onFocus"), ba("focusout", "onBlur"), ba(Tv, "onTransitionEnd"), S("onMouseEnter", ["mouseout", "mouseover"]), S("onMouseLeave", ["mouseout", "mouseover"]), S("onPointerEnter", ["pointerout", "pointerover"]), S("onPointerLeave", ["pointerout", "pointerover"]), _t("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), _t("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), _t("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), _t("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), _t("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), _t("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var ts = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), dd = new Set("cancel close invalid load scroll toggle".split(" ").concat(ts));
  function hc(n, r, l) {
    var o = n.type || "unknown-event";
    n.currentTarget = l, he(o, r, void 0, n), n.currentTarget = null;
  }
  function cu(n, r) {
    r = (r & 4) !== 0;
    for (var l = 0; l < n.length; l++) {
      var o = n[l], c = o.event;
      o = o.listeners;
      e: {
        var d = void 0;
        if (r) for (var m = o.length - 1; 0 <= m; m--) {
          var E = o[m], T = E.instance, A = E.currentTarget;
          if (E = E.listener, T !== d && c.isPropagationStopped()) break e;
          hc(c, E, A), d = T;
        }
        else for (m = 0; m < o.length; m++) {
          if (E = o[m], T = E.instance, A = E.currentTarget, E = E.listener, T !== d && c.isPropagationStopped()) break e;
          hc(c, E, A), d = T;
        }
      }
    }
    if (di) throw n = R, di = !1, R = null, n;
  }
  function jt(n, r) {
    var l = r[is];
    l === void 0 && (l = r[is] = /* @__PURE__ */ new Set());
    var o = n + "__bubble";
    l.has(o) || (wv(r, n, 2, !1), l.add(o));
  }
  function mc(n, r, l) {
    var o = 0;
    r && (o |= 4), wv(l, n, o, r);
  }
  var yc = "_reactListening" + Math.random().toString(36).slice(2);
  function lo(n) {
    if (!n[yc]) {
      n[yc] = !0, Be.forEach(function(l) {
        l !== "selectionchange" && (dd.has(l) || mc(l, !1, n), mc(l, !0, n));
      });
      var r = n.nodeType === 9 ? n : n.ownerDocument;
      r === null || r[yc] || (r[yc] = !0, mc("selectionchange", !1, r));
    }
  }
  function wv(n, r, l, o) {
    switch (to(r)) {
      case 1:
        var c = Zu;
        break;
      case 4:
        c = Ju;
        break;
      default:
        c = Sl;
    }
    l = c.bind(null, r, l, n), c = void 0, !br || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (c = !0), o ? c !== void 0 ? n.addEventListener(r, l, { capture: !0, passive: c }) : n.addEventListener(r, l, !0) : c !== void 0 ? n.addEventListener(r, l, { passive: c }) : n.addEventListener(r, l, !1);
  }
  function gc(n, r, l, o, c) {
    var d = o;
    if ((r & 1) === 0 && (r & 2) === 0 && o !== null) e: for (; ; ) {
      if (o === null) return;
      var m = o.tag;
      if (m === 3 || m === 4) {
        var E = o.stateNode.containerInfo;
        if (E === c || E.nodeType === 8 && E.parentNode === c) break;
        if (m === 4) for (m = o.return; m !== null; ) {
          var T = m.tag;
          if ((T === 3 || T === 4) && (T = m.stateNode.containerInfo, T === c || T.nodeType === 8 && T.parentNode === c)) return;
          m = m.return;
        }
        for (; E !== null; ) {
          if (m = du(E), m === null) return;
          if (T = m.tag, T === 5 || T === 6) {
            o = d = m;
            continue e;
          }
          E = E.parentNode;
        }
      }
      o = o.return;
    }
    Jl(function() {
      var A = d, W = Bt(l), q = [];
      e: {
        var Q = cd.get(n);
        if (Q !== void 0) {
          var se = ct, me = n;
          switch (n) {
            case "keypress":
              if (H(l) === 0) break e;
            case "keydown":
            case "keyup":
              se = ed;
              break;
            case "focusin":
              me = "focus", se = lu;
              break;
            case "focusout":
              me = "blur", se = lu;
              break;
            case "beforeblur":
            case "afterblur":
              se = lu;
              break;
            case "click":
              if (l.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              se = El;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              se = Vi;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              se = iv;
              break;
            case Ev:
            case Cv:
            case Rv:
              se = uc;
              break;
            case Tv:
              se = Bi;
              break;
            case "scroll":
              se = tn;
              break;
            case "wheel":
              se = $i;
              break;
            case "copy":
            case "cut":
            case "paste":
              se = tv;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              se = av;
          }
          var Se = (r & 4) !== 0, _n = !Se && n === "scroll", k = Se ? Q !== null ? Q + "Capture" : null : Q;
          Se = [];
          for (var x = A, N; x !== null; ) {
            N = x;
            var G = N.stateNode;
            if (N.tag === 5 && G !== null && (N = G, k !== null && (G = xr(x, k), G != null && Se.push(uo(x, G, N)))), _n) break;
            x = x.return;
          }
          0 < Se.length && (Q = new se(Q, me, null, l, W), q.push({ event: Q, listeners: Se }));
        }
      }
      if ((r & 7) === 0) {
        e: {
          if (Q = n === "mouseover" || n === "pointerover", se = n === "mouseout" || n === "pointerout", Q && l !== Jt && (me = l.relatedTarget || l.fromElement) && (du(me) || me[Ii])) break e;
          if ((se || Q) && (Q = W.window === W ? W : (Q = W.ownerDocument) ? Q.defaultView || Q.parentWindow : window, se ? (me = l.relatedTarget || l.toElement, se = A, me = me ? du(me) : null, me !== null && (_n = Ge(me), me !== _n || me.tag !== 5 && me.tag !== 6) && (me = null)) : (se = null, me = A), se !== me)) {
            if (Se = El, G = "onMouseLeave", k = "onMouseEnter", x = "mouse", (n === "pointerout" || n === "pointerover") && (Se = av, G = "onPointerLeave", k = "onPointerEnter", x = "pointer"), _n = se == null ? Q : ei(se), N = me == null ? Q : ei(me), Q = new Se(G, x + "leave", se, l, W), Q.target = _n, Q.relatedTarget = N, G = null, du(W) === A && (Se = new Se(k, x + "enter", me, l, W), Se.target = N, Se.relatedTarget = _n, G = Se), _n = G, se && me) t: {
              for (Se = se, k = me, x = 0, N = Se; N; N = Rl(N)) x++;
              for (N = 0, G = k; G; G = Rl(G)) N++;
              for (; 0 < x - N; ) Se = Rl(Se), x--;
              for (; 0 < N - x; ) k = Rl(k), N--;
              for (; x--; ) {
                if (Se === k || k !== null && Se === k.alternate) break t;
                Se = Rl(Se), k = Rl(k);
              }
              Se = null;
            }
            else Se = null;
            se !== null && xv(q, Q, se, Se, !1), me !== null && _n !== null && xv(q, _n, me, Se, !0);
          }
        }
        e: {
          if (Q = A ? ei(A) : window, se = Q.nodeName && Q.nodeName.toLowerCase(), se === "select" || se === "input" && Q.type === "file") var ye = ty;
          else if (fv(Q)) if (pv) ye = gv;
          else {
            ye = yv;
            var Me = ny;
          }
          else (se = Q.nodeName) && se.toLowerCase() === "input" && (Q.type === "checkbox" || Q.type === "radio") && (ye = ry);
          if (ye && (ye = ye(n, A))) {
            rd(q, ye, l, W);
            break e;
          }
          Me && Me(n, Q, A), n === "focusout" && (Me = Q._wrapperState) && Me.controlled && Q.type === "number" && ua(Q, "number", Q.value);
        }
        switch (Me = A ? ei(A) : window, n) {
          case "focusin":
            (fv(Me) || Me.contentEditable === "true") && (io = Me, ld = A, es = null);
            break;
          case "focusout":
            es = ld = io = null;
            break;
          case "mousedown":
            ud = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ud = !1, od(q, l, W);
            break;
          case "selectionchange":
            if (iy) break;
          case "keydown":
          case "keyup":
            od(q, l, W);
        }
        var ze;
        if (no) e: {
          switch (n) {
            case "compositionstart":
              var Ve = "onCompositionStart";
              break e;
            case "compositionend":
              Ve = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Ve = "onCompositionUpdate";
              break e;
          }
          Ve = void 0;
        }
        else ro ? ov(n, l) && (Ve = "onCompositionEnd") : n === "keydown" && l.keyCode === 229 && (Ve = "onCompositionStart");
        Ve && (lv && l.locale !== "ko" && (ro || Ve !== "onCompositionStart" ? Ve === "onCompositionEnd" && ro && (ze = U()) : (Za = W, h = "value" in Za ? Za.value : Za.textContent, ro = !0)), Me = ns(A, Ve), 0 < Me.length && (Ve = new Kf(Ve, n, null, l, W), q.push({ event: Ve, listeners: Me }), ze ? Ve.data = ze : (ze = sv(l), ze !== null && (Ve.data = ze)))), (ze = Xo ? cv(n, l) : Jm(n, l)) && (A = ns(A, "onBeforeInput"), 0 < A.length && (W = new Kf("onBeforeInput", "beforeinput", null, l, W), q.push({ event: W, listeners: A }), W.data = ze));
      }
      cu(q, r);
    });
  }
  function uo(n, r, l) {
    return { instance: n, listener: r, currentTarget: l };
  }
  function ns(n, r) {
    for (var l = r + "Capture", o = []; n !== null; ) {
      var c = n, d = c.stateNode;
      c.tag === 5 && d !== null && (c = d, d = xr(n, l), d != null && o.unshift(uo(n, d, c)), d = xr(n, r), d != null && o.push(uo(n, d, c))), n = n.return;
    }
    return o;
  }
  function Rl(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function xv(n, r, l, o, c) {
    for (var d = r._reactName, m = []; l !== null && l !== o; ) {
      var E = l, T = E.alternate, A = E.stateNode;
      if (T !== null && T === o) break;
      E.tag === 5 && A !== null && (E = A, c ? (T = xr(l, d), T != null && m.unshift(uo(l, T, E))) : c || (T = xr(l, d), T != null && m.push(uo(l, T, E)))), l = l.return;
    }
    m.length !== 0 && n.push({ event: r, listeners: m });
  }
  var bv = /\r\n?/g, oy = /\u0000|\uFFFD/g;
  function _v(n) {
    return (typeof n == "string" ? n : "" + n).replace(bv, `
`).replace(oy, "");
  }
  function Sc(n, r, l) {
    if (r = _v(r), _v(n) !== r && l) throw Error(D(425));
  }
  function Tl() {
  }
  var rs = null, fu = null;
  function Ec(n, r) {
    return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var Cc = typeof setTimeout == "function" ? setTimeout : void 0, pd = typeof clearTimeout == "function" ? clearTimeout : void 0, Dv = typeof Promise == "function" ? Promise : void 0, oo = typeof queueMicrotask == "function" ? queueMicrotask : typeof Dv < "u" ? function(n) {
    return Dv.resolve(null).then(n).catch(Rc);
  } : Cc;
  function Rc(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function so(n, r) {
    var l = r, o = 0;
    do {
      var c = l.nextSibling;
      if (n.removeChild(l), c && c.nodeType === 8) if (l = c.data, l === "/$") {
        if (o === 0) {
          n.removeChild(c), Ka(r);
          return;
        }
        o--;
      } else l !== "$" && l !== "$?" && l !== "$!" || o++;
      l = c;
    } while (l);
    Ka(r);
  }
  function gi(n) {
    for (; n != null; n = n.nextSibling) {
      var r = n.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = n.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return n;
  }
  function kv(n) {
    n = n.previousSibling;
    for (var r = 0; n; ) {
      if (n.nodeType === 8) {
        var l = n.data;
        if (l === "$" || l === "$!" || l === "$?") {
          if (r === 0) return n;
          r--;
        } else l === "/$" && r++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var wl = Math.random().toString(36).slice(2), Si = "__reactFiber$" + wl, as = "__reactProps$" + wl, Ii = "__reactContainer$" + wl, is = "__reactEvents$" + wl, co = "__reactListeners$" + wl, sy = "__reactHandles$" + wl;
  function du(n) {
    var r = n[Si];
    if (r) return r;
    for (var l = n.parentNode; l; ) {
      if (r = l[Ii] || l[Si]) {
        if (l = r.alternate, r.child !== null || l !== null && l.child !== null) for (n = kv(n); n !== null; ) {
          if (l = n[Si]) return l;
          n = kv(n);
        }
        return r;
      }
      n = l, l = n.parentNode;
    }
    return null;
  }
  function _e(n) {
    return n = n[Si] || n[Ii], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function ei(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(D(33));
  }
  function hn(n) {
    return n[as] || null;
  }
  var gt = [], _a = -1;
  function Da(n) {
    return { current: n };
  }
  function nn(n) {
    0 > _a || (n.current = gt[_a], gt[_a] = null, _a--);
  }
  function xe(n, r) {
    _a++, gt[_a] = n.current, n.current = r;
  }
  var Er = {}, Sn = Da(Er), In = Da(!1), Qr = Er;
  function Wr(n, r) {
    var l = n.type.contextTypes;
    if (!l) return Er;
    var o = n.stateNode;
    if (o && o.__reactInternalMemoizedUnmaskedChildContext === r) return o.__reactInternalMemoizedMaskedChildContext;
    var c = {}, d;
    for (d in l) c[d] = r[d];
    return o && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = r, n.__reactInternalMemoizedMaskedChildContext = c), c;
  }
  function Mn(n) {
    return n = n.childContextTypes, n != null;
  }
  function fo() {
    nn(In), nn(Sn);
  }
  function Ov(n, r, l) {
    if (Sn.current !== Er) throw Error(D(168));
    xe(Sn, r), xe(In, l);
  }
  function ls(n, r, l) {
    var o = n.stateNode;
    if (r = r.childContextTypes, typeof o.getChildContext != "function") return l;
    o = o.getChildContext();
    for (var c in o) if (!(c in r)) throw Error(D(108, Ke(n) || "Unknown", c));
    return ne({}, l, o);
  }
  function Xn(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || Er, Qr = Sn.current, xe(Sn, n), xe(In, In.current), !0;
  }
  function Tc(n, r, l) {
    var o = n.stateNode;
    if (!o) throw Error(D(169));
    l ? (n = ls(n, r, Qr), o.__reactInternalMemoizedMergedChildContext = n, nn(In), nn(Sn), xe(Sn, n)) : nn(In), xe(In, l);
  }
  var Ei = null, po = !1, Yi = !1;
  function wc(n) {
    Ei === null ? Ei = [n] : Ei.push(n);
  }
  function xl(n) {
    po = !0, wc(n);
  }
  function Ci() {
    if (!Yi && Ei !== null) {
      Yi = !0;
      var n = 0, r = kt;
      try {
        var l = Ei;
        for (kt = 1; n < l.length; n++) {
          var o = l[n];
          do
            o = o(!0);
          while (o !== null);
        }
        Ei = null, po = !1;
      } catch (c) {
        throw Ei !== null && (Ei = Ei.slice(n + 1)), un(Ga, Ci), c;
      } finally {
        kt = r, Yi = !1;
      }
    }
    return null;
  }
  var bl = [], _l = 0, Dl = null, Qi = 0, Nn = [], ka = 0, fa = null, Ri = 1, Ti = "";
  function pu(n, r) {
    bl[_l++] = Qi, bl[_l++] = Dl, Dl = n, Qi = r;
  }
  function Lv(n, r, l) {
    Nn[ka++] = Ri, Nn[ka++] = Ti, Nn[ka++] = fa, fa = n;
    var o = Ri;
    n = Ti;
    var c = 32 - _r(o) - 1;
    o &= ~(1 << c), l += 1;
    var d = 32 - _r(r) + c;
    if (30 < d) {
      var m = c - c % 5;
      d = (o & (1 << m) - 1).toString(32), o >>= m, c -= m, Ri = 1 << 32 - _r(r) + c | l << c | o, Ti = d + n;
    } else Ri = 1 << d | l << c | o, Ti = n;
  }
  function xc(n) {
    n.return !== null && (pu(n, 1), Lv(n, 1, 0));
  }
  function bc(n) {
    for (; n === Dl; ) Dl = bl[--_l], bl[_l] = null, Qi = bl[--_l], bl[_l] = null;
    for (; n === fa; ) fa = Nn[--ka], Nn[ka] = null, Ti = Nn[--ka], Nn[ka] = null, Ri = Nn[--ka], Nn[ka] = null;
  }
  var Gr = null, qr = null, fn = !1, Oa = null;
  function vd(n, r) {
    var l = Ua(5, null, null, 0);
    l.elementType = "DELETED", l.stateNode = r, l.return = n, r = n.deletions, r === null ? (n.deletions = [l], n.flags |= 16) : r.push(l);
  }
  function Mv(n, r) {
    switch (n.tag) {
      case 5:
        var l = n.type;
        return r = r.nodeType !== 1 || l.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (n.stateNode = r, Gr = n, qr = gi(r.firstChild), !0) : !1;
      case 6:
        return r = n.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (n.stateNode = r, Gr = n, qr = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (l = fa !== null ? { id: Ri, overflow: Ti } : null, n.memoizedState = { dehydrated: r, treeContext: l, retryLane: 1073741824 }, l = Ua(18, null, null, 0), l.stateNode = r, l.return = n, n.child = l, Gr = n, qr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function hd(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function md(n) {
    if (fn) {
      var r = qr;
      if (r) {
        var l = r;
        if (!Mv(n, r)) {
          if (hd(n)) throw Error(D(418));
          r = gi(l.nextSibling);
          var o = Gr;
          r && Mv(n, r) ? vd(o, l) : (n.flags = n.flags & -4097 | 2, fn = !1, Gr = n);
        }
      } else {
        if (hd(n)) throw Error(D(418));
        n.flags = n.flags & -4097 | 2, fn = !1, Gr = n;
      }
    }
  }
  function Yn(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    Gr = n;
  }
  function _c(n) {
    if (n !== Gr) return !1;
    if (!fn) return Yn(n), fn = !0, !1;
    var r;
    if ((r = n.tag !== 3) && !(r = n.tag !== 5) && (r = n.type, r = r !== "head" && r !== "body" && !Ec(n.type, n.memoizedProps)), r && (r = qr)) {
      if (hd(n)) throw us(), Error(D(418));
      for (; r; ) vd(n, r), r = gi(r.nextSibling);
    }
    if (Yn(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(D(317));
      e: {
        for (n = n.nextSibling, r = 0; n; ) {
          if (n.nodeType === 8) {
            var l = n.data;
            if (l === "/$") {
              if (r === 0) {
                qr = gi(n.nextSibling);
                break e;
              }
              r--;
            } else l !== "$" && l !== "$!" && l !== "$?" || r++;
          }
          n = n.nextSibling;
        }
        qr = null;
      }
    } else qr = Gr ? gi(n.stateNode.nextSibling) : null;
    return !0;
  }
  function us() {
    for (var n = qr; n; ) n = gi(n.nextSibling);
  }
  function kl() {
    qr = Gr = null, fn = !1;
  }
  function Wi(n) {
    Oa === null ? Oa = [n] : Oa.push(n);
  }
  var cy = pt.ReactCurrentBatchConfig;
  function vu(n, r, l) {
    if (n = l.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (l._owner) {
        if (l = l._owner, l) {
          if (l.tag !== 1) throw Error(D(309));
          var o = l.stateNode;
        }
        if (!o) throw Error(D(147, n));
        var c = o, d = "" + n;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === d ? r.ref : (r = function(m) {
          var E = c.refs;
          m === null ? delete E[d] : E[d] = m;
        }, r._stringRef = d, r);
      }
      if (typeof n != "string") throw Error(D(284));
      if (!l._owner) throw Error(D(290, n));
    }
    return n;
  }
  function Dc(n, r) {
    throw n = Object.prototype.toString.call(r), Error(D(31, n === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : n));
  }
  function Nv(n) {
    var r = n._init;
    return r(n._payload);
  }
  function hu(n) {
    function r(k, x) {
      if (n) {
        var N = k.deletions;
        N === null ? (k.deletions = [x], k.flags |= 16) : N.push(x);
      }
    }
    function l(k, x) {
      if (!n) return null;
      for (; x !== null; ) r(k, x), x = x.sibling;
      return null;
    }
    function o(k, x) {
      for (k = /* @__PURE__ */ new Map(); x !== null; ) x.key !== null ? k.set(x.key, x) : k.set(x.index, x), x = x.sibling;
      return k;
    }
    function c(k, x) {
      return k = Fl(k, x), k.index = 0, k.sibling = null, k;
    }
    function d(k, x, N) {
      return k.index = N, n ? (N = k.alternate, N !== null ? (N = N.index, N < x ? (k.flags |= 2, x) : N) : (k.flags |= 2, x)) : (k.flags |= 1048576, x);
    }
    function m(k) {
      return n && k.alternate === null && (k.flags |= 2), k;
    }
    function E(k, x, N, G) {
      return x === null || x.tag !== 6 ? (x = Wd(N, k.mode, G), x.return = k, x) : (x = c(x, N), x.return = k, x);
    }
    function T(k, x, N, G) {
      var ye = N.type;
      return ye === Fe ? W(k, x, N.props.children, G, N.key) : x !== null && (x.elementType === ye || typeof ye == "object" && ye !== null && ye.$$typeof === Dt && Nv(ye) === x.type) ? (G = c(x, N.props), G.ref = vu(k, x, N), G.return = k, G) : (G = Fs(N.type, N.key, N.props, null, k.mode, G), G.ref = vu(k, x, N), G.return = k, G);
    }
    function A(k, x, N, G) {
      return x === null || x.tag !== 4 || x.stateNode.containerInfo !== N.containerInfo || x.stateNode.implementation !== N.implementation ? (x = of(N, k.mode, G), x.return = k, x) : (x = c(x, N.children || []), x.return = k, x);
    }
    function W(k, x, N, G, ye) {
      return x === null || x.tag !== 7 ? (x = Ji(N, k.mode, G, ye), x.return = k, x) : (x = c(x, N), x.return = k, x);
    }
    function q(k, x, N) {
      if (typeof x == "string" && x !== "" || typeof x == "number") return x = Wd("" + x, k.mode, N), x.return = k, x;
      if (typeof x == "object" && x !== null) {
        switch (x.$$typeof) {
          case be:
            return N = Fs(x.type, x.key, x.props, null, k.mode, N), N.ref = vu(k, null, x), N.return = k, N;
          case ot:
            return x = of(x, k.mode, N), x.return = k, x;
          case Dt:
            var G = x._init;
            return q(k, G(x._payload), N);
        }
        if (Gn(x) || Re(x)) return x = Ji(x, k.mode, N, null), x.return = k, x;
        Dc(k, x);
      }
      return null;
    }
    function Q(k, x, N, G) {
      var ye = x !== null ? x.key : null;
      if (typeof N == "string" && N !== "" || typeof N == "number") return ye !== null ? null : E(k, x, "" + N, G);
      if (typeof N == "object" && N !== null) {
        switch (N.$$typeof) {
          case be:
            return N.key === ye ? T(k, x, N, G) : null;
          case ot:
            return N.key === ye ? A(k, x, N, G) : null;
          case Dt:
            return ye = N._init, Q(
              k,
              x,
              ye(N._payload),
              G
            );
        }
        if (Gn(N) || Re(N)) return ye !== null ? null : W(k, x, N, G, null);
        Dc(k, N);
      }
      return null;
    }
    function se(k, x, N, G, ye) {
      if (typeof G == "string" && G !== "" || typeof G == "number") return k = k.get(N) || null, E(x, k, "" + G, ye);
      if (typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case be:
            return k = k.get(G.key === null ? N : G.key) || null, T(x, k, G, ye);
          case ot:
            return k = k.get(G.key === null ? N : G.key) || null, A(x, k, G, ye);
          case Dt:
            var Me = G._init;
            return se(k, x, N, Me(G._payload), ye);
        }
        if (Gn(G) || Re(G)) return k = k.get(N) || null, W(x, k, G, ye, null);
        Dc(x, G);
      }
      return null;
    }
    function me(k, x, N, G) {
      for (var ye = null, Me = null, ze = x, Ve = x = 0, Jn = null; ze !== null && Ve < N.length; Ve++) {
        ze.index > Ve ? (Jn = ze, ze = null) : Jn = ze.sibling;
        var Mt = Q(k, ze, N[Ve], G);
        if (Mt === null) {
          ze === null && (ze = Jn);
          break;
        }
        n && ze && Mt.alternate === null && r(k, ze), x = d(Mt, x, Ve), Me === null ? ye = Mt : Me.sibling = Mt, Me = Mt, ze = Jn;
      }
      if (Ve === N.length) return l(k, ze), fn && pu(k, Ve), ye;
      if (ze === null) {
        for (; Ve < N.length; Ve++) ze = q(k, N[Ve], G), ze !== null && (x = d(ze, x, Ve), Me === null ? ye = ze : Me.sibling = ze, Me = ze);
        return fn && pu(k, Ve), ye;
      }
      for (ze = o(k, ze); Ve < N.length; Ve++) Jn = se(ze, k, Ve, N[Ve], G), Jn !== null && (n && Jn.alternate !== null && ze.delete(Jn.key === null ? Ve : Jn.key), x = d(Jn, x, Ve), Me === null ? ye = Jn : Me.sibling = Jn, Me = Jn);
      return n && ze.forEach(function(Vl) {
        return r(k, Vl);
      }), fn && pu(k, Ve), ye;
    }
    function Se(k, x, N, G) {
      var ye = Re(N);
      if (typeof ye != "function") throw Error(D(150));
      if (N = ye.call(N), N == null) throw Error(D(151));
      for (var Me = ye = null, ze = x, Ve = x = 0, Jn = null, Mt = N.next(); ze !== null && !Mt.done; Ve++, Mt = N.next()) {
        ze.index > Ve ? (Jn = ze, ze = null) : Jn = ze.sibling;
        var Vl = Q(k, ze, Mt.value, G);
        if (Vl === null) {
          ze === null && (ze = Jn);
          break;
        }
        n && ze && Vl.alternate === null && r(k, ze), x = d(Vl, x, Ve), Me === null ? ye = Vl : Me.sibling = Vl, Me = Vl, ze = Jn;
      }
      if (Mt.done) return l(
        k,
        ze
      ), fn && pu(k, Ve), ye;
      if (ze === null) {
        for (; !Mt.done; Ve++, Mt = N.next()) Mt = q(k, Mt.value, G), Mt !== null && (x = d(Mt, x, Ve), Me === null ? ye = Mt : Me.sibling = Mt, Me = Mt);
        return fn && pu(k, Ve), ye;
      }
      for (ze = o(k, ze); !Mt.done; Ve++, Mt = N.next()) Mt = se(ze, k, Ve, Mt.value, G), Mt !== null && (n && Mt.alternate !== null && ze.delete(Mt.key === null ? Ve : Mt.key), x = d(Mt, x, Ve), Me === null ? ye = Mt : Me.sibling = Mt, Me = Mt);
      return n && ze.forEach(function(hh) {
        return r(k, hh);
      }), fn && pu(k, Ve), ye;
    }
    function _n(k, x, N, G) {
      if (typeof N == "object" && N !== null && N.type === Fe && N.key === null && (N = N.props.children), typeof N == "object" && N !== null) {
        switch (N.$$typeof) {
          case be:
            e: {
              for (var ye = N.key, Me = x; Me !== null; ) {
                if (Me.key === ye) {
                  if (ye = N.type, ye === Fe) {
                    if (Me.tag === 7) {
                      l(k, Me.sibling), x = c(Me, N.props.children), x.return = k, k = x;
                      break e;
                    }
                  } else if (Me.elementType === ye || typeof ye == "object" && ye !== null && ye.$$typeof === Dt && Nv(ye) === Me.type) {
                    l(k, Me.sibling), x = c(Me, N.props), x.ref = vu(k, Me, N), x.return = k, k = x;
                    break e;
                  }
                  l(k, Me);
                  break;
                } else r(k, Me);
                Me = Me.sibling;
              }
              N.type === Fe ? (x = Ji(N.props.children, k.mode, G, N.key), x.return = k, k = x) : (G = Fs(N.type, N.key, N.props, null, k.mode, G), G.ref = vu(k, x, N), G.return = k, k = G);
            }
            return m(k);
          case ot:
            e: {
              for (Me = N.key; x !== null; ) {
                if (x.key === Me) if (x.tag === 4 && x.stateNode.containerInfo === N.containerInfo && x.stateNode.implementation === N.implementation) {
                  l(k, x.sibling), x = c(x, N.children || []), x.return = k, k = x;
                  break e;
                } else {
                  l(k, x);
                  break;
                }
                else r(k, x);
                x = x.sibling;
              }
              x = of(N, k.mode, G), x.return = k, k = x;
            }
            return m(k);
          case Dt:
            return Me = N._init, _n(k, x, Me(N._payload), G);
        }
        if (Gn(N)) return me(k, x, N, G);
        if (Re(N)) return Se(k, x, N, G);
        Dc(k, N);
      }
      return typeof N == "string" && N !== "" || typeof N == "number" ? (N = "" + N, x !== null && x.tag === 6 ? (l(k, x.sibling), x = c(x, N), x.return = k, k = x) : (l(k, x), x = Wd(N, k.mode, G), x.return = k, k = x), m(k)) : l(k, x);
    }
    return _n;
  }
  var Tn = hu(!0), ie = hu(!1), da = Da(null), Xr = null, vo = null, yd = null;
  function gd() {
    yd = vo = Xr = null;
  }
  function Sd(n) {
    var r = da.current;
    nn(da), n._currentValue = r;
  }
  function Ed(n, r, l) {
    for (; n !== null; ) {
      var o = n.alternate;
      if ((n.childLanes & r) !== r ? (n.childLanes |= r, o !== null && (o.childLanes |= r)) : o !== null && (o.childLanes & r) !== r && (o.childLanes |= r), n === l) break;
      n = n.return;
    }
  }
  function mn(n, r) {
    Xr = n, yd = vo = null, n = n.dependencies, n !== null && n.firstContext !== null && ((n.lanes & r) !== 0 && (Un = !0), n.firstContext = null);
  }
  function La(n) {
    var r = n._currentValue;
    if (yd !== n) if (n = { context: n, memoizedValue: r, next: null }, vo === null) {
      if (Xr === null) throw Error(D(308));
      vo = n, Xr.dependencies = { lanes: 0, firstContext: n };
    } else vo = vo.next = n;
    return r;
  }
  var mu = null;
  function Cd(n) {
    mu === null ? mu = [n] : mu.push(n);
  }
  function Rd(n, r, l, o) {
    var c = r.interleaved;
    return c === null ? (l.next = l, Cd(r)) : (l.next = c.next, c.next = l), r.interleaved = l, pa(n, o);
  }
  function pa(n, r) {
    n.lanes |= r;
    var l = n.alternate;
    for (l !== null && (l.lanes |= r), l = n, n = n.return; n !== null; ) n.childLanes |= r, l = n.alternate, l !== null && (l.childLanes |= r), l = n, n = n.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var va = !1;
  function Td(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function zv(n, r) {
    n = n.updateQueue, r.updateQueue === n && (r.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function Gi(n, r) {
    return { eventTime: n, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function Ol(n, r, l) {
    var o = n.updateQueue;
    if (o === null) return null;
    if (o = o.shared, (St & 2) !== 0) {
      var c = o.pending;
      return c === null ? r.next = r : (r.next = c.next, c.next = r), o.pending = r, pa(n, l);
    }
    return c = o.interleaved, c === null ? (r.next = r, Cd(o)) : (r.next = c.next, c.next = r), o.interleaved = r, pa(n, l);
  }
  function kc(n, r, l) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (l & 4194240) !== 0)) {
      var o = r.lanes;
      o &= n.pendingLanes, l |= o, r.lanes = l, Hi(n, l);
    }
  }
  function Uv(n, r) {
    var l = n.updateQueue, o = n.alternate;
    if (o !== null && (o = o.updateQueue, l === o)) {
      var c = null, d = null;
      if (l = l.firstBaseUpdate, l !== null) {
        do {
          var m = { eventTime: l.eventTime, lane: l.lane, tag: l.tag, payload: l.payload, callback: l.callback, next: null };
          d === null ? c = d = m : d = d.next = m, l = l.next;
        } while (l !== null);
        d === null ? c = d = r : d = d.next = r;
      } else c = d = r;
      l = { baseState: o.baseState, firstBaseUpdate: c, lastBaseUpdate: d, shared: o.shared, effects: o.effects }, n.updateQueue = l;
      return;
    }
    n = l.lastBaseUpdate, n === null ? l.firstBaseUpdate = r : n.next = r, l.lastBaseUpdate = r;
  }
  function os(n, r, l, o) {
    var c = n.updateQueue;
    va = !1;
    var d = c.firstBaseUpdate, m = c.lastBaseUpdate, E = c.shared.pending;
    if (E !== null) {
      c.shared.pending = null;
      var T = E, A = T.next;
      T.next = null, m === null ? d = A : m.next = A, m = T;
      var W = n.alternate;
      W !== null && (W = W.updateQueue, E = W.lastBaseUpdate, E !== m && (E === null ? W.firstBaseUpdate = A : E.next = A, W.lastBaseUpdate = T));
    }
    if (d !== null) {
      var q = c.baseState;
      m = 0, W = A = T = null, E = d;
      do {
        var Q = E.lane, se = E.eventTime;
        if ((o & Q) === Q) {
          W !== null && (W = W.next = {
            eventTime: se,
            lane: 0,
            tag: E.tag,
            payload: E.payload,
            callback: E.callback,
            next: null
          });
          e: {
            var me = n, Se = E;
            switch (Q = r, se = l, Se.tag) {
              case 1:
                if (me = Se.payload, typeof me == "function") {
                  q = me.call(se, q, Q);
                  break e;
                }
                q = me;
                break e;
              case 3:
                me.flags = me.flags & -65537 | 128;
              case 0:
                if (me = Se.payload, Q = typeof me == "function" ? me.call(se, q, Q) : me, Q == null) break e;
                q = ne({}, q, Q);
                break e;
              case 2:
                va = !0;
            }
          }
          E.callback !== null && E.lane !== 0 && (n.flags |= 64, Q = c.effects, Q === null ? c.effects = [E] : Q.push(E));
        } else se = { eventTime: se, lane: Q, tag: E.tag, payload: E.payload, callback: E.callback, next: null }, W === null ? (A = W = se, T = q) : W = W.next = se, m |= Q;
        if (E = E.next, E === null) {
          if (E = c.shared.pending, E === null) break;
          Q = E, E = Q.next, Q.next = null, c.lastBaseUpdate = Q, c.shared.pending = null;
        }
      } while (!0);
      if (W === null && (T = q), c.baseState = T, c.firstBaseUpdate = A, c.lastBaseUpdate = W, r = c.shared.interleaved, r !== null) {
        c = r;
        do
          m |= c.lane, c = c.next;
        while (c !== r);
      } else d === null && (c.shared.lanes = 0);
      Di |= m, n.lanes = m, n.memoizedState = q;
    }
  }
  function wd(n, r, l) {
    if (n = r.effects, r.effects = null, n !== null) for (r = 0; r < n.length; r++) {
      var o = n[r], c = o.callback;
      if (c !== null) {
        if (o.callback = null, o = l, typeof c != "function") throw Error(D(191, c));
        c.call(o);
      }
    }
  }
  var ss = {}, wi = Da(ss), cs = Da(ss), fs = Da(ss);
  function yu(n) {
    if (n === ss) throw Error(D(174));
    return n;
  }
  function xd(n, r) {
    switch (xe(fs, r), xe(cs, n), xe(wi, ss), n = r.nodeType, n) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : oa(null, "");
        break;
      default:
        n = n === 8 ? r.parentNode : r, r = n.namespaceURI || null, n = n.tagName, r = oa(r, n);
    }
    nn(wi), xe(wi, r);
  }
  function gu() {
    nn(wi), nn(cs), nn(fs);
  }
  function Av(n) {
    yu(fs.current);
    var r = yu(wi.current), l = oa(r, n.type);
    r !== l && (xe(cs, n), xe(wi, l));
  }
  function Oc(n) {
    cs.current === n && (nn(wi), nn(cs));
  }
  var yn = Da(0);
  function Lc(n) {
    for (var r = n; r !== null; ) {
      if (r.tag === 13) {
        var l = r.memoizedState;
        if (l !== null && (l = l.dehydrated, l === null || l.data === "$?" || l.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if ((r.flags & 128) !== 0) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === n) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === n) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var ds = [];
  function De() {
    for (var n = 0; n < ds.length; n++) ds[n]._workInProgressVersionPrimary = null;
    ds.length = 0;
  }
  var lt = pt.ReactCurrentDispatcher, Ot = pt.ReactCurrentBatchConfig, Wt = 0, Lt = null, zn = null, Kn = null, Mc = !1, ps = !1, Su = 0, Y = 0;
  function bt() {
    throw Error(D(321));
  }
  function Ae(n, r) {
    if (r === null) return !1;
    for (var l = 0; l < r.length && l < n.length; l++) if (!Ja(n[l], r[l])) return !1;
    return !0;
  }
  function Ll(n, r, l, o, c, d) {
    if (Wt = d, Lt = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, lt.current = n === null || n.memoizedState === null ? Wc : Ss, n = l(o, c), ps) {
      d = 0;
      do {
        if (ps = !1, Su = 0, 25 <= d) throw Error(D(301));
        d += 1, Kn = zn = null, r.updateQueue = null, lt.current = Gc, n = l(o, c);
      } while (ps);
    }
    if (lt.current = wu, r = zn !== null && zn.next !== null, Wt = 0, Kn = zn = Lt = null, Mc = !1, r) throw Error(D(300));
    return n;
  }
  function ti() {
    var n = Su !== 0;
    return Su = 0, n;
  }
  function Cr() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Kn === null ? Lt.memoizedState = Kn = n : Kn = Kn.next = n, Kn;
  }
  function wn() {
    if (zn === null) {
      var n = Lt.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = zn.next;
    var r = Kn === null ? Lt.memoizedState : Kn.next;
    if (r !== null) Kn = r, zn = n;
    else {
      if (n === null) throw Error(D(310));
      zn = n, n = { memoizedState: zn.memoizedState, baseState: zn.baseState, baseQueue: zn.baseQueue, queue: zn.queue, next: null }, Kn === null ? Lt.memoizedState = Kn = n : Kn = Kn.next = n;
    }
    return Kn;
  }
  function qi(n, r) {
    return typeof r == "function" ? r(n) : r;
  }
  function Ml(n) {
    var r = wn(), l = r.queue;
    if (l === null) throw Error(D(311));
    l.lastRenderedReducer = n;
    var o = zn, c = o.baseQueue, d = l.pending;
    if (d !== null) {
      if (c !== null) {
        var m = c.next;
        c.next = d.next, d.next = m;
      }
      o.baseQueue = c = d, l.pending = null;
    }
    if (c !== null) {
      d = c.next, o = o.baseState;
      var E = m = null, T = null, A = d;
      do {
        var W = A.lane;
        if ((Wt & W) === W) T !== null && (T = T.next = { lane: 0, action: A.action, hasEagerState: A.hasEagerState, eagerState: A.eagerState, next: null }), o = A.hasEagerState ? A.eagerState : n(o, A.action);
        else {
          var q = {
            lane: W,
            action: A.action,
            hasEagerState: A.hasEagerState,
            eagerState: A.eagerState,
            next: null
          };
          T === null ? (E = T = q, m = o) : T = T.next = q, Lt.lanes |= W, Di |= W;
        }
        A = A.next;
      } while (A !== null && A !== d);
      T === null ? m = o : T.next = E, Ja(o, r.memoizedState) || (Un = !0), r.memoizedState = o, r.baseState = m, r.baseQueue = T, l.lastRenderedState = o;
    }
    if (n = l.interleaved, n !== null) {
      c = n;
      do
        d = c.lane, Lt.lanes |= d, Di |= d, c = c.next;
      while (c !== n);
    } else c === null && (l.lanes = 0);
    return [r.memoizedState, l.dispatch];
  }
  function Eu(n) {
    var r = wn(), l = r.queue;
    if (l === null) throw Error(D(311));
    l.lastRenderedReducer = n;
    var o = l.dispatch, c = l.pending, d = r.memoizedState;
    if (c !== null) {
      l.pending = null;
      var m = c = c.next;
      do
        d = n(d, m.action), m = m.next;
      while (m !== c);
      Ja(d, r.memoizedState) || (Un = !0), r.memoizedState = d, r.baseQueue === null && (r.baseState = d), l.lastRenderedState = d;
    }
    return [d, o];
  }
  function Nc() {
  }
  function zc(n, r) {
    var l = Lt, o = wn(), c = r(), d = !Ja(o.memoizedState, c);
    if (d && (o.memoizedState = c, Un = !0), o = o.queue, vs(Fc.bind(null, l, o, n), [n]), o.getSnapshot !== r || d || Kn !== null && Kn.memoizedState.tag & 1) {
      if (l.flags |= 2048, Cu(9, Ac.bind(null, l, o, c, r), void 0, null), Qn === null) throw Error(D(349));
      (Wt & 30) !== 0 || Uc(l, r, c);
    }
    return c;
  }
  function Uc(n, r, l) {
    n.flags |= 16384, n = { getSnapshot: r, value: l }, r = Lt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, Lt.updateQueue = r, r.stores = [n]) : (l = r.stores, l === null ? r.stores = [n] : l.push(n));
  }
  function Ac(n, r, l, o) {
    r.value = l, r.getSnapshot = o, jc(r) && Hc(n);
  }
  function Fc(n, r, l) {
    return l(function() {
      jc(r) && Hc(n);
    });
  }
  function jc(n) {
    var r = n.getSnapshot;
    n = n.value;
    try {
      var l = r();
      return !Ja(n, l);
    } catch {
      return !0;
    }
  }
  function Hc(n) {
    var r = pa(n, 1);
    r !== null && Nr(r, n, 1, -1);
  }
  function Vc(n) {
    var r = Cr();
    return typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: qi, lastRenderedState: n }, r.queue = n, n = n.dispatch = Tu.bind(null, Lt, n), [r.memoizedState, n];
  }
  function Cu(n, r, l, o) {
    return n = { tag: n, create: r, destroy: l, deps: o, next: null }, r = Lt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, Lt.updateQueue = r, r.lastEffect = n.next = n) : (l = r.lastEffect, l === null ? r.lastEffect = n.next = n : (o = l.next, l.next = n, n.next = o, r.lastEffect = n)), n;
  }
  function Pc() {
    return wn().memoizedState;
  }
  function ho(n, r, l, o) {
    var c = Cr();
    Lt.flags |= n, c.memoizedState = Cu(1 | r, l, void 0, o === void 0 ? null : o);
  }
  function mo(n, r, l, o) {
    var c = wn();
    o = o === void 0 ? null : o;
    var d = void 0;
    if (zn !== null) {
      var m = zn.memoizedState;
      if (d = m.destroy, o !== null && Ae(o, m.deps)) {
        c.memoizedState = Cu(r, l, d, o);
        return;
      }
    }
    Lt.flags |= n, c.memoizedState = Cu(1 | r, l, d, o);
  }
  function Bc(n, r) {
    return ho(8390656, 8, n, r);
  }
  function vs(n, r) {
    return mo(2048, 8, n, r);
  }
  function $c(n, r) {
    return mo(4, 2, n, r);
  }
  function hs(n, r) {
    return mo(4, 4, n, r);
  }
  function Ru(n, r) {
    if (typeof r == "function") return n = n(), r(n), function() {
      r(null);
    };
    if (r != null) return n = n(), r.current = n, function() {
      r.current = null;
    };
  }
  function Ic(n, r, l) {
    return l = l != null ? l.concat([n]) : null, mo(4, 4, Ru.bind(null, r, n), l);
  }
  function ms() {
  }
  function Yc(n, r) {
    var l = wn();
    r = r === void 0 ? null : r;
    var o = l.memoizedState;
    return o !== null && r !== null && Ae(r, o[1]) ? o[0] : (l.memoizedState = [n, r], n);
  }
  function Qc(n, r) {
    var l = wn();
    r = r === void 0 ? null : r;
    var o = l.memoizedState;
    return o !== null && r !== null && Ae(r, o[1]) ? o[0] : (n = n(), l.memoizedState = [n, r], n);
  }
  function bd(n, r, l) {
    return (Wt & 21) === 0 ? (n.baseState && (n.baseState = !1, Un = !0), n.memoizedState = l) : (Ja(l, r) || (l = Gu(), Lt.lanes |= l, Di |= l, n.baseState = !0), r);
  }
  function ys(n, r) {
    var l = kt;
    kt = l !== 0 && 4 > l ? l : 4, n(!0);
    var o = Ot.transition;
    Ot.transition = {};
    try {
      n(!1), r();
    } finally {
      kt = l, Ot.transition = o;
    }
  }
  function _d() {
    return wn().memoizedState;
  }
  function gs(n, r, l) {
    var o = ki(n);
    if (l = { lane: o, action: l, hasEagerState: !1, eagerState: null, next: null }, Kr(n)) Fv(r, l);
    else if (l = Rd(n, r, l, o), l !== null) {
      var c = jn();
      Nr(l, n, o, c), Xt(l, r, o);
    }
  }
  function Tu(n, r, l) {
    var o = ki(n), c = { lane: o, action: l, hasEagerState: !1, eagerState: null, next: null };
    if (Kr(n)) Fv(r, c);
    else {
      var d = n.alternate;
      if (n.lanes === 0 && (d === null || d.lanes === 0) && (d = r.lastRenderedReducer, d !== null)) try {
        var m = r.lastRenderedState, E = d(m, l);
        if (c.hasEagerState = !0, c.eagerState = E, Ja(E, m)) {
          var T = r.interleaved;
          T === null ? (c.next = c, Cd(r)) : (c.next = T.next, T.next = c), r.interleaved = c;
          return;
        }
      } catch {
      }
      l = Rd(n, r, c, o), l !== null && (c = jn(), Nr(l, n, o, c), Xt(l, r, o));
    }
  }
  function Kr(n) {
    var r = n.alternate;
    return n === Lt || r !== null && r === Lt;
  }
  function Fv(n, r) {
    ps = Mc = !0;
    var l = n.pending;
    l === null ? r.next = r : (r.next = l.next, l.next = r), n.pending = r;
  }
  function Xt(n, r, l) {
    if ((l & 4194240) !== 0) {
      var o = r.lanes;
      o &= n.pendingLanes, l |= o, r.lanes = l, Hi(n, l);
    }
  }
  var wu = { readContext: La, useCallback: bt, useContext: bt, useEffect: bt, useImperativeHandle: bt, useInsertionEffect: bt, useLayoutEffect: bt, useMemo: bt, useReducer: bt, useRef: bt, useState: bt, useDebugValue: bt, useDeferredValue: bt, useTransition: bt, useMutableSource: bt, useSyncExternalStore: bt, useId: bt, unstable_isNewReconciler: !1 }, Wc = { readContext: La, useCallback: function(n, r) {
    return Cr().memoizedState = [n, r === void 0 ? null : r], n;
  }, useContext: La, useEffect: Bc, useImperativeHandle: function(n, r, l) {
    return l = l != null ? l.concat([n]) : null, ho(
      4194308,
      4,
      Ru.bind(null, r, n),
      l
    );
  }, useLayoutEffect: function(n, r) {
    return ho(4194308, 4, n, r);
  }, useInsertionEffect: function(n, r) {
    return ho(4, 2, n, r);
  }, useMemo: function(n, r) {
    var l = Cr();
    return r = r === void 0 ? null : r, n = n(), l.memoizedState = [n, r], n;
  }, useReducer: function(n, r, l) {
    var o = Cr();
    return r = l !== void 0 ? l(r) : r, o.memoizedState = o.baseState = r, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: r }, o.queue = n, n = n.dispatch = gs.bind(null, Lt, n), [o.memoizedState, n];
  }, useRef: function(n) {
    var r = Cr();
    return n = { current: n }, r.memoizedState = n;
  }, useState: Vc, useDebugValue: ms, useDeferredValue: function(n) {
    return Cr().memoizedState = n;
  }, useTransition: function() {
    var n = Vc(!1), r = n[0];
    return n = ys.bind(null, n[1]), Cr().memoizedState = n, [r, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, r, l) {
    var o = Lt, c = Cr();
    if (fn) {
      if (l === void 0) throw Error(D(407));
      l = l();
    } else {
      if (l = r(), Qn === null) throw Error(D(349));
      (Wt & 30) !== 0 || Uc(o, r, l);
    }
    c.memoizedState = l;
    var d = { value: l, getSnapshot: r };
    return c.queue = d, Bc(Fc.bind(
      null,
      o,
      d,
      n
    ), [n]), o.flags |= 2048, Cu(9, Ac.bind(null, o, d, l, r), void 0, null), l;
  }, useId: function() {
    var n = Cr(), r = Qn.identifierPrefix;
    if (fn) {
      var l = Ti, o = Ri;
      l = (o & ~(1 << 32 - _r(o) - 1)).toString(32) + l, r = ":" + r + "R" + l, l = Su++, 0 < l && (r += "H" + l.toString(32)), r += ":";
    } else l = Y++, r = ":" + r + "r" + l.toString(32) + ":";
    return n.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, Ss = {
    readContext: La,
    useCallback: Yc,
    useContext: La,
    useEffect: vs,
    useImperativeHandle: Ic,
    useInsertionEffect: $c,
    useLayoutEffect: hs,
    useMemo: Qc,
    useReducer: Ml,
    useRef: Pc,
    useState: function() {
      return Ml(qi);
    },
    useDebugValue: ms,
    useDeferredValue: function(n) {
      var r = wn();
      return bd(r, zn.memoizedState, n);
    },
    useTransition: function() {
      var n = Ml(qi)[0], r = wn().memoizedState;
      return [n, r];
    },
    useMutableSource: Nc,
    useSyncExternalStore: zc,
    useId: _d,
    unstable_isNewReconciler: !1
  }, Gc = { readContext: La, useCallback: Yc, useContext: La, useEffect: vs, useImperativeHandle: Ic, useInsertionEffect: $c, useLayoutEffect: hs, useMemo: Qc, useReducer: Eu, useRef: Pc, useState: function() {
    return Eu(qi);
  }, useDebugValue: ms, useDeferredValue: function(n) {
    var r = wn();
    return zn === null ? r.memoizedState = n : bd(r, zn.memoizedState, n);
  }, useTransition: function() {
    var n = Eu(qi)[0], r = wn().memoizedState;
    return [n, r];
  }, useMutableSource: Nc, useSyncExternalStore: zc, useId: _d, unstable_isNewReconciler: !1 };
  function ni(n, r) {
    if (n && n.defaultProps) {
      r = ne({}, r), n = n.defaultProps;
      for (var l in n) r[l] === void 0 && (r[l] = n[l]);
      return r;
    }
    return r;
  }
  function Dd(n, r, l, o) {
    r = n.memoizedState, l = l(o, r), l = l == null ? r : ne({}, r, l), n.memoizedState = l, n.lanes === 0 && (n.updateQueue.baseState = l);
  }
  var qc = { isMounted: function(n) {
    return (n = n._reactInternals) ? Ge(n) === n : !1;
  }, enqueueSetState: function(n, r, l) {
    n = n._reactInternals;
    var o = jn(), c = ki(n), d = Gi(o, c);
    d.payload = r, l != null && (d.callback = l), r = Ol(n, d, c), r !== null && (Nr(r, n, c, o), kc(r, n, c));
  }, enqueueReplaceState: function(n, r, l) {
    n = n._reactInternals;
    var o = jn(), c = ki(n), d = Gi(o, c);
    d.tag = 1, d.payload = r, l != null && (d.callback = l), r = Ol(n, d, c), r !== null && (Nr(r, n, c, o), kc(r, n, c));
  }, enqueueForceUpdate: function(n, r) {
    n = n._reactInternals;
    var l = jn(), o = ki(n), c = Gi(l, o);
    c.tag = 2, r != null && (c.callback = r), r = Ol(n, c, o), r !== null && (Nr(r, n, o, l), kc(r, n, o));
  } };
  function jv(n, r, l, o, c, d, m) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(o, d, m) : r.prototype && r.prototype.isPureReactComponent ? !Zo(l, o) || !Zo(c, d) : !0;
  }
  function Xc(n, r, l) {
    var o = !1, c = Er, d = r.contextType;
    return typeof d == "object" && d !== null ? d = La(d) : (c = Mn(r) ? Qr : Sn.current, o = r.contextTypes, d = (o = o != null) ? Wr(n, c) : Er), r = new r(l, d), n.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = qc, n.stateNode = r, r._reactInternals = n, o && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = c, n.__reactInternalMemoizedMaskedChildContext = d), r;
  }
  function Hv(n, r, l, o) {
    n = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(l, o), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(l, o), r.state !== n && qc.enqueueReplaceState(r, r.state, null);
  }
  function Es(n, r, l, o) {
    var c = n.stateNode;
    c.props = l, c.state = n.memoizedState, c.refs = {}, Td(n);
    var d = r.contextType;
    typeof d == "object" && d !== null ? c.context = La(d) : (d = Mn(r) ? Qr : Sn.current, c.context = Wr(n, d)), c.state = n.memoizedState, d = r.getDerivedStateFromProps, typeof d == "function" && (Dd(n, r, d, l), c.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof c.getSnapshotBeforeUpdate == "function" || typeof c.UNSAFE_componentWillMount != "function" && typeof c.componentWillMount != "function" || (r = c.state, typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount(), r !== c.state && qc.enqueueReplaceState(c, c.state, null), os(n, l, c, o), c.state = n.memoizedState), typeof c.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function xu(n, r) {
    try {
      var l = "", o = r;
      do
        l += rt(o), o = o.return;
      while (o);
      var c = l;
    } catch (d) {
      c = `
Error generating stack: ` + d.message + `
` + d.stack;
    }
    return { value: n, source: r, stack: c, digest: null };
  }
  function kd(n, r, l) {
    return { value: n, source: null, stack: l ?? null, digest: r ?? null };
  }
  function Od(n, r) {
    try {
      console.error(r.value);
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  var Kc = typeof WeakMap == "function" ? WeakMap : Map;
  function Vv(n, r, l) {
    l = Gi(-1, l), l.tag = 3, l.payload = { element: null };
    var o = r.value;
    return l.callback = function() {
      Ro || (Ro = !0, Du = o), Od(n, r);
    }, l;
  }
  function Ld(n, r, l) {
    l = Gi(-1, l), l.tag = 3;
    var o = n.type.getDerivedStateFromError;
    if (typeof o == "function") {
      var c = r.value;
      l.payload = function() {
        return o(c);
      }, l.callback = function() {
        Od(n, r);
      };
    }
    var d = n.stateNode;
    return d !== null && typeof d.componentDidCatch == "function" && (l.callback = function() {
      Od(n, r), typeof o != "function" && (Ul === null ? Ul = /* @__PURE__ */ new Set([this]) : Ul.add(this));
      var m = r.stack;
      this.componentDidCatch(r.value, { componentStack: m !== null ? m : "" });
    }), l;
  }
  function Md(n, r, l) {
    var o = n.pingCache;
    if (o === null) {
      o = n.pingCache = new Kc();
      var c = /* @__PURE__ */ new Set();
      o.set(r, c);
    } else c = o.get(r), c === void 0 && (c = /* @__PURE__ */ new Set(), o.set(r, c));
    c.has(l) || (c.add(l), n = yy.bind(null, n, r, l), r.then(n, n));
  }
  function Pv(n) {
    do {
      var r;
      if ((r = n.tag === 13) && (r = n.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function Nl(n, r, l, o, c) {
    return (n.mode & 1) === 0 ? (n === r ? n.flags |= 65536 : (n.flags |= 128, l.flags |= 131072, l.flags &= -52805, l.tag === 1 && (l.alternate === null ? l.tag = 17 : (r = Gi(-1, 1), r.tag = 2, Ol(l, r, 1))), l.lanes |= 1), n) : (n.flags |= 65536, n.lanes = c, n);
  }
  var Cs = pt.ReactCurrentOwner, Un = !1;
  function lr(n, r, l, o) {
    r.child = n === null ? ie(r, null, l, o) : Tn(r, n.child, l, o);
  }
  function Zr(n, r, l, o, c) {
    l = l.render;
    var d = r.ref;
    return mn(r, c), o = Ll(n, r, l, o, d, c), l = ti(), n !== null && !Un ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~c, Na(n, r, c)) : (fn && l && xc(r), r.flags |= 1, lr(n, r, o, c), r.child);
  }
  function bu(n, r, l, o, c) {
    if (n === null) {
      var d = l.type;
      return typeof d == "function" && !Qd(d) && d.defaultProps === void 0 && l.compare === null && l.defaultProps === void 0 ? (r.tag = 15, r.type = d, Xe(n, r, d, o, c)) : (n = Fs(l.type, null, o, r, r.mode, c), n.ref = r.ref, n.return = r, r.child = n);
    }
    if (d = n.child, (n.lanes & c) === 0) {
      var m = d.memoizedProps;
      if (l = l.compare, l = l !== null ? l : Zo, l(m, o) && n.ref === r.ref) return Na(n, r, c);
    }
    return r.flags |= 1, n = Fl(d, o), n.ref = r.ref, n.return = r, r.child = n;
  }
  function Xe(n, r, l, o, c) {
    if (n !== null) {
      var d = n.memoizedProps;
      if (Zo(d, o) && n.ref === r.ref) if (Un = !1, r.pendingProps = o = d, (n.lanes & c) !== 0) (n.flags & 131072) !== 0 && (Un = !0);
      else return r.lanes = n.lanes, Na(n, r, c);
    }
    return Bv(n, r, l, o, c);
  }
  function Rs(n, r, l) {
    var o = r.pendingProps, c = o.children, d = n !== null ? n.memoizedState : null;
    if (o.mode === "hidden") if ((r.mode & 1) === 0) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, xe(So, ha), ha |= l;
    else {
      if ((l & 1073741824) === 0) return n = d !== null ? d.baseLanes | l : l, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, r.updateQueue = null, xe(So, ha), ha |= n, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, o = d !== null ? d.baseLanes : l, xe(So, ha), ha |= o;
    }
    else d !== null ? (o = d.baseLanes | l, r.memoizedState = null) : o = l, xe(So, ha), ha |= o;
    return lr(n, r, c, l), r.child;
  }
  function Nd(n, r) {
    var l = r.ref;
    (n === null && l !== null || n !== null && n.ref !== l) && (r.flags |= 512, r.flags |= 2097152);
  }
  function Bv(n, r, l, o, c) {
    var d = Mn(l) ? Qr : Sn.current;
    return d = Wr(r, d), mn(r, c), l = Ll(n, r, l, o, d, c), o = ti(), n !== null && !Un ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~c, Na(n, r, c)) : (fn && o && xc(r), r.flags |= 1, lr(n, r, l, c), r.child);
  }
  function $v(n, r, l, o, c) {
    if (Mn(l)) {
      var d = !0;
      Xn(r);
    } else d = !1;
    if (mn(r, c), r.stateNode === null) Ma(n, r), Xc(r, l, o), Es(r, l, o, c), o = !0;
    else if (n === null) {
      var m = r.stateNode, E = r.memoizedProps;
      m.props = E;
      var T = m.context, A = l.contextType;
      typeof A == "object" && A !== null ? A = La(A) : (A = Mn(l) ? Qr : Sn.current, A = Wr(r, A));
      var W = l.getDerivedStateFromProps, q = typeof W == "function" || typeof m.getSnapshotBeforeUpdate == "function";
      q || typeof m.UNSAFE_componentWillReceiveProps != "function" && typeof m.componentWillReceiveProps != "function" || (E !== o || T !== A) && Hv(r, m, o, A), va = !1;
      var Q = r.memoizedState;
      m.state = Q, os(r, o, m, c), T = r.memoizedState, E !== o || Q !== T || In.current || va ? (typeof W == "function" && (Dd(r, l, W, o), T = r.memoizedState), (E = va || jv(r, l, E, o, Q, T, A)) ? (q || typeof m.UNSAFE_componentWillMount != "function" && typeof m.componentWillMount != "function" || (typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount()), typeof m.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof m.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = o, r.memoizedState = T), m.props = o, m.state = T, m.context = A, o = E) : (typeof m.componentDidMount == "function" && (r.flags |= 4194308), o = !1);
    } else {
      m = r.stateNode, zv(n, r), E = r.memoizedProps, A = r.type === r.elementType ? E : ni(r.type, E), m.props = A, q = r.pendingProps, Q = m.context, T = l.contextType, typeof T == "object" && T !== null ? T = La(T) : (T = Mn(l) ? Qr : Sn.current, T = Wr(r, T));
      var se = l.getDerivedStateFromProps;
      (W = typeof se == "function" || typeof m.getSnapshotBeforeUpdate == "function") || typeof m.UNSAFE_componentWillReceiveProps != "function" && typeof m.componentWillReceiveProps != "function" || (E !== q || Q !== T) && Hv(r, m, o, T), va = !1, Q = r.memoizedState, m.state = Q, os(r, o, m, c);
      var me = r.memoizedState;
      E !== q || Q !== me || In.current || va ? (typeof se == "function" && (Dd(r, l, se, o), me = r.memoizedState), (A = va || jv(r, l, A, o, Q, me, T) || !1) ? (W || typeof m.UNSAFE_componentWillUpdate != "function" && typeof m.componentWillUpdate != "function" || (typeof m.componentWillUpdate == "function" && m.componentWillUpdate(o, me, T), typeof m.UNSAFE_componentWillUpdate == "function" && m.UNSAFE_componentWillUpdate(o, me, T)), typeof m.componentDidUpdate == "function" && (r.flags |= 4), typeof m.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof m.componentDidUpdate != "function" || E === n.memoizedProps && Q === n.memoizedState || (r.flags |= 4), typeof m.getSnapshotBeforeUpdate != "function" || E === n.memoizedProps && Q === n.memoizedState || (r.flags |= 1024), r.memoizedProps = o, r.memoizedState = me), m.props = o, m.state = me, m.context = T, o = A) : (typeof m.componentDidUpdate != "function" || E === n.memoizedProps && Q === n.memoizedState || (r.flags |= 4), typeof m.getSnapshotBeforeUpdate != "function" || E === n.memoizedProps && Q === n.memoizedState || (r.flags |= 1024), o = !1);
    }
    return Ts(n, r, l, o, d, c);
  }
  function Ts(n, r, l, o, c, d) {
    Nd(n, r);
    var m = (r.flags & 128) !== 0;
    if (!o && !m) return c && Tc(r, l, !1), Na(n, r, d);
    o = r.stateNode, Cs.current = r;
    var E = m && typeof l.getDerivedStateFromError != "function" ? null : o.render();
    return r.flags |= 1, n !== null && m ? (r.child = Tn(r, n.child, null, d), r.child = Tn(r, null, E, d)) : lr(n, r, E, d), r.memoizedState = o.state, c && Tc(r, l, !0), r.child;
  }
  function yo(n) {
    var r = n.stateNode;
    r.pendingContext ? Ov(n, r.pendingContext, r.pendingContext !== r.context) : r.context && Ov(n, r.context, !1), xd(n, r.containerInfo);
  }
  function Iv(n, r, l, o, c) {
    return kl(), Wi(c), r.flags |= 256, lr(n, r, l, o), r.child;
  }
  var Zc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function zd(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function Jc(n, r, l) {
    var o = r.pendingProps, c = yn.current, d = !1, m = (r.flags & 128) !== 0, E;
    if ((E = m) || (E = n !== null && n.memoizedState === null ? !1 : (c & 2) !== 0), E ? (d = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (c |= 1), xe(yn, c & 1), n === null)
      return md(r), n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? ((r.mode & 1) === 0 ? r.lanes = 1 : n.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824, null) : (m = o.children, n = o.fallback, d ? (o = r.mode, d = r.child, m = { mode: "hidden", children: m }, (o & 1) === 0 && d !== null ? (d.childLanes = 0, d.pendingProps = m) : d = jl(m, o, 0, null), n = Ji(n, o, l, null), d.return = r, n.return = r, d.sibling = n, r.child = d, r.child.memoizedState = zd(l), r.memoizedState = Zc, n) : Ud(r, m));
    if (c = n.memoizedState, c !== null && (E = c.dehydrated, E !== null)) return Yv(n, r, m, o, E, c, l);
    if (d) {
      d = o.fallback, m = r.mode, c = n.child, E = c.sibling;
      var T = { mode: "hidden", children: o.children };
      return (m & 1) === 0 && r.child !== c ? (o = r.child, o.childLanes = 0, o.pendingProps = T, r.deletions = null) : (o = Fl(c, T), o.subtreeFlags = c.subtreeFlags & 14680064), E !== null ? d = Fl(E, d) : (d = Ji(d, m, l, null), d.flags |= 2), d.return = r, o.return = r, o.sibling = d, r.child = o, o = d, d = r.child, m = n.child.memoizedState, m = m === null ? zd(l) : { baseLanes: m.baseLanes | l, cachePool: null, transitions: m.transitions }, d.memoizedState = m, d.childLanes = n.childLanes & ~l, r.memoizedState = Zc, o;
    }
    return d = n.child, n = d.sibling, o = Fl(d, { mode: "visible", children: o.children }), (r.mode & 1) === 0 && (o.lanes = l), o.return = r, o.sibling = null, n !== null && (l = r.deletions, l === null ? (r.deletions = [n], r.flags |= 16) : l.push(n)), r.child = o, r.memoizedState = null, o;
  }
  function Ud(n, r) {
    return r = jl({ mode: "visible", children: r }, n.mode, 0, null), r.return = n, n.child = r;
  }
  function ws(n, r, l, o) {
    return o !== null && Wi(o), Tn(r, n.child, null, l), n = Ud(r, r.pendingProps.children), n.flags |= 2, r.memoizedState = null, n;
  }
  function Yv(n, r, l, o, c, d, m) {
    if (l)
      return r.flags & 256 ? (r.flags &= -257, o = kd(Error(D(422))), ws(n, r, m, o)) : r.memoizedState !== null ? (r.child = n.child, r.flags |= 128, null) : (d = o.fallback, c = r.mode, o = jl({ mode: "visible", children: o.children }, c, 0, null), d = Ji(d, c, m, null), d.flags |= 2, o.return = r, d.return = r, o.sibling = d, r.child = o, (r.mode & 1) !== 0 && Tn(r, n.child, null, m), r.child.memoizedState = zd(m), r.memoizedState = Zc, d);
    if ((r.mode & 1) === 0) return ws(n, r, m, null);
    if (c.data === "$!") {
      if (o = c.nextSibling && c.nextSibling.dataset, o) var E = o.dgst;
      return o = E, d = Error(D(419)), o = kd(d, o, void 0), ws(n, r, m, o);
    }
    if (E = (m & n.childLanes) !== 0, Un || E) {
      if (o = Qn, o !== null) {
        switch (m & -m) {
          case 4:
            c = 2;
            break;
          case 16:
            c = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            c = 32;
            break;
          case 536870912:
            c = 268435456;
            break;
          default:
            c = 0;
        }
        c = (c & (o.suspendedLanes | m)) !== 0 ? 0 : c, c !== 0 && c !== d.retryLane && (d.retryLane = c, pa(n, c), Nr(o, n, c, -1));
      }
      return Yd(), o = kd(Error(D(421))), ws(n, r, m, o);
    }
    return c.data === "$?" ? (r.flags |= 128, r.child = n.child, r = gy.bind(null, n), c._reactRetry = r, null) : (n = d.treeContext, qr = gi(c.nextSibling), Gr = r, fn = !0, Oa = null, n !== null && (Nn[ka++] = Ri, Nn[ka++] = Ti, Nn[ka++] = fa, Ri = n.id, Ti = n.overflow, fa = r), r = Ud(r, o.children), r.flags |= 4096, r);
  }
  function Ad(n, r, l) {
    n.lanes |= r;
    var o = n.alternate;
    o !== null && (o.lanes |= r), Ed(n.return, r, l);
  }
  function Or(n, r, l, o, c) {
    var d = n.memoizedState;
    d === null ? n.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: o, tail: l, tailMode: c } : (d.isBackwards = r, d.rendering = null, d.renderingStartTime = 0, d.last = o, d.tail = l, d.tailMode = c);
  }
  function xi(n, r, l) {
    var o = r.pendingProps, c = o.revealOrder, d = o.tail;
    if (lr(n, r, o.children, l), o = yn.current, (o & 2) !== 0) o = o & 1 | 2, r.flags |= 128;
    else {
      if (n !== null && (n.flags & 128) !== 0) e: for (n = r.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && Ad(n, l, r);
        else if (n.tag === 19) Ad(n, l, r);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === r) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === r) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      o &= 1;
    }
    if (xe(yn, o), (r.mode & 1) === 0) r.memoizedState = null;
    else switch (c) {
      case "forwards":
        for (l = r.child, c = null; l !== null; ) n = l.alternate, n !== null && Lc(n) === null && (c = l), l = l.sibling;
        l = c, l === null ? (c = r.child, r.child = null) : (c = l.sibling, l.sibling = null), Or(r, !1, c, l, d);
        break;
      case "backwards":
        for (l = null, c = r.child, r.child = null; c !== null; ) {
          if (n = c.alternate, n !== null && Lc(n) === null) {
            r.child = c;
            break;
          }
          n = c.sibling, c.sibling = l, l = c, c = n;
        }
        Or(r, !0, l, null, d);
        break;
      case "together":
        Or(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Ma(n, r) {
    (r.mode & 1) === 0 && n !== null && (n.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Na(n, r, l) {
    if (n !== null && (r.dependencies = n.dependencies), Di |= r.lanes, (l & r.childLanes) === 0) return null;
    if (n !== null && r.child !== n.child) throw Error(D(153));
    if (r.child !== null) {
      for (n = r.child, l = Fl(n, n.pendingProps), r.child = l, l.return = r; n.sibling !== null; ) n = n.sibling, l = l.sibling = Fl(n, n.pendingProps), l.return = r;
      l.sibling = null;
    }
    return r.child;
  }
  function xs(n, r, l) {
    switch (r.tag) {
      case 3:
        yo(r), kl();
        break;
      case 5:
        Av(r);
        break;
      case 1:
        Mn(r.type) && Xn(r);
        break;
      case 4:
        xd(r, r.stateNode.containerInfo);
        break;
      case 10:
        var o = r.type._context, c = r.memoizedProps.value;
        xe(da, o._currentValue), o._currentValue = c;
        break;
      case 13:
        if (o = r.memoizedState, o !== null)
          return o.dehydrated !== null ? (xe(yn, yn.current & 1), r.flags |= 128, null) : (l & r.child.childLanes) !== 0 ? Jc(n, r, l) : (xe(yn, yn.current & 1), n = Na(n, r, l), n !== null ? n.sibling : null);
        xe(yn, yn.current & 1);
        break;
      case 19:
        if (o = (l & r.childLanes) !== 0, (n.flags & 128) !== 0) {
          if (o) return xi(n, r, l);
          r.flags |= 128;
        }
        if (c = r.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), xe(yn, yn.current), o) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, Rs(n, r, l);
    }
    return Na(n, r, l);
  }
  var za, An, Qv, Wv;
  za = function(n, r) {
    for (var l = r.child; l !== null; ) {
      if (l.tag === 5 || l.tag === 6) n.appendChild(l.stateNode);
      else if (l.tag !== 4 && l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === r) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === r) return;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
  }, An = function() {
  }, Qv = function(n, r, l, o) {
    var c = n.memoizedProps;
    if (c !== o) {
      n = r.stateNode, yu(wi.current);
      var d = null;
      switch (l) {
        case "input":
          c = tr(n, c), o = tr(n, o), d = [];
          break;
        case "select":
          c = ne({}, c, { value: void 0 }), o = ne({}, o, { value: void 0 }), d = [];
          break;
        case "textarea":
          c = Bn(n, c), o = Bn(n, o), d = [];
          break;
        default:
          typeof c.onClick != "function" && typeof o.onClick == "function" && (n.onclick = Tl);
      }
      ln(l, o);
      var m;
      l = null;
      for (A in c) if (!o.hasOwnProperty(A) && c.hasOwnProperty(A) && c[A] != null) if (A === "style") {
        var E = c[A];
        for (m in E) E.hasOwnProperty(m) && (l || (l = {}), l[m] = "");
      } else A !== "dangerouslySetInnerHTML" && A !== "children" && A !== "suppressContentEditableWarning" && A !== "suppressHydrationWarning" && A !== "autoFocus" && (ht.hasOwnProperty(A) ? d || (d = []) : (d = d || []).push(A, null));
      for (A in o) {
        var T = o[A];
        if (E = c?.[A], o.hasOwnProperty(A) && T !== E && (T != null || E != null)) if (A === "style") if (E) {
          for (m in E) !E.hasOwnProperty(m) || T && T.hasOwnProperty(m) || (l || (l = {}), l[m] = "");
          for (m in T) T.hasOwnProperty(m) && E[m] !== T[m] && (l || (l = {}), l[m] = T[m]);
        } else l || (d || (d = []), d.push(
          A,
          l
        )), l = T;
        else A === "dangerouslySetInnerHTML" ? (T = T ? T.__html : void 0, E = E ? E.__html : void 0, T != null && E !== T && (d = d || []).push(A, T)) : A === "children" ? typeof T != "string" && typeof T != "number" || (d = d || []).push(A, "" + T) : A !== "suppressContentEditableWarning" && A !== "suppressHydrationWarning" && (ht.hasOwnProperty(A) ? (T != null && A === "onScroll" && jt("scroll", n), d || E === T || (d = [])) : (d = d || []).push(A, T));
      }
      l && (d = d || []).push("style", l);
      var A = d;
      (r.updateQueue = A) && (r.flags |= 4);
    }
  }, Wv = function(n, r, l, o) {
    l !== o && (r.flags |= 4);
  };
  function bs(n, r) {
    if (!fn) switch (n.tailMode) {
      case "hidden":
        r = n.tail;
        for (var l = null; r !== null; ) r.alternate !== null && (l = r), r = r.sibling;
        l === null ? n.tail = null : l.sibling = null;
        break;
      case "collapsed":
        l = n.tail;
        for (var o = null; l !== null; ) l.alternate !== null && (o = l), l = l.sibling;
        o === null ? r || n.tail === null ? n.tail = null : n.tail.sibling = null : o.sibling = null;
    }
  }
  function Zn(n) {
    var r = n.alternate !== null && n.alternate.child === n.child, l = 0, o = 0;
    if (r) for (var c = n.child; c !== null; ) l |= c.lanes | c.childLanes, o |= c.subtreeFlags & 14680064, o |= c.flags & 14680064, c.return = n, c = c.sibling;
    else for (c = n.child; c !== null; ) l |= c.lanes | c.childLanes, o |= c.subtreeFlags, o |= c.flags, c.return = n, c = c.sibling;
    return n.subtreeFlags |= o, n.childLanes = l, r;
  }
  function Gv(n, r, l) {
    var o = r.pendingProps;
    switch (bc(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Zn(r), null;
      case 1:
        return Mn(r.type) && fo(), Zn(r), null;
      case 3:
        return o = r.stateNode, gu(), nn(In), nn(Sn), De(), o.pendingContext && (o.context = o.pendingContext, o.pendingContext = null), (n === null || n.child === null) && (_c(r) ? r.flags |= 4 : n === null || n.memoizedState.isDehydrated && (r.flags & 256) === 0 || (r.flags |= 1024, Oa !== null && (ku(Oa), Oa = null))), An(n, r), Zn(r), null;
      case 5:
        Oc(r);
        var c = yu(fs.current);
        if (l = r.type, n !== null && r.stateNode != null) Qv(n, r, l, o, c), n.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!o) {
            if (r.stateNode === null) throw Error(D(166));
            return Zn(r), null;
          }
          if (n = yu(wi.current), _c(r)) {
            o = r.stateNode, l = r.type;
            var d = r.memoizedProps;
            switch (o[Si] = r, o[as] = d, n = (r.mode & 1) !== 0, l) {
              case "dialog":
                jt("cancel", o), jt("close", o);
                break;
              case "iframe":
              case "object":
              case "embed":
                jt("load", o);
                break;
              case "video":
              case "audio":
                for (c = 0; c < ts.length; c++) jt(ts[c], o);
                break;
              case "source":
                jt("error", o);
                break;
              case "img":
              case "image":
              case "link":
                jt(
                  "error",
                  o
                ), jt("load", o);
                break;
              case "details":
                jt("toggle", o);
                break;
              case "input":
                Vn(o, d), jt("invalid", o);
                break;
              case "select":
                o._wrapperState = { wasMultiple: !!d.multiple }, jt("invalid", o);
                break;
              case "textarea":
                yr(o, d), jt("invalid", o);
            }
            ln(l, d), c = null;
            for (var m in d) if (d.hasOwnProperty(m)) {
              var E = d[m];
              m === "children" ? typeof E == "string" ? o.textContent !== E && (d.suppressHydrationWarning !== !0 && Sc(o.textContent, E, n), c = ["children", E]) : typeof E == "number" && o.textContent !== "" + E && (d.suppressHydrationWarning !== !0 && Sc(
                o.textContent,
                E,
                n
              ), c = ["children", "" + E]) : ht.hasOwnProperty(m) && E != null && m === "onScroll" && jt("scroll", o);
            }
            switch (l) {
              case "input":
                kn(o), oi(o, d, !0);
                break;
              case "textarea":
                kn(o), On(o);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof d.onClick == "function" && (o.onclick = Tl);
            }
            o = c, r.updateQueue = o, o !== null && (r.flags |= 4);
          } else {
            m = c.nodeType === 9 ? c : c.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = gr(l)), n === "http://www.w3.org/1999/xhtml" ? l === "script" ? (n = m.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof o.is == "string" ? n = m.createElement(l, { is: o.is }) : (n = m.createElement(l), l === "select" && (m = n, o.multiple ? m.multiple = !0 : o.size && (m.size = o.size))) : n = m.createElementNS(n, l), n[Si] = r, n[as] = o, za(n, r, !1, !1), r.stateNode = n;
            e: {
              switch (m = qn(l, o), l) {
                case "dialog":
                  jt("cancel", n), jt("close", n), c = o;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  jt("load", n), c = o;
                  break;
                case "video":
                case "audio":
                  for (c = 0; c < ts.length; c++) jt(ts[c], n);
                  c = o;
                  break;
                case "source":
                  jt("error", n), c = o;
                  break;
                case "img":
                case "image":
                case "link":
                  jt(
                    "error",
                    n
                  ), jt("load", n), c = o;
                  break;
                case "details":
                  jt("toggle", n), c = o;
                  break;
                case "input":
                  Vn(n, o), c = tr(n, o), jt("invalid", n);
                  break;
                case "option":
                  c = o;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!o.multiple }, c = ne({}, o, { value: void 0 }), jt("invalid", n);
                  break;
                case "textarea":
                  yr(n, o), c = Bn(n, o), jt("invalid", n);
                  break;
                default:
                  c = o;
              }
              ln(l, c), E = c;
              for (d in E) if (E.hasOwnProperty(d)) {
                var T = E[d];
                d === "style" ? Zt(n, T) : d === "dangerouslySetInnerHTML" ? (T = T ? T.__html : void 0, T != null && si(n, T)) : d === "children" ? typeof T == "string" ? (l !== "textarea" || T !== "") && J(n, T) : typeof T == "number" && J(n, "" + T) : d !== "suppressContentEditableWarning" && d !== "suppressHydrationWarning" && d !== "autoFocus" && (ht.hasOwnProperty(d) ? T != null && d === "onScroll" && jt("scroll", n) : T != null && Qe(n, d, T, m));
              }
              switch (l) {
                case "input":
                  kn(n), oi(n, o, !1);
                  break;
                case "textarea":
                  kn(n), On(n);
                  break;
                case "option":
                  o.value != null && n.setAttribute("value", "" + et(o.value));
                  break;
                case "select":
                  n.multiple = !!o.multiple, d = o.value, d != null ? Cn(n, !!o.multiple, d, !1) : o.defaultValue != null && Cn(
                    n,
                    !!o.multiple,
                    o.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof c.onClick == "function" && (n.onclick = Tl);
              }
              switch (l) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  o = !!o.autoFocus;
                  break e;
                case "img":
                  o = !0;
                  break e;
                default:
                  o = !1;
              }
            }
            o && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return Zn(r), null;
      case 6:
        if (n && r.stateNode != null) Wv(n, r, n.memoizedProps, o);
        else {
          if (typeof o != "string" && r.stateNode === null) throw Error(D(166));
          if (l = yu(fs.current), yu(wi.current), _c(r)) {
            if (o = r.stateNode, l = r.memoizedProps, o[Si] = r, (d = o.nodeValue !== l) && (n = Gr, n !== null)) switch (n.tag) {
              case 3:
                Sc(o.nodeValue, l, (n.mode & 1) !== 0);
                break;
              case 5:
                n.memoizedProps.suppressHydrationWarning !== !0 && Sc(o.nodeValue, l, (n.mode & 1) !== 0);
            }
            d && (r.flags |= 4);
          } else o = (l.nodeType === 9 ? l : l.ownerDocument).createTextNode(o), o[Si] = r, r.stateNode = o;
        }
        return Zn(r), null;
      case 13:
        if (nn(yn), o = r.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (fn && qr !== null && (r.mode & 1) !== 0 && (r.flags & 128) === 0) us(), kl(), r.flags |= 98560, d = !1;
          else if (d = _c(r), o !== null && o.dehydrated !== null) {
            if (n === null) {
              if (!d) throw Error(D(318));
              if (d = r.memoizedState, d = d !== null ? d.dehydrated : null, !d) throw Error(D(317));
              d[Si] = r;
            } else kl(), (r.flags & 128) === 0 && (r.memoizedState = null), r.flags |= 4;
            Zn(r), d = !1;
          } else Oa !== null && (ku(Oa), Oa = null), d = !0;
          if (!d) return r.flags & 65536 ? r : null;
        }
        return (r.flags & 128) !== 0 ? (r.lanes = l, r) : (o = o !== null, o !== (n !== null && n.memoizedState !== null) && o && (r.child.flags |= 8192, (r.mode & 1) !== 0 && (n === null || (yn.current & 1) !== 0 ? bn === 0 && (bn = 3) : Yd())), r.updateQueue !== null && (r.flags |= 4), Zn(r), null);
      case 4:
        return gu(), An(n, r), n === null && lo(r.stateNode.containerInfo), Zn(r), null;
      case 10:
        return Sd(r.type._context), Zn(r), null;
      case 17:
        return Mn(r.type) && fo(), Zn(r), null;
      case 19:
        if (nn(yn), d = r.memoizedState, d === null) return Zn(r), null;
        if (o = (r.flags & 128) !== 0, m = d.rendering, m === null) if (o) bs(d, !1);
        else {
          if (bn !== 0 || n !== null && (n.flags & 128) !== 0) for (n = r.child; n !== null; ) {
            if (m = Lc(n), m !== null) {
              for (r.flags |= 128, bs(d, !1), o = m.updateQueue, o !== null && (r.updateQueue = o, r.flags |= 4), r.subtreeFlags = 0, o = l, l = r.child; l !== null; ) d = l, n = o, d.flags &= 14680066, m = d.alternate, m === null ? (d.childLanes = 0, d.lanes = n, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = m.childLanes, d.lanes = m.lanes, d.child = m.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = m.memoizedProps, d.memoizedState = m.memoizedState, d.updateQueue = m.updateQueue, d.type = m.type, n = m.dependencies, d.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), l = l.sibling;
              return xe(yn, yn.current & 1 | 2), r.child;
            }
            n = n.sibling;
          }
          d.tail !== null && qe() > Co && (r.flags |= 128, o = !0, bs(d, !1), r.lanes = 4194304);
        }
        else {
          if (!o) if (n = Lc(m), n !== null) {
            if (r.flags |= 128, o = !0, l = n.updateQueue, l !== null && (r.updateQueue = l, r.flags |= 4), bs(d, !0), d.tail === null && d.tailMode === "hidden" && !m.alternate && !fn) return Zn(r), null;
          } else 2 * qe() - d.renderingStartTime > Co && l !== 1073741824 && (r.flags |= 128, o = !0, bs(d, !1), r.lanes = 4194304);
          d.isBackwards ? (m.sibling = r.child, r.child = m) : (l = d.last, l !== null ? l.sibling = m : r.child = m, d.last = m);
        }
        return d.tail !== null ? (r = d.tail, d.rendering = r, d.tail = r.sibling, d.renderingStartTime = qe(), r.sibling = null, l = yn.current, xe(yn, o ? l & 1 | 2 : l & 1), r) : (Zn(r), null);
      case 22:
      case 23:
        return Id(), o = r.memoizedState !== null, n !== null && n.memoizedState !== null !== o && (r.flags |= 8192), o && (r.mode & 1) !== 0 ? (ha & 1073741824) !== 0 && (Zn(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : Zn(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(D(156, r.tag));
  }
  function ef(n, r) {
    switch (bc(r), r.tag) {
      case 1:
        return Mn(r.type) && fo(), n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 3:
        return gu(), nn(In), nn(Sn), De(), n = r.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (r.flags = n & -65537 | 128, r) : null;
      case 5:
        return Oc(r), null;
      case 13:
        if (nn(yn), n = r.memoizedState, n !== null && n.dehydrated !== null) {
          if (r.alternate === null) throw Error(D(340));
          kl();
        }
        return n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 19:
        return nn(yn), null;
      case 4:
        return gu(), null;
      case 10:
        return Sd(r.type._context), null;
      case 22:
      case 23:
        return Id(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var _s = !1, Rr = !1, fy = typeof WeakSet == "function" ? WeakSet : Set, pe = null;
  function go(n, r) {
    var l = n.ref;
    if (l !== null) if (typeof l == "function") try {
      l(null);
    } catch (o) {
      dn(n, r, o);
    }
    else l.current = null;
  }
  function tf(n, r, l) {
    try {
      l();
    } catch (o) {
      dn(n, r, o);
    }
  }
  var qv = !1;
  function Xv(n, r) {
    if (rs = xa, n = Jo(), fc(n)) {
      if ("selectionStart" in n) var l = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        l = (l = n.ownerDocument) && l.defaultView || window;
        var o = l.getSelection && l.getSelection();
        if (o && o.rangeCount !== 0) {
          l = o.anchorNode;
          var c = o.anchorOffset, d = o.focusNode;
          o = o.focusOffset;
          try {
            l.nodeType, d.nodeType;
          } catch {
            l = null;
            break e;
          }
          var m = 0, E = -1, T = -1, A = 0, W = 0, q = n, Q = null;
          t: for (; ; ) {
            for (var se; q !== l || c !== 0 && q.nodeType !== 3 || (E = m + c), q !== d || o !== 0 && q.nodeType !== 3 || (T = m + o), q.nodeType === 3 && (m += q.nodeValue.length), (se = q.firstChild) !== null; )
              Q = q, q = se;
            for (; ; ) {
              if (q === n) break t;
              if (Q === l && ++A === c && (E = m), Q === d && ++W === o && (T = m), (se = q.nextSibling) !== null) break;
              q = Q, Q = q.parentNode;
            }
            q = se;
          }
          l = E === -1 || T === -1 ? null : { start: E, end: T };
        } else l = null;
      }
      l = l || { start: 0, end: 0 };
    } else l = null;
    for (fu = { focusedElem: n, selectionRange: l }, xa = !1, pe = r; pe !== null; ) if (r = pe, n = r.child, (r.subtreeFlags & 1028) !== 0 && n !== null) n.return = r, pe = n;
    else for (; pe !== null; ) {
      r = pe;
      try {
        var me = r.alternate;
        if ((r.flags & 1024) !== 0) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (me !== null) {
              var Se = me.memoizedProps, _n = me.memoizedState, k = r.stateNode, x = k.getSnapshotBeforeUpdate(r.elementType === r.type ? Se : ni(r.type, Se), _n);
              k.__reactInternalSnapshotBeforeUpdate = x;
            }
            break;
          case 3:
            var N = r.stateNode.containerInfo;
            N.nodeType === 1 ? N.textContent = "" : N.nodeType === 9 && N.documentElement && N.removeChild(N.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(D(163));
        }
      } catch (G) {
        dn(r, r.return, G);
      }
      if (n = r.sibling, n !== null) {
        n.return = r.return, pe = n;
        break;
      }
      pe = r.return;
    }
    return me = qv, qv = !1, me;
  }
  function Ds(n, r, l) {
    var o = r.updateQueue;
    if (o = o !== null ? o.lastEffect : null, o !== null) {
      var c = o = o.next;
      do {
        if ((c.tag & n) === n) {
          var d = c.destroy;
          c.destroy = void 0, d !== void 0 && tf(r, l, d);
        }
        c = c.next;
      } while (c !== o);
    }
  }
  function ks(n, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var l = r = r.next;
      do {
        if ((l.tag & n) === n) {
          var o = l.create;
          l.destroy = o();
        }
        l = l.next;
      } while (l !== r);
    }
  }
  function Fd(n) {
    var r = n.ref;
    if (r !== null) {
      var l = n.stateNode;
      n.tag, n = l, typeof r == "function" ? r(n) : r.current = n;
    }
  }
  function nf(n) {
    var r = n.alternate;
    r !== null && (n.alternate = null, nf(r)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (r = n.stateNode, r !== null && (delete r[Si], delete r[as], delete r[is], delete r[co], delete r[sy])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Os(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function Xi(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Os(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function bi(n, r, l) {
    var o = n.tag;
    if (o === 5 || o === 6) n = n.stateNode, r ? l.nodeType === 8 ? l.parentNode.insertBefore(n, r) : l.insertBefore(n, r) : (l.nodeType === 8 ? (r = l.parentNode, r.insertBefore(n, l)) : (r = l, r.appendChild(n)), l = l._reactRootContainer, l != null || r.onclick !== null || (r.onclick = Tl));
    else if (o !== 4 && (n = n.child, n !== null)) for (bi(n, r, l), n = n.sibling; n !== null; ) bi(n, r, l), n = n.sibling;
  }
  function _i(n, r, l) {
    var o = n.tag;
    if (o === 5 || o === 6) n = n.stateNode, r ? l.insertBefore(n, r) : l.appendChild(n);
    else if (o !== 4 && (n = n.child, n !== null)) for (_i(n, r, l), n = n.sibling; n !== null; ) _i(n, r, l), n = n.sibling;
  }
  var xn = null, Lr = !1;
  function Mr(n, r, l) {
    for (l = l.child; l !== null; ) Kv(n, r, l), l = l.sibling;
  }
  function Kv(n, r, l) {
    if (Ir && typeof Ir.onCommitFiberUnmount == "function") try {
      Ir.onCommitFiberUnmount(vl, l);
    } catch {
    }
    switch (l.tag) {
      case 5:
        Rr || go(l, r);
      case 6:
        var o = xn, c = Lr;
        xn = null, Mr(n, r, l), xn = o, Lr = c, xn !== null && (Lr ? (n = xn, l = l.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(l) : n.removeChild(l)) : xn.removeChild(l.stateNode));
        break;
      case 18:
        xn !== null && (Lr ? (n = xn, l = l.stateNode, n.nodeType === 8 ? so(n.parentNode, l) : n.nodeType === 1 && so(n, l), Ka(n)) : so(xn, l.stateNode));
        break;
      case 4:
        o = xn, c = Lr, xn = l.stateNode.containerInfo, Lr = !0, Mr(n, r, l), xn = o, Lr = c;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Rr && (o = l.updateQueue, o !== null && (o = o.lastEffect, o !== null))) {
          c = o = o.next;
          do {
            var d = c, m = d.destroy;
            d = d.tag, m !== void 0 && ((d & 2) !== 0 || (d & 4) !== 0) && tf(l, r, m), c = c.next;
          } while (c !== o);
        }
        Mr(n, r, l);
        break;
      case 1:
        if (!Rr && (go(l, r), o = l.stateNode, typeof o.componentWillUnmount == "function")) try {
          o.props = l.memoizedProps, o.state = l.memoizedState, o.componentWillUnmount();
        } catch (E) {
          dn(l, r, E);
        }
        Mr(n, r, l);
        break;
      case 21:
        Mr(n, r, l);
        break;
      case 22:
        l.mode & 1 ? (Rr = (o = Rr) || l.memoizedState !== null, Mr(n, r, l), Rr = o) : Mr(n, r, l);
        break;
      default:
        Mr(n, r, l);
    }
  }
  function Zv(n) {
    var r = n.updateQueue;
    if (r !== null) {
      n.updateQueue = null;
      var l = n.stateNode;
      l === null && (l = n.stateNode = new fy()), r.forEach(function(o) {
        var c = uh.bind(null, n, o);
        l.has(o) || (l.add(o), o.then(c, c));
      });
    }
  }
  function ri(n, r) {
    var l = r.deletions;
    if (l !== null) for (var o = 0; o < l.length; o++) {
      var c = l[o];
      try {
        var d = n, m = r, E = m;
        e: for (; E !== null; ) {
          switch (E.tag) {
            case 5:
              xn = E.stateNode, Lr = !1;
              break e;
            case 3:
              xn = E.stateNode.containerInfo, Lr = !0;
              break e;
            case 4:
              xn = E.stateNode.containerInfo, Lr = !0;
              break e;
          }
          E = E.return;
        }
        if (xn === null) throw Error(D(160));
        Kv(d, m, c), xn = null, Lr = !1;
        var T = c.alternate;
        T !== null && (T.return = null), c.return = null;
      } catch (A) {
        dn(c, r, A);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) jd(r, n), r = r.sibling;
  }
  function jd(n, r) {
    var l = n.alternate, o = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ri(r, n), Jr(n), o & 4) {
          try {
            Ds(3, n, n.return), ks(3, n);
          } catch (Se) {
            dn(n, n.return, Se);
          }
          try {
            Ds(5, n, n.return);
          } catch (Se) {
            dn(n, n.return, Se);
          }
        }
        break;
      case 1:
        ri(r, n), Jr(n), o & 512 && l !== null && go(l, l.return);
        break;
      case 5:
        if (ri(r, n), Jr(n), o & 512 && l !== null && go(l, l.return), n.flags & 32) {
          var c = n.stateNode;
          try {
            J(c, "");
          } catch (Se) {
            dn(n, n.return, Se);
          }
        }
        if (o & 4 && (c = n.stateNode, c != null)) {
          var d = n.memoizedProps, m = l !== null ? l.memoizedProps : d, E = n.type, T = n.updateQueue;
          if (n.updateQueue = null, T !== null) try {
            E === "input" && d.type === "radio" && d.name != null && Pn(c, d), qn(E, m);
            var A = qn(E, d);
            for (m = 0; m < T.length; m += 2) {
              var W = T[m], q = T[m + 1];
              W === "style" ? Zt(c, q) : W === "dangerouslySetInnerHTML" ? si(c, q) : W === "children" ? J(c, q) : Qe(c, W, q, A);
            }
            switch (E) {
              case "input":
                $r(c, d);
                break;
              case "textarea":
                $a(c, d);
                break;
              case "select":
                var Q = c._wrapperState.wasMultiple;
                c._wrapperState.wasMultiple = !!d.multiple;
                var se = d.value;
                se != null ? Cn(c, !!d.multiple, se, !1) : Q !== !!d.multiple && (d.defaultValue != null ? Cn(
                  c,
                  !!d.multiple,
                  d.defaultValue,
                  !0
                ) : Cn(c, !!d.multiple, d.multiple ? [] : "", !1));
            }
            c[as] = d;
          } catch (Se) {
            dn(n, n.return, Se);
          }
        }
        break;
      case 6:
        if (ri(r, n), Jr(n), o & 4) {
          if (n.stateNode === null) throw Error(D(162));
          c = n.stateNode, d = n.memoizedProps;
          try {
            c.nodeValue = d;
          } catch (Se) {
            dn(n, n.return, Se);
          }
        }
        break;
      case 3:
        if (ri(r, n), Jr(n), o & 4 && l !== null && l.memoizedState.isDehydrated) try {
          Ka(r.containerInfo);
        } catch (Se) {
          dn(n, n.return, Se);
        }
        break;
      case 4:
        ri(r, n), Jr(n);
        break;
      case 13:
        ri(r, n), Jr(n), c = n.child, c.flags & 8192 && (d = c.memoizedState !== null, c.stateNode.isHidden = d, !d || c.alternate !== null && c.alternate.memoizedState !== null || (Pd = qe())), o & 4 && Zv(n);
        break;
      case 22:
        if (W = l !== null && l.memoizedState !== null, n.mode & 1 ? (Rr = (A = Rr) || W, ri(r, n), Rr = A) : ri(r, n), Jr(n), o & 8192) {
          if (A = n.memoizedState !== null, (n.stateNode.isHidden = A) && !W && (n.mode & 1) !== 0) for (pe = n, W = n.child; W !== null; ) {
            for (q = pe = W; pe !== null; ) {
              switch (Q = pe, se = Q.child, Q.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Ds(4, Q, Q.return);
                  break;
                case 1:
                  go(Q, Q.return);
                  var me = Q.stateNode;
                  if (typeof me.componentWillUnmount == "function") {
                    o = Q, l = Q.return;
                    try {
                      r = o, me.props = r.memoizedProps, me.state = r.memoizedState, me.componentWillUnmount();
                    } catch (Se) {
                      dn(o, l, Se);
                    }
                  }
                  break;
                case 5:
                  go(Q, Q.return);
                  break;
                case 22:
                  if (Q.memoizedState !== null) {
                    Ls(q);
                    continue;
                  }
              }
              se !== null ? (se.return = Q, pe = se) : Ls(q);
            }
            W = W.sibling;
          }
          e: for (W = null, q = n; ; ) {
            if (q.tag === 5) {
              if (W === null) {
                W = q;
                try {
                  c = q.stateNode, A ? (d = c.style, typeof d.setProperty == "function" ? d.setProperty("display", "none", "important") : d.display = "none") : (E = q.stateNode, T = q.memoizedProps.style, m = T != null && T.hasOwnProperty("display") ? T.display : null, E.style.display = At("display", m));
                } catch (Se) {
                  dn(n, n.return, Se);
                }
              }
            } else if (q.tag === 6) {
              if (W === null) try {
                q.stateNode.nodeValue = A ? "" : q.memoizedProps;
              } catch (Se) {
                dn(n, n.return, Se);
              }
            } else if ((q.tag !== 22 && q.tag !== 23 || q.memoizedState === null || q === n) && q.child !== null) {
              q.child.return = q, q = q.child;
              continue;
            }
            if (q === n) break e;
            for (; q.sibling === null; ) {
              if (q.return === null || q.return === n) break e;
              W === q && (W = null), q = q.return;
            }
            W === q && (W = null), q.sibling.return = q.return, q = q.sibling;
          }
        }
        break;
      case 19:
        ri(r, n), Jr(n), o & 4 && Zv(n);
        break;
      case 21:
        break;
      default:
        ri(
          r,
          n
        ), Jr(n);
    }
  }
  function Jr(n) {
    var r = n.flags;
    if (r & 2) {
      try {
        e: {
          for (var l = n.return; l !== null; ) {
            if (Os(l)) {
              var o = l;
              break e;
            }
            l = l.return;
          }
          throw Error(D(160));
        }
        switch (o.tag) {
          case 5:
            var c = o.stateNode;
            o.flags & 32 && (J(c, ""), o.flags &= -33);
            var d = Xi(n);
            _i(n, d, c);
            break;
          case 3:
          case 4:
            var m = o.stateNode.containerInfo, E = Xi(n);
            bi(n, E, m);
            break;
          default:
            throw Error(D(161));
        }
      } catch (T) {
        dn(n, n.return, T);
      }
      n.flags &= -3;
    }
    r & 4096 && (n.flags &= -4097);
  }
  function dy(n, r, l) {
    pe = n, Hd(n);
  }
  function Hd(n, r, l) {
    for (var o = (n.mode & 1) !== 0; pe !== null; ) {
      var c = pe, d = c.child;
      if (c.tag === 22 && o) {
        var m = c.memoizedState !== null || _s;
        if (!m) {
          var E = c.alternate, T = E !== null && E.memoizedState !== null || Rr;
          E = _s;
          var A = Rr;
          if (_s = m, (Rr = T) && !A) for (pe = c; pe !== null; ) m = pe, T = m.child, m.tag === 22 && m.memoizedState !== null ? Vd(c) : T !== null ? (T.return = m, pe = T) : Vd(c);
          for (; d !== null; ) pe = d, Hd(d), d = d.sibling;
          pe = c, _s = E, Rr = A;
        }
        Jv(n);
      } else (c.subtreeFlags & 8772) !== 0 && d !== null ? (d.return = c, pe = d) : Jv(n);
    }
  }
  function Jv(n) {
    for (; pe !== null; ) {
      var r = pe;
      if ((r.flags & 8772) !== 0) {
        var l = r.alternate;
        try {
          if ((r.flags & 8772) !== 0) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              Rr || ks(5, r);
              break;
            case 1:
              var o = r.stateNode;
              if (r.flags & 4 && !Rr) if (l === null) o.componentDidMount();
              else {
                var c = r.elementType === r.type ? l.memoizedProps : ni(r.type, l.memoizedProps);
                o.componentDidUpdate(c, l.memoizedState, o.__reactInternalSnapshotBeforeUpdate);
              }
              var d = r.updateQueue;
              d !== null && wd(r, d, o);
              break;
            case 3:
              var m = r.updateQueue;
              if (m !== null) {
                if (l = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    l = r.child.stateNode;
                    break;
                  case 1:
                    l = r.child.stateNode;
                }
                wd(r, m, l);
              }
              break;
            case 5:
              var E = r.stateNode;
              if (l === null && r.flags & 4) {
                l = E;
                var T = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    T.autoFocus && l.focus();
                    break;
                  case "img":
                    T.src && (l.src = T.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var A = r.alternate;
                if (A !== null) {
                  var W = A.memoizedState;
                  if (W !== null) {
                    var q = W.dehydrated;
                    q !== null && Ka(q);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(D(163));
          }
          Rr || r.flags & 512 && Fd(r);
        } catch (Q) {
          dn(r, r.return, Q);
        }
      }
      if (r === n) {
        pe = null;
        break;
      }
      if (l = r.sibling, l !== null) {
        l.return = r.return, pe = l;
        break;
      }
      pe = r.return;
    }
  }
  function Ls(n) {
    for (; pe !== null; ) {
      var r = pe;
      if (r === n) {
        pe = null;
        break;
      }
      var l = r.sibling;
      if (l !== null) {
        l.return = r.return, pe = l;
        break;
      }
      pe = r.return;
    }
  }
  function Vd(n) {
    for (; pe !== null; ) {
      var r = pe;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var l = r.return;
            try {
              ks(4, r);
            } catch (T) {
              dn(r, l, T);
            }
            break;
          case 1:
            var o = r.stateNode;
            if (typeof o.componentDidMount == "function") {
              var c = r.return;
              try {
                o.componentDidMount();
              } catch (T) {
                dn(r, c, T);
              }
            }
            var d = r.return;
            try {
              Fd(r);
            } catch (T) {
              dn(r, d, T);
            }
            break;
          case 5:
            var m = r.return;
            try {
              Fd(r);
            } catch (T) {
              dn(r, m, T);
            }
        }
      } catch (T) {
        dn(r, r.return, T);
      }
      if (r === n) {
        pe = null;
        break;
      }
      var E = r.sibling;
      if (E !== null) {
        E.return = r.return, pe = E;
        break;
      }
      pe = r.return;
    }
  }
  var py = Math.ceil, zl = pt.ReactCurrentDispatcher, _u = pt.ReactCurrentOwner, ur = pt.ReactCurrentBatchConfig, St = 0, Qn = null, Fn = null, or = 0, ha = 0, So = Da(0), bn = 0, Ms = null, Di = 0, Eo = 0, rf = 0, Ns = null, ea = null, Pd = 0, Co = 1 / 0, ma = null, Ro = !1, Du = null, Ul = null, af = !1, Ki = null, zs = 0, Al = 0, To = null, Us = -1, Tr = 0;
  function jn() {
    return (St & 6) !== 0 ? qe() : Us !== -1 ? Us : Us = qe();
  }
  function ki(n) {
    return (n.mode & 1) === 0 ? 1 : (St & 2) !== 0 && or !== 0 ? or & -or : cy.transition !== null ? (Tr === 0 && (Tr = Gu()), Tr) : (n = kt, n !== 0 || (n = window.event, n = n === void 0 ? 16 : to(n.type)), n);
  }
  function Nr(n, r, l, o) {
    if (50 < Al) throw Al = 0, To = null, Error(D(185));
    ji(n, l, o), ((St & 2) === 0 || n !== Qn) && (n === Qn && ((St & 2) === 0 && (Eo |= l), bn === 4 && ai(n, or)), ta(n, o), l === 1 && St === 0 && (r.mode & 1) === 0 && (Co = qe() + 500, po && Ci()));
  }
  function ta(n, r) {
    var l = n.callbackNode;
    nu(n, r);
    var o = Xa(n, n === Qn ? or : 0);
    if (o === 0) l !== null && rr(l), n.callbackNode = null, n.callbackPriority = 0;
    else if (r = o & -o, n.callbackPriority !== r) {
      if (l != null && rr(l), r === 1) n.tag === 0 ? xl(Bd.bind(null, n)) : wc(Bd.bind(null, n)), oo(function() {
        (St & 6) === 0 && Ci();
      }), l = null;
      else {
        switch (Xu(o)) {
          case 1:
            l = Ga;
            break;
          case 4:
            l = eu;
            break;
          case 16:
            l = tu;
            break;
          case 536870912:
            l = Yu;
            break;
          default:
            l = tu;
        }
        l = sh(l, lf.bind(null, n));
      }
      n.callbackPriority = r, n.callbackNode = l;
    }
  }
  function lf(n, r) {
    if (Us = -1, Tr = 0, (St & 6) !== 0) throw Error(D(327));
    var l = n.callbackNode;
    if (wo() && n.callbackNode !== l) return null;
    var o = Xa(n, n === Qn ? or : 0);
    if (o === 0) return null;
    if ((o & 30) !== 0 || (o & n.expiredLanes) !== 0 || r) r = uf(n, o);
    else {
      r = o;
      var c = St;
      St |= 2;
      var d = th();
      (Qn !== n || or !== r) && (ma = null, Co = qe() + 500, Zi(n, r));
      do
        try {
          nh();
          break;
        } catch (E) {
          eh(n, E);
        }
      while (!0);
      gd(), zl.current = d, St = c, Fn !== null ? r = 0 : (Qn = null, or = 0, r = bn);
    }
    if (r !== 0) {
      if (r === 2 && (c = ml(n), c !== 0 && (o = c, r = As(n, c))), r === 1) throw l = Ms, Zi(n, 0), ai(n, o), ta(n, qe()), l;
      if (r === 6) ai(n, o);
      else {
        if (c = n.current.alternate, (o & 30) === 0 && !vy(c) && (r = uf(n, o), r === 2 && (d = ml(n), d !== 0 && (o = d, r = As(n, d))), r === 1)) throw l = Ms, Zi(n, 0), ai(n, o), ta(n, qe()), l;
        switch (n.finishedWork = c, n.finishedLanes = o, r) {
          case 0:
          case 1:
            throw Error(D(345));
          case 2:
            Lu(n, ea, ma);
            break;
          case 3:
            if (ai(n, o), (o & 130023424) === o && (r = Pd + 500 - qe(), 10 < r)) {
              if (Xa(n, 0) !== 0) break;
              if (c = n.suspendedLanes, (c & o) !== o) {
                jn(), n.pingedLanes |= n.suspendedLanes & c;
                break;
              }
              n.timeoutHandle = Cc(Lu.bind(null, n, ea, ma), r);
              break;
            }
            Lu(n, ea, ma);
            break;
          case 4:
            if (ai(n, o), (o & 4194240) === o) break;
            for (r = n.eventTimes, c = -1; 0 < o; ) {
              var m = 31 - _r(o);
              d = 1 << m, m = r[m], m > c && (c = m), o &= ~d;
            }
            if (o = c, o = qe() - o, o = (120 > o ? 120 : 480 > o ? 480 : 1080 > o ? 1080 : 1920 > o ? 1920 : 3e3 > o ? 3e3 : 4320 > o ? 4320 : 1960 * py(o / 1960)) - o, 10 < o) {
              n.timeoutHandle = Cc(Lu.bind(null, n, ea, ma), o);
              break;
            }
            Lu(n, ea, ma);
            break;
          case 5:
            Lu(n, ea, ma);
            break;
          default:
            throw Error(D(329));
        }
      }
    }
    return ta(n, qe()), n.callbackNode === l ? lf.bind(null, n) : null;
  }
  function As(n, r) {
    var l = Ns;
    return n.current.memoizedState.isDehydrated && (Zi(n, r).flags |= 256), n = uf(n, r), n !== 2 && (r = ea, ea = l, r !== null && ku(r)), n;
  }
  function ku(n) {
    ea === null ? ea = n : ea.push.apply(ea, n);
  }
  function vy(n) {
    for (var r = n; ; ) {
      if (r.flags & 16384) {
        var l = r.updateQueue;
        if (l !== null && (l = l.stores, l !== null)) for (var o = 0; o < l.length; o++) {
          var c = l[o], d = c.getSnapshot;
          c = c.value;
          try {
            if (!Ja(d(), c)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (l = r.child, r.subtreeFlags & 16384 && l !== null) l.return = r, r = l;
      else {
        if (r === n) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function ai(n, r) {
    for (r &= ~rf, r &= ~Eo, n.suspendedLanes |= r, n.pingedLanes &= ~r, n = n.expirationTimes; 0 < r; ) {
      var l = 31 - _r(r), o = 1 << l;
      n[l] = -1, r &= ~o;
    }
  }
  function Bd(n) {
    if ((St & 6) !== 0) throw Error(D(327));
    wo();
    var r = Xa(n, 0);
    if ((r & 1) === 0) return ta(n, qe()), null;
    var l = uf(n, r);
    if (n.tag !== 0 && l === 2) {
      var o = ml(n);
      o !== 0 && (r = o, l = As(n, o));
    }
    if (l === 1) throw l = Ms, Zi(n, 0), ai(n, r), ta(n, qe()), l;
    if (l === 6) throw Error(D(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = r, Lu(n, ea, ma), ta(n, qe()), null;
  }
  function $d(n, r) {
    var l = St;
    St |= 1;
    try {
      return n(r);
    } finally {
      St = l, St === 0 && (Co = qe() + 500, po && Ci());
    }
  }
  function Ou(n) {
    Ki !== null && Ki.tag === 0 && (St & 6) === 0 && wo();
    var r = St;
    St |= 1;
    var l = ur.transition, o = kt;
    try {
      if (ur.transition = null, kt = 1, n) return n();
    } finally {
      kt = o, ur.transition = l, St = r, (St & 6) === 0 && Ci();
    }
  }
  function Id() {
    ha = So.current, nn(So);
  }
  function Zi(n, r) {
    n.finishedWork = null, n.finishedLanes = 0;
    var l = n.timeoutHandle;
    if (l !== -1 && (n.timeoutHandle = -1, pd(l)), Fn !== null) for (l = Fn.return; l !== null; ) {
      var o = l;
      switch (bc(o), o.tag) {
        case 1:
          o = o.type.childContextTypes, o != null && fo();
          break;
        case 3:
          gu(), nn(In), nn(Sn), De();
          break;
        case 5:
          Oc(o);
          break;
        case 4:
          gu();
          break;
        case 13:
          nn(yn);
          break;
        case 19:
          nn(yn);
          break;
        case 10:
          Sd(o.type._context);
          break;
        case 22:
        case 23:
          Id();
      }
      l = l.return;
    }
    if (Qn = n, Fn = n = Fl(n.current, null), or = ha = r, bn = 0, Ms = null, rf = Eo = Di = 0, ea = Ns = null, mu !== null) {
      for (r = 0; r < mu.length; r++) if (l = mu[r], o = l.interleaved, o !== null) {
        l.interleaved = null;
        var c = o.next, d = l.pending;
        if (d !== null) {
          var m = d.next;
          d.next = c, o.next = m;
        }
        l.pending = o;
      }
      mu = null;
    }
    return n;
  }
  function eh(n, r) {
    do {
      var l = Fn;
      try {
        if (gd(), lt.current = wu, Mc) {
          for (var o = Lt.memoizedState; o !== null; ) {
            var c = o.queue;
            c !== null && (c.pending = null), o = o.next;
          }
          Mc = !1;
        }
        if (Wt = 0, Kn = zn = Lt = null, ps = !1, Su = 0, _u.current = null, l === null || l.return === null) {
          bn = 1, Ms = r, Fn = null;
          break;
        }
        e: {
          var d = n, m = l.return, E = l, T = r;
          if (r = or, E.flags |= 32768, T !== null && typeof T == "object" && typeof T.then == "function") {
            var A = T, W = E, q = W.tag;
            if ((W.mode & 1) === 0 && (q === 0 || q === 11 || q === 15)) {
              var Q = W.alternate;
              Q ? (W.updateQueue = Q.updateQueue, W.memoizedState = Q.memoizedState, W.lanes = Q.lanes) : (W.updateQueue = null, W.memoizedState = null);
            }
            var se = Pv(m);
            if (se !== null) {
              se.flags &= -257, Nl(se, m, E, d, r), se.mode & 1 && Md(d, A, r), r = se, T = A;
              var me = r.updateQueue;
              if (me === null) {
                var Se = /* @__PURE__ */ new Set();
                Se.add(T), r.updateQueue = Se;
              } else me.add(T);
              break e;
            } else {
              if ((r & 1) === 0) {
                Md(d, A, r), Yd();
                break e;
              }
              T = Error(D(426));
            }
          } else if (fn && E.mode & 1) {
            var _n = Pv(m);
            if (_n !== null) {
              (_n.flags & 65536) === 0 && (_n.flags |= 256), Nl(_n, m, E, d, r), Wi(xu(T, E));
              break e;
            }
          }
          d = T = xu(T, E), bn !== 4 && (bn = 2), Ns === null ? Ns = [d] : Ns.push(d), d = m;
          do {
            switch (d.tag) {
              case 3:
                d.flags |= 65536, r &= -r, d.lanes |= r;
                var k = Vv(d, T, r);
                Uv(d, k);
                break e;
              case 1:
                E = T;
                var x = d.type, N = d.stateNode;
                if ((d.flags & 128) === 0 && (typeof x.getDerivedStateFromError == "function" || N !== null && typeof N.componentDidCatch == "function" && (Ul === null || !Ul.has(N)))) {
                  d.flags |= 65536, r &= -r, d.lanes |= r;
                  var G = Ld(d, E, r);
                  Uv(d, G);
                  break e;
                }
            }
            d = d.return;
          } while (d !== null);
        }
        ah(l);
      } catch (ye) {
        r = ye, Fn === l && l !== null && (Fn = l = l.return);
        continue;
      }
      break;
    } while (!0);
  }
  function th() {
    var n = zl.current;
    return zl.current = wu, n === null ? wu : n;
  }
  function Yd() {
    (bn === 0 || bn === 3 || bn === 2) && (bn = 4), Qn === null || (Di & 268435455) === 0 && (Eo & 268435455) === 0 || ai(Qn, or);
  }
  function uf(n, r) {
    var l = St;
    St |= 2;
    var o = th();
    (Qn !== n || or !== r) && (ma = null, Zi(n, r));
    do
      try {
        hy();
        break;
      } catch (c) {
        eh(n, c);
      }
    while (!0);
    if (gd(), St = l, zl.current = o, Fn !== null) throw Error(D(261));
    return Qn = null, or = 0, bn;
  }
  function hy() {
    for (; Fn !== null; ) rh(Fn);
  }
  function nh() {
    for (; Fn !== null && !Qa(); ) rh(Fn);
  }
  function rh(n) {
    var r = oh(n.alternate, n, ha);
    n.memoizedProps = n.pendingProps, r === null ? ah(n) : Fn = r, _u.current = null;
  }
  function ah(n) {
    var r = n;
    do {
      var l = r.alternate;
      if (n = r.return, (r.flags & 32768) === 0) {
        if (l = Gv(l, r, ha), l !== null) {
          Fn = l;
          return;
        }
      } else {
        if (l = ef(l, r), l !== null) {
          l.flags &= 32767, Fn = l;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          bn = 6, Fn = null;
          return;
        }
      }
      if (r = r.sibling, r !== null) {
        Fn = r;
        return;
      }
      Fn = r = n;
    } while (r !== null);
    bn === 0 && (bn = 5);
  }
  function Lu(n, r, l) {
    var o = kt, c = ur.transition;
    try {
      ur.transition = null, kt = 1, my(n, r, l, o);
    } finally {
      ur.transition = c, kt = o;
    }
    return null;
  }
  function my(n, r, l, o) {
    do
      wo();
    while (Ki !== null);
    if ((St & 6) !== 0) throw Error(D(327));
    l = n.finishedWork;
    var c = n.finishedLanes;
    if (l === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, l === n.current) throw Error(D(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var d = l.lanes | l.childLanes;
    if (Qf(n, d), n === Qn && (Fn = Qn = null, or = 0), (l.subtreeFlags & 2064) === 0 && (l.flags & 2064) === 0 || af || (af = !0, sh(tu, function() {
      return wo(), null;
    })), d = (l.flags & 15990) !== 0, (l.subtreeFlags & 15990) !== 0 || d) {
      d = ur.transition, ur.transition = null;
      var m = kt;
      kt = 1;
      var E = St;
      St |= 4, _u.current = null, Xv(n, l), jd(l, n), ao(fu), xa = !!rs, fu = rs = null, n.current = l, dy(l), Wa(), St = E, kt = m, ur.transition = d;
    } else n.current = l;
    if (af && (af = !1, Ki = n, zs = c), d = n.pendingLanes, d === 0 && (Ul = null), $o(l.stateNode), ta(n, qe()), r !== null) for (o = n.onRecoverableError, l = 0; l < r.length; l++) c = r[l], o(c.value, { componentStack: c.stack, digest: c.digest });
    if (Ro) throw Ro = !1, n = Du, Du = null, n;
    return (zs & 1) !== 0 && n.tag !== 0 && wo(), d = n.pendingLanes, (d & 1) !== 0 ? n === To ? Al++ : (Al = 0, To = n) : Al = 0, Ci(), null;
  }
  function wo() {
    if (Ki !== null) {
      var n = Xu(zs), r = ur.transition, l = kt;
      try {
        if (ur.transition = null, kt = 16 > n ? 16 : n, Ki === null) var o = !1;
        else {
          if (n = Ki, Ki = null, zs = 0, (St & 6) !== 0) throw Error(D(331));
          var c = St;
          for (St |= 4, pe = n.current; pe !== null; ) {
            var d = pe, m = d.child;
            if ((pe.flags & 16) !== 0) {
              var E = d.deletions;
              if (E !== null) {
                for (var T = 0; T < E.length; T++) {
                  var A = E[T];
                  for (pe = A; pe !== null; ) {
                    var W = pe;
                    switch (W.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Ds(8, W, d);
                    }
                    var q = W.child;
                    if (q !== null) q.return = W, pe = q;
                    else for (; pe !== null; ) {
                      W = pe;
                      var Q = W.sibling, se = W.return;
                      if (nf(W), W === A) {
                        pe = null;
                        break;
                      }
                      if (Q !== null) {
                        Q.return = se, pe = Q;
                        break;
                      }
                      pe = se;
                    }
                  }
                }
                var me = d.alternate;
                if (me !== null) {
                  var Se = me.child;
                  if (Se !== null) {
                    me.child = null;
                    do {
                      var _n = Se.sibling;
                      Se.sibling = null, Se = _n;
                    } while (Se !== null);
                  }
                }
                pe = d;
              }
            }
            if ((d.subtreeFlags & 2064) !== 0 && m !== null) m.return = d, pe = m;
            else e: for (; pe !== null; ) {
              if (d = pe, (d.flags & 2048) !== 0) switch (d.tag) {
                case 0:
                case 11:
                case 15:
                  Ds(9, d, d.return);
              }
              var k = d.sibling;
              if (k !== null) {
                k.return = d.return, pe = k;
                break e;
              }
              pe = d.return;
            }
          }
          var x = n.current;
          for (pe = x; pe !== null; ) {
            m = pe;
            var N = m.child;
            if ((m.subtreeFlags & 2064) !== 0 && N !== null) N.return = m, pe = N;
            else e: for (m = x; pe !== null; ) {
              if (E = pe, (E.flags & 2048) !== 0) try {
                switch (E.tag) {
                  case 0:
                  case 11:
                  case 15:
                    ks(9, E);
                }
              } catch (ye) {
                dn(E, E.return, ye);
              }
              if (E === m) {
                pe = null;
                break e;
              }
              var G = E.sibling;
              if (G !== null) {
                G.return = E.return, pe = G;
                break e;
              }
              pe = E.return;
            }
          }
          if (St = c, Ci(), Ir && typeof Ir.onPostCommitFiberRoot == "function") try {
            Ir.onPostCommitFiberRoot(vl, n);
          } catch {
          }
          o = !0;
        }
        return o;
      } finally {
        kt = l, ur.transition = r;
      }
    }
    return !1;
  }
  function ih(n, r, l) {
    r = xu(l, r), r = Vv(n, r, 1), n = Ol(n, r, 1), r = jn(), n !== null && (ji(n, 1, r), ta(n, r));
  }
  function dn(n, r, l) {
    if (n.tag === 3) ih(n, n, l);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        ih(r, n, l);
        break;
      } else if (r.tag === 1) {
        var o = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof o.componentDidCatch == "function" && (Ul === null || !Ul.has(o))) {
          n = xu(l, n), n = Ld(r, n, 1), r = Ol(r, n, 1), n = jn(), r !== null && (ji(r, 1, n), ta(r, n));
          break;
        }
      }
      r = r.return;
    }
  }
  function yy(n, r, l) {
    var o = n.pingCache;
    o !== null && o.delete(r), r = jn(), n.pingedLanes |= n.suspendedLanes & l, Qn === n && (or & l) === l && (bn === 4 || bn === 3 && (or & 130023424) === or && 500 > qe() - Pd ? Zi(n, 0) : rf |= l), ta(n, r);
  }
  function lh(n, r) {
    r === 0 && ((n.mode & 1) === 0 ? r = 1 : (r = ca, ca <<= 1, (ca & 130023424) === 0 && (ca = 4194304)));
    var l = jn();
    n = pa(n, r), n !== null && (ji(n, r, l), ta(n, l));
  }
  function gy(n) {
    var r = n.memoizedState, l = 0;
    r !== null && (l = r.retryLane), lh(n, l);
  }
  function uh(n, r) {
    var l = 0;
    switch (n.tag) {
      case 13:
        var o = n.stateNode, c = n.memoizedState;
        c !== null && (l = c.retryLane);
        break;
      case 19:
        o = n.stateNode;
        break;
      default:
        throw Error(D(314));
    }
    o !== null && o.delete(r), lh(n, l);
  }
  var oh;
  oh = function(n, r, l) {
    if (n !== null) if (n.memoizedProps !== r.pendingProps || In.current) Un = !0;
    else {
      if ((n.lanes & l) === 0 && (r.flags & 128) === 0) return Un = !1, xs(n, r, l);
      Un = (n.flags & 131072) !== 0;
    }
    else Un = !1, fn && (r.flags & 1048576) !== 0 && Lv(r, Qi, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var o = r.type;
        Ma(n, r), n = r.pendingProps;
        var c = Wr(r, Sn.current);
        mn(r, l), c = Ll(null, r, o, n, c, l);
        var d = ti();
        return r.flags |= 1, typeof c == "object" && c !== null && typeof c.render == "function" && c.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Mn(o) ? (d = !0, Xn(r)) : d = !1, r.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null, Td(r), c.updater = qc, r.stateNode = c, c._reactInternals = r, Es(r, o, n, l), r = Ts(null, r, o, !0, d, l)) : (r.tag = 0, fn && d && xc(r), lr(null, r, c, l), r = r.child), r;
      case 16:
        o = r.elementType;
        e: {
          switch (Ma(n, r), n = r.pendingProps, c = o._init, o = c(o._payload), r.type = o, c = r.tag = Ey(o), n = ni(o, n), c) {
            case 0:
              r = Bv(null, r, o, n, l);
              break e;
            case 1:
              r = $v(null, r, o, n, l);
              break e;
            case 11:
              r = Zr(null, r, o, n, l);
              break e;
            case 14:
              r = bu(null, r, o, ni(o.type, n), l);
              break e;
          }
          throw Error(D(
            306,
            o,
            ""
          ));
        }
        return r;
      case 0:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ni(o, c), Bv(n, r, o, c, l);
      case 1:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ni(o, c), $v(n, r, o, c, l);
      case 3:
        e: {
          if (yo(r), n === null) throw Error(D(387));
          o = r.pendingProps, d = r.memoizedState, c = d.element, zv(n, r), os(r, o, null, l);
          var m = r.memoizedState;
          if (o = m.element, d.isDehydrated) if (d = { element: o, isDehydrated: !1, cache: m.cache, pendingSuspenseBoundaries: m.pendingSuspenseBoundaries, transitions: m.transitions }, r.updateQueue.baseState = d, r.memoizedState = d, r.flags & 256) {
            c = xu(Error(D(423)), r), r = Iv(n, r, o, l, c);
            break e;
          } else if (o !== c) {
            c = xu(Error(D(424)), r), r = Iv(n, r, o, l, c);
            break e;
          } else for (qr = gi(r.stateNode.containerInfo.firstChild), Gr = r, fn = !0, Oa = null, l = ie(r, null, o, l), r.child = l; l; ) l.flags = l.flags & -3 | 4096, l = l.sibling;
          else {
            if (kl(), o === c) {
              r = Na(n, r, l);
              break e;
            }
            lr(n, r, o, l);
          }
          r = r.child;
        }
        return r;
      case 5:
        return Av(r), n === null && md(r), o = r.type, c = r.pendingProps, d = n !== null ? n.memoizedProps : null, m = c.children, Ec(o, c) ? m = null : d !== null && Ec(o, d) && (r.flags |= 32), Nd(n, r), lr(n, r, m, l), r.child;
      case 6:
        return n === null && md(r), null;
      case 13:
        return Jc(n, r, l);
      case 4:
        return xd(r, r.stateNode.containerInfo), o = r.pendingProps, n === null ? r.child = Tn(r, null, o, l) : lr(n, r, o, l), r.child;
      case 11:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ni(o, c), Zr(n, r, o, c, l);
      case 7:
        return lr(n, r, r.pendingProps, l), r.child;
      case 8:
        return lr(n, r, r.pendingProps.children, l), r.child;
      case 12:
        return lr(n, r, r.pendingProps.children, l), r.child;
      case 10:
        e: {
          if (o = r.type._context, c = r.pendingProps, d = r.memoizedProps, m = c.value, xe(da, o._currentValue), o._currentValue = m, d !== null) if (Ja(d.value, m)) {
            if (d.children === c.children && !In.current) {
              r = Na(n, r, l);
              break e;
            }
          } else for (d = r.child, d !== null && (d.return = r); d !== null; ) {
            var E = d.dependencies;
            if (E !== null) {
              m = d.child;
              for (var T = E.firstContext; T !== null; ) {
                if (T.context === o) {
                  if (d.tag === 1) {
                    T = Gi(-1, l & -l), T.tag = 2;
                    var A = d.updateQueue;
                    if (A !== null) {
                      A = A.shared;
                      var W = A.pending;
                      W === null ? T.next = T : (T.next = W.next, W.next = T), A.pending = T;
                    }
                  }
                  d.lanes |= l, T = d.alternate, T !== null && (T.lanes |= l), Ed(
                    d.return,
                    l,
                    r
                  ), E.lanes |= l;
                  break;
                }
                T = T.next;
              }
            } else if (d.tag === 10) m = d.type === r.type ? null : d.child;
            else if (d.tag === 18) {
              if (m = d.return, m === null) throw Error(D(341));
              m.lanes |= l, E = m.alternate, E !== null && (E.lanes |= l), Ed(m, l, r), m = d.sibling;
            } else m = d.child;
            if (m !== null) m.return = d;
            else for (m = d; m !== null; ) {
              if (m === r) {
                m = null;
                break;
              }
              if (d = m.sibling, d !== null) {
                d.return = m.return, m = d;
                break;
              }
              m = m.return;
            }
            d = m;
          }
          lr(n, r, c.children, l), r = r.child;
        }
        return r;
      case 9:
        return c = r.type, o = r.pendingProps.children, mn(r, l), c = La(c), o = o(c), r.flags |= 1, lr(n, r, o, l), r.child;
      case 14:
        return o = r.type, c = ni(o, r.pendingProps), c = ni(o.type, c), bu(n, r, o, c, l);
      case 15:
        return Xe(n, r, r.type, r.pendingProps, l);
      case 17:
        return o = r.type, c = r.pendingProps, c = r.elementType === o ? c : ni(o, c), Ma(n, r), r.tag = 1, Mn(o) ? (n = !0, Xn(r)) : n = !1, mn(r, l), Xc(r, o, c), Es(r, o, c, l), Ts(null, r, o, !0, n, l);
      case 19:
        return xi(n, r, l);
      case 22:
        return Rs(n, r, l);
    }
    throw Error(D(156, r.tag));
  };
  function sh(n, r) {
    return un(n, r);
  }
  function Sy(n, r, l, o) {
    this.tag = n, this.key = l, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = o, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ua(n, r, l, o) {
    return new Sy(n, r, l, o);
  }
  function Qd(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function Ey(n) {
    if (typeof n == "function") return Qd(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === wt) return 11;
      if (n === xt) return 14;
    }
    return 2;
  }
  function Fl(n, r) {
    var l = n.alternate;
    return l === null ? (l = Ua(n.tag, r, n.key, n.mode), l.elementType = n.elementType, l.type = n.type, l.stateNode = n.stateNode, l.alternate = n, n.alternate = l) : (l.pendingProps = r, l.type = n.type, l.flags = 0, l.subtreeFlags = 0, l.deletions = null), l.flags = n.flags & 14680064, l.childLanes = n.childLanes, l.lanes = n.lanes, l.child = n.child, l.memoizedProps = n.memoizedProps, l.memoizedState = n.memoizedState, l.updateQueue = n.updateQueue, r = n.dependencies, l.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, l.sibling = n.sibling, l.index = n.index, l.ref = n.ref, l;
  }
  function Fs(n, r, l, o, c, d) {
    var m = 2;
    if (o = n, typeof n == "function") Qd(n) && (m = 1);
    else if (typeof n == "string") m = 5;
    else e: switch (n) {
      case Fe:
        return Ji(l.children, c, d, r);
      case rn:
        m = 8, c |= 8;
        break;
      case Ft:
        return n = Ua(12, l, r, c | 2), n.elementType = Ft, n.lanes = d, n;
      case ke:
        return n = Ua(13, l, r, c), n.elementType = ke, n.lanes = d, n;
      case Ut:
        return n = Ua(19, l, r, c), n.elementType = Ut, n.lanes = d, n;
      case Ee:
        return jl(l, c, d, r);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case Kt:
            m = 10;
            break e;
          case an:
            m = 9;
            break e;
          case wt:
            m = 11;
            break e;
          case xt:
            m = 14;
            break e;
          case Dt:
            m = 16, o = null;
            break e;
        }
        throw Error(D(130, n == null ? n : typeof n, ""));
    }
    return r = Ua(m, l, r, c), r.elementType = n, r.type = o, r.lanes = d, r;
  }
  function Ji(n, r, l, o) {
    return n = Ua(7, n, o, r), n.lanes = l, n;
  }
  function jl(n, r, l, o) {
    return n = Ua(22, n, o, r), n.elementType = Ee, n.lanes = l, n.stateNode = { isHidden: !1 }, n;
  }
  function Wd(n, r, l) {
    return n = Ua(6, n, null, r), n.lanes = l, n;
  }
  function of(n, r, l) {
    return r = Ua(4, n.children !== null ? n.children : [], n.key, r), r.lanes = l, r.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, r;
  }
  function ch(n, r, l, o, c) {
    this.tag = r, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = qu(0), this.expirationTimes = qu(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = qu(0), this.identifierPrefix = o, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null;
  }
  function sf(n, r, l, o, c, d, m, E, T) {
    return n = new ch(n, r, l, E, T), r === 1 ? (r = 1, d === !0 && (r |= 8)) : r = 0, d = Ua(3, null, null, r), n.current = d, d.stateNode = n, d.memoizedState = { element: o, isDehydrated: l, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Td(d), n;
  }
  function Cy(n, r, l) {
    var o = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ot, key: o == null ? null : "" + o, children: n, containerInfo: r, implementation: l };
  }
  function Gd(n) {
    if (!n) return Er;
    n = n._reactInternals;
    e: {
      if (Ge(n) !== n || n.tag !== 1) throw Error(D(170));
      var r = n;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Mn(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(D(171));
    }
    if (n.tag === 1) {
      var l = n.type;
      if (Mn(l)) return ls(n, l, r);
    }
    return r;
  }
  function fh(n, r, l, o, c, d, m, E, T) {
    return n = sf(l, o, !0, n, c, d, m, E, T), n.context = Gd(null), l = n.current, o = jn(), c = ki(l), d = Gi(o, c), d.callback = r ?? null, Ol(l, d, c), n.current.lanes = c, ji(n, c, o), ta(n, o), n;
  }
  function cf(n, r, l, o) {
    var c = r.current, d = jn(), m = ki(c);
    return l = Gd(l), r.context === null ? r.context = l : r.pendingContext = l, r = Gi(d, m), r.payload = { element: n }, o = o === void 0 ? null : o, o !== null && (r.callback = o), n = Ol(c, r, m), n !== null && (Nr(n, c, m, d), kc(n, c, m)), m;
  }
  function ff(n) {
    return n = n.current, n.child ? (n.child.tag === 5, n.child.stateNode) : null;
  }
  function qd(n, r) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var l = n.retryLane;
      n.retryLane = l !== 0 && l < r ? l : r;
    }
  }
  function df(n, r) {
    qd(n, r), (n = n.alternate) && qd(n, r);
  }
  function dh() {
    return null;
  }
  var Mu = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function Xd(n) {
    this._internalRoot = n;
  }
  pf.prototype.render = Xd.prototype.render = function(n) {
    var r = this._internalRoot;
    if (r === null) throw Error(D(409));
    cf(n, r, null, null);
  }, pf.prototype.unmount = Xd.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var r = n.containerInfo;
      Ou(function() {
        cf(null, n, null, null);
      }), r[Ii] = null;
    }
  };
  function pf(n) {
    this._internalRoot = n;
  }
  pf.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var r = Pe();
      n = { blockedOn: null, target: n, priority: r };
      for (var l = 0; l < $n.length && r !== 0 && r < $n[l].priority; l++) ;
      $n.splice(l, 0, n), l === 0 && Qo(n);
    }
  };
  function Kd(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function vf(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function ph() {
  }
  function Ry(n, r, l, o, c) {
    if (c) {
      if (typeof o == "function") {
        var d = o;
        o = function() {
          var A = ff(m);
          d.call(A);
        };
      }
      var m = fh(r, o, n, 0, null, !1, !1, "", ph);
      return n._reactRootContainer = m, n[Ii] = m.current, lo(n.nodeType === 8 ? n.parentNode : n), Ou(), m;
    }
    for (; c = n.lastChild; ) n.removeChild(c);
    if (typeof o == "function") {
      var E = o;
      o = function() {
        var A = ff(T);
        E.call(A);
      };
    }
    var T = sf(n, 0, !1, null, null, !1, !1, "", ph);
    return n._reactRootContainer = T, n[Ii] = T.current, lo(n.nodeType === 8 ? n.parentNode : n), Ou(function() {
      cf(r, T, l, o);
    }), T;
  }
  function js(n, r, l, o, c) {
    var d = l._reactRootContainer;
    if (d) {
      var m = d;
      if (typeof c == "function") {
        var E = c;
        c = function() {
          var T = ff(m);
          E.call(T);
        };
      }
      cf(r, m, n, c);
    } else m = Ry(l, r, n, c, o);
    return ff(m);
  }
  Rt = function(n) {
    switch (n.tag) {
      case 3:
        var r = n.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var l = qa(r.pendingLanes);
          l !== 0 && (Hi(r, l | 1), ta(r, qe()), (St & 6) === 0 && (Co = qe() + 500, Ci()));
        }
        break;
      case 13:
        Ou(function() {
          var o = pa(n, 1);
          if (o !== null) {
            var c = jn();
            Nr(o, n, 1, c);
          }
        }), df(n, 1);
    }
  }, Io = function(n) {
    if (n.tag === 13) {
      var r = pa(n, 134217728);
      if (r !== null) {
        var l = jn();
        Nr(r, n, 134217728, l);
      }
      df(n, 134217728);
    }
  }, pi = function(n) {
    if (n.tag === 13) {
      var r = ki(n), l = pa(n, r);
      if (l !== null) {
        var o = jn();
        Nr(l, n, r, o);
      }
      df(n, r);
    }
  }, Pe = function() {
    return kt;
  }, Ku = function(n, r) {
    var l = kt;
    try {
      return kt = n, r();
    } finally {
      kt = l;
    }
  }, $t = function(n, r, l) {
    switch (r) {
      case "input":
        if ($r(n, l), r = l.name, l.type === "radio" && r != null) {
          for (l = n; l.parentNode; ) l = l.parentNode;
          for (l = l.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < l.length; r++) {
            var o = l[r];
            if (o !== n && o.form === n.form) {
              var c = hn(o);
              if (!c) throw Error(D(90));
              wr(o), $r(o, c);
            }
          }
        }
        break;
      case "textarea":
        $a(n, l);
        break;
      case "select":
        r = l.value, r != null && Cn(n, !!l.multiple, r, !1);
    }
  }, Zl = $d, fl = Ou;
  var Ty = { usingClientEntryPoint: !1, Events: [_e, ei, hn, Fi, Kl, $d] }, Hs = { findFiberByHostInstance: du, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, vh = { bundleType: Hs.bundleType, version: Hs.version, rendererPackageName: Hs.rendererPackageName, rendererConfig: Hs.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: pt.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = Rn(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: Hs.findFiberByHostInstance || dh, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Hl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Hl.isDisabled && Hl.supportsFiber) try {
      vl = Hl.inject(vh), Ir = Hl;
    } catch {
    }
  }
  return Pa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ty, Pa.createPortal = function(n, r) {
    var l = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Kd(r)) throw Error(D(200));
    return Cy(n, r, null, l);
  }, Pa.createRoot = function(n, r) {
    if (!Kd(n)) throw Error(D(299));
    var l = !1, o = "", c = Mu;
    return r != null && (r.unstable_strictMode === !0 && (l = !0), r.identifierPrefix !== void 0 && (o = r.identifierPrefix), r.onRecoverableError !== void 0 && (c = r.onRecoverableError)), r = sf(n, 1, !1, null, null, l, !1, o, c), n[Ii] = r.current, lo(n.nodeType === 8 ? n.parentNode : n), new Xd(r);
  }, Pa.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var r = n._reactInternals;
    if (r === void 0)
      throw typeof n.render == "function" ? Error(D(188)) : (n = Object.keys(n).join(","), Error(D(268, n)));
    return n = Rn(r), n = n === null ? null : n.stateNode, n;
  }, Pa.flushSync = function(n) {
    return Ou(n);
  }, Pa.hydrate = function(n, r, l) {
    if (!vf(r)) throw Error(D(200));
    return js(null, n, r, !0, l);
  }, Pa.hydrateRoot = function(n, r, l) {
    if (!Kd(n)) throw Error(D(405));
    var o = l != null && l.hydratedSources || null, c = !1, d = "", m = Mu;
    if (l != null && (l.unstable_strictMode === !0 && (c = !0), l.identifierPrefix !== void 0 && (d = l.identifierPrefix), l.onRecoverableError !== void 0 && (m = l.onRecoverableError)), r = fh(r, null, n, 1, l ?? null, c, !1, d, m), n[Ii] = r.current, lo(n), o) for (n = 0; n < o.length; n++) l = o[n], c = l._getVersion, c = c(l._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [l, c] : r.mutableSourceEagerHydrationData.push(
      l,
      c
    );
    return new pf(r);
  }, Pa.render = function(n, r, l) {
    if (!vf(r)) throw Error(D(200));
    return js(null, n, r, !1, l);
  }, Pa.unmountComponentAtNode = function(n) {
    if (!vf(n)) throw Error(D(40));
    return n._reactRootContainer ? (Ou(function() {
      js(null, null, n, !1, function() {
        n._reactRootContainer = null, n[Ii] = null;
      });
    }), !0) : !1;
  }, Pa.unstable_batchedUpdates = $d, Pa.unstable_renderSubtreeIntoContainer = function(n, r, l, o) {
    if (!vf(l)) throw Error(D(200));
    if (n == null || n._reactInternals === void 0) throw Error(D(38));
    return js(n, r, l, !1, o);
  }, Pa.version = "18.3.1-next-f1338f8080-20240426", Pa;
}
var Ba = {};
var sT;
function fD() {
  return sT || (sT = 1, process.env.NODE_ENV !== "production" && (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var M = ev(), j = vT(), D = M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Be = !1;
    function ht(e) {
      Be = e;
    }
    function _t(e) {
      if (!Be) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        Pt("warn", e, a);
      }
    }
    function S(e) {
      if (!Be) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        Pt("error", e, a);
      }
    }
    function Pt(e, t, a) {
      {
        var i = D.ReactDebugCurrentFrame, u = i.getStackAddendum();
        u !== "" && (t += "%s", a = a.concat([u]));
        var s = a.map(function(f) {
          return String(f);
        });
        s.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var de = 0, ve = 1, ut = 2, ee = 3, Ce = 4, ue = 5, Ye = 6, yt = 7, dt = 8, cn = 9, ft = 10, Qe = 11, pt = 12, be = 13, ot = 14, Fe = 15, rn = 16, Ft = 17, Kt = 18, an = 19, wt = 21, ke = 22, Ut = 23, xt = 24, Dt = 25, Ee = !0, Z = !1, Re = !1, ne = !1, _ = !1, B = !0, je = !0, Ue = !0, rt = !0, Je = /* @__PURE__ */ new Set(), Ke = {}, et = {};
    function at(e, t) {
      Vt(e, t), Vt(e + "Capture", t);
    }
    function Vt(e, t) {
      Ke[e] && S("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), Ke[e] = t;
      {
        var a = e.toLowerCase();
        et[a] = e, e === "onDoubleClick" && (et.ondblclick = e);
      }
      for (var i = 0; i < t.length; i++)
        Je.add(t[i]);
    }
    var kn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", wr = Object.prototype.hasOwnProperty;
    function En(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function tr(e) {
      try {
        return Vn(e), !1;
      } catch {
        return !0;
      }
    }
    function Vn(e) {
      return "" + e;
    }
    function Pn(e, t) {
      if (tr(e))
        return S("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, En(e)), Vn(e);
    }
    function $r(e) {
      if (tr(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", En(e)), Vn(e);
    }
    function oi(e, t) {
      if (tr(e))
        return S("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, En(e)), Vn(e);
    }
    function ua(e, t) {
      if (tr(e))
        return S("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, En(e)), Vn(e);
    }
    function Gn(e) {
      if (tr(e))
        return S("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", En(e)), Vn(e);
    }
    function Cn(e) {
      if (tr(e))
        return S("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", En(e)), Vn(e);
    }
    var Bn = 0, yr = 1, $a = 2, On = 3, gr = 4, oa = 5, Ia = 6, si = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", J = si + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Te = new RegExp("^[" + si + "][" + J + "]*$"), tt = {}, At = {};
    function Zt(e) {
      return wr.call(At, e) ? !0 : wr.call(tt, e) ? !1 : Te.test(e) ? (At[e] = !0, !0) : (tt[e] = !0, S("Invalid attribute name: `%s`", e), !1);
    }
    function pn(e, t, a) {
      return t !== null ? t.type === Bn : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function ln(e, t, a, i) {
      if (a !== null && a.type === Bn)
        return !1;
      switch (typeof t) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (i)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var u = e.toLowerCase().slice(0, 5);
          return u !== "data-" && u !== "aria-";
        }
        default:
          return !1;
      }
    }
    function qn(e, t, a, i) {
      if (t === null || typeof t > "u" || ln(e, t, a, i))
        return !0;
      if (i)
        return !1;
      if (a !== null)
        switch (a.type) {
          case On:
            return !t;
          case gr:
            return t === !1;
          case oa:
            return isNaN(t);
          case Ia:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Jt(e) {
      return $t.hasOwnProperty(e) ? $t[e] : null;
    }
    function Bt(e, t, a, i, u, s, f) {
      this.acceptsBooleans = t === $a || t === On || t === gr, this.attributeName = i, this.attributeNamespace = u, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = s, this.removeEmptyString = f;
    }
    var $t = {}, sa = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    sa.forEach(function(e) {
      $t[e] = new Bt(
        e,
        Bn,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      $t[t] = new Bt(
        t,
        yr,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      $t[e] = new Bt(
        e,
        $a,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      $t[e] = new Bt(
        e,
        $a,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      $t[e] = new Bt(
        e,
        On,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      $t[e] = new Bt(
        e,
        On,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      $t[e] = new Bt(
        e,
        gr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      $t[e] = new Bt(
        e,
        Ia,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      $t[e] = new Bt(
        e,
        oa,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Sr = /[\-\:]([a-z])/g, Ra = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, Ra);
      $t[t] = new Bt(
        t,
        yr,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, Ra);
      $t[t] = new Bt(
        t,
        yr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Sr, Ra);
      $t[t] = new Bt(
        t,
        yr,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      $t[e] = new Bt(
        e,
        yr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Fi = "xlinkHref";
    $t[Fi] = new Bt(
      "xlinkHref",
      yr,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      $t[e] = new Bt(
        e,
        yr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Kl = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Zl = !1;
    function fl(e) {
      !Zl && Kl.test(e) && (Zl = !0, S("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function dl(e, t, a, i) {
      if (i.mustUseProperty) {
        var u = i.propertyName;
        return e[u];
      } else {
        Pn(a, t), i.sanitizeURL && fl("" + a);
        var s = i.attributeName, f = null;
        if (i.type === gr) {
          if (e.hasAttribute(s)) {
            var p = e.getAttribute(s);
            return p === "" ? !0 : qn(t, a, i, !1) ? p : p === "" + a ? a : p;
          }
        } else if (e.hasAttribute(s)) {
          if (qn(t, a, i, !1))
            return e.getAttribute(s);
          if (i.type === On)
            return a;
          f = e.getAttribute(s);
        }
        return qn(t, a, i, !1) ? f === null ? a : f : f === "" + a ? a : f;
      }
    }
    function Jl(e, t, a, i) {
      {
        if (!Zt(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var u = e.getAttribute(t);
        return Pn(a, t), u === "" + a ? a : u;
      }
    }
    function xr(e, t, a, i) {
      var u = Jt(t);
      if (!pn(t, u, i)) {
        if (qn(t, a, u, i) && (a = null), i || u === null) {
          if (Zt(t)) {
            var s = t;
            a === null ? e.removeAttribute(s) : (Pn(a, t), e.setAttribute(s, "" + a));
          }
          return;
        }
        var f = u.mustUseProperty;
        if (f) {
          var p = u.propertyName;
          if (a === null) {
            var v = u.type;
            e[p] = v === On ? !1 : "";
          } else
            e[p] = a;
          return;
        }
        var y = u.attributeName, g = u.attributeNamespace;
        if (a === null)
          e.removeAttribute(y);
        else {
          var b = u.type, w;
          b === On || b === gr && a === !0 ? w = "" : (Pn(a, y), w = "" + a, u.sanitizeURL && fl(w.toString())), g ? e.setAttributeNS(g, y, w) : e.setAttribute(y, w);
        }
      }
    }
    var br = /* @__PURE__ */ Symbol.for("react.element"), nr = /* @__PURE__ */ Symbol.for("react.portal"), ci = /* @__PURE__ */ Symbol.for("react.fragment"), Ya = /* @__PURE__ */ Symbol.for("react.strict_mode"), fi = /* @__PURE__ */ Symbol.for("react.profiler"), di = /* @__PURE__ */ Symbol.for("react.provider"), R = /* @__PURE__ */ Symbol.for("react.context"), I = /* @__PURE__ */ Symbol.for("react.forward_ref"), ae = /* @__PURE__ */ Symbol.for("react.suspense"), he = /* @__PURE__ */ Symbol.for("react.suspense_list"), Ge = /* @__PURE__ */ Symbol.for("react.memo"), $e = /* @__PURE__ */ Symbol.for("react.lazy"), st = /* @__PURE__ */ Symbol.for("react.scope"), it = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), Rn = /* @__PURE__ */ Symbol.for("react.offscreen"), en = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), un = /* @__PURE__ */ Symbol.for("react.cache"), rr = /* @__PURE__ */ Symbol.for("react.tracing_marker"), Qa = Symbol.iterator, Wa = "@@iterator";
    function qe(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Qa && e[Qa] || e[Wa];
      return typeof t == "function" ? t : null;
    }
    var Ze = Object.assign, Ga = 0, eu, tu, pl, Yu, vl, Ir, $o;
    function _r() {
    }
    _r.__reactDisabledLog = !0;
    function ic() {
      {
        if (Ga === 0) {
          eu = console.log, tu = console.info, pl = console.warn, Yu = console.error, vl = console.group, Ir = console.groupCollapsed, $o = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: _r,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Ga++;
      }
    }
    function lc() {
      {
        if (Ga--, Ga === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ze({}, e, {
              value: eu
            }),
            info: Ze({}, e, {
              value: tu
            }),
            warn: Ze({}, e, {
              value: pl
            }),
            error: Ze({}, e, {
              value: Yu
            }),
            group: Ze({}, e, {
              value: vl
            }),
            groupCollapsed: Ze({}, e, {
              value: Ir
            }),
            groupEnd: Ze({}, e, {
              value: $o
            })
          });
        }
        Ga < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Qu = D.ReactCurrentDispatcher, hl;
    function ca(e, t, a) {
      {
        if (hl === void 0)
          try {
            throw Error();
          } catch (u) {
            var i = u.stack.trim().match(/\n( *(at )?)/);
            hl = i && i[1] || "";
          }
        return `
` + hl + e;
      }
    }
    var qa = !1, Xa;
    {
      var Wu = typeof WeakMap == "function" ? WeakMap : Map;
      Xa = new Wu();
    }
    function nu(e, t) {
      if (!e || qa)
        return "";
      {
        var a = Xa.get(e);
        if (a !== void 0)
          return a;
      }
      var i;
      qa = !0;
      var u = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = Qu.current, Qu.current = null, ic();
      try {
        if (t) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (F) {
              i = F;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (F) {
              i = F;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            i = F;
          }
          e();
        }
      } catch (F) {
        if (F && i && typeof F.stack == "string") {
          for (var p = F.stack.split(`
`), v = i.stack.split(`
`), y = p.length - 1, g = v.length - 1; y >= 1 && g >= 0 && p[y] !== v[g]; )
            g--;
          for (; y >= 1 && g >= 0; y--, g--)
            if (p[y] !== v[g]) {
              if (y !== 1 || g !== 1)
                do
                  if (y--, g--, g < 0 || p[y] !== v[g]) {
                    var b = `
` + p[y].replace(" at new ", " at ");
                    return e.displayName && b.includes("<anonymous>") && (b = b.replace("<anonymous>", e.displayName)), typeof e == "function" && Xa.set(e, b), b;
                  }
                while (y >= 1 && g >= 0);
              break;
            }
        }
      } finally {
        qa = !1, Qu.current = s, lc(), Error.prepareStackTrace = u;
      }
      var w = e ? e.displayName || e.name : "", z = w ? ca(w) : "";
      return typeof e == "function" && Xa.set(e, z), z;
    }
    function ml(e, t, a) {
      return nu(e, !0);
    }
    function Gu(e, t, a) {
      return nu(e, !1);
    }
    function qu(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function ji(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return nu(e, qu(e));
      if (typeof e == "string")
        return ca(e);
      switch (e) {
        case ae:
          return ca("Suspense");
        case he:
          return ca("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case I:
            return Gu(e.render);
          case Ge:
            return ji(e.type, t, a);
          case $e: {
            var i = e, u = i._payload, s = i._init;
            try {
              return ji(s(u), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function Qf(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case ue:
          return ca(e.type);
        case rn:
          return ca("Lazy");
        case be:
          return ca("Suspense");
        case an:
          return ca("SuspenseList");
        case de:
        case ut:
        case Fe:
          return Gu(e.type);
        case Qe:
          return Gu(e.type.render);
        case ve:
          return ml(e.type);
        default:
          return "";
      }
    }
    function Hi(e) {
      try {
        var t = "", a = e;
        do
          t += Qf(a), a = a.return;
        while (a);
        return t;
      } catch (i) {
        return `
Error generating stack: ` + i.message + `
` + i.stack;
      }
    }
    function kt(e, t, a) {
      var i = e.displayName;
      if (i)
        return i;
      var u = t.displayName || t.name || "";
      return u !== "" ? a + "(" + u + ")" : a;
    }
    function Xu(e) {
      return e.displayName || "Context";
    }
    function Rt(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case ci:
          return "Fragment";
        case nr:
          return "Portal";
        case fi:
          return "Profiler";
        case Ya:
          return "StrictMode";
        case ae:
          return "Suspense";
        case he:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case R:
            var t = e;
            return Xu(t) + ".Consumer";
          case di:
            var a = e;
            return Xu(a._context) + ".Provider";
          case I:
            return kt(e, e.render, "ForwardRef");
          case Ge:
            var i = e.displayName || null;
            return i !== null ? i : Rt(e.type) || "Memo";
          case $e: {
            var u = e, s = u._payload, f = u._init;
            try {
              return Rt(f(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Io(e, t, a) {
      var i = t.displayName || t.name || "";
      return e.displayName || (i !== "" ? a + "(" + i + ")" : a);
    }
    function pi(e) {
      return e.displayName || "Context";
    }
    function Pe(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case xt:
          return "Cache";
        case cn:
          var i = a;
          return pi(i) + ".Consumer";
        case ft:
          var u = a;
          return pi(u._context) + ".Provider";
        case Kt:
          return "DehydratedFragment";
        case Qe:
          return Io(a, a.render, "ForwardRef");
        case yt:
          return "Fragment";
        case ue:
          return a;
        case Ce:
          return "Portal";
        case ee:
          return "Root";
        case Ye:
          return "Text";
        case rn:
          return Rt(a);
        case dt:
          return a === Ya ? "StrictMode" : "Mode";
        case ke:
          return "Offscreen";
        case pt:
          return "Profiler";
        case wt:
          return "Scope";
        case be:
          return "Suspense";
        case an:
          return "SuspenseList";
        case Dt:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case ve:
        case de:
        case Ft:
        case ut:
        case ot:
        case Fe:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var Ku = D.ReactDebugCurrentFrame, ar = null, vi = !1;
    function Dr() {
      {
        if (ar === null)
          return null;
        var e = ar._debugOwner;
        if (e !== null && typeof e < "u")
          return Pe(e);
      }
      return null;
    }
    function hi() {
      return ar === null ? "" : Hi(ar);
    }
    function on() {
      Ku.getCurrentStack = null, ar = null, vi = !1;
    }
    function It(e) {
      Ku.getCurrentStack = e === null ? null : hi, ar = e, vi = !1;
    }
    function yl() {
      return ar;
    }
    function $n(e) {
      vi = e;
    }
    function kr(e) {
      return "" + e;
    }
    function Ta(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return Cn(e), e;
        default:
          return "";
      }
    }
    var ru = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Yo(e, t) {
      ru[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || S("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || S("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Qo(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function gl(e) {
      return e._valueTracker;
    }
    function au(e) {
      e._valueTracker = null;
    }
    function Wf(e) {
      var t = "";
      return e && (Qo(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function wa(e) {
      var t = Qo(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      Cn(e[t]);
      var i = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var u = a.get, s = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return u.call(this);
          },
          set: function(p) {
            Cn(p), i = "" + p, s.call(this, p);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var f = {
          getValue: function() {
            return i;
          },
          setValue: function(p) {
            Cn(p), i = "" + p;
          },
          stopTracking: function() {
            au(e), delete e[t];
          }
        };
        return f;
      }
    }
    function Ka(e) {
      gl(e) || (e._valueTracker = wa(e));
    }
    function mi(e) {
      if (!e)
        return !1;
      var t = gl(e);
      if (!t)
        return !0;
      var a = t.getValue(), i = Wf(e);
      return i !== a ? (t.setValue(i), !0) : !1;
    }
    function xa(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var Zu = !1, Ju = !1, Sl = !1, iu = !1;
    function eo(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function to(e, t) {
      var a = e, i = t.checked, u = Ze({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: i ?? a._wrapperState.initialChecked
      });
      return u;
    }
    function Za(e, t) {
      Yo("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !Ju && (S("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Dr() || "A component", t.type), Ju = !0), t.value !== void 0 && t.defaultValue !== void 0 && !Zu && (S("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Dr() || "A component", t.type), Zu = !0);
      var a = e, i = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: Ta(t.value != null ? t.value : i),
        controlled: eo(t)
      };
    }
    function h(e, t) {
      var a = e, i = t.checked;
      i != null && xr(a, "checked", i, !1);
    }
    function C(e, t) {
      var a = e;
      {
        var i = eo(t);
        !a._wrapperState.controlled && i && !iu && (S("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), iu = !0), a._wrapperState.controlled && !i && !Sl && (S("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Sl = !0);
      }
      h(e, t);
      var u = Ta(t.value), s = t.type;
      if (u != null)
        s === "number" ? (u === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != u) && (a.value = kr(u)) : a.value !== kr(u) && (a.value = kr(u));
      else if (s === "submit" || s === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? Oe(a, t.type, u) : t.hasOwnProperty("defaultValue") && Oe(a, t.type, Ta(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function U(e, t, a) {
      var i = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var u = t.type, s = u === "submit" || u === "reset";
        if (s && (t.value === void 0 || t.value === null))
          return;
        var f = kr(i._wrapperState.initialValue);
        a || f !== i.value && (i.value = f), i.defaultValue = f;
      }
      var p = i.name;
      p !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, p !== "" && (i.name = p);
    }
    function H(e, t) {
      var a = e;
      C(a, t), K(a, t);
    }
    function K(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var i = e; i.parentNode; )
          i = i.parentNode;
        Pn(a, "name");
        for (var u = i.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), s = 0; s < u.length; s++) {
          var f = u[s];
          if (!(f === e || f.form !== e.form)) {
            var p = Mh(f);
            if (!p)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            mi(f), C(f, p);
          }
        }
      }
    }
    function Oe(e, t, a) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || xa(e.ownerDocument) !== e) && (a == null ? e.defaultValue = kr(e._wrapperState.initialValue) : e.defaultValue !== kr(a) && (e.defaultValue = kr(a)));
    }
    var re = !1, Ne = !1, ct = !1;
    function Tt(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? M.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || Ne || (Ne = !0, S("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (ct || (ct = !0, S("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !re && (S("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), re = !0);
    }
    function tn(e, t) {
      t.value != null && e.setAttribute("value", kr(Ta(t.value)));
    }
    var Yt = Array.isArray;
    function nt(e) {
      return Yt(e);
    }
    var Qt;
    Qt = !1;
    function vn() {
      var e = Dr();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var El = ["value", "defaultValue"];
    function Wo(e) {
      {
        Yo("select", e);
        for (var t = 0; t < El.length; t++) {
          var a = El[t];
          if (e[a] != null) {
            var i = nt(e[a]);
            e.multiple && !i ? S("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, vn()) : !e.multiple && i && S("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, vn());
          }
        }
      }
    }
    function Vi(e, t, a, i) {
      var u = e.options;
      if (t) {
        for (var s = a, f = {}, p = 0; p < s.length; p++)
          f["$" + s[p]] = !0;
        for (var v = 0; v < u.length; v++) {
          var y = f.hasOwnProperty("$" + u[v].value);
          u[v].selected !== y && (u[v].selected = y), y && i && (u[v].defaultSelected = !0);
        }
      } else {
        for (var g = kr(Ta(a)), b = null, w = 0; w < u.length; w++) {
          if (u[w].value === g) {
            u[w].selected = !0, i && (u[w].defaultSelected = !0);
            return;
          }
          b === null && !u[w].disabled && (b = u[w]);
        }
        b !== null && (b.selected = !0);
      }
    }
    function Go(e, t) {
      return Ze({}, t, {
        value: void 0
      });
    }
    function lu(e, t) {
      var a = e;
      Wo(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !Qt && (S("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Qt = !0);
    }
    function Gf(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var i = t.value;
      i != null ? Vi(a, !!t.multiple, i, !1) : t.defaultValue != null && Vi(a, !!t.multiple, t.defaultValue, !0);
    }
    function uc(e, t) {
      var a = e, i = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var u = t.value;
      u != null ? Vi(a, !!t.multiple, u, !1) : i !== !!t.multiple && (t.defaultValue != null ? Vi(a, !!t.multiple, t.defaultValue, !0) : Vi(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function qf(e, t) {
      var a = e, i = t.value;
      i != null && Vi(a, !!t.multiple, i, !1);
    }
    var tv = !1;
    function Xf(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var i = Ze({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: kr(a._wrapperState.initialValue)
      });
      return i;
    }
    function Kf(e, t) {
      var a = e;
      Yo("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !tv && (S("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Dr() || "A component"), tv = !0);
      var i = t.value;
      if (i == null) {
        var u = t.children, s = t.defaultValue;
        if (u != null) {
          S("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (s != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (nt(u)) {
              if (u.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              u = u[0];
            }
            s = u;
          }
        }
        s == null && (s = ""), i = s;
      }
      a._wrapperState = {
        initialValue: Ta(i)
      };
    }
    function nv(e, t) {
      var a = e, i = Ta(t.value), u = Ta(t.defaultValue);
      if (i != null) {
        var s = kr(i);
        s !== a.value && (a.value = s), t.defaultValue == null && a.defaultValue !== s && (a.defaultValue = s);
      }
      u != null && (a.defaultValue = kr(u));
    }
    function rv(e, t) {
      var a = e, i = a.textContent;
      i === a._wrapperState.initialValue && i !== "" && i !== null && (a.value = i);
    }
    function Zm(e, t) {
      nv(e, t);
    }
    var Pi = "http://www.w3.org/1999/xhtml", Zf = "http://www.w3.org/1998/Math/MathML", Jf = "http://www.w3.org/2000/svg";
    function ed(e) {
      switch (e) {
        case "svg":
          return Jf;
        case "math":
          return Zf;
        default:
          return Pi;
      }
    }
    function td(e, t) {
      return e == null || e === Pi ? ed(t) : e === Jf && t === "foreignObject" ? Pi : e;
    }
    var av = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, i, u) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, i, u);
        });
      } : e;
    }, oc, iv = av(function(e, t) {
      if (e.namespaceURI === Jf && !("innerHTML" in e)) {
        oc = oc || document.createElement("div"), oc.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = oc.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), Yr = 1, Bi = 3, Ln = 8, $i = 9, nd = 11, no = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === Bi) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, qo = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Xo = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function lv(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var uv = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Xo).forEach(function(e) {
      uv.forEach(function(t) {
        Xo[lv(t, e)] = Xo[e];
      });
    });
    function sc(e, t, a) {
      var i = t == null || typeof t == "boolean" || t === "";
      return i ? "" : !a && typeof t == "number" && t !== 0 && !(Xo.hasOwnProperty(e) && Xo[e]) ? t + "px" : (ua(t, e), ("" + t).trim());
    }
    var ov = /([A-Z])/g, sv = /^ms-/;
    function ro(e) {
      return e.replace(ov, "-$1").toLowerCase().replace(sv, "-ms-");
    }
    var cv = function() {
    };
    {
      var Jm = /^(?:webkit|moz|o)[A-Z]/, ey = /^-ms-/, fv = /-(.)/g, rd = /;\s*$/, yi = {}, uu = {}, dv = !1, Ko = !1, ty = function(e) {
        return e.replace(fv, function(t, a) {
          return a.toUpperCase();
        });
      }, pv = function(e) {
        yi.hasOwnProperty(e) && yi[e] || (yi[e] = !0, S(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          ty(e.replace(ey, "ms-"))
        ));
      }, ad = function(e) {
        yi.hasOwnProperty(e) && yi[e] || (yi[e] = !0, S("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, id = function(e, t) {
        uu.hasOwnProperty(t) && uu[t] || (uu[t] = !0, S(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(rd, "")));
      }, vv = function(e, t) {
        dv || (dv = !0, S("`NaN` is an invalid value for the `%s` css style property.", e));
      }, hv = function(e, t) {
        Ko || (Ko = !0, S("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      cv = function(e, t) {
        e.indexOf("-") > -1 ? pv(e) : Jm.test(e) ? ad(e) : rd.test(t) && id(e, t), typeof t == "number" && (isNaN(t) ? vv(e, t) : isFinite(t) || hv(e, t));
      };
    }
    var mv = cv;
    function ny(e) {
      {
        var t = "", a = "";
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var u = e[i];
            if (u != null) {
              var s = i.indexOf("--") === 0;
              t += a + (s ? i : ro(i)) + ":", t += sc(i, u, s), a = ";";
            }
          }
        return t || null;
      }
    }
    function yv(e, t) {
      var a = e.style;
      for (var i in t)
        if (t.hasOwnProperty(i)) {
          var u = i.indexOf("--") === 0;
          u || mv(i, t[i]);
          var s = sc(i, t[i], u);
          i === "float" && (i = "cssFloat"), u ? a.setProperty(i, s) : a[i] = s;
        }
    }
    function ry(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function gv(e) {
      var t = {};
      for (var a in e)
        for (var i = qo[a] || [a], u = 0; u < i.length; u++)
          t[i[u]] = a;
      return t;
    }
    function ay(e, t) {
      {
        if (!t)
          return;
        var a = gv(e), i = gv(t), u = {};
        for (var s in a) {
          var f = a[s], p = i[s];
          if (p && f !== p) {
            var v = f + "," + p;
            if (u[v])
              continue;
            u[v] = !0, S("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", ry(e[f]) ? "Removing" : "Updating", f, p);
          }
        }
      }
    }
    var Ja = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Zo = Ze({
      menuitem: !0
    }, Ja), Sv = "__html";
    function cc(e, t) {
      if (t) {
        if (Zo[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(Sv in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && S("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Cl(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Jo = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, fc = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, ao = {}, iy = new RegExp("^(aria)-[" + J + "]*$"), io = new RegExp("^(aria)[A-Z][" + J + "]*$");
    function ld(e, t) {
      {
        if (wr.call(ao, t) && ao[t])
          return !0;
        if (io.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), i = fc.hasOwnProperty(a) ? a : null;
          if (i == null)
            return S("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), ao[t] = !0, !0;
          if (t !== i)
            return S("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), ao[t] = !0, !0;
        }
        if (iy.test(t)) {
          var u = t.toLowerCase(), s = fc.hasOwnProperty(u) ? u : null;
          if (s == null)
            return ao[t] = !0, !1;
          if (t !== s)
            return S("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, s), ao[t] = !0, !0;
        }
      }
      return !0;
    }
    function es(e, t) {
      {
        var a = [];
        for (var i in t) {
          var u = ld(e, i);
          u || a.push(i);
        }
        var s = a.map(function(f) {
          return "`" + f + "`";
        }).join(", ");
        a.length === 1 ? S("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", s, e) : a.length > 1 && S("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", s, e);
      }
    }
    function ud(e, t) {
      Cl(e, t) || es(e, t);
    }
    var od = !1;
    function dc(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !od && (od = !0, e === "select" && t.multiple ? S("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : S("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var ou = function() {
    };
    {
      var ir = {}, sd = /^on./, pc = /^on[^A-Z]/, Ev = new RegExp("^(aria)-[" + J + "]*$"), Cv = new RegExp("^(aria)[A-Z][" + J + "]*$");
      ou = function(e, t, a, i) {
        if (wr.call(ir, t) && ir[t])
          return !0;
        var u = t.toLowerCase();
        if (u === "onfocusin" || u === "onfocusout")
          return S("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ir[t] = !0, !0;
        if (i != null) {
          var s = i.registrationNameDependencies, f = i.possibleRegistrationNames;
          if (s.hasOwnProperty(t))
            return !0;
          var p = f.hasOwnProperty(u) ? f[u] : null;
          if (p != null)
            return S("Invalid event handler property `%s`. Did you mean `%s`?", t, p), ir[t] = !0, !0;
          if (sd.test(t))
            return S("Unknown event handler property `%s`. It will be ignored.", t), ir[t] = !0, !0;
        } else if (sd.test(t))
          return pc.test(t) && S("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), ir[t] = !0, !0;
        if (Ev.test(t) || Cv.test(t))
          return !0;
        if (u === "innerhtml")
          return S("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ir[t] = !0, !0;
        if (u === "aria")
          return S("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ir[t] = !0, !0;
        if (u === "is" && a !== null && a !== void 0 && typeof a != "string")
          return S("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), ir[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return S("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), ir[t] = !0, !0;
        var v = Jt(t), y = v !== null && v.type === Bn;
        if (Jo.hasOwnProperty(u)) {
          var g = Jo[u];
          if (g !== t)
            return S("Invalid DOM property `%s`. Did you mean `%s`?", t, g), ir[t] = !0, !0;
        } else if (!y && t !== u)
          return S("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, u), ir[t] = !0, !0;
        return typeof a == "boolean" && ln(t, a, v, !1) ? (a ? S('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : S('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), ir[t] = !0, !0) : y ? !0 : ln(t, a, v, !1) ? (ir[t] = !0, !1) : ((a === "false" || a === "true") && v !== null && v.type === On && (S("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), ir[t] = !0), !0);
      };
    }
    var Rv = function(e, t, a) {
      {
        var i = [];
        for (var u in t) {
          var s = ou(e, u, t[u], a);
          s || i.push(u);
        }
        var f = i.map(function(p) {
          return "`" + p + "`";
        }).join(", ");
        i.length === 1 ? S("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, e) : i.length > 1 && S("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, e);
      }
    };
    function Tv(e, t, a) {
      Cl(e, t) || Rv(e, t, a);
    }
    var cd = 1, vc = 2, ba = 4, fd = cd | vc | ba, su = null;
    function ly(e) {
      su !== null && S("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), su = e;
    }
    function uy() {
      su === null && S("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), su = null;
    }
    function ts(e) {
      return e === su;
    }
    function dd(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Bi ? t.parentNode : t;
    }
    var hc = null, cu = null, jt = null;
    function mc(e) {
      var t = _o(e);
      if (t) {
        if (typeof hc != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var i = Mh(a);
          hc(t.stateNode, t.type, i);
        }
      }
    }
    function yc(e) {
      hc = e;
    }
    function lo(e) {
      cu ? jt ? jt.push(e) : jt = [e] : cu = e;
    }
    function wv() {
      return cu !== null || jt !== null;
    }
    function gc() {
      if (cu) {
        var e = cu, t = jt;
        if (cu = null, jt = null, mc(e), t)
          for (var a = 0; a < t.length; a++)
            mc(t[a]);
      }
    }
    var uo = function(e, t) {
      return e(t);
    }, ns = function() {
    }, Rl = !1;
    function xv() {
      var e = wv();
      e && (ns(), gc());
    }
    function bv(e, t, a) {
      if (Rl)
        return e(t, a);
      Rl = !0;
      try {
        return uo(e, t, a);
      } finally {
        Rl = !1, xv();
      }
    }
    function oy(e, t, a) {
      uo = e, ns = a;
    }
    function _v(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Sc(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && _v(t));
        default:
          return !1;
      }
    }
    function Tl(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var i = Mh(a);
      if (i === null)
        return null;
      var u = i[t];
      if (Sc(t, e.type, i))
        return null;
      if (u && typeof u != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof u + "` type.");
      return u;
    }
    var rs = !1;
    if (kn)
      try {
        var fu = {};
        Object.defineProperty(fu, "passive", {
          get: function() {
            rs = !0;
          }
        }), window.addEventListener("test", fu, fu), window.removeEventListener("test", fu, fu);
      } catch {
        rs = !1;
      }
    function Ec(e, t, a, i, u, s, f, p, v) {
      var y = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, y);
      } catch (g) {
        this.onError(g);
      }
    }
    var Cc = Ec;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var pd = document.createElement("react");
      Cc = function(t, a, i, u, s, f, p, v, y) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var g = document.createEvent("Event"), b = !1, w = !0, z = window.event, F = Object.getOwnPropertyDescriptor(window, "event");
        function V() {
          pd.removeEventListener(P, Le, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = z);
        }
        var le = Array.prototype.slice.call(arguments, 3);
        function Le() {
          b = !0, V(), a.apply(i, le), w = !1;
        }
        var we, Ct = !1, vt = !1;
        function O(L) {
          if (we = L.error, Ct = !0, we === null && L.colno === 0 && L.lineno === 0 && (vt = !0), L.defaultPrevented && we != null && typeof we == "object")
            try {
              we._suppressLogging = !0;
            } catch {
            }
        }
        var P = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", O), pd.addEventListener(P, Le, !1), g.initEvent(P, !1, !1), pd.dispatchEvent(g), F && Object.defineProperty(window, "event", F), b && w && (Ct ? vt && (we = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : we = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(we)), window.removeEventListener("error", O), !b)
          return V(), Ec.apply(this, arguments);
      };
    }
    var Dv = Cc, oo = !1, Rc = null, so = !1, gi = null, kv = {
      onError: function(e) {
        oo = !0, Rc = e;
      }
    };
    function wl(e, t, a, i, u, s, f, p, v) {
      oo = !1, Rc = null, Dv.apply(kv, arguments);
    }
    function Si(e, t, a, i, u, s, f, p, v) {
      if (wl.apply(this, arguments), oo) {
        var y = is();
        so || (so = !0, gi = y);
      }
    }
    function as() {
      if (so) {
        var e = gi;
        throw so = !1, gi = null, e;
      }
    }
    function Ii() {
      return oo;
    }
    function is() {
      if (oo) {
        var e = Rc;
        return oo = !1, Rc = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function co(e) {
      return e._reactInternals;
    }
    function sy(e) {
      return e._reactInternals !== void 0;
    }
    function du(e, t) {
      e._reactInternals = t;
    }
    var _e = (
      /*                      */
      0
    ), ei = (
      /*                */
      1
    ), hn = (
      /*                    */
      2
    ), gt = (
      /*                       */
      4
    ), _a = (
      /*                */
      16
    ), Da = (
      /*                 */
      32
    ), nn = (
      /*                     */
      64
    ), xe = (
      /*                   */
      128
    ), Er = (
      /*            */
      256
    ), Sn = (
      /*                          */
      512
    ), In = (
      /*                     */
      1024
    ), Qr = (
      /*                      */
      2048
    ), Wr = (
      /*                    */
      4096
    ), Mn = (
      /*                   */
      8192
    ), fo = (
      /*             */
      16384
    ), Ov = (
      /*               */
      32767
    ), ls = (
      /*                   */
      32768
    ), Xn = (
      /*                */
      65536
    ), Tc = (
      /* */
      131072
    ), Ei = (
      /*                       */
      1048576
    ), po = (
      /*                    */
      2097152
    ), Yi = (
      /*                 */
      4194304
    ), wc = (
      /*                */
      8388608
    ), xl = (
      /*               */
      16777216
    ), Ci = (
      /*              */
      33554432
    ), bl = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      gt | In | 0
    ), _l = hn | gt | _a | Da | Sn | Wr | Mn, Dl = gt | nn | Sn | Mn, Qi = Qr | _a, Nn = Yi | wc | po, ka = D.ReactCurrentOwner;
    function fa(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var i = t;
        do
          t = i, (t.flags & (hn | Wr)) !== _e && (a = t.return), i = t.return;
        while (i);
      }
      return t.tag === ee ? a : null;
    }
    function Ri(e) {
      if (e.tag === be) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function Ti(e) {
      return e.tag === ee ? e.stateNode.containerInfo : null;
    }
    function pu(e) {
      return fa(e) === e;
    }
    function Lv(e) {
      {
        var t = ka.current;
        if (t !== null && t.tag === ve) {
          var a = t, i = a.stateNode;
          i._warnedAboutRefsInRender || S("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Pe(a) || "A component"), i._warnedAboutRefsInRender = !0;
        }
      }
      var u = co(e);
      return u ? fa(u) === u : !1;
    }
    function xc(e) {
      if (fa(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function bc(e) {
      var t = e.alternate;
      if (!t) {
        var a = fa(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var i = e, u = t; ; ) {
        var s = i.return;
        if (s === null)
          break;
        var f = s.alternate;
        if (f === null) {
          var p = s.return;
          if (p !== null) {
            i = u = p;
            continue;
          }
          break;
        }
        if (s.child === f.child) {
          for (var v = s.child; v; ) {
            if (v === i)
              return xc(s), e;
            if (v === u)
              return xc(s), t;
            v = v.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== u.return)
          i = s, u = f;
        else {
          for (var y = !1, g = s.child; g; ) {
            if (g === i) {
              y = !0, i = s, u = f;
              break;
            }
            if (g === u) {
              y = !0, u = s, i = f;
              break;
            }
            g = g.sibling;
          }
          if (!y) {
            for (g = f.child; g; ) {
              if (g === i) {
                y = !0, i = f, u = s;
                break;
              }
              if (g === u) {
                y = !0, u = f, i = s;
                break;
              }
              g = g.sibling;
            }
            if (!y)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (i.alternate !== u)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (i.tag !== ee)
        throw new Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function Gr(e) {
      var t = bc(e);
      return t !== null ? qr(t) : null;
    }
    function qr(e) {
      if (e.tag === ue || e.tag === Ye)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = qr(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function fn(e) {
      var t = bc(e);
      return t !== null ? Oa(t) : null;
    }
    function Oa(e) {
      if (e.tag === ue || e.tag === Ye)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== Ce) {
          var a = Oa(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var vd = j.unstable_scheduleCallback, Mv = j.unstable_cancelCallback, hd = j.unstable_shouldYield, md = j.unstable_requestPaint, Yn = j.unstable_now, _c = j.unstable_getCurrentPriorityLevel, us = j.unstable_ImmediatePriority, kl = j.unstable_UserBlockingPriority, Wi = j.unstable_NormalPriority, cy = j.unstable_LowPriority, vu = j.unstable_IdlePriority, Dc = j.unstable_yieldValue, Nv = j.unstable_setDisableYieldValue, hu = null, Tn = null, ie = null, da = !1, Xr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function vo(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return S("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        je && (e = Ze({}, e, {
          getLaneLabelMap: mu,
          injectProfilingHooks: La
        })), hu = t.inject(e), Tn = t;
      } catch (a) {
        S("React instrumentation encountered an error: %s.", a);
      }
      return !!t.checkDCE;
    }
    function yd(e, t) {
      if (Tn && typeof Tn.onScheduleFiberRoot == "function")
        try {
          Tn.onScheduleFiberRoot(hu, e, t);
        } catch (a) {
          da || (da = !0, S("React instrumentation encountered an error: %s", a));
        }
    }
    function gd(e, t) {
      if (Tn && typeof Tn.onCommitFiberRoot == "function")
        try {
          var a = (e.current.flags & xe) === xe;
          if (Ue) {
            var i;
            switch (t) {
              case Or:
                i = us;
                break;
              case xi:
                i = kl;
                break;
              case Ma:
                i = Wi;
                break;
              case Na:
                i = vu;
                break;
              default:
                i = Wi;
                break;
            }
            Tn.onCommitFiberRoot(hu, e, i, a);
          }
        } catch (u) {
          da || (da = !0, S("React instrumentation encountered an error: %s", u));
        }
    }
    function Sd(e) {
      if (Tn && typeof Tn.onPostCommitFiberRoot == "function")
        try {
          Tn.onPostCommitFiberRoot(hu, e);
        } catch (t) {
          da || (da = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function Ed(e) {
      if (Tn && typeof Tn.onCommitFiberUnmount == "function")
        try {
          Tn.onCommitFiberUnmount(hu, e);
        } catch (t) {
          da || (da = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function mn(e) {
      if (typeof Dc == "function" && (Nv(e), ht(e)), Tn && typeof Tn.setStrictMode == "function")
        try {
          Tn.setStrictMode(hu, e);
        } catch (t) {
          da || (da = !0, S("React instrumentation encountered an error: %s", t));
        }
    }
    function La(e) {
      ie = e;
    }
    function mu() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, a = 0; a < Su; a++) {
          var i = Fv(t);
          e.set(t, i), t *= 2;
        }
        return e;
      }
    }
    function Cd(e) {
      ie !== null && typeof ie.markCommitStarted == "function" && ie.markCommitStarted(e);
    }
    function Rd() {
      ie !== null && typeof ie.markCommitStopped == "function" && ie.markCommitStopped();
    }
    function pa(e) {
      ie !== null && typeof ie.markComponentRenderStarted == "function" && ie.markComponentRenderStarted(e);
    }
    function va() {
      ie !== null && typeof ie.markComponentRenderStopped == "function" && ie.markComponentRenderStopped();
    }
    function Td(e) {
      ie !== null && typeof ie.markComponentPassiveEffectMountStarted == "function" && ie.markComponentPassiveEffectMountStarted(e);
    }
    function zv() {
      ie !== null && typeof ie.markComponentPassiveEffectMountStopped == "function" && ie.markComponentPassiveEffectMountStopped();
    }
    function Gi(e) {
      ie !== null && typeof ie.markComponentPassiveEffectUnmountStarted == "function" && ie.markComponentPassiveEffectUnmountStarted(e);
    }
    function Ol() {
      ie !== null && typeof ie.markComponentPassiveEffectUnmountStopped == "function" && ie.markComponentPassiveEffectUnmountStopped();
    }
    function kc(e) {
      ie !== null && typeof ie.markComponentLayoutEffectMountStarted == "function" && ie.markComponentLayoutEffectMountStarted(e);
    }
    function Uv() {
      ie !== null && typeof ie.markComponentLayoutEffectMountStopped == "function" && ie.markComponentLayoutEffectMountStopped();
    }
    function os(e) {
      ie !== null && typeof ie.markComponentLayoutEffectUnmountStarted == "function" && ie.markComponentLayoutEffectUnmountStarted(e);
    }
    function wd() {
      ie !== null && typeof ie.markComponentLayoutEffectUnmountStopped == "function" && ie.markComponentLayoutEffectUnmountStopped();
    }
    function ss(e, t, a) {
      ie !== null && typeof ie.markComponentErrored == "function" && ie.markComponentErrored(e, t, a);
    }
    function wi(e, t, a) {
      ie !== null && typeof ie.markComponentSuspended == "function" && ie.markComponentSuspended(e, t, a);
    }
    function cs(e) {
      ie !== null && typeof ie.markLayoutEffectsStarted == "function" && ie.markLayoutEffectsStarted(e);
    }
    function fs() {
      ie !== null && typeof ie.markLayoutEffectsStopped == "function" && ie.markLayoutEffectsStopped();
    }
    function yu(e) {
      ie !== null && typeof ie.markPassiveEffectsStarted == "function" && ie.markPassiveEffectsStarted(e);
    }
    function xd() {
      ie !== null && typeof ie.markPassiveEffectsStopped == "function" && ie.markPassiveEffectsStopped();
    }
    function gu(e) {
      ie !== null && typeof ie.markRenderStarted == "function" && ie.markRenderStarted(e);
    }
    function Av() {
      ie !== null && typeof ie.markRenderYielded == "function" && ie.markRenderYielded();
    }
    function Oc() {
      ie !== null && typeof ie.markRenderStopped == "function" && ie.markRenderStopped();
    }
    function yn(e) {
      ie !== null && typeof ie.markRenderScheduled == "function" && ie.markRenderScheduled(e);
    }
    function Lc(e, t) {
      ie !== null && typeof ie.markForceUpdateScheduled == "function" && ie.markForceUpdateScheduled(e, t);
    }
    function ds(e, t) {
      ie !== null && typeof ie.markStateUpdateScheduled == "function" && ie.markStateUpdateScheduled(e, t);
    }
    var De = (
      /*                         */
      0
    ), lt = (
      /*                 */
      1
    ), Ot = (
      /*                    */
      2
    ), Wt = (
      /*               */
      8
    ), Lt = (
      /*              */
      16
    ), zn = Math.clz32 ? Math.clz32 : ps, Kn = Math.log, Mc = Math.LN2;
    function ps(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (Kn(t) / Mc | 0) | 0;
    }
    var Su = 31, Y = (
      /*                        */
      0
    ), bt = (
      /*                          */
      0
    ), Ae = (
      /*                        */
      1
    ), Ll = (
      /*    */
      2
    ), ti = (
      /*             */
      4
    ), Cr = (
      /*            */
      8
    ), wn = (
      /*                     */
      16
    ), qi = (
      /*                */
      32
    ), Ml = (
      /*                       */
      4194240
    ), Eu = (
      /*                        */
      64
    ), Nc = (
      /*                        */
      128
    ), zc = (
      /*                        */
      256
    ), Uc = (
      /*                        */
      512
    ), Ac = (
      /*                        */
      1024
    ), Fc = (
      /*                        */
      2048
    ), jc = (
      /*                        */
      4096
    ), Hc = (
      /*                        */
      8192
    ), Vc = (
      /*                        */
      16384
    ), Cu = (
      /*                       */
      32768
    ), Pc = (
      /*                       */
      65536
    ), ho = (
      /*                       */
      131072
    ), mo = (
      /*                       */
      262144
    ), Bc = (
      /*                       */
      524288
    ), vs = (
      /*                       */
      1048576
    ), $c = (
      /*                       */
      2097152
    ), hs = (
      /*                            */
      130023424
    ), Ru = (
      /*                             */
      4194304
    ), Ic = (
      /*                             */
      8388608
    ), ms = (
      /*                             */
      16777216
    ), Yc = (
      /*                             */
      33554432
    ), Qc = (
      /*                             */
      67108864
    ), bd = Ru, ys = (
      /*          */
      134217728
    ), _d = (
      /*                          */
      268435455
    ), gs = (
      /*               */
      268435456
    ), Tu = (
      /*                        */
      536870912
    ), Kr = (
      /*                   */
      1073741824
    );
    function Fv(e) {
      {
        if (e & Ae)
          return "Sync";
        if (e & Ll)
          return "InputContinuousHydration";
        if (e & ti)
          return "InputContinuous";
        if (e & Cr)
          return "DefaultHydration";
        if (e & wn)
          return "Default";
        if (e & qi)
          return "TransitionHydration";
        if (e & Ml)
          return "Transition";
        if (e & hs)
          return "Retry";
        if (e & ys)
          return "SelectiveHydration";
        if (e & gs)
          return "IdleHydration";
        if (e & Tu)
          return "Idle";
        if (e & Kr)
          return "Offscreen";
      }
    }
    var Xt = -1, wu = Eu, Wc = Ru;
    function Ss(e) {
      switch (Nl(e)) {
        case Ae:
          return Ae;
        case Ll:
          return Ll;
        case ti:
          return ti;
        case Cr:
          return Cr;
        case wn:
          return wn;
        case qi:
          return qi;
        case Eu:
        case Nc:
        case zc:
        case Uc:
        case Ac:
        case Fc:
        case jc:
        case Hc:
        case Vc:
        case Cu:
        case Pc:
        case ho:
        case mo:
        case Bc:
        case vs:
        case $c:
          return e & Ml;
        case Ru:
        case Ic:
        case ms:
        case Yc:
        case Qc:
          return e & hs;
        case ys:
          return ys;
        case gs:
          return gs;
        case Tu:
          return Tu;
        case Kr:
          return Kr;
        default:
          return S("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function Gc(e, t) {
      var a = e.pendingLanes;
      if (a === Y)
        return Y;
      var i = Y, u = e.suspendedLanes, s = e.pingedLanes, f = a & _d;
      if (f !== Y) {
        var p = f & ~u;
        if (p !== Y)
          i = Ss(p);
        else {
          var v = f & s;
          v !== Y && (i = Ss(v));
        }
      } else {
        var y = a & ~u;
        y !== Y ? i = Ss(y) : s !== Y && (i = Ss(s));
      }
      if (i === Y)
        return Y;
      if (t !== Y && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & u) === Y) {
        var g = Nl(i), b = Nl(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          g >= b || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          g === wn && (b & Ml) !== Y
        )
          return t;
      }
      (i & ti) !== Y && (i |= a & wn);
      var w = e.entangledLanes;
      if (w !== Y)
        for (var z = e.entanglements, F = i & w; F > 0; ) {
          var V = Un(F), le = 1 << V;
          i |= z[V], F &= ~le;
        }
      return i;
    }
    function ni(e, t) {
      for (var a = e.eventTimes, i = Xt; t > 0; ) {
        var u = Un(t), s = 1 << u, f = a[u];
        f > i && (i = f), t &= ~s;
      }
      return i;
    }
    function Dd(e, t) {
      switch (e) {
        case Ae:
        case Ll:
        case ti:
          return t + 250;
        case Cr:
        case wn:
        case qi:
        case Eu:
        case Nc:
        case zc:
        case Uc:
        case Ac:
        case Fc:
        case jc:
        case Hc:
        case Vc:
        case Cu:
        case Pc:
        case ho:
        case mo:
        case Bc:
        case vs:
        case $c:
          return t + 5e3;
        case Ru:
        case Ic:
        case ms:
        case Yc:
        case Qc:
          return Xt;
        case ys:
        case gs:
        case Tu:
        case Kr:
          return Xt;
        default:
          return S("Should have found matching lanes. This is a bug in React."), Xt;
      }
    }
    function qc(e, t) {
      for (var a = e.pendingLanes, i = e.suspendedLanes, u = e.pingedLanes, s = e.expirationTimes, f = a; f > 0; ) {
        var p = Un(f), v = 1 << p, y = s[p];
        y === Xt ? ((v & i) === Y || (v & u) !== Y) && (s[p] = Dd(v, t)) : y <= t && (e.expiredLanes |= v), f &= ~v;
      }
    }
    function jv(e) {
      return Ss(e.pendingLanes);
    }
    function Xc(e) {
      var t = e.pendingLanes & ~Kr;
      return t !== Y ? t : t & Kr ? Kr : Y;
    }
    function Hv(e) {
      return (e & Ae) !== Y;
    }
    function Es(e) {
      return (e & _d) !== Y;
    }
    function xu(e) {
      return (e & hs) === e;
    }
    function kd(e) {
      var t = Ae | ti | wn;
      return (e & t) === Y;
    }
    function Od(e) {
      return (e & Ml) === e;
    }
    function Kc(e, t) {
      var a = Ll | ti | Cr | wn;
      return (t & a) !== Y;
    }
    function Vv(e, t) {
      return (t & e.expiredLanes) !== Y;
    }
    function Ld(e) {
      return (e & Ml) !== Y;
    }
    function Md() {
      var e = wu;
      return wu <<= 1, (wu & Ml) === Y && (wu = Eu), e;
    }
    function Pv() {
      var e = Wc;
      return Wc <<= 1, (Wc & hs) === Y && (Wc = Ru), e;
    }
    function Nl(e) {
      return e & -e;
    }
    function Cs(e) {
      return Nl(e);
    }
    function Un(e) {
      return 31 - zn(e);
    }
    function lr(e) {
      return Un(e);
    }
    function Zr(e, t) {
      return (e & t) !== Y;
    }
    function bu(e, t) {
      return (e & t) === t;
    }
    function Xe(e, t) {
      return e | t;
    }
    function Rs(e, t) {
      return e & ~t;
    }
    function Nd(e, t) {
      return e & t;
    }
    function Bv(e) {
      return e;
    }
    function $v(e, t) {
      return e !== bt && e < t ? e : t;
    }
    function Ts(e) {
      for (var t = [], a = 0; a < Su; a++)
        t.push(e);
      return t;
    }
    function yo(e, t, a) {
      e.pendingLanes |= t, t !== Tu && (e.suspendedLanes = Y, e.pingedLanes = Y);
      var i = e.eventTimes, u = lr(t);
      i[u] = a;
    }
    function Iv(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, i = t; i > 0; ) {
        var u = Un(i), s = 1 << u;
        a[u] = Xt, i &= ~s;
      }
    }
    function Zc(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function zd(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = Y, e.pingedLanes = Y, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var i = e.entanglements, u = e.eventTimes, s = e.expirationTimes, f = a; f > 0; ) {
        var p = Un(f), v = 1 << p;
        i[p] = Y, u[p] = Xt, s[p] = Xt, f &= ~v;
      }
    }
    function Jc(e, t) {
      for (var a = e.entangledLanes |= t, i = e.entanglements, u = a; u; ) {
        var s = Un(u), f = 1 << s;
        // Is this one of the newly entangled lanes?
        f & t | // Is this lane transitively entangled with the newly entangled lanes?
        i[s] & t && (i[s] |= t), u &= ~f;
      }
    }
    function Ud(e, t) {
      var a = Nl(t), i;
      switch (a) {
        case ti:
          i = Ll;
          break;
        case wn:
          i = Cr;
          break;
        case Eu:
        case Nc:
        case zc:
        case Uc:
        case Ac:
        case Fc:
        case jc:
        case Hc:
        case Vc:
        case Cu:
        case Pc:
        case ho:
        case mo:
        case Bc:
        case vs:
        case $c:
        case Ru:
        case Ic:
        case ms:
        case Yc:
        case Qc:
          i = qi;
          break;
        case Tu:
          i = gs;
          break;
        default:
          i = bt;
          break;
      }
      return (i & (e.suspendedLanes | t)) !== bt ? bt : i;
    }
    function ws(e, t, a) {
      if (Xr)
        for (var i = e.pendingUpdatersLaneMap; a > 0; ) {
          var u = lr(a), s = 1 << u, f = i[u];
          f.add(t), a &= ~s;
        }
    }
    function Yv(e, t) {
      if (Xr)
        for (var a = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
          var u = lr(t), s = 1 << u, f = a[u];
          f.size > 0 && (f.forEach(function(p) {
            var v = p.alternate;
            (v === null || !i.has(v)) && i.add(p);
          }), f.clear()), t &= ~s;
        }
    }
    function Ad(e, t) {
      return null;
    }
    var Or = Ae, xi = ti, Ma = wn, Na = Tu, xs = bt;
    function za() {
      return xs;
    }
    function An(e) {
      xs = e;
    }
    function Qv(e, t) {
      var a = xs;
      try {
        return xs = e, t();
      } finally {
        xs = a;
      }
    }
    function Wv(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function bs(e, t) {
      return e > t ? e : t;
    }
    function Zn(e, t) {
      return e !== 0 && e < t;
    }
    function Gv(e) {
      var t = Nl(e);
      return Zn(Or, t) ? Zn(xi, t) ? Es(t) ? Ma : Na : xi : Or;
    }
    function ef(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var _s;
    function Rr(e) {
      _s = e;
    }
    function fy(e) {
      _s(e);
    }
    var pe;
    function go(e) {
      pe = e;
    }
    var tf;
    function qv(e) {
      tf = e;
    }
    var Xv;
    function Ds(e) {
      Xv = e;
    }
    var ks;
    function Fd(e) {
      ks = e;
    }
    var nf = !1, Os = [], Xi = null, bi = null, _i = null, xn = /* @__PURE__ */ new Map(), Lr = /* @__PURE__ */ new Map(), Mr = [], Kv = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Zv(e) {
      return Kv.indexOf(e) > -1;
    }
    function ri(e, t, a, i, u) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: u,
        targetContainers: [i]
      };
    }
    function jd(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Xi = null;
          break;
        case "dragenter":
        case "dragleave":
          bi = null;
          break;
        case "mouseover":
        case "mouseout":
          _i = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          xn.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var i = t.pointerId;
          Lr.delete(i);
          break;
        }
      }
    }
    function Jr(e, t, a, i, u, s) {
      if (e === null || e.nativeEvent !== s) {
        var f = ri(t, a, i, u, s);
        if (t !== null) {
          var p = _o(t);
          p !== null && pe(p);
        }
        return f;
      }
      e.eventSystemFlags |= i;
      var v = e.targetContainers;
      return u !== null && v.indexOf(u) === -1 && v.push(u), e;
    }
    function dy(e, t, a, i, u) {
      switch (t) {
        case "focusin": {
          var s = u;
          return Xi = Jr(Xi, e, t, a, i, s), !0;
        }
        case "dragenter": {
          var f = u;
          return bi = Jr(bi, e, t, a, i, f), !0;
        }
        case "mouseover": {
          var p = u;
          return _i = Jr(_i, e, t, a, i, p), !0;
        }
        case "pointerover": {
          var v = u, y = v.pointerId;
          return xn.set(y, Jr(xn.get(y) || null, e, t, a, i, v)), !0;
        }
        case "gotpointercapture": {
          var g = u, b = g.pointerId;
          return Lr.set(b, Jr(Lr.get(b) || null, e, t, a, i, g)), !0;
        }
      }
      return !1;
    }
    function Hd(e) {
      var t = Bs(e.target);
      if (t !== null) {
        var a = fa(t);
        if (a !== null) {
          var i = a.tag;
          if (i === be) {
            var u = Ri(a);
            if (u !== null) {
              e.blockedOn = u, ks(e.priority, function() {
                tf(a);
              });
              return;
            }
          } else if (i === ee) {
            var s = a.stateNode;
            if (ef(s)) {
              e.blockedOn = Ti(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function Jv(e) {
      for (var t = Xv(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, i = 0; i < Mr.length && Zn(t, Mr[i].priority); i++)
        ;
      Mr.splice(i, 0, a), i === 0 && Hd(a);
    }
    function Ls(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], i = Eo(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (i === null) {
          var u = e.nativeEvent, s = new u.constructor(u.type, u);
          ly(s), u.target.dispatchEvent(s), uy();
        } else {
          var f = _o(i);
          return f !== null && pe(f), e.blockedOn = i, !1;
        }
        t.shift();
      }
      return !0;
    }
    function Vd(e, t, a) {
      Ls(e) && a.delete(t);
    }
    function py() {
      nf = !1, Xi !== null && Ls(Xi) && (Xi = null), bi !== null && Ls(bi) && (bi = null), _i !== null && Ls(_i) && (_i = null), xn.forEach(Vd), Lr.forEach(Vd);
    }
    function zl(e, t) {
      e.blockedOn === t && (e.blockedOn = null, nf || (nf = !0, j.unstable_scheduleCallback(j.unstable_NormalPriority, py)));
    }
    function _u(e) {
      if (Os.length > 0) {
        zl(Os[0], e);
        for (var t = 1; t < Os.length; t++) {
          var a = Os[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      Xi !== null && zl(Xi, e), bi !== null && zl(bi, e), _i !== null && zl(_i, e);
      var i = function(p) {
        return zl(p, e);
      };
      xn.forEach(i), Lr.forEach(i);
      for (var u = 0; u < Mr.length; u++) {
        var s = Mr[u];
        s.blockedOn === e && (s.blockedOn = null);
      }
      for (; Mr.length > 0; ) {
        var f = Mr[0];
        if (f.blockedOn !== null)
          break;
        Hd(f), f.blockedOn === null && Mr.shift();
      }
    }
    var ur = D.ReactCurrentBatchConfig, St = !0;
    function Qn(e) {
      St = !!e;
    }
    function Fn() {
      return St;
    }
    function or(e, t, a) {
      var i = rf(t), u;
      switch (i) {
        case Or:
          u = ha;
          break;
        case xi:
          u = So;
          break;
        case Ma:
        default:
          u = bn;
          break;
      }
      return u.bind(null, t, a, e);
    }
    function ha(e, t, a, i) {
      var u = za(), s = ur.transition;
      ur.transition = null;
      try {
        An(Or), bn(e, t, a, i);
      } finally {
        An(u), ur.transition = s;
      }
    }
    function So(e, t, a, i) {
      var u = za(), s = ur.transition;
      ur.transition = null;
      try {
        An(xi), bn(e, t, a, i);
      } finally {
        An(u), ur.transition = s;
      }
    }
    function bn(e, t, a, i) {
      St && Ms(e, t, a, i);
    }
    function Ms(e, t, a, i) {
      var u = Eo(e, t, a, i);
      if (u === null) {
        Oy(e, t, i, Di, a), jd(e, i);
        return;
      }
      if (dy(u, e, t, a, i)) {
        i.stopPropagation();
        return;
      }
      if (jd(e, i), t & ba && Zv(e)) {
        for (; u !== null; ) {
          var s = _o(u);
          s !== null && fy(s);
          var f = Eo(e, t, a, i);
          if (f === null && Oy(e, t, i, Di, a), f === u)
            break;
          u = f;
        }
        u !== null && i.stopPropagation();
        return;
      }
      Oy(e, t, i, null, a);
    }
    var Di = null;
    function Eo(e, t, a, i) {
      Di = null;
      var u = dd(i), s = Bs(u);
      if (s !== null) {
        var f = fa(s);
        if (f === null)
          s = null;
        else {
          var p = f.tag;
          if (p === be) {
            var v = Ri(f);
            if (v !== null)
              return v;
            s = null;
          } else if (p === ee) {
            var y = f.stateNode;
            if (ef(y))
              return Ti(f);
            s = null;
          } else f !== s && (s = null);
        }
      }
      return Di = s, null;
    }
    function rf(e) {
      switch (e) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Or;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return xi;
        case "message": {
          var t = _c();
          switch (t) {
            case us:
              return Or;
            case kl:
              return xi;
            case Wi:
            case cy:
              return Ma;
            case vu:
              return Na;
            default:
              return Ma;
          }
        }
        default:
          return Ma;
      }
    }
    function Ns(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function ea(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function Pd(e, t, a, i) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: i
      }), a;
    }
    function Co(e, t, a, i) {
      return e.addEventListener(t, a, {
        passive: i
      }), a;
    }
    var ma = null, Ro = null, Du = null;
    function Ul(e) {
      return ma = e, Ro = zs(), !0;
    }
    function af() {
      ma = null, Ro = null, Du = null;
    }
    function Ki() {
      if (Du)
        return Du;
      var e, t = Ro, a = t.length, i, u = zs(), s = u.length;
      for (e = 0; e < a && t[e] === u[e]; e++)
        ;
      var f = a - e;
      for (i = 1; i <= f && t[a - i] === u[s - i]; i++)
        ;
      var p = i > 1 ? 1 - i : void 0;
      return Du = u.slice(e, p), Du;
    }
    function zs() {
      return "value" in ma ? ma.value : ma.textContent;
    }
    function Al(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function To() {
      return !0;
    }
    function Us() {
      return !1;
    }
    function Tr(e) {
      function t(a, i, u, s, f) {
        this._reactName = a, this._targetInst = u, this.type = i, this.nativeEvent = s, this.target = f, this.currentTarget = null;
        for (var p in e)
          if (e.hasOwnProperty(p)) {
            var v = e[p];
            v ? this[p] = v(s) : this[p] = s[p];
          }
        var y = s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1;
        return y ? this.isDefaultPrevented = To : this.isDefaultPrevented = Us, this.isPropagationStopped = Us, this;
      }
      return Ze(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = To);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = To);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: To
      }), t;
    }
    var jn = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, ki = Tr(jn), Nr = Ze({}, jn, {
      view: 0,
      detail: 0
    }), ta = Tr(Nr), lf, As, ku;
    function vy(e) {
      e !== ku && (ku && e.type === "mousemove" ? (lf = e.screenX - ku.screenX, As = e.screenY - ku.screenY) : (lf = 0, As = 0), ku = e);
    }
    var ai = Ze({}, Nr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: dn,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (vy(e), lf);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : As;
      }
    }), Bd = Tr(ai), $d = Ze({}, ai, {
      dataTransfer: 0
    }), Ou = Tr($d), Id = Ze({}, Nr, {
      relatedTarget: 0
    }), Zi = Tr(Id), eh = Ze({}, jn, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), th = Tr(eh), Yd = Ze({}, jn, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), uf = Tr(Yd), hy = Ze({}, jn, {
      data: 0
    }), nh = Tr(hy), rh = nh, ah = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Lu = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function my(e) {
      if (e.key) {
        var t = ah[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = Al(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? Lu[e.keyCode] || "Unidentified" : "";
    }
    var wo = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function ih(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var i = wo[e];
      return i ? !!a[i] : !1;
    }
    function dn(e) {
      return ih;
    }
    var yy = Ze({}, Nr, {
      key: my,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: dn,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Al(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Al(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), lh = Tr(yy), gy = Ze({}, ai, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), uh = Tr(gy), oh = Ze({}, Nr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: dn
    }), sh = Tr(oh), Sy = Ze({}, jn, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ua = Tr(Sy), Qd = Ze({}, ai, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Ey = Tr(Qd), Fl = [9, 13, 27, 32], Fs = 229, Ji = kn && "CompositionEvent" in window, jl = null;
    kn && "documentMode" in document && (jl = document.documentMode);
    var Wd = kn && "TextEvent" in window && !jl, of = kn && (!Ji || jl && jl > 8 && jl <= 11), ch = 32, sf = String.fromCharCode(ch);
    function Cy() {
      at("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), at("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), at("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), at("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Gd = !1;
    function fh(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function cf(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function ff(e, t) {
      return e === "keydown" && t.keyCode === Fs;
    }
    function qd(e, t) {
      switch (e) {
        case "keyup":
          return Fl.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== Fs;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function df(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function dh(e) {
      return e.locale === "ko";
    }
    var Mu = !1;
    function Xd(e, t, a, i, u) {
      var s, f;
      if (Ji ? s = cf(t) : Mu ? qd(t, i) && (s = "onCompositionEnd") : ff(t, i) && (s = "onCompositionStart"), !s)
        return null;
      of && !dh(i) && (!Mu && s === "onCompositionStart" ? Mu = Ul(u) : s === "onCompositionEnd" && Mu && (f = Ki()));
      var p = Sh(a, s);
      if (p.length > 0) {
        var v = new nh(s, t, null, i, u);
        if (e.push({
          event: v,
          listeners: p
        }), f)
          v.data = f;
        else {
          var y = df(i);
          y !== null && (v.data = y);
        }
      }
    }
    function pf(e, t) {
      switch (e) {
        case "compositionend":
          return df(t);
        case "keypress":
          var a = t.which;
          return a !== ch ? null : (Gd = !0, sf);
        case "textInput":
          var i = t.data;
          return i === sf && Gd ? null : i;
        default:
          return null;
      }
    }
    function Kd(e, t) {
      if (Mu) {
        if (e === "compositionend" || !Ji && qd(e, t)) {
          var a = Ki();
          return af(), Mu = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!fh(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return of && !dh(t) ? null : t.data;
        default:
          return null;
      }
    }
    function vf(e, t, a, i, u) {
      var s;
      if (Wd ? s = pf(t, i) : s = Kd(t, i), !s)
        return null;
      var f = Sh(a, "onBeforeInput");
      if (f.length > 0) {
        var p = new rh("onBeforeInput", "beforeinput", null, i, u);
        e.push({
          event: p,
          listeners: f
        }), p.data = s;
      }
    }
    function ph(e, t, a, i, u, s, f) {
      Xd(e, t, a, i, u), vf(e, t, a, i, u);
    }
    var Ry = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function js(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Ry[e.type] : t === "textarea";
    }
    function Ty(e) {
      if (!kn)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var i = document.createElement("div");
        i.setAttribute(t, "return;"), a = typeof i[t] == "function";
      }
      return a;
    }
    function Hs() {
      at("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function vh(e, t, a, i) {
      lo(i);
      var u = Sh(t, "onChange");
      if (u.length > 0) {
        var s = new ki("onChange", "change", null, a, i);
        e.push({
          event: s,
          listeners: u
        });
      }
    }
    var Hl = null, n = null;
    function r(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function l(e) {
      var t = [];
      vh(t, n, e, dd(e)), bv(o, t);
    }
    function o(e) {
      kE(e, 0);
    }
    function c(e) {
      var t = Ef(e);
      if (mi(t))
        return e;
    }
    function d(e, t) {
      if (e === "change")
        return t;
    }
    var m = !1;
    kn && (m = Ty("input") && (!document.documentMode || document.documentMode > 9));
    function E(e, t) {
      Hl = e, n = t, Hl.attachEvent("onpropertychange", A);
    }
    function T() {
      Hl && (Hl.detachEvent("onpropertychange", A), Hl = null, n = null);
    }
    function A(e) {
      e.propertyName === "value" && c(n) && l(e);
    }
    function W(e, t, a) {
      e === "focusin" ? (T(), E(t, a)) : e === "focusout" && T();
    }
    function q(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return c(n);
    }
    function Q(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function se(e, t) {
      if (e === "click")
        return c(t);
    }
    function me(e, t) {
      if (e === "input" || e === "change")
        return c(t);
    }
    function Se(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || Oe(e, "number", e.value);
    }
    function _n(e, t, a, i, u, s, f) {
      var p = a ? Ef(a) : window, v, y;
      if (r(p) ? v = d : js(p) ? m ? v = me : (v = q, y = W) : Q(p) && (v = se), v) {
        var g = v(t, a);
        if (g) {
          vh(e, g, i, u);
          return;
        }
      }
      y && y(t, p, a), t === "focusout" && Se(p);
    }
    function k() {
      Vt("onMouseEnter", ["mouseout", "mouseover"]), Vt("onMouseLeave", ["mouseout", "mouseover"]), Vt("onPointerEnter", ["pointerout", "pointerover"]), Vt("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function x(e, t, a, i, u, s, f) {
      var p = t === "mouseover" || t === "pointerover", v = t === "mouseout" || t === "pointerout";
      if (p && !ts(i)) {
        var y = i.relatedTarget || i.fromElement;
        if (y && (Bs(y) || fp(y)))
          return;
      }
      if (!(!v && !p)) {
        var g;
        if (u.window === u)
          g = u;
        else {
          var b = u.ownerDocument;
          b ? g = b.defaultView || b.parentWindow : g = window;
        }
        var w, z;
        if (v) {
          var F = i.relatedTarget || i.toElement;
          if (w = a, z = F ? Bs(F) : null, z !== null) {
            var V = fa(z);
            (z !== V || z.tag !== ue && z.tag !== Ye) && (z = null);
          }
        } else
          w = null, z = a;
        if (w !== z) {
          var le = Bd, Le = "onMouseLeave", we = "onMouseEnter", Ct = "mouse";
          (t === "pointerout" || t === "pointerover") && (le = uh, Le = "onPointerLeave", we = "onPointerEnter", Ct = "pointer");
          var vt = w == null ? g : Ef(w), O = z == null ? g : Ef(z), P = new le(Le, Ct + "leave", w, i, u);
          P.target = vt, P.relatedTarget = O;
          var L = null, X = Bs(u);
          if (X === a) {
            var fe = new le(we, Ct + "enter", z, i, u);
            fe.target = O, fe.relatedTarget = vt, L = fe;
          }
          NT(e, P, L, w, z);
        }
      }
    }
    function N(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var G = typeof Object.is == "function" ? Object.is : N;
    function ye(e, t) {
      if (G(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), i = Object.keys(t);
      if (a.length !== i.length)
        return !1;
      for (var u = 0; u < a.length; u++) {
        var s = a[u];
        if (!wr.call(t, s) || !G(e[s], t[s]))
          return !1;
      }
      return !0;
    }
    function Me(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function ze(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function Ve(e, t) {
      for (var a = Me(e), i = 0, u = 0; a; ) {
        if (a.nodeType === Bi) {
          if (u = i + a.textContent.length, i <= t && u >= t)
            return {
              node: a,
              offset: t - i
            };
          i = u;
        }
        a = Me(ze(a));
      }
    }
    function Jn(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, i = a.getSelection && a.getSelection();
      if (!i || i.rangeCount === 0)
        return null;
      var u = i.anchorNode, s = i.anchorOffset, f = i.focusNode, p = i.focusOffset;
      try {
        u.nodeType, f.nodeType;
      } catch {
        return null;
      }
      return Mt(e, u, s, f, p);
    }
    function Mt(e, t, a, i, u) {
      var s = 0, f = -1, p = -1, v = 0, y = 0, g = e, b = null;
      e: for (; ; ) {
        for (var w = null; g === t && (a === 0 || g.nodeType === Bi) && (f = s + a), g === i && (u === 0 || g.nodeType === Bi) && (p = s + u), g.nodeType === Bi && (s += g.nodeValue.length), (w = g.firstChild) !== null; )
          b = g, g = w;
        for (; ; ) {
          if (g === e)
            break e;
          if (b === t && ++v === a && (f = s), b === i && ++y === u && (p = s), (w = g.nextSibling) !== null)
            break;
          g = b, b = g.parentNode;
        }
        g = w;
      }
      return f === -1 || p === -1 ? null : {
        start: f,
        end: p
      };
    }
    function Vl(e, t) {
      var a = e.ownerDocument || document, i = a && a.defaultView || window;
      if (i.getSelection) {
        var u = i.getSelection(), s = e.textContent.length, f = Math.min(t.start, s), p = t.end === void 0 ? f : Math.min(t.end, s);
        if (!u.extend && f > p) {
          var v = p;
          p = f, f = v;
        }
        var y = Ve(e, f), g = Ve(e, p);
        if (y && g) {
          if (u.rangeCount === 1 && u.anchorNode === y.node && u.anchorOffset === y.offset && u.focusNode === g.node && u.focusOffset === g.offset)
            return;
          var b = a.createRange();
          b.setStart(y.node, y.offset), u.removeAllRanges(), f > p ? (u.addRange(b), u.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), u.addRange(b));
        }
      }
    }
    function hh(e) {
      return e && e.nodeType === Bi;
    }
    function gE(e, t) {
      return !e || !t ? !1 : e === t ? !0 : hh(e) ? !1 : hh(t) ? gE(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function hT(e) {
      return e && e.ownerDocument && gE(e.ownerDocument.documentElement, e);
    }
    function mT(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function SE() {
      for (var e = window, t = xa(); t instanceof e.HTMLIFrameElement; ) {
        if (mT(t))
          e = t.contentWindow;
        else
          return t;
        t = xa(e.document);
      }
      return t;
    }
    function wy(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function yT() {
      var e = SE();
      return {
        focusedElem: e,
        selectionRange: wy(e) ? ST(e) : null
      };
    }
    function gT(e) {
      var t = SE(), a = e.focusedElem, i = e.selectionRange;
      if (t !== a && hT(a)) {
        i !== null && wy(a) && ET(a, i);
        for (var u = [], s = a; s = s.parentNode; )
          s.nodeType === Yr && u.push({
            element: s,
            left: s.scrollLeft,
            top: s.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var f = 0; f < u.length; f++) {
          var p = u[f];
          p.element.scrollLeft = p.left, p.element.scrollTop = p.top;
        }
      }
    }
    function ST(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = Jn(e), t || {
        start: 0,
        end: 0
      };
    }
    function ET(e, t) {
      var a = t.start, i = t.end;
      i === void 0 && (i = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(i, e.value.length)) : Vl(e, t);
    }
    var CT = kn && "documentMode" in document && document.documentMode <= 11;
    function RT() {
      at("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var hf = null, xy = null, Zd = null, by = !1;
    function TT(e) {
      if ("selectionStart" in e && wy(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function wT(e) {
      return e.window === e ? e.document : e.nodeType === $i ? e : e.ownerDocument;
    }
    function EE(e, t, a) {
      var i = wT(a);
      if (!(by || hf == null || hf !== xa(i))) {
        var u = TT(hf);
        if (!Zd || !ye(Zd, u)) {
          Zd = u;
          var s = Sh(xy, "onSelect");
          if (s.length > 0) {
            var f = new ki("onSelect", "select", null, t, a);
            e.push({
              event: f,
              listeners: s
            }), f.target = hf;
          }
        }
      }
    }
    function xT(e, t, a, i, u, s, f) {
      var p = a ? Ef(a) : window;
      switch (t) {
        // Track the input node that has focus.
        case "focusin":
          (js(p) || p.contentEditable === "true") && (hf = p, xy = a, Zd = null);
          break;
        case "focusout":
          hf = null, xy = null, Zd = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          by = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          by = !1, EE(e, i, u);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (CT)
            break;
        // falls through
        case "keydown":
        case "keyup":
          EE(e, i, u);
      }
    }
    function mh(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var mf = {
      animationend: mh("Animation", "AnimationEnd"),
      animationiteration: mh("Animation", "AnimationIteration"),
      animationstart: mh("Animation", "AnimationStart"),
      transitionend: mh("Transition", "TransitionEnd")
    }, _y = {}, CE = {};
    kn && (CE = document.createElement("div").style, "AnimationEvent" in window || (delete mf.animationend.animation, delete mf.animationiteration.animation, delete mf.animationstart.animation), "TransitionEvent" in window || delete mf.transitionend.transition);
    function yh(e) {
      if (_y[e])
        return _y[e];
      if (!mf[e])
        return e;
      var t = mf[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in CE)
          return _y[e] = t[a];
      return e;
    }
    var RE = yh("animationend"), TE = yh("animationiteration"), wE = yh("animationstart"), xE = yh("transitionend"), bE = /* @__PURE__ */ new Map(), _E = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function xo(e, t) {
      bE.set(e, t), at(t, [e]);
    }
    function bT() {
      for (var e = 0; e < _E.length; e++) {
        var t = _E[e], a = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
        xo(a, "on" + i);
      }
      xo(RE, "onAnimationEnd"), xo(TE, "onAnimationIteration"), xo(wE, "onAnimationStart"), xo("dblclick", "onDoubleClick"), xo("focusin", "onFocus"), xo("focusout", "onBlur"), xo(xE, "onTransitionEnd");
    }
    function _T(e, t, a, i, u, s, f) {
      var p = bE.get(t);
      if (p !== void 0) {
        var v = ki, y = t;
        switch (t) {
          case "keypress":
            if (Al(i) === 0)
              return;
          /* falls through */
          case "keydown":
          case "keyup":
            v = lh;
            break;
          case "focusin":
            y = "focus", v = Zi;
            break;
          case "focusout":
            y = "blur", v = Zi;
            break;
          case "beforeblur":
          case "afterblur":
            v = Zi;
            break;
          case "click":
            if (i.button === 2)
              return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            v = Bd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            v = Ou;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            v = sh;
            break;
          case RE:
          case TE:
          case wE:
            v = th;
            break;
          case xE:
            v = Ua;
            break;
          case "scroll":
            v = ta;
            break;
          case "wheel":
            v = Ey;
            break;
          case "copy":
          case "cut":
          case "paste":
            v = uf;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            v = uh;
            break;
        }
        var g = (s & ba) !== 0;
        {
          var b = !g && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", w = LT(a, p, i.type, g, b);
          if (w.length > 0) {
            var z = new v(p, y, null, i, u);
            e.push({
              event: z,
              listeners: w
            });
          }
        }
      }
    }
    bT(), k(), Hs(), RT(), Cy();
    function DT(e, t, a, i, u, s, f) {
      _T(e, t, a, i, u, s);
      var p = (s & fd) === 0;
      p && (x(e, t, a, i, u), _n(e, t, a, i, u), xT(e, t, a, i, u), ph(e, t, a, i, u));
    }
    var Jd = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Dy = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Jd));
    function DE(e, t, a) {
      var i = e.type || "unknown-event";
      e.currentTarget = a, Si(i, t, void 0, e), e.currentTarget = null;
    }
    function kT(e, t, a) {
      var i;
      if (a)
        for (var u = t.length - 1; u >= 0; u--) {
          var s = t[u], f = s.instance, p = s.currentTarget, v = s.listener;
          if (f !== i && e.isPropagationStopped())
            return;
          DE(e, v, p), i = f;
        }
      else
        for (var y = 0; y < t.length; y++) {
          var g = t[y], b = g.instance, w = g.currentTarget, z = g.listener;
          if (b !== i && e.isPropagationStopped())
            return;
          DE(e, z, w), i = b;
        }
    }
    function kE(e, t) {
      for (var a = (t & ba) !== 0, i = 0; i < e.length; i++) {
        var u = e[i], s = u.event, f = u.listeners;
        kT(s, f, a);
      }
      as();
    }
    function OT(e, t, a, i, u) {
      var s = dd(a), f = [];
      DT(f, e, i, a, s, t), kE(f, t);
    }
    function gn(e, t) {
      Dy.has(e) || S('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, i = lw(t), u = zT(e);
      i.has(u) || (OE(t, e, vc, a), i.add(u));
    }
    function ky(e, t, a) {
      Dy.has(e) && !t && S('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var i = 0;
      t && (i |= ba), OE(a, e, i, t);
    }
    var gh = "_reactListening" + Math.random().toString(36).slice(2);
    function ep(e) {
      if (!e[gh]) {
        e[gh] = !0, Je.forEach(function(a) {
          a !== "selectionchange" && (Dy.has(a) || ky(a, !1, e), ky(a, !0, e));
        });
        var t = e.nodeType === $i ? e : e.ownerDocument;
        t !== null && (t[gh] || (t[gh] = !0, ky("selectionchange", !1, t)));
      }
    }
    function OE(e, t, a, i, u) {
      var s = or(e, t, a), f = void 0;
      rs && (t === "touchstart" || t === "touchmove" || t === "wheel") && (f = !0), e = e, i ? f !== void 0 ? Pd(e, t, s, f) : ea(e, t, s) : f !== void 0 ? Co(e, t, s, f) : Ns(e, t, s);
    }
    function LE(e, t) {
      return e === t || e.nodeType === Ln && e.parentNode === t;
    }
    function Oy(e, t, a, i, u) {
      var s = i;
      if ((t & cd) === 0 && (t & vc) === 0) {
        var f = u;
        if (i !== null) {
          var p = i;
          e: for (; ; ) {
            if (p === null)
              return;
            var v = p.tag;
            if (v === ee || v === Ce) {
              var y = p.stateNode.containerInfo;
              if (LE(y, f))
                break;
              if (v === Ce)
                for (var g = p.return; g !== null; ) {
                  var b = g.tag;
                  if (b === ee || b === Ce) {
                    var w = g.stateNode.containerInfo;
                    if (LE(w, f))
                      return;
                  }
                  g = g.return;
                }
              for (; y !== null; ) {
                var z = Bs(y);
                if (z === null)
                  return;
                var F = z.tag;
                if (F === ue || F === Ye) {
                  p = s = z;
                  continue e;
                }
                y = y.parentNode;
              }
            }
            p = p.return;
          }
        }
      }
      bv(function() {
        return OT(e, t, a, s);
      });
    }
    function tp(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function LT(e, t, a, i, u, s) {
      for (var f = t !== null ? t + "Capture" : null, p = i ? f : t, v = [], y = e, g = null; y !== null; ) {
        var b = y, w = b.stateNode, z = b.tag;
        if (z === ue && w !== null && (g = w, p !== null)) {
          var F = Tl(y, p);
          F != null && v.push(tp(y, F, g));
        }
        if (u)
          break;
        y = y.return;
      }
      return v;
    }
    function Sh(e, t) {
      for (var a = t + "Capture", i = [], u = e; u !== null; ) {
        var s = u, f = s.stateNode, p = s.tag;
        if (p === ue && f !== null) {
          var v = f, y = Tl(u, a);
          y != null && i.unshift(tp(u, y, v));
          var g = Tl(u, t);
          g != null && i.push(tp(u, g, v));
        }
        u = u.return;
      }
      return i;
    }
    function yf(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== ue);
      return e || null;
    }
    function MT(e, t) {
      for (var a = e, i = t, u = 0, s = a; s; s = yf(s))
        u++;
      for (var f = 0, p = i; p; p = yf(p))
        f++;
      for (; u - f > 0; )
        a = yf(a), u--;
      for (; f - u > 0; )
        i = yf(i), f--;
      for (var v = u; v--; ) {
        if (a === i || i !== null && a === i.alternate)
          return a;
        a = yf(a), i = yf(i);
      }
      return null;
    }
    function ME(e, t, a, i, u) {
      for (var s = t._reactName, f = [], p = a; p !== null && p !== i; ) {
        var v = p, y = v.alternate, g = v.stateNode, b = v.tag;
        if (y !== null && y === i)
          break;
        if (b === ue && g !== null) {
          var w = g;
          if (u) {
            var z = Tl(p, s);
            z != null && f.unshift(tp(p, z, w));
          } else if (!u) {
            var F = Tl(p, s);
            F != null && f.push(tp(p, F, w));
          }
        }
        p = p.return;
      }
      f.length !== 0 && e.push({
        event: t,
        listeners: f
      });
    }
    function NT(e, t, a, i, u) {
      var s = i && u ? MT(i, u) : null;
      i !== null && ME(e, t, i, s, !1), u !== null && a !== null && ME(e, a, u, s, !0);
    }
    function zT(e, t) {
      return e + "__bubble";
    }
    var Aa = !1, np = "dangerouslySetInnerHTML", Eh = "suppressContentEditableWarning", bo = "suppressHydrationWarning", NE = "autoFocus", Vs = "children", Ps = "style", Ch = "__html", Ly, Rh, rp, zE, Th, UE, AE;
    Ly = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Rh = function(e, t) {
      ud(e, t), dc(e, t), Tv(e, t, {
        registrationNameDependencies: Ke,
        possibleRegistrationNames: et
      });
    }, UE = kn && !document.documentMode, rp = function(e, t, a) {
      if (!Aa) {
        var i = wh(a), u = wh(t);
        u !== i && (Aa = !0, S("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(u), JSON.stringify(i)));
      }
    }, zE = function(e) {
      if (!Aa) {
        Aa = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), S("Extra attributes from the server: %s", t);
      }
    }, Th = function(e, t) {
      t === !1 ? S("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : S("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, AE = function(e, t) {
      var a = e.namespaceURI === Pi ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var UT = /\r\n?/g, AT = /\u0000|\uFFFD/g;
    function wh(e) {
      Gn(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(UT, `
`).replace(AT, "");
    }
    function xh(e, t, a, i) {
      var u = wh(t), s = wh(e);
      if (s !== u && (i && (Aa || (Aa = !0, S('Text content did not match. Server: "%s" Client: "%s"', s, u))), a && Ee))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function FE(e) {
      return e.nodeType === $i ? e : e.ownerDocument;
    }
    function FT() {
    }
    function bh(e) {
      e.onclick = FT;
    }
    function jT(e, t, a, i, u) {
      for (var s in i)
        if (i.hasOwnProperty(s)) {
          var f = i[s];
          if (s === Ps)
            f && Object.freeze(f), yv(t, f);
          else if (s === np) {
            var p = f ? f[Ch] : void 0;
            p != null && iv(t, p);
          } else if (s === Vs)
            if (typeof f == "string") {
              var v = e !== "textarea" || f !== "";
              v && no(t, f);
            } else typeof f == "number" && no(t, "" + f);
          else s === Eh || s === bo || s === NE || (Ke.hasOwnProperty(s) ? f != null && (typeof f != "function" && Th(s, f), s === "onScroll" && gn("scroll", t)) : f != null && xr(t, s, f, u));
        }
    }
    function HT(e, t, a, i) {
      for (var u = 0; u < t.length; u += 2) {
        var s = t[u], f = t[u + 1];
        s === Ps ? yv(e, f) : s === np ? iv(e, f) : s === Vs ? no(e, f) : xr(e, s, f, i);
      }
    }
    function VT(e, t, a, i) {
      var u, s = FE(a), f, p = i;
      if (p === Pi && (p = ed(e)), p === Pi) {
        if (u = Cl(e, t), !u && e !== e.toLowerCase() && S("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var v = s.createElement("div");
          v.innerHTML = "<script><\/script>";
          var y = v.firstChild;
          f = v.removeChild(y);
        } else if (typeof t.is == "string")
          f = s.createElement(e, {
            is: t.is
          });
        else if (f = s.createElement(e), e === "select") {
          var g = f;
          t.multiple ? g.multiple = !0 : t.size && (g.size = t.size);
        }
      } else
        f = s.createElementNS(p, e);
      return p === Pi && !u && Object.prototype.toString.call(f) === "[object HTMLUnknownElement]" && !wr.call(Ly, e) && (Ly[e] = !0, S("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), f;
    }
    function PT(e, t) {
      return FE(t).createTextNode(e);
    }
    function BT(e, t, a, i) {
      var u = Cl(t, a);
      Rh(t, a);
      var s;
      switch (t) {
        case "dialog":
          gn("cancel", e), gn("close", e), s = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          gn("load", e), s = a;
          break;
        case "video":
        case "audio":
          for (var f = 0; f < Jd.length; f++)
            gn(Jd[f], e);
          s = a;
          break;
        case "source":
          gn("error", e), s = a;
          break;
        case "img":
        case "image":
        case "link":
          gn("error", e), gn("load", e), s = a;
          break;
        case "details":
          gn("toggle", e), s = a;
          break;
        case "input":
          Za(e, a), s = to(e, a), gn("invalid", e);
          break;
        case "option":
          Tt(e, a), s = a;
          break;
        case "select":
          lu(e, a), s = Go(e, a), gn("invalid", e);
          break;
        case "textarea":
          Kf(e, a), s = Xf(e, a), gn("invalid", e);
          break;
        default:
          s = a;
      }
      switch (cc(t, s), jT(t, e, i, s, u), t) {
        case "input":
          Ka(e), U(e, a, !1);
          break;
        case "textarea":
          Ka(e), rv(e);
          break;
        case "option":
          tn(e, a);
          break;
        case "select":
          Gf(e, a);
          break;
        default:
          typeof s.onClick == "function" && bh(e);
          break;
      }
    }
    function $T(e, t, a, i, u) {
      Rh(t, i);
      var s = null, f, p;
      switch (t) {
        case "input":
          f = to(e, a), p = to(e, i), s = [];
          break;
        case "select":
          f = Go(e, a), p = Go(e, i), s = [];
          break;
        case "textarea":
          f = Xf(e, a), p = Xf(e, i), s = [];
          break;
        default:
          f = a, p = i, typeof f.onClick != "function" && typeof p.onClick == "function" && bh(e);
          break;
      }
      cc(t, p);
      var v, y, g = null;
      for (v in f)
        if (!(p.hasOwnProperty(v) || !f.hasOwnProperty(v) || f[v] == null))
          if (v === Ps) {
            var b = f[v];
            for (y in b)
              b.hasOwnProperty(y) && (g || (g = {}), g[y] = "");
          } else v === np || v === Vs || v === Eh || v === bo || v === NE || (Ke.hasOwnProperty(v) ? s || (s = []) : (s = s || []).push(v, null));
      for (v in p) {
        var w = p[v], z = f?.[v];
        if (!(!p.hasOwnProperty(v) || w === z || w == null && z == null))
          if (v === Ps)
            if (w && Object.freeze(w), z) {
              for (y in z)
                z.hasOwnProperty(y) && (!w || !w.hasOwnProperty(y)) && (g || (g = {}), g[y] = "");
              for (y in w)
                w.hasOwnProperty(y) && z[y] !== w[y] && (g || (g = {}), g[y] = w[y]);
            } else
              g || (s || (s = []), s.push(v, g)), g = w;
          else if (v === np) {
            var F = w ? w[Ch] : void 0, V = z ? z[Ch] : void 0;
            F != null && V !== F && (s = s || []).push(v, F);
          } else v === Vs ? (typeof w == "string" || typeof w == "number") && (s = s || []).push(v, "" + w) : v === Eh || v === bo || (Ke.hasOwnProperty(v) ? (w != null && (typeof w != "function" && Th(v, w), v === "onScroll" && gn("scroll", e)), !s && z !== w && (s = [])) : (s = s || []).push(v, w));
      }
      return g && (ay(g, p[Ps]), (s = s || []).push(Ps, g)), s;
    }
    function IT(e, t, a, i, u) {
      a === "input" && u.type === "radio" && u.name != null && h(e, u);
      var s = Cl(a, i), f = Cl(a, u);
      switch (HT(e, t, s, f), a) {
        case "input":
          C(e, u);
          break;
        case "textarea":
          nv(e, u);
          break;
        case "select":
          uc(e, u);
          break;
      }
    }
    function YT(e) {
      {
        var t = e.toLowerCase();
        return Jo.hasOwnProperty(t) && Jo[t] || null;
      }
    }
    function QT(e, t, a, i, u, s, f) {
      var p, v;
      switch (p = Cl(t, a), Rh(t, a), t) {
        case "dialog":
          gn("cancel", e), gn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          gn("load", e);
          break;
        case "video":
        case "audio":
          for (var y = 0; y < Jd.length; y++)
            gn(Jd[y], e);
          break;
        case "source":
          gn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          gn("error", e), gn("load", e);
          break;
        case "details":
          gn("toggle", e);
          break;
        case "input":
          Za(e, a), gn("invalid", e);
          break;
        case "option":
          Tt(e, a);
          break;
        case "select":
          lu(e, a), gn("invalid", e);
          break;
        case "textarea":
          Kf(e, a), gn("invalid", e);
          break;
      }
      cc(t, a);
      {
        v = /* @__PURE__ */ new Set();
        for (var g = e.attributes, b = 0; b < g.length; b++) {
          var w = g[b].name.toLowerCase();
          switch (w) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              v.add(g[b].name);
          }
        }
      }
      var z = null;
      for (var F in a)
        if (a.hasOwnProperty(F)) {
          var V = a[F];
          if (F === Vs)
            typeof V == "string" ? e.textContent !== V && (a[bo] !== !0 && xh(e.textContent, V, s, f), z = [Vs, V]) : typeof V == "number" && e.textContent !== "" + V && (a[bo] !== !0 && xh(e.textContent, V, s, f), z = [Vs, "" + V]);
          else if (Ke.hasOwnProperty(F))
            V != null && (typeof V != "function" && Th(F, V), F === "onScroll" && gn("scroll", e));
          else if (f && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof p == "boolean") {
            var le = void 0, Le = Jt(F);
            if (a[bo] !== !0) {
              if (!(F === Eh || F === bo || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              F === "value" || F === "checked" || F === "selected")) {
                if (F === np) {
                  var we = e.innerHTML, Ct = V ? V[Ch] : void 0;
                  if (Ct != null) {
                    var vt = AE(e, Ct);
                    vt !== we && rp(F, we, vt);
                  }
                } else if (F === Ps) {
                  if (v.delete(F), UE) {
                    var O = ny(V);
                    le = e.getAttribute("style"), O !== le && rp(F, le, O);
                  }
                } else if (p && !_)
                  v.delete(F.toLowerCase()), le = Jl(e, F, V), V !== le && rp(F, le, V);
                else if (!pn(F, Le, p) && !qn(F, V, Le, p)) {
                  var P = !1;
                  if (Le !== null)
                    v.delete(Le.attributeName), le = dl(e, F, V, Le);
                  else {
                    var L = i;
                    if (L === Pi && (L = ed(t)), L === Pi)
                      v.delete(F.toLowerCase());
                    else {
                      var X = YT(F);
                      X !== null && X !== F && (P = !0, v.delete(X)), v.delete(F);
                    }
                    le = Jl(e, F, V);
                  }
                  var fe = _;
                  !fe && V !== le && !P && rp(F, le, V);
                }
              }
            }
          }
        }
      switch (f && // $FlowFixMe - Should be inferred as not undefined.
      v.size > 0 && a[bo] !== !0 && zE(v), t) {
        case "input":
          Ka(e), U(e, a, !0);
          break;
        case "textarea":
          Ka(e), rv(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && bh(e);
          break;
      }
      return z;
    }
    function WT(e, t, a) {
      var i = e.nodeValue !== t;
      return i;
    }
    function My(e, t) {
      {
        if (Aa)
          return;
        Aa = !0, S("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function Ny(e, t) {
      {
        if (Aa)
          return;
        Aa = !0, S('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function zy(e, t, a) {
      {
        if (Aa)
          return;
        Aa = !0, S("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function Uy(e, t) {
      {
        if (t === "" || Aa)
          return;
        Aa = !0, S('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function GT(e, t, a) {
      switch (t) {
        case "input":
          H(e, a);
          return;
        case "textarea":
          Zm(e, a);
          return;
        case "select":
          qf(e, a);
          return;
      }
    }
    var ap = function() {
    }, ip = function() {
    };
    {
      var qT = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], jE = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], XT = jE.concat(["button"]), KT = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], HE = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      ip = function(e, t) {
        var a = Ze({}, e || HE), i = {
          tag: t
        };
        return jE.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), XT.indexOf(t) !== -1 && (a.pTagInButtonScope = null), qT.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = i, t === "form" && (a.formTag = i), t === "a" && (a.aTagInScope = i), t === "button" && (a.buttonTagInScope = i), t === "nobr" && (a.nobrTagInScope = i), t === "p" && (a.pTagInButtonScope = i), t === "li" && (a.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = i), a;
      };
      var ZT = function(e, t) {
        switch (t) {
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
          // but
          case "option":
            return e === "#text";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
          // No special behavior since these rules fall back to "in body" mode for
          // all except special table nodes which cause bad parsing behavior anyway.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
          case "colgroup":
            return e === "col" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return KT.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, JT = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, VE = {};
      ap = function(e, t, a) {
        a = a || HE;
        var i = a.current, u = i && i.tag;
        t != null && (e != null && S("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var s = ZT(e, u) ? null : i, f = s ? null : JT(e, a), p = s || f;
        if (p) {
          var v = p.tag, y = !!s + "|" + e + "|" + v;
          if (!VE[y]) {
            VE[y] = !0;
            var g = e, b = "";
            if (e === "#text" ? /\S/.test(t) ? g = "Text nodes" : (g = "Whitespace text nodes", b = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : g = "<" + e + ">", s) {
              var w = "";
              v === "table" && e === "tr" && (w += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), S("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", g, v, b, w);
            } else
              S("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", g, v);
          }
        }
      };
    }
    var _h = "suppressHydrationWarning", Dh = "$", kh = "/$", lp = "$?", up = "$!", e1 = "style", Ay = null, Fy = null;
    function t1(e) {
      var t, a, i = e.nodeType;
      switch (i) {
        case $i:
        case nd: {
          t = i === $i ? "#document" : "#fragment";
          var u = e.documentElement;
          a = u ? u.namespaceURI : td(null, "");
          break;
        }
        default: {
          var s = i === Ln ? e.parentNode : e, f = s.namespaceURI || null;
          t = s.tagName, a = td(f, t);
          break;
        }
      }
      {
        var p = t.toLowerCase(), v = ip(null, p);
        return {
          namespace: a,
          ancestorInfo: v
        };
      }
    }
    function n1(e, t, a) {
      {
        var i = e, u = td(i.namespace, t), s = ip(i.ancestorInfo, t);
        return {
          namespace: u,
          ancestorInfo: s
        };
      }
    }
    function gD(e) {
      return e;
    }
    function r1(e) {
      Ay = Fn(), Fy = yT();
      var t = null;
      return Qn(!1), t;
    }
    function a1(e) {
      gT(Fy), Qn(Ay), Ay = null, Fy = null;
    }
    function i1(e, t, a, i, u) {
      var s;
      {
        var f = i;
        if (ap(e, null, f.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var p = "" + t.children, v = ip(f.ancestorInfo, e);
          ap(null, p, v);
        }
        s = f.namespace;
      }
      var y = VT(e, t, a, s);
      return cp(u, y), Yy(y, t), y;
    }
    function l1(e, t) {
      e.appendChild(t);
    }
    function u1(e, t, a, i, u) {
      switch (BT(e, t, a, i), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function o1(e, t, a, i, u, s) {
      {
        var f = s;
        if (typeof i.children != typeof a.children && (typeof i.children == "string" || typeof i.children == "number")) {
          var p = "" + i.children, v = ip(f.ancestorInfo, t);
          ap(null, p, v);
        }
      }
      return $T(e, t, a, i);
    }
    function jy(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function s1(e, t, a, i) {
      {
        var u = a;
        ap(null, e, u.ancestorInfo);
      }
      var s = PT(e, t);
      return cp(i, s), s;
    }
    function c1() {
      var e = window.event;
      return e === void 0 ? Ma : rf(e.type);
    }
    var Hy = typeof setTimeout == "function" ? setTimeout : void 0, f1 = typeof clearTimeout == "function" ? clearTimeout : void 0, Vy = -1, PE = typeof Promise == "function" ? Promise : void 0, d1 = typeof queueMicrotask == "function" ? queueMicrotask : typeof PE < "u" ? function(e) {
      return PE.resolve(null).then(e).catch(p1);
    } : Hy;
    function p1(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function v1(e, t, a, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function h1(e, t, a, i, u, s) {
      IT(e, t, a, i, u), Yy(e, u);
    }
    function BE(e) {
      no(e, "");
    }
    function m1(e, t, a) {
      e.nodeValue = a;
    }
    function y1(e, t) {
      e.appendChild(t);
    }
    function g1(e, t) {
      var a;
      e.nodeType === Ln ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var i = e._reactRootContainer;
      i == null && a.onclick === null && bh(a);
    }
    function S1(e, t, a) {
      e.insertBefore(t, a);
    }
    function E1(e, t, a) {
      e.nodeType === Ln ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function C1(e, t) {
      e.removeChild(t);
    }
    function R1(e, t) {
      e.nodeType === Ln ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function Py(e, t) {
      var a = t, i = 0;
      do {
        var u = a.nextSibling;
        if (e.removeChild(a), u && u.nodeType === Ln) {
          var s = u.data;
          if (s === kh)
            if (i === 0) {
              e.removeChild(u), _u(t);
              return;
            } else
              i--;
          else (s === Dh || s === lp || s === up) && i++;
        }
        a = u;
      } while (a);
      _u(t);
    }
    function T1(e, t) {
      e.nodeType === Ln ? Py(e.parentNode, t) : e.nodeType === Yr && Py(e, t), _u(e);
    }
    function w1(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function x1(e) {
      e.nodeValue = "";
    }
    function b1(e, t) {
      e = e;
      var a = t[e1], i = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = sc("display", i);
    }
    function _1(e, t) {
      e.nodeValue = t;
    }
    function D1(e) {
      e.nodeType === Yr ? e.textContent = "" : e.nodeType === $i && e.documentElement && e.removeChild(e.documentElement);
    }
    function k1(e, t, a) {
      return e.nodeType !== Yr || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function O1(e, t) {
      return t === "" || e.nodeType !== Bi ? null : e;
    }
    function L1(e) {
      return e.nodeType !== Ln ? null : e;
    }
    function $E(e) {
      return e.data === lp;
    }
    function By(e) {
      return e.data === up;
    }
    function M1(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, i, u;
      return t && (a = t.dgst, i = t.msg, u = t.stck), {
        message: i,
        digest: a,
        stack: u
      };
    }
    function N1(e, t) {
      e._reactRetry = t;
    }
    function Oh(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === Yr || t === Bi)
          break;
        if (t === Ln) {
          var a = e.data;
          if (a === Dh || a === up || a === lp)
            break;
          if (a === kh)
            return null;
        }
      }
      return e;
    }
    function op(e) {
      return Oh(e.nextSibling);
    }
    function z1(e) {
      return Oh(e.firstChild);
    }
    function U1(e) {
      return Oh(e.firstChild);
    }
    function A1(e) {
      return Oh(e.nextSibling);
    }
    function F1(e, t, a, i, u, s, f) {
      cp(s, e), Yy(e, a);
      var p;
      {
        var v = u;
        p = v.namespace;
      }
      var y = (s.mode & lt) !== De;
      return QT(e, t, a, p, i, y, f);
    }
    function j1(e, t, a, i) {
      return cp(a, e), a.mode & lt, WT(e, t);
    }
    function H1(e, t) {
      cp(t, e);
    }
    function V1(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === Ln) {
          var i = t.data;
          if (i === kh) {
            if (a === 0)
              return op(t);
            a--;
          } else (i === Dh || i === up || i === lp) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function IE(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === Ln) {
          var i = t.data;
          if (i === Dh || i === up || i === lp) {
            if (a === 0)
              return t;
            a--;
          } else i === kh && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function P1(e) {
      _u(e);
    }
    function B1(e) {
      _u(e);
    }
    function $1(e) {
      return e !== "head" && e !== "body";
    }
    function I1(e, t, a, i) {
      var u = !0;
      xh(t.nodeValue, a, i, u);
    }
    function Y1(e, t, a, i, u, s) {
      if (t[_h] !== !0) {
        var f = !0;
        xh(i.nodeValue, u, s, f);
      }
    }
    function Q1(e, t) {
      t.nodeType === Yr ? My(e, t) : t.nodeType === Ln || Ny(e, t);
    }
    function W1(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === Yr ? My(a, t) : t.nodeType === Ln || Ny(a, t));
      }
    }
    function G1(e, t, a, i, u) {
      (u || t[_h] !== !0) && (i.nodeType === Yr ? My(a, i) : i.nodeType === Ln || Ny(a, i));
    }
    function q1(e, t, a) {
      zy(e, t);
    }
    function X1(e, t) {
      Uy(e, t);
    }
    function K1(e, t, a) {
      {
        var i = e.parentNode;
        i !== null && zy(i, t);
      }
    }
    function Z1(e, t) {
      {
        var a = e.parentNode;
        a !== null && Uy(a, t);
      }
    }
    function J1(e, t, a, i, u, s) {
      (s || t[_h] !== !0) && zy(a, i);
    }
    function ew(e, t, a, i, u) {
      (u || t[_h] !== !0) && Uy(a, i);
    }
    function tw(e) {
      S("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function nw(e) {
      ep(e);
    }
    var gf = Math.random().toString(36).slice(2), Sf = "__reactFiber$" + gf, $y = "__reactProps$" + gf, sp = "__reactContainer$" + gf, Iy = "__reactEvents$" + gf, rw = "__reactListeners$" + gf, aw = "__reactHandles$" + gf;
    function iw(e) {
      delete e[Sf], delete e[$y], delete e[Iy], delete e[rw], delete e[aw];
    }
    function cp(e, t) {
      t[Sf] = e;
    }
    function Lh(e, t) {
      t[sp] = e;
    }
    function YE(e) {
      e[sp] = null;
    }
    function fp(e) {
      return !!e[sp];
    }
    function Bs(e) {
      var t = e[Sf];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[sp] || a[Sf], t) {
          var i = t.alternate;
          if (t.child !== null || i !== null && i.child !== null)
            for (var u = IE(e); u !== null; ) {
              var s = u[Sf];
              if (s)
                return s;
              u = IE(u);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function _o(e) {
      var t = e[Sf] || e[sp];
      return t && (t.tag === ue || t.tag === Ye || t.tag === be || t.tag === ee) ? t : null;
    }
    function Ef(e) {
      if (e.tag === ue || e.tag === Ye)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Mh(e) {
      return e[$y] || null;
    }
    function Yy(e, t) {
      e[$y] = t;
    }
    function lw(e) {
      var t = e[Iy];
      return t === void 0 && (t = e[Iy] = /* @__PURE__ */ new Set()), t;
    }
    var QE = {}, WE = D.ReactDebugCurrentFrame;
    function Nh(e) {
      if (e) {
        var t = e._owner, a = ji(e.type, e._source, t ? t.type : null);
        WE.setExtraStackFrame(a);
      } else
        WE.setExtraStackFrame(null);
    }
    function el(e, t, a, i, u) {
      {
        var s = Function.call.bind(wr);
        for (var f in e)
          if (s(e, f)) {
            var p = void 0;
            try {
              if (typeof e[f] != "function") {
                var v = Error((i || "React class") + ": " + a + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              p = e[f](t, f, i, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y) {
              p = y;
            }
            p && !(p instanceof Error) && (Nh(u), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", a, f, typeof p), Nh(null)), p instanceof Error && !(p.message in QE) && (QE[p.message] = !0, Nh(u), S("Failed %s type: %s", a, p.message), Nh(null));
          }
      }
    }
    var Qy = [], zh;
    zh = [];
    var Nu = -1;
    function Do(e) {
      return {
        current: e
      };
    }
    function na(e, t) {
      if (Nu < 0) {
        S("Unexpected pop.");
        return;
      }
      t !== zh[Nu] && S("Unexpected Fiber popped."), e.current = Qy[Nu], Qy[Nu] = null, zh[Nu] = null, Nu--;
    }
    function ra(e, t, a) {
      Nu++, Qy[Nu] = e.current, zh[Nu] = a, e.current = t;
    }
    var Wy;
    Wy = {};
    var ii = {};
    Object.freeze(ii);
    var zu = Do(ii), Pl = Do(!1), Gy = ii;
    function Cf(e, t, a) {
      return a && Bl(t) ? Gy : zu.current;
    }
    function GE(e, t, a) {
      {
        var i = e.stateNode;
        i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function Rf(e, t) {
      {
        var a = e.type, i = a.contextTypes;
        if (!i)
          return ii;
        var u = e.stateNode;
        if (u && u.__reactInternalMemoizedUnmaskedChildContext === t)
          return u.__reactInternalMemoizedMaskedChildContext;
        var s = {};
        for (var f in i)
          s[f] = t[f];
        {
          var p = Pe(e) || "Unknown";
          el(i, s, "context", p);
        }
        return u && GE(e, t, s), s;
      }
    }
    function Uh() {
      return Pl.current;
    }
    function Bl(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function Ah(e) {
      na(Pl, e), na(zu, e);
    }
    function qy(e) {
      na(Pl, e), na(zu, e);
    }
    function qE(e, t, a) {
      {
        if (zu.current !== ii)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ra(zu, t, e), ra(Pl, a, e);
      }
    }
    function XE(e, t, a) {
      {
        var i = e.stateNode, u = t.childContextTypes;
        if (typeof i.getChildContext != "function") {
          {
            var s = Pe(e) || "Unknown";
            Wy[s] || (Wy[s] = !0, S("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", s, s));
          }
          return a;
        }
        var f = i.getChildContext();
        for (var p in f)
          if (!(p in u))
            throw new Error((Pe(e) || "Unknown") + '.getChildContext(): key "' + p + '" is not defined in childContextTypes.');
        {
          var v = Pe(e) || "Unknown";
          el(u, f, "child context", v);
        }
        return Ze({}, a, f);
      }
    }
    function Fh(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || ii;
        return Gy = zu.current, ra(zu, a, e), ra(Pl, Pl.current, e), !0;
      }
    }
    function KE(e, t, a) {
      {
        var i = e.stateNode;
        if (!i)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var u = XE(e, t, Gy);
          i.__reactInternalMemoizedMergedChildContext = u, na(Pl, e), na(zu, e), ra(zu, u, e), ra(Pl, a, e);
        } else
          na(Pl, e), ra(Pl, a, e);
      }
    }
    function uw(e) {
      {
        if (!pu(e) || e.tag !== ve)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case ee:
              return t.stateNode.context;
            case ve: {
              var a = t.type;
              if (Bl(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var ko = 0, jh = 1, Uu = null, Xy = !1, Ky = !1;
    function ZE(e) {
      Uu === null ? Uu = [e] : Uu.push(e);
    }
    function ow(e) {
      Xy = !0, ZE(e);
    }
    function JE() {
      Xy && Oo();
    }
    function Oo() {
      if (!Ky && Uu !== null) {
        Ky = !0;
        var e = 0, t = za();
        try {
          var a = !0, i = Uu;
          for (An(Or); e < i.length; e++) {
            var u = i[e];
            do
              u = u(a);
            while (u !== null);
          }
          Uu = null, Xy = !1;
        } catch (s) {
          throw Uu !== null && (Uu = Uu.slice(e + 1)), vd(us, Oo), s;
        } finally {
          An(t), Ky = !1;
        }
      }
      return null;
    }
    var Tf = [], wf = 0, Hh = null, Vh = 0, Oi = [], Li = 0, $s = null, Au = 1, Fu = "";
    function sw(e) {
      return Ys(), (e.flags & Ei) !== _e;
    }
    function cw(e) {
      return Ys(), Vh;
    }
    function fw() {
      var e = Fu, t = Au, a = t & ~dw(t);
      return a.toString(32) + e;
    }
    function Is(e, t) {
      Ys(), Tf[wf++] = Vh, Tf[wf++] = Hh, Hh = e, Vh = t;
    }
    function eC(e, t, a) {
      Ys(), Oi[Li++] = Au, Oi[Li++] = Fu, Oi[Li++] = $s, $s = e;
      var i = Au, u = Fu, s = Ph(i) - 1, f = i & ~(1 << s), p = a + 1, v = Ph(t) + s;
      if (v > 30) {
        var y = s - s % 5, g = (1 << y) - 1, b = (f & g).toString(32), w = f >> y, z = s - y, F = Ph(t) + z, V = p << z, le = V | w, Le = b + u;
        Au = 1 << F | le, Fu = Le;
      } else {
        var we = p << s, Ct = we | f, vt = u;
        Au = 1 << v | Ct, Fu = vt;
      }
    }
    function Zy(e) {
      Ys();
      var t = e.return;
      if (t !== null) {
        var a = 1, i = 0;
        Is(e, a), eC(e, a, i);
      }
    }
    function Ph(e) {
      return 32 - zn(e);
    }
    function dw(e) {
      return 1 << Ph(e) - 1;
    }
    function Jy(e) {
      for (; e === Hh; )
        Hh = Tf[--wf], Tf[wf] = null, Vh = Tf[--wf], Tf[wf] = null;
      for (; e === $s; )
        $s = Oi[--Li], Oi[Li] = null, Fu = Oi[--Li], Oi[Li] = null, Au = Oi[--Li], Oi[Li] = null;
    }
    function pw() {
      return Ys(), $s !== null ? {
        id: Au,
        overflow: Fu
      } : null;
    }
    function vw(e, t) {
      Ys(), Oi[Li++] = Au, Oi[Li++] = Fu, Oi[Li++] = $s, Au = t.id, Fu = t.overflow, $s = e;
    }
    function Ys() {
      Ur() || S("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var zr = null, Mi = null, tl = !1, Qs = !1, Lo = null;
    function hw() {
      tl && S("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function tC() {
      Qs = !0;
    }
    function mw() {
      return Qs;
    }
    function yw(e) {
      var t = e.stateNode.containerInfo;
      return Mi = U1(t), zr = e, tl = !0, Lo = null, Qs = !1, !0;
    }
    function gw(e, t, a) {
      return Mi = A1(t), zr = e, tl = !0, Lo = null, Qs = !1, a !== null && vw(e, a), !0;
    }
    function nC(e, t) {
      switch (e.tag) {
        case ee: {
          Q1(e.stateNode.containerInfo, t);
          break;
        }
        case ue: {
          var a = (e.mode & lt) !== De;
          G1(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case be: {
          var i = e.memoizedState;
          i.dehydrated !== null && W1(i.dehydrated, t);
          break;
        }
      }
    }
    function rC(e, t) {
      nC(e, t);
      var a = R_();
      a.stateNode = t, a.return = e;
      var i = e.deletions;
      i === null ? (e.deletions = [a], e.flags |= _a) : i.push(a);
    }
    function eg(e, t) {
      {
        if (Qs)
          return;
        switch (e.tag) {
          case ee: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case ue:
                var i = t.type;
                t.pendingProps, q1(a, i);
                break;
              case Ye:
                var u = t.pendingProps;
                X1(a, u);
                break;
            }
            break;
          }
          case ue: {
            var s = e.type, f = e.memoizedProps, p = e.stateNode;
            switch (t.tag) {
              case ue: {
                var v = t.type, y = t.pendingProps, g = (e.mode & lt) !== De;
                J1(
                  s,
                  f,
                  p,
                  v,
                  y,
                  // TODO: Delete this argument when we remove the legacy root API.
                  g
                );
                break;
              }
              case Ye: {
                var b = t.pendingProps, w = (e.mode & lt) !== De;
                ew(
                  s,
                  f,
                  p,
                  b,
                  // TODO: Delete this argument when we remove the legacy root API.
                  w
                );
                break;
              }
            }
            break;
          }
          case be: {
            var z = e.memoizedState, F = z.dehydrated;
            if (F !== null) switch (t.tag) {
              case ue:
                var V = t.type;
                t.pendingProps, K1(F, V);
                break;
              case Ye:
                var le = t.pendingProps;
                Z1(F, le);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function aC(e, t) {
      t.flags = t.flags & ~Wr | hn, eg(e, t);
    }
    function iC(e, t) {
      switch (e.tag) {
        case ue: {
          var a = e.type;
          e.pendingProps;
          var i = k1(t, a);
          return i !== null ? (e.stateNode = i, zr = e, Mi = z1(i), !0) : !1;
        }
        case Ye: {
          var u = e.pendingProps, s = O1(t, u);
          return s !== null ? (e.stateNode = s, zr = e, Mi = null, !0) : !1;
        }
        case be: {
          var f = L1(t);
          if (f !== null) {
            var p = {
              dehydrated: f,
              treeContext: pw(),
              retryLane: Kr
            };
            e.memoizedState = p;
            var v = T_(f);
            return v.return = e, e.child = v, zr = e, Mi = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function tg(e) {
      return (e.mode & lt) !== De && (e.flags & xe) === _e;
    }
    function ng(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function rg(e) {
      if (tl) {
        var t = Mi;
        if (!t) {
          tg(e) && (eg(zr, e), ng()), aC(zr, e), tl = !1, zr = e;
          return;
        }
        var a = t;
        if (!iC(e, t)) {
          tg(e) && (eg(zr, e), ng()), t = op(a);
          var i = zr;
          if (!t || !iC(e, t)) {
            aC(zr, e), tl = !1, zr = e;
            return;
          }
          rC(i, a);
        }
      }
    }
    function Sw(e, t, a) {
      var i = e.stateNode, u = !Qs, s = F1(i, e.type, e.memoizedProps, t, a, e, u);
      return e.updateQueue = s, s !== null;
    }
    function Ew(e) {
      var t = e.stateNode, a = e.memoizedProps, i = j1(t, a, e);
      if (i) {
        var u = zr;
        if (u !== null)
          switch (u.tag) {
            case ee: {
              var s = u.stateNode.containerInfo, f = (u.mode & lt) !== De;
              I1(
                s,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                f
              );
              break;
            }
            case ue: {
              var p = u.type, v = u.memoizedProps, y = u.stateNode, g = (u.mode & lt) !== De;
              Y1(
                p,
                v,
                y,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                g
              );
              break;
            }
          }
      }
      return i;
    }
    function Cw(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      H1(a, e);
    }
    function Rw(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return V1(a);
    }
    function lC(e) {
      for (var t = e.return; t !== null && t.tag !== ue && t.tag !== ee && t.tag !== be; )
        t = t.return;
      zr = t;
    }
    function Bh(e) {
      if (e !== zr)
        return !1;
      if (!tl)
        return lC(e), tl = !0, !1;
      if (e.tag !== ee && (e.tag !== ue || $1(e.type) && !jy(e.type, e.memoizedProps))) {
        var t = Mi;
        if (t)
          if (tg(e))
            uC(e), ng();
          else
            for (; t; )
              rC(e, t), t = op(t);
      }
      return lC(e), e.tag === be ? Mi = Rw(e) : Mi = zr ? op(e.stateNode) : null, !0;
    }
    function Tw() {
      return tl && Mi !== null;
    }
    function uC(e) {
      for (var t = Mi; t; )
        nC(e, t), t = op(t);
    }
    function xf() {
      zr = null, Mi = null, tl = !1, Qs = !1;
    }
    function oC() {
      Lo !== null && (tR(Lo), Lo = null);
    }
    function Ur() {
      return tl;
    }
    function ag(e) {
      Lo === null ? Lo = [e] : Lo.push(e);
    }
    var ww = D.ReactCurrentBatchConfig, xw = null;
    function bw() {
      return ww.transition;
    }
    var nl = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var _w = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & Wt && (t = a), a = a.return;
        return t;
      }, Ws = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, dp = [], pp = [], vp = [], hp = [], mp = [], yp = [], Gs = /* @__PURE__ */ new Set();
      nl.recordUnsafeLifecycleWarnings = function(e, t) {
        Gs.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && dp.push(e), e.mode & Wt && typeof t.UNSAFE_componentWillMount == "function" && pp.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && vp.push(e), e.mode & Wt && typeof t.UNSAFE_componentWillReceiveProps == "function" && hp.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && mp.push(e), e.mode & Wt && typeof t.UNSAFE_componentWillUpdate == "function" && yp.push(e));
      }, nl.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        dp.length > 0 && (dp.forEach(function(w) {
          e.add(Pe(w) || "Component"), Gs.add(w.type);
        }), dp = []);
        var t = /* @__PURE__ */ new Set();
        pp.length > 0 && (pp.forEach(function(w) {
          t.add(Pe(w) || "Component"), Gs.add(w.type);
        }), pp = []);
        var a = /* @__PURE__ */ new Set();
        vp.length > 0 && (vp.forEach(function(w) {
          a.add(Pe(w) || "Component"), Gs.add(w.type);
        }), vp = []);
        var i = /* @__PURE__ */ new Set();
        hp.length > 0 && (hp.forEach(function(w) {
          i.add(Pe(w) || "Component"), Gs.add(w.type);
        }), hp = []);
        var u = /* @__PURE__ */ new Set();
        mp.length > 0 && (mp.forEach(function(w) {
          u.add(Pe(w) || "Component"), Gs.add(w.type);
        }), mp = []);
        var s = /* @__PURE__ */ new Set();
        if (yp.length > 0 && (yp.forEach(function(w) {
          s.add(Pe(w) || "Component"), Gs.add(w.type);
        }), yp = []), t.size > 0) {
          var f = Ws(t);
          S(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, f);
        }
        if (i.size > 0) {
          var p = Ws(i);
          S(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, p);
        }
        if (s.size > 0) {
          var v = Ws(s);
          S(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, v);
        }
        if (e.size > 0) {
          var y = Ws(e);
          _t(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, y);
        }
        if (a.size > 0) {
          var g = Ws(a);
          _t(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, g);
        }
        if (u.size > 0) {
          var b = Ws(u);
          _t(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, b);
        }
      };
      var $h = /* @__PURE__ */ new Map(), sC = /* @__PURE__ */ new Set();
      nl.recordLegacyContextWarning = function(e, t) {
        var a = _w(e);
        if (a === null) {
          S("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!sC.has(e.type)) {
          var i = $h.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], $h.set(a, i)), i.push(e));
        }
      }, nl.flushLegacyContextWarning = function() {
        $h.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], i = /* @__PURE__ */ new Set();
            e.forEach(function(s) {
              i.add(Pe(s) || "Component"), sC.add(s.type);
            });
            var u = Ws(i);
            try {
              It(a), S(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, u);
            } finally {
              on();
            }
          }
        });
      }, nl.discardPendingWarnings = function() {
        dp = [], pp = [], vp = [], hp = [], mp = [], yp = [], $h = /* @__PURE__ */ new Map();
      };
    }
    var ig, lg, ug, og, sg, cC = function(e, t) {
    };
    ig = !1, lg = !1, ug = {}, og = {}, sg = {}, cC = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = Pe(t) || "Component";
        og[a] || (og[a] = !0, S('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Dw(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function gp(e, t, a) {
      var i = a.ref;
      if (i !== null && typeof i != "function" && typeof i != "object") {
        if ((e.mode & Wt || B) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self) && // Will already throw with "Function components cannot have string refs"
        !(a._owner && a._owner.tag !== ve) && // Will already warn with "Function components cannot be given refs"
        !(typeof a.type == "function" && !Dw(a.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        a._owner) {
          var u = Pe(e) || "Component";
          ug[u] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', u, i), ug[u] = !0);
        }
        if (a._owner) {
          var s = a._owner, f;
          if (s) {
            var p = s;
            if (p.tag !== ve)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            f = p.stateNode;
          }
          if (!f)
            throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
          var v = f;
          oi(i, "ref");
          var y = "" + i;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === y)
            return t.ref;
          var g = function(b) {
            var w = v.refs;
            b === null ? delete w[y] : w[y] = b;
          };
          return g._stringRef = y, g;
        } else {
          if (typeof i != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return i;
    }
    function Ih(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Yh(e) {
      {
        var t = Pe(e) || "Component";
        if (sg[t])
          return;
        sg[t] = !0, S("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function fC(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function dC(e) {
      function t(O, P) {
        if (e) {
          var L = O.deletions;
          L === null ? (O.deletions = [P], O.flags |= _a) : L.push(P);
        }
      }
      function a(O, P) {
        if (!e)
          return null;
        for (var L = P; L !== null; )
          t(O, L), L = L.sibling;
        return null;
      }
      function i(O, P) {
        for (var L = /* @__PURE__ */ new Map(), X = P; X !== null; )
          X.key !== null ? L.set(X.key, X) : L.set(X.index, X), X = X.sibling;
        return L;
      }
      function u(O, P) {
        var L = rc(O, P);
        return L.index = 0, L.sibling = null, L;
      }
      function s(O, P, L) {
        if (O.index = L, !e)
          return O.flags |= Ei, P;
        var X = O.alternate;
        if (X !== null) {
          var fe = X.index;
          return fe < P ? (O.flags |= hn, P) : fe;
        } else
          return O.flags |= hn, P;
      }
      function f(O) {
        return e && O.alternate === null && (O.flags |= hn), O;
      }
      function p(O, P, L, X) {
        if (P === null || P.tag !== Ye) {
          var fe = aE(L, O.mode, X);
          return fe.return = O, fe;
        } else {
          var oe = u(P, L);
          return oe.return = O, oe;
        }
      }
      function v(O, P, L, X) {
        var fe = L.type;
        if (fe === ci)
          return g(O, P, L.props.children, X, L.key);
        if (P !== null && (P.elementType === fe || // Keep this check inline so it only runs on the false path:
        yR(P, L) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof fe == "object" && fe !== null && fe.$$typeof === $e && fC(fe) === P.type)) {
          var oe = u(P, L.props);
          return oe.ref = gp(O, P, L), oe.return = O, oe._debugSource = L._source, oe._debugOwner = L._owner, oe;
        }
        var He = rE(L, O.mode, X);
        return He.ref = gp(O, P, L), He.return = O, He;
      }
      function y(O, P, L, X) {
        if (P === null || P.tag !== Ce || P.stateNode.containerInfo !== L.containerInfo || P.stateNode.implementation !== L.implementation) {
          var fe = iE(L, O.mode, X);
          return fe.return = O, fe;
        } else {
          var oe = u(P, L.children || []);
          return oe.return = O, oe;
        }
      }
      function g(O, P, L, X, fe) {
        if (P === null || P.tag !== yt) {
          var oe = Bo(L, O.mode, X, fe);
          return oe.return = O, oe;
        } else {
          var He = u(P, L);
          return He.return = O, He;
        }
      }
      function b(O, P, L) {
        if (typeof P == "string" && P !== "" || typeof P == "number") {
          var X = aE("" + P, O.mode, L);
          return X.return = O, X;
        }
        if (typeof P == "object" && P !== null) {
          switch (P.$$typeof) {
            case br: {
              var fe = rE(P, O.mode, L);
              return fe.ref = gp(O, null, P), fe.return = O, fe;
            }
            case nr: {
              var oe = iE(P, O.mode, L);
              return oe.return = O, oe;
            }
            case $e: {
              var He = P._payload, We = P._init;
              return b(O, We(He), L);
            }
          }
          if (nt(P) || qe(P)) {
            var qt = Bo(P, O.mode, L, null);
            return qt.return = O, qt;
          }
          Ih(O, P);
        }
        return typeof P == "function" && Yh(O), null;
      }
      function w(O, P, L, X) {
        var fe = P !== null ? P.key : null;
        if (typeof L == "string" && L !== "" || typeof L == "number")
          return fe !== null ? null : p(O, P, "" + L, X);
        if (typeof L == "object" && L !== null) {
          switch (L.$$typeof) {
            case br:
              return L.key === fe ? v(O, P, L, X) : null;
            case nr:
              return L.key === fe ? y(O, P, L, X) : null;
            case $e: {
              var oe = L._payload, He = L._init;
              return w(O, P, He(oe), X);
            }
          }
          if (nt(L) || qe(L))
            return fe !== null ? null : g(O, P, L, X, null);
          Ih(O, L);
        }
        return typeof L == "function" && Yh(O), null;
      }
      function z(O, P, L, X, fe) {
        if (typeof X == "string" && X !== "" || typeof X == "number") {
          var oe = O.get(L) || null;
          return p(P, oe, "" + X, fe);
        }
        if (typeof X == "object" && X !== null) {
          switch (X.$$typeof) {
            case br: {
              var He = O.get(X.key === null ? L : X.key) || null;
              return v(P, He, X, fe);
            }
            case nr: {
              var We = O.get(X.key === null ? L : X.key) || null;
              return y(P, We, X, fe);
            }
            case $e:
              var qt = X._payload, Nt = X._init;
              return z(O, P, L, Nt(qt), fe);
          }
          if (nt(X) || qe(X)) {
            var Wn = O.get(L) || null;
            return g(P, Wn, X, fe, null);
          }
          Ih(P, X);
        }
        return typeof X == "function" && Yh(P), null;
      }
      function F(O, P, L) {
        {
          if (typeof O != "object" || O === null)
            return P;
          switch (O.$$typeof) {
            case br:
            case nr:
              cC(O, L);
              var X = O.key;
              if (typeof X != "string")
                break;
              if (P === null) {
                P = /* @__PURE__ */ new Set(), P.add(X);
                break;
              }
              if (!P.has(X)) {
                P.add(X);
                break;
              }
              S("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", X);
              break;
            case $e:
              var fe = O._payload, oe = O._init;
              F(oe(fe), P, L);
              break;
          }
        }
        return P;
      }
      function V(O, P, L, X) {
        for (var fe = null, oe = 0; oe < L.length; oe++) {
          var He = L[oe];
          fe = F(He, fe, O);
        }
        for (var We = null, qt = null, Nt = P, Wn = 0, zt = 0, Hn = null; Nt !== null && zt < L.length; zt++) {
          Nt.index > zt ? (Hn = Nt, Nt = null) : Hn = Nt.sibling;
          var ia = w(O, Nt, L[zt], X);
          if (ia === null) {
            Nt === null && (Nt = Hn);
            break;
          }
          e && Nt && ia.alternate === null && t(O, Nt), Wn = s(ia, Wn, zt), qt === null ? We = ia : qt.sibling = ia, qt = ia, Nt = Hn;
        }
        if (zt === L.length) {
          if (a(O, Nt), Ur()) {
            var Br = zt;
            Is(O, Br);
          }
          return We;
        }
        if (Nt === null) {
          for (; zt < L.length; zt++) {
            var ui = b(O, L[zt], X);
            ui !== null && (Wn = s(ui, Wn, zt), qt === null ? We = ui : qt.sibling = ui, qt = ui);
          }
          if (Ur()) {
            var Ea = zt;
            Is(O, Ea);
          }
          return We;
        }
        for (var Ca = i(O, Nt); zt < L.length; zt++) {
          var la = z(Ca, O, zt, L[zt], X);
          la !== null && (e && la.alternate !== null && Ca.delete(la.key === null ? zt : la.key), Wn = s(la, Wn, zt), qt === null ? We = la : qt.sibling = la, qt = la);
        }
        if (e && Ca.forEach(function(If) {
          return t(O, If);
        }), Ur()) {
          var Iu = zt;
          Is(O, Iu);
        }
        return We;
      }
      function le(O, P, L, X) {
        var fe = qe(L);
        if (typeof fe != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          L[Symbol.toStringTag] === "Generator" && (lg || S("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), lg = !0), L.entries === fe && (ig || S("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), ig = !0);
          var oe = fe.call(L);
          if (oe)
            for (var He = null, We = oe.next(); !We.done; We = oe.next()) {
              var qt = We.value;
              He = F(qt, He, O);
            }
        }
        var Nt = fe.call(L);
        if (Nt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Wn = null, zt = null, Hn = P, ia = 0, Br = 0, ui = null, Ea = Nt.next(); Hn !== null && !Ea.done; Br++, Ea = Nt.next()) {
          Hn.index > Br ? (ui = Hn, Hn = null) : ui = Hn.sibling;
          var Ca = w(O, Hn, Ea.value, X);
          if (Ca === null) {
            Hn === null && (Hn = ui);
            break;
          }
          e && Hn && Ca.alternate === null && t(O, Hn), ia = s(Ca, ia, Br), zt === null ? Wn = Ca : zt.sibling = Ca, zt = Ca, Hn = ui;
        }
        if (Ea.done) {
          if (a(O, Hn), Ur()) {
            var la = Br;
            Is(O, la);
          }
          return Wn;
        }
        if (Hn === null) {
          for (; !Ea.done; Br++, Ea = Nt.next()) {
            var Iu = b(O, Ea.value, X);
            Iu !== null && (ia = s(Iu, ia, Br), zt === null ? Wn = Iu : zt.sibling = Iu, zt = Iu);
          }
          if (Ur()) {
            var If = Br;
            Is(O, If);
          }
          return Wn;
        }
        for (var Xp = i(O, Hn); !Ea.done; Br++, Ea = Nt.next()) {
          var Xl = z(Xp, O, Br, Ea.value, X);
          Xl !== null && (e && Xl.alternate !== null && Xp.delete(Xl.key === null ? Br : Xl.key), ia = s(Xl, ia, Br), zt === null ? Wn = Xl : zt.sibling = Xl, zt = Xl);
        }
        if (e && Xp.forEach(function(eD) {
          return t(O, eD);
        }), Ur()) {
          var J_ = Br;
          Is(O, J_);
        }
        return Wn;
      }
      function Le(O, P, L, X) {
        if (P !== null && P.tag === Ye) {
          a(O, P.sibling);
          var fe = u(P, L);
          return fe.return = O, fe;
        }
        a(O, P);
        var oe = aE(L, O.mode, X);
        return oe.return = O, oe;
      }
      function we(O, P, L, X) {
        for (var fe = L.key, oe = P; oe !== null; ) {
          if (oe.key === fe) {
            var He = L.type;
            if (He === ci) {
              if (oe.tag === yt) {
                a(O, oe.sibling);
                var We = u(oe, L.props.children);
                return We.return = O, We._debugSource = L._source, We._debugOwner = L._owner, We;
              }
            } else if (oe.elementType === He || // Keep this check inline so it only runs on the false path:
            yR(oe, L) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof He == "object" && He !== null && He.$$typeof === $e && fC(He) === oe.type) {
              a(O, oe.sibling);
              var qt = u(oe, L.props);
              return qt.ref = gp(O, oe, L), qt.return = O, qt._debugSource = L._source, qt._debugOwner = L._owner, qt;
            }
            a(O, oe);
            break;
          } else
            t(O, oe);
          oe = oe.sibling;
        }
        if (L.type === ci) {
          var Nt = Bo(L.props.children, O.mode, X, L.key);
          return Nt.return = O, Nt;
        } else {
          var Wn = rE(L, O.mode, X);
          return Wn.ref = gp(O, P, L), Wn.return = O, Wn;
        }
      }
      function Ct(O, P, L, X) {
        for (var fe = L.key, oe = P; oe !== null; ) {
          if (oe.key === fe)
            if (oe.tag === Ce && oe.stateNode.containerInfo === L.containerInfo && oe.stateNode.implementation === L.implementation) {
              a(O, oe.sibling);
              var He = u(oe, L.children || []);
              return He.return = O, He;
            } else {
              a(O, oe);
              break;
            }
          else
            t(O, oe);
          oe = oe.sibling;
        }
        var We = iE(L, O.mode, X);
        return We.return = O, We;
      }
      function vt(O, P, L, X) {
        var fe = typeof L == "object" && L !== null && L.type === ci && L.key === null;
        if (fe && (L = L.props.children), typeof L == "object" && L !== null) {
          switch (L.$$typeof) {
            case br:
              return f(we(O, P, L, X));
            case nr:
              return f(Ct(O, P, L, X));
            case $e:
              var oe = L._payload, He = L._init;
              return vt(O, P, He(oe), X);
          }
          if (nt(L))
            return V(O, P, L, X);
          if (qe(L))
            return le(O, P, L, X);
          Ih(O, L);
        }
        return typeof L == "string" && L !== "" || typeof L == "number" ? f(Le(O, P, "" + L, X)) : (typeof L == "function" && Yh(O), a(O, P));
      }
      return vt;
    }
    var bf = dC(!0), pC = dC(!1);
    function kw(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, i = rc(a, a.pendingProps);
        for (t.child = i, i.return = t; a.sibling !== null; )
          a = a.sibling, i = i.sibling = rc(a, a.pendingProps), i.return = t;
        i.sibling = null;
      }
    }
    function Ow(e, t) {
      for (var a = e.child; a !== null; )
        y_(a, t), a = a.sibling;
    }
    var cg = Do(null), fg;
    fg = {};
    var Qh = null, _f = null, dg = null, Wh = !1;
    function Gh() {
      Qh = null, _f = null, dg = null, Wh = !1;
    }
    function vC() {
      Wh = !0;
    }
    function hC() {
      Wh = !1;
    }
    function mC(e, t, a) {
      ra(cg, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== fg && S("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = fg;
    }
    function pg(e, t) {
      var a = cg.current;
      na(cg, t), e._currentValue = a;
    }
    function vg(e, t, a) {
      for (var i = e; i !== null; ) {
        var u = i.alternate;
        if (bu(i.childLanes, t) ? u !== null && !bu(u.childLanes, t) && (u.childLanes = Xe(u.childLanes, t)) : (i.childLanes = Xe(i.childLanes, t), u !== null && (u.childLanes = Xe(u.childLanes, t))), i === a)
          break;
        i = i.return;
      }
      i !== a && S("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Lw(e, t, a) {
      Mw(e, t, a);
    }
    function Mw(e, t, a) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var u = void 0, s = i.dependencies;
        if (s !== null) {
          u = i.child;
          for (var f = s.firstContext; f !== null; ) {
            if (f.context === t) {
              if (i.tag === ve) {
                var p = Cs(a), v = ju(Xt, p);
                v.tag = Xh;
                var y = i.updateQueue;
                if (y !== null) {
                  var g = y.shared, b = g.pending;
                  b === null ? v.next = v : (v.next = b.next, b.next = v), g.pending = v;
                }
              }
              i.lanes = Xe(i.lanes, a);
              var w = i.alternate;
              w !== null && (w.lanes = Xe(w.lanes, a)), vg(i.return, a, e), s.lanes = Xe(s.lanes, a);
              break;
            }
            f = f.next;
          }
        } else if (i.tag === ft)
          u = i.type === e.type ? null : i.child;
        else if (i.tag === Kt) {
          var z = i.return;
          if (z === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          z.lanes = Xe(z.lanes, a);
          var F = z.alternate;
          F !== null && (F.lanes = Xe(F.lanes, a)), vg(z, a, e), u = i.sibling;
        } else
          u = i.child;
        if (u !== null)
          u.return = i;
        else
          for (u = i; u !== null; ) {
            if (u === e) {
              u = null;
              break;
            }
            var V = u.sibling;
            if (V !== null) {
              V.return = u.return, u = V;
              break;
            }
            u = u.return;
          }
        i = u;
      }
    }
    function Df(e, t) {
      Qh = e, _f = null, dg = null;
      var a = e.dependencies;
      if (a !== null) {
        var i = a.firstContext;
        i !== null && (Zr(a.lanes, t) && Np(), a.firstContext = null);
      }
    }
    function er(e) {
      Wh && S("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (dg !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (_f === null) {
          if (Qh === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          _f = a, Qh.dependencies = {
            lanes: Y,
            firstContext: a
          };
        } else
          _f = _f.next = a;
      }
      return t;
    }
    var qs = null;
    function hg(e) {
      qs === null ? qs = [e] : qs.push(e);
    }
    function Nw() {
      if (qs !== null) {
        for (var e = 0; e < qs.length; e++) {
          var t = qs[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var i = a.next, u = t.pending;
            if (u !== null) {
              var s = u.next;
              u.next = i, a.next = s;
            }
            t.pending = a;
          }
        }
        qs = null;
      }
    }
    function yC(e, t, a, i) {
      var u = t.interleaved;
      return u === null ? (a.next = a, hg(t)) : (a.next = u.next, u.next = a), t.interleaved = a, qh(e, i);
    }
    function zw(e, t, a, i) {
      var u = t.interleaved;
      u === null ? (a.next = a, hg(t)) : (a.next = u.next, u.next = a), t.interleaved = a;
    }
    function Uw(e, t, a, i) {
      var u = t.interleaved;
      return u === null ? (a.next = a, hg(t)) : (a.next = u.next, u.next = a), t.interleaved = a, qh(e, i);
    }
    function Fa(e, t) {
      return qh(e, t);
    }
    var Aw = qh;
    function qh(e, t) {
      e.lanes = Xe(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = Xe(a.lanes, t)), a === null && (e.flags & (hn | Wr)) !== _e && pR(e);
      for (var i = e, u = e.return; u !== null; )
        u.childLanes = Xe(u.childLanes, t), a = u.alternate, a !== null ? a.childLanes = Xe(a.childLanes, t) : (u.flags & (hn | Wr)) !== _e && pR(e), i = u, u = u.return;
      if (i.tag === ee) {
        var s = i.stateNode;
        return s;
      } else
        return null;
    }
    var gC = 0, SC = 1, Xh = 2, mg = 3, Kh = !1, yg, Zh;
    yg = !1, Zh = null;
    function gg(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Y
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function EC(e, t) {
      var a = t.updateQueue, i = e.updateQueue;
      if (a === i) {
        var u = {
          baseState: i.baseState,
          firstBaseUpdate: i.firstBaseUpdate,
          lastBaseUpdate: i.lastBaseUpdate,
          shared: i.shared,
          effects: i.effects
        };
        t.updateQueue = u;
      }
    }
    function ju(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: gC,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function Mo(e, t, a) {
      var i = e.updateQueue;
      if (i === null)
        return null;
      var u = i.shared;
      if (Zh === u && !yg && (S("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), yg = !0), zb()) {
        var s = u.pending;
        return s === null ? t.next = t : (t.next = s.next, s.next = t), u.pending = t, Aw(e, a);
      } else
        return Uw(e, u, t, a);
    }
    function Jh(e, t, a) {
      var i = t.updateQueue;
      if (i !== null) {
        var u = i.shared;
        if (Ld(a)) {
          var s = u.lanes;
          s = Nd(s, e.pendingLanes);
          var f = Xe(s, a);
          u.lanes = f, Jc(e, f);
        }
      }
    }
    function Sg(e, t) {
      var a = e.updateQueue, i = e.alternate;
      if (i !== null) {
        var u = i.updateQueue;
        if (a === u) {
          var s = null, f = null, p = a.firstBaseUpdate;
          if (p !== null) {
            var v = p;
            do {
              var y = {
                eventTime: v.eventTime,
                lane: v.lane,
                tag: v.tag,
                payload: v.payload,
                callback: v.callback,
                next: null
              };
              f === null ? s = f = y : (f.next = y, f = y), v = v.next;
            } while (v !== null);
            f === null ? s = f = t : (f.next = t, f = t);
          } else
            s = f = t;
          a = {
            baseState: u.baseState,
            firstBaseUpdate: s,
            lastBaseUpdate: f,
            shared: u.shared,
            effects: u.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var g = a.lastBaseUpdate;
      g === null ? a.firstBaseUpdate = t : g.next = t, a.lastBaseUpdate = t;
    }
    function Fw(e, t, a, i, u, s) {
      switch (a.tag) {
        case SC: {
          var f = a.payload;
          if (typeof f == "function") {
            vC();
            var p = f.call(s, i, u);
            {
              if (e.mode & Wt) {
                mn(!0);
                try {
                  f.call(s, i, u);
                } finally {
                  mn(!1);
                }
              }
              hC();
            }
            return p;
          }
          return f;
        }
        case mg:
          e.flags = e.flags & ~Xn | xe;
        // Intentional fallthrough
        case gC: {
          var v = a.payload, y;
          if (typeof v == "function") {
            vC(), y = v.call(s, i, u);
            {
              if (e.mode & Wt) {
                mn(!0);
                try {
                  v.call(s, i, u);
                } finally {
                  mn(!1);
                }
              }
              hC();
            }
          } else
            y = v;
          return y == null ? i : Ze({}, i, y);
        }
        case Xh:
          return Kh = !0, i;
      }
      return i;
    }
    function em(e, t, a, i) {
      var u = e.updateQueue;
      Kh = !1, Zh = u.shared;
      var s = u.firstBaseUpdate, f = u.lastBaseUpdate, p = u.shared.pending;
      if (p !== null) {
        u.shared.pending = null;
        var v = p, y = v.next;
        v.next = null, f === null ? s = y : f.next = y, f = v;
        var g = e.alternate;
        if (g !== null) {
          var b = g.updateQueue, w = b.lastBaseUpdate;
          w !== f && (w === null ? b.firstBaseUpdate = y : w.next = y, b.lastBaseUpdate = v);
        }
      }
      if (s !== null) {
        var z = u.baseState, F = Y, V = null, le = null, Le = null, we = s;
        do {
          var Ct = we.lane, vt = we.eventTime;
          if (bu(i, Ct)) {
            if (Le !== null) {
              var P = {
                eventTime: vt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: bt,
                tag: we.tag,
                payload: we.payload,
                callback: we.callback,
                next: null
              };
              Le = Le.next = P;
            }
            z = Fw(e, u, we, z, t, a);
            var L = we.callback;
            if (L !== null && // If the update was already committed, we should not queue its
            // callback again.
            we.lane !== bt) {
              e.flags |= nn;
              var X = u.effects;
              X === null ? u.effects = [we] : X.push(we);
            }
          } else {
            var O = {
              eventTime: vt,
              lane: Ct,
              tag: we.tag,
              payload: we.payload,
              callback: we.callback,
              next: null
            };
            Le === null ? (le = Le = O, V = z) : Le = Le.next = O, F = Xe(F, Ct);
          }
          if (we = we.next, we === null) {
            if (p = u.shared.pending, p === null)
              break;
            var fe = p, oe = fe.next;
            fe.next = null, we = oe, u.lastBaseUpdate = fe, u.shared.pending = null;
          }
        } while (!0);
        Le === null && (V = z), u.baseState = V, u.firstBaseUpdate = le, u.lastBaseUpdate = Le;
        var He = u.shared.interleaved;
        if (He !== null) {
          var We = He;
          do
            F = Xe(F, We.lane), We = We.next;
          while (We !== He);
        } else s === null && (u.shared.lanes = Y);
        Yp(F), e.lanes = F, e.memoizedState = z;
      }
      Zh = null;
    }
    function jw(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function CC() {
      Kh = !1;
    }
    function tm() {
      return Kh;
    }
    function RC(e, t, a) {
      var i = t.effects;
      if (t.effects = null, i !== null)
        for (var u = 0; u < i.length; u++) {
          var s = i[u], f = s.callback;
          f !== null && (s.callback = null, jw(f, a));
        }
    }
    var Sp = {}, No = Do(Sp), Ep = Do(Sp), nm = Do(Sp);
    function rm(e) {
      if (e === Sp)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function TC() {
      var e = rm(nm.current);
      return e;
    }
    function Eg(e, t) {
      ra(nm, t, e), ra(Ep, e, e), ra(No, Sp, e);
      var a = t1(t);
      na(No, e), ra(No, a, e);
    }
    function kf(e) {
      na(No, e), na(Ep, e), na(nm, e);
    }
    function Cg() {
      var e = rm(No.current);
      return e;
    }
    function wC(e) {
      rm(nm.current);
      var t = rm(No.current), a = n1(t, e.type);
      t !== a && (ra(Ep, e, e), ra(No, a, e));
    }
    function Rg(e) {
      Ep.current === e && (na(No, e), na(Ep, e));
    }
    var Hw = 0, xC = 1, bC = 1, Cp = 2, rl = Do(Hw);
    function Tg(e, t) {
      return (e & t) !== 0;
    }
    function Of(e) {
      return e & xC;
    }
    function wg(e, t) {
      return e & xC | t;
    }
    function Vw(e, t) {
      return e | t;
    }
    function zo(e, t) {
      ra(rl, t, e);
    }
    function Lf(e) {
      na(rl, e);
    }
    function Pw(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function am(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === be) {
          var a = t.memoizedState;
          if (a !== null) {
            var i = a.dehydrated;
            if (i === null || $E(i) || By(i))
              return t;
          }
        } else if (t.tag === an && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var u = (t.flags & xe) !== _e;
          if (u)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var ja = (
      /*   */
      0
    ), sr = (
      /* */
      1
    ), $l = (
      /*  */
      2
    ), cr = (
      /*    */
      4
    ), Ar = (
      /*   */
      8
    ), xg = [];
    function bg() {
      for (var e = 0; e < xg.length; e++) {
        var t = xg[e];
        t._workInProgressVersionPrimary = null;
      }
      xg.length = 0;
    }
    function Bw(e, t) {
      var a = t._getVersion, i = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
    }
    var ce = D.ReactCurrentDispatcher, Rp = D.ReactCurrentBatchConfig, _g, Mf;
    _g = /* @__PURE__ */ new Set();
    var Xs = Y, Gt = null, fr = null, dr = null, im = !1, Tp = !1, wp = 0, $w = 0, Iw = 25, $ = null, Ni = null, Uo = -1, Dg = !1;
    function Ht() {
      {
        var e = $;
        Ni === null ? Ni = [e] : Ni.push(e);
      }
    }
    function te() {
      {
        var e = $;
        Ni !== null && (Uo++, Ni[Uo] !== e && Yw(e));
      }
    }
    function Nf(e) {
      e != null && !nt(e) && S("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", $, typeof e);
    }
    function Yw(e) {
      {
        var t = Pe(Gt);
        if (!_g.has(t) && (_g.add(t), Ni !== null)) {
          for (var a = "", i = 30, u = 0; u <= Uo; u++) {
            for (var s = Ni[u], f = u === Uo ? e : s, p = u + 1 + ". " + s; p.length < i; )
              p += " ";
            p += f + `
`, a += p;
          }
          S(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function aa() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function kg(e, t) {
      if (Dg)
        return !1;
      if (t === null)
        return S("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", $), !1;
      e.length !== t.length && S(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, $, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!G(e[a], t[a]))
          return !1;
      return !0;
    }
    function zf(e, t, a, i, u, s) {
      Xs = s, Gt = t, Ni = e !== null ? e._debugHookTypes : null, Uo = -1, Dg = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = Y, e !== null && e.memoizedState !== null ? ce.current = GC : Ni !== null ? ce.current = WC : ce.current = QC;
      var f = a(i, u);
      if (Tp) {
        var p = 0;
        do {
          if (Tp = !1, wp = 0, p >= Iw)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          p += 1, Dg = !1, fr = null, dr = null, t.updateQueue = null, Uo = -1, ce.current = qC, f = a(i, u);
        } while (Tp);
      }
      ce.current = gm, t._debugHookTypes = Ni;
      var v = fr !== null && fr.next !== null;
      if (Xs = Y, Gt = null, fr = null, dr = null, $ = null, Ni = null, Uo = -1, e !== null && (e.flags & Nn) !== (t.flags & Nn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & lt) !== De && S("Internal React error: Expected static flag was missing. Please notify the React team."), im = !1, v)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return f;
    }
    function Uf() {
      var e = wp !== 0;
      return wp = 0, e;
    }
    function _C(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & Lt) !== De ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = Rs(e.lanes, a);
    }
    function DC() {
      if (ce.current = gm, im) {
        for (var e = Gt.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        im = !1;
      }
      Xs = Y, Gt = null, fr = null, dr = null, Ni = null, Uo = -1, $ = null, PC = !1, Tp = !1, wp = 0;
    }
    function Il() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return dr === null ? Gt.memoizedState = dr = e : dr = dr.next = e, dr;
    }
    function zi() {
      var e;
      if (fr === null) {
        var t = Gt.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = fr.next;
      var a;
      if (dr === null ? a = Gt.memoizedState : a = dr.next, a !== null)
        dr = a, a = dr.next, fr = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        fr = e;
        var i = {
          memoizedState: fr.memoizedState,
          baseState: fr.baseState,
          baseQueue: fr.baseQueue,
          queue: fr.queue,
          next: null
        };
        dr === null ? Gt.memoizedState = dr = i : dr = dr.next = i;
      }
      return dr;
    }
    function kC() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Og(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Lg(e, t, a) {
      var i = Il(), u;
      a !== void 0 ? u = a(t) : u = t, i.memoizedState = i.baseState = u;
      var s = {
        pending: null,
        interleaved: null,
        lanes: Y,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: u
      };
      i.queue = s;
      var f = s.dispatch = qw.bind(null, Gt, s);
      return [i.memoizedState, f];
    }
    function Mg(e, t, a) {
      var i = zi(), u = i.queue;
      if (u === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      u.lastRenderedReducer = e;
      var s = fr, f = s.baseQueue, p = u.pending;
      if (p !== null) {
        if (f !== null) {
          var v = f.next, y = p.next;
          f.next = y, p.next = v;
        }
        s.baseQueue !== f && S("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), s.baseQueue = f = p, u.pending = null;
      }
      if (f !== null) {
        var g = f.next, b = s.baseState, w = null, z = null, F = null, V = g;
        do {
          var le = V.lane;
          if (bu(Xs, le)) {
            if (F !== null) {
              var we = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: bt,
                action: V.action,
                hasEagerState: V.hasEagerState,
                eagerState: V.eagerState,
                next: null
              };
              F = F.next = we;
            }
            if (V.hasEagerState)
              b = V.eagerState;
            else {
              var Ct = V.action;
              b = e(b, Ct);
            }
          } else {
            var Le = {
              lane: le,
              action: V.action,
              hasEagerState: V.hasEagerState,
              eagerState: V.eagerState,
              next: null
            };
            F === null ? (z = F = Le, w = b) : F = F.next = Le, Gt.lanes = Xe(Gt.lanes, le), Yp(le);
          }
          V = V.next;
        } while (V !== null && V !== g);
        F === null ? w = b : F.next = z, G(b, i.memoizedState) || Np(), i.memoizedState = b, i.baseState = w, i.baseQueue = F, u.lastRenderedState = b;
      }
      var vt = u.interleaved;
      if (vt !== null) {
        var O = vt;
        do {
          var P = O.lane;
          Gt.lanes = Xe(Gt.lanes, P), Yp(P), O = O.next;
        } while (O !== vt);
      } else f === null && (u.lanes = Y);
      var L = u.dispatch;
      return [i.memoizedState, L];
    }
    function Ng(e, t, a) {
      var i = zi(), u = i.queue;
      if (u === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      u.lastRenderedReducer = e;
      var s = u.dispatch, f = u.pending, p = i.memoizedState;
      if (f !== null) {
        u.pending = null;
        var v = f.next, y = v;
        do {
          var g = y.action;
          p = e(p, g), y = y.next;
        } while (y !== v);
        G(p, i.memoizedState) || Np(), i.memoizedState = p, i.baseQueue === null && (i.baseState = p), u.lastRenderedState = p;
      }
      return [p, s];
    }
    function SD(e, t, a) {
    }
    function ED(e, t, a) {
    }
    function zg(e, t, a) {
      var i = Gt, u = Il(), s, f = Ur();
      if (f) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        s = a(), Mf || s !== a() && (S("The result of getServerSnapshot should be cached to avoid an infinite loop"), Mf = !0);
      } else {
        if (s = t(), !Mf) {
          var p = t();
          G(s, p) || (S("The result of getSnapshot should be cached to avoid an infinite loop"), Mf = !0);
        }
        var v = Fm();
        if (v === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Kc(v, Xs) || OC(i, t, s);
      }
      u.memoizedState = s;
      var y = {
        value: s,
        getSnapshot: t
      };
      return u.queue = y, cm(MC.bind(null, i, y, e), [e]), i.flags |= Qr, xp(sr | Ar, LC.bind(null, i, y, s, t), void 0, null), s;
    }
    function lm(e, t, a) {
      var i = Gt, u = zi(), s = t();
      if (!Mf) {
        var f = t();
        G(s, f) || (S("The result of getSnapshot should be cached to avoid an infinite loop"), Mf = !0);
      }
      var p = u.memoizedState, v = !G(p, s);
      v && (u.memoizedState = s, Np());
      var y = u.queue;
      if (_p(MC.bind(null, i, y, e), [e]), y.getSnapshot !== t || v || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      dr !== null && dr.memoizedState.tag & sr) {
        i.flags |= Qr, xp(sr | Ar, LC.bind(null, i, y, s, t), void 0, null);
        var g = Fm();
        if (g === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Kc(g, Xs) || OC(i, t, s);
      }
      return s;
    }
    function OC(e, t, a) {
      e.flags |= fo;
      var i = {
        getSnapshot: t,
        value: a
      }, u = Gt.updateQueue;
      if (u === null)
        u = kC(), Gt.updateQueue = u, u.stores = [i];
      else {
        var s = u.stores;
        s === null ? u.stores = [i] : s.push(i);
      }
    }
    function LC(e, t, a, i) {
      t.value = a, t.getSnapshot = i, NC(t) && zC(e);
    }
    function MC(e, t, a) {
      var i = function() {
        NC(t) && zC(e);
      };
      return a(i);
    }
    function NC(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var i = t();
        return !G(a, i);
      } catch {
        return !0;
      }
    }
    function zC(e) {
      var t = Fa(e, Ae);
      t !== null && mr(t, e, Ae, Xt);
    }
    function um(e) {
      var t = Il();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: Y,
        dispatch: null,
        lastRenderedReducer: Og,
        lastRenderedState: e
      };
      t.queue = a;
      var i = a.dispatch = Xw.bind(null, Gt, a);
      return [t.memoizedState, i];
    }
    function Ug(e) {
      return Mg(Og);
    }
    function Ag(e) {
      return Ng(Og);
    }
    function xp(e, t, a, i) {
      var u = {
        tag: e,
        create: t,
        destroy: a,
        deps: i,
        // Circular
        next: null
      }, s = Gt.updateQueue;
      if (s === null)
        s = kC(), Gt.updateQueue = s, s.lastEffect = u.next = u;
      else {
        var f = s.lastEffect;
        if (f === null)
          s.lastEffect = u.next = u;
        else {
          var p = f.next;
          f.next = u, u.next = p, s.lastEffect = u;
        }
      }
      return u;
    }
    function Fg(e) {
      var t = Il();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function om(e) {
      var t = zi();
      return t.memoizedState;
    }
    function bp(e, t, a, i) {
      var u = Il(), s = i === void 0 ? null : i;
      Gt.flags |= e, u.memoizedState = xp(sr | t, a, void 0, s);
    }
    function sm(e, t, a, i) {
      var u = zi(), s = i === void 0 ? null : i, f = void 0;
      if (fr !== null) {
        var p = fr.memoizedState;
        if (f = p.destroy, s !== null) {
          var v = p.deps;
          if (kg(s, v)) {
            u.memoizedState = xp(t, a, f, s);
            return;
          }
        }
      }
      Gt.flags |= e, u.memoizedState = xp(sr | t, a, f, s);
    }
    function cm(e, t) {
      return (Gt.mode & Lt) !== De ? bp(Ci | Qr | wc, Ar, e, t) : bp(Qr | wc, Ar, e, t);
    }
    function _p(e, t) {
      return sm(Qr, Ar, e, t);
    }
    function jg(e, t) {
      return bp(gt, $l, e, t);
    }
    function fm(e, t) {
      return sm(gt, $l, e, t);
    }
    function Hg(e, t) {
      var a = gt;
      return a |= Yi, (Gt.mode & Lt) !== De && (a |= xl), bp(a, cr, e, t);
    }
    function dm(e, t) {
      return sm(gt, cr, e, t);
    }
    function UC(e, t) {
      if (typeof t == "function") {
        var a = t, i = e();
        return a(i), function() {
          a(null);
        };
      } else if (t != null) {
        var u = t;
        u.hasOwnProperty("current") || S("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(u).join(", ") + "}");
        var s = e();
        return u.current = s, function() {
          u.current = null;
        };
      }
    }
    function Vg(e, t, a) {
      typeof t != "function" && S("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null, u = gt;
      return u |= Yi, (Gt.mode & Lt) !== De && (u |= xl), bp(u, cr, UC.bind(null, t, e), i);
    }
    function pm(e, t, a) {
      typeof t != "function" && S("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null;
      return sm(gt, cr, UC.bind(null, t, e), i);
    }
    function Qw(e, t) {
    }
    var vm = Qw;
    function Pg(e, t) {
      var a = Il(), i = t === void 0 ? null : t;
      return a.memoizedState = [e, i], e;
    }
    function hm(e, t) {
      var a = zi(), i = t === void 0 ? null : t, u = a.memoizedState;
      if (u !== null && i !== null) {
        var s = u[1];
        if (kg(i, s))
          return u[0];
      }
      return a.memoizedState = [e, i], e;
    }
    function Bg(e, t) {
      var a = Il(), i = t === void 0 ? null : t, u = e();
      return a.memoizedState = [u, i], u;
    }
    function mm(e, t) {
      var a = zi(), i = t === void 0 ? null : t, u = a.memoizedState;
      if (u !== null && i !== null) {
        var s = u[1];
        if (kg(i, s))
          return u[0];
      }
      var f = e();
      return a.memoizedState = [f, i], f;
    }
    function $g(e) {
      var t = Il();
      return t.memoizedState = e, e;
    }
    function AC(e) {
      var t = zi(), a = fr, i = a.memoizedState;
      return jC(t, i, e);
    }
    function FC(e) {
      var t = zi();
      if (fr === null)
        return t.memoizedState = e, e;
      var a = fr.memoizedState;
      return jC(t, a, e);
    }
    function jC(e, t, a) {
      var i = !kd(Xs);
      if (i) {
        if (!G(a, t)) {
          var u = Md();
          Gt.lanes = Xe(Gt.lanes, u), Yp(u), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, Np()), e.memoizedState = a, a;
    }
    function Ww(e, t, a) {
      var i = za();
      An(Wv(i, xi)), e(!0);
      var u = Rp.transition;
      Rp.transition = {};
      var s = Rp.transition;
      Rp.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (An(i), Rp.transition = u, u === null && s._updatedFibers) {
          var f = s._updatedFibers.size;
          f > 10 && _t("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), s._updatedFibers.clear();
        }
      }
    }
    function Ig() {
      var e = um(!1), t = e[0], a = e[1], i = Ww.bind(null, a), u = Il();
      return u.memoizedState = i, [t, i];
    }
    function HC() {
      var e = Ug(), t = e[0], a = zi(), i = a.memoizedState;
      return [t, i];
    }
    function VC() {
      var e = Ag(), t = e[0], a = zi(), i = a.memoizedState;
      return [t, i];
    }
    var PC = !1;
    function Gw() {
      return PC;
    }
    function Yg() {
      var e = Il(), t = Fm(), a = t.identifierPrefix, i;
      if (Ur()) {
        var u = fw();
        i = ":" + a + "R" + u;
        var s = wp++;
        s > 0 && (i += "H" + s.toString(32)), i += ":";
      } else {
        var f = $w++;
        i = ":" + a + "r" + f.toString(32) + ":";
      }
      return e.memoizedState = i, i;
    }
    function ym() {
      var e = zi(), t = e.memoizedState;
      return t;
    }
    function qw(e, t, a) {
      typeof arguments[3] == "function" && S("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Vo(e), u = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (BC(e))
        $C(t, u);
      else {
        var s = yC(e, t, u, i);
        if (s !== null) {
          var f = Sa();
          mr(s, e, i, f), IC(s, t, i);
        }
      }
      YC(e, i);
    }
    function Xw(e, t, a) {
      typeof arguments[3] == "function" && S("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Vo(e), u = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (BC(e))
        $C(t, u);
      else {
        var s = e.alternate;
        if (e.lanes === Y && (s === null || s.lanes === Y)) {
          var f = t.lastRenderedReducer;
          if (f !== null) {
            var p;
            p = ce.current, ce.current = al;
            try {
              var v = t.lastRenderedState, y = f(v, a);
              if (u.hasEagerState = !0, u.eagerState = y, G(y, v)) {
                zw(e, t, u, i);
                return;
              }
            } catch {
            } finally {
              ce.current = p;
            }
          }
        }
        var g = yC(e, t, u, i);
        if (g !== null) {
          var b = Sa();
          mr(g, e, i, b), IC(g, t, i);
        }
      }
      YC(e, i);
    }
    function BC(e) {
      var t = e.alternate;
      return e === Gt || t !== null && t === Gt;
    }
    function $C(e, t) {
      Tp = im = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function IC(e, t, a) {
      if (Ld(a)) {
        var i = t.lanes;
        i = Nd(i, e.pendingLanes);
        var u = Xe(i, a);
        t.lanes = u, Jc(e, u);
      }
    }
    function YC(e, t, a) {
      ds(e, t);
    }
    var gm = {
      readContext: er,
      useCallback: aa,
      useContext: aa,
      useEffect: aa,
      useImperativeHandle: aa,
      useInsertionEffect: aa,
      useLayoutEffect: aa,
      useMemo: aa,
      useReducer: aa,
      useRef: aa,
      useState: aa,
      useDebugValue: aa,
      useDeferredValue: aa,
      useTransition: aa,
      useMutableSource: aa,
      useSyncExternalStore: aa,
      useId: aa,
      unstable_isNewReconciler: Z
    }, QC = null, WC = null, GC = null, qC = null, Yl = null, al = null, Sm = null;
    {
      var Qg = function() {
        S("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Ie = function() {
        S("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      QC = {
        readContext: function(e) {
          return er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", Ht(), Nf(t), Pg(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", Ht(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", Ht(), Nf(t), cm(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", Ht(), Nf(a), Vg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", Ht(), Nf(t), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", Ht(), Nf(t), Hg(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", Ht(), Nf(t);
          var a = ce.current;
          ce.current = Yl;
          try {
            return Bg(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", Ht();
          var i = ce.current;
          ce.current = Yl;
          try {
            return Lg(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", Ht(), Fg(e);
        },
        useState: function(e) {
          $ = "useState", Ht();
          var t = ce.current;
          ce.current = Yl;
          try {
            return um(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", Ht(), void 0;
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", Ht(), $g(e);
        },
        useTransition: function() {
          return $ = "useTransition", Ht(), Ig();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", Ht(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", Ht(), zg(e, t, a);
        },
        useId: function() {
          return $ = "useId", Ht(), Yg();
        },
        unstable_isNewReconciler: Z
      }, WC = {
        readContext: function(e) {
          return er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", te(), Pg(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", te(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", te(), cm(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", te(), Vg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", te(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", te(), Hg(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", te();
          var a = ce.current;
          ce.current = Yl;
          try {
            return Bg(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", te();
          var i = ce.current;
          ce.current = Yl;
          try {
            return Lg(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", te(), Fg(e);
        },
        useState: function(e) {
          $ = "useState", te();
          var t = ce.current;
          ce.current = Yl;
          try {
            return um(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", te(), void 0;
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", te(), $g(e);
        },
        useTransition: function() {
          return $ = "useTransition", te(), Ig();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", te(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", te(), zg(e, t, a);
        },
        useId: function() {
          return $ = "useId", te(), Yg();
        },
        unstable_isNewReconciler: Z
      }, GC = {
        readContext: function(e) {
          return er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", te(), hm(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", te(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", te(), _p(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", te(), pm(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", te(), fm(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", te(), dm(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", te();
          var a = ce.current;
          ce.current = al;
          try {
            return mm(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", te();
          var i = ce.current;
          ce.current = al;
          try {
            return Mg(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", te(), om();
        },
        useState: function(e) {
          $ = "useState", te();
          var t = ce.current;
          ce.current = al;
          try {
            return Ug(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", te(), vm();
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", te(), AC(e);
        },
        useTransition: function() {
          return $ = "useTransition", te(), HC();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", te(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", te(), lm(e, t);
        },
        useId: function() {
          return $ = "useId", te(), ym();
        },
        unstable_isNewReconciler: Z
      }, qC = {
        readContext: function(e) {
          return er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", te(), hm(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", te(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", te(), _p(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", te(), pm(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", te(), fm(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", te(), dm(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", te();
          var a = ce.current;
          ce.current = Sm;
          try {
            return mm(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", te();
          var i = ce.current;
          ce.current = Sm;
          try {
            return Ng(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", te(), om();
        },
        useState: function(e) {
          $ = "useState", te();
          var t = ce.current;
          ce.current = Sm;
          try {
            return Ag(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", te(), vm();
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", te(), FC(e);
        },
        useTransition: function() {
          return $ = "useTransition", te(), VC();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", te(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", te(), lm(e, t);
        },
        useId: function() {
          return $ = "useId", te(), ym();
        },
        unstable_isNewReconciler: Z
      }, Yl = {
        readContext: function(e) {
          return Qg(), er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", Ie(), Ht(), Pg(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", Ie(), Ht(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", Ie(), Ht(), cm(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", Ie(), Ht(), Vg(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", Ie(), Ht(), jg(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", Ie(), Ht(), Hg(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", Ie(), Ht();
          var a = ce.current;
          ce.current = Yl;
          try {
            return Bg(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", Ie(), Ht();
          var i = ce.current;
          ce.current = Yl;
          try {
            return Lg(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", Ie(), Ht(), Fg(e);
        },
        useState: function(e) {
          $ = "useState", Ie(), Ht();
          var t = ce.current;
          ce.current = Yl;
          try {
            return um(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", Ie(), Ht(), void 0;
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", Ie(), Ht(), $g(e);
        },
        useTransition: function() {
          return $ = "useTransition", Ie(), Ht(), Ig();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", Ie(), Ht(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", Ie(), Ht(), zg(e, t, a);
        },
        useId: function() {
          return $ = "useId", Ie(), Ht(), Yg();
        },
        unstable_isNewReconciler: Z
      }, al = {
        readContext: function(e) {
          return Qg(), er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", Ie(), te(), hm(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", Ie(), te(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", Ie(), te(), _p(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", Ie(), te(), pm(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", Ie(), te(), fm(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", Ie(), te(), dm(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", Ie(), te();
          var a = ce.current;
          ce.current = al;
          try {
            return mm(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", Ie(), te();
          var i = ce.current;
          ce.current = al;
          try {
            return Mg(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", Ie(), te(), om();
        },
        useState: function(e) {
          $ = "useState", Ie(), te();
          var t = ce.current;
          ce.current = al;
          try {
            return Ug(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", Ie(), te(), vm();
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", Ie(), te(), AC(e);
        },
        useTransition: function() {
          return $ = "useTransition", Ie(), te(), HC();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", Ie(), te(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", Ie(), te(), lm(e, t);
        },
        useId: function() {
          return $ = "useId", Ie(), te(), ym();
        },
        unstable_isNewReconciler: Z
      }, Sm = {
        readContext: function(e) {
          return Qg(), er(e);
        },
        useCallback: function(e, t) {
          return $ = "useCallback", Ie(), te(), hm(e, t);
        },
        useContext: function(e) {
          return $ = "useContext", Ie(), te(), er(e);
        },
        useEffect: function(e, t) {
          return $ = "useEffect", Ie(), te(), _p(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return $ = "useImperativeHandle", Ie(), te(), pm(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return $ = "useInsertionEffect", Ie(), te(), fm(e, t);
        },
        useLayoutEffect: function(e, t) {
          return $ = "useLayoutEffect", Ie(), te(), dm(e, t);
        },
        useMemo: function(e, t) {
          $ = "useMemo", Ie(), te();
          var a = ce.current;
          ce.current = al;
          try {
            return mm(e, t);
          } finally {
            ce.current = a;
          }
        },
        useReducer: function(e, t, a) {
          $ = "useReducer", Ie(), te();
          var i = ce.current;
          ce.current = al;
          try {
            return Ng(e, t, a);
          } finally {
            ce.current = i;
          }
        },
        useRef: function(e) {
          return $ = "useRef", Ie(), te(), om();
        },
        useState: function(e) {
          $ = "useState", Ie(), te();
          var t = ce.current;
          ce.current = al;
          try {
            return Ag(e);
          } finally {
            ce.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return $ = "useDebugValue", Ie(), te(), vm();
        },
        useDeferredValue: function(e) {
          return $ = "useDeferredValue", Ie(), te(), FC(e);
        },
        useTransition: function() {
          return $ = "useTransition", Ie(), te(), VC();
        },
        useMutableSource: function(e, t, a) {
          return $ = "useMutableSource", Ie(), te(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return $ = "useSyncExternalStore", Ie(), te(), lm(e, t);
        },
        useId: function() {
          return $ = "useId", Ie(), te(), ym();
        },
        unstable_isNewReconciler: Z
      };
    }
    var Ao = j.unstable_now, XC = 0, Em = -1, Dp = -1, Cm = -1, Wg = !1, Rm = !1;
    function KC() {
      return Wg;
    }
    function Kw() {
      Rm = !0;
    }
    function Zw() {
      Wg = !1, Rm = !1;
    }
    function Jw() {
      Wg = Rm, Rm = !1;
    }
    function ZC() {
      return XC;
    }
    function JC() {
      XC = Ao();
    }
    function Gg(e) {
      Dp = Ao(), e.actualStartTime < 0 && (e.actualStartTime = Ao());
    }
    function e0(e) {
      Dp = -1;
    }
    function Tm(e, t) {
      if (Dp >= 0) {
        var a = Ao() - Dp;
        e.actualDuration += a, t && (e.selfBaseDuration = a), Dp = -1;
      }
    }
    function Ql(e) {
      if (Em >= 0) {
        var t = Ao() - Em;
        Em = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case ee:
              var i = a.stateNode;
              i.effectDuration += t;
              return;
            case pt:
              var u = a.stateNode;
              u.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function qg(e) {
      if (Cm >= 0) {
        var t = Ao() - Cm;
        Cm = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case ee:
              var i = a.stateNode;
              i !== null && (i.passiveEffectDuration += t);
              return;
            case pt:
              var u = a.stateNode;
              u !== null && (u.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function Wl() {
      Em = Ao();
    }
    function Xg() {
      Cm = Ao();
    }
    function Kg(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function il(e, t) {
      if (e && e.defaultProps) {
        var a = Ze({}, t), i = e.defaultProps;
        for (var u in i)
          a[u] === void 0 && (a[u] = i[u]);
        return a;
      }
      return t;
    }
    var Zg = {}, Jg, eS, tS, nS, rS, t0, wm, aS, iS, lS, kp;
    {
      Jg = /* @__PURE__ */ new Set(), eS = /* @__PURE__ */ new Set(), tS = /* @__PURE__ */ new Set(), nS = /* @__PURE__ */ new Set(), aS = /* @__PURE__ */ new Set(), rS = /* @__PURE__ */ new Set(), iS = /* @__PURE__ */ new Set(), lS = /* @__PURE__ */ new Set(), kp = /* @__PURE__ */ new Set();
      var n0 = /* @__PURE__ */ new Set();
      wm = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          n0.has(a) || (n0.add(a), S("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, t0 = function(e, t) {
        if (t === void 0) {
          var a = Rt(e) || "Component";
          rS.has(a) || (rS.add(a), S("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(Zg, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Zg);
    }
    function uS(e, t, a, i) {
      var u = e.memoizedState, s = a(i, u);
      {
        if (e.mode & Wt) {
          mn(!0);
          try {
            s = a(i, u);
          } finally {
            mn(!1);
          }
        }
        t0(t, s);
      }
      var f = s == null ? u : Ze({}, u, s);
      if (e.memoizedState = f, e.lanes === Y) {
        var p = e.updateQueue;
        p.baseState = f;
      }
    }
    var oS = {
      isMounted: Lv,
      enqueueSetState: function(e, t, a) {
        var i = co(e), u = Sa(), s = Vo(i), f = ju(u, s);
        f.payload = t, a != null && (wm(a, "setState"), f.callback = a);
        var p = Mo(i, f, s);
        p !== null && (mr(p, i, s, u), Jh(p, i, s)), ds(i, s);
      },
      enqueueReplaceState: function(e, t, a) {
        var i = co(e), u = Sa(), s = Vo(i), f = ju(u, s);
        f.tag = SC, f.payload = t, a != null && (wm(a, "replaceState"), f.callback = a);
        var p = Mo(i, f, s);
        p !== null && (mr(p, i, s, u), Jh(p, i, s)), ds(i, s);
      },
      enqueueForceUpdate: function(e, t) {
        var a = co(e), i = Sa(), u = Vo(a), s = ju(i, u);
        s.tag = Xh, t != null && (wm(t, "forceUpdate"), s.callback = t);
        var f = Mo(a, s, u);
        f !== null && (mr(f, a, u, i), Jh(f, a, u)), Lc(a, u);
      }
    };
    function r0(e, t, a, i, u, s, f) {
      var p = e.stateNode;
      if (typeof p.shouldComponentUpdate == "function") {
        var v = p.shouldComponentUpdate(i, s, f);
        {
          if (e.mode & Wt) {
            mn(!0);
            try {
              v = p.shouldComponentUpdate(i, s, f);
            } finally {
              mn(!1);
            }
          }
          v === void 0 && S("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Rt(t) || "Component");
        }
        return v;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !ye(a, i) || !ye(u, s) : !0;
    }
    function ex(e, t, a) {
      var i = e.stateNode;
      {
        var u = Rt(t) || "Component", s = i.render;
        s || (t.prototype && typeof t.prototype.render == "function" ? S("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", u) : S("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", u)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && S("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", u), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && S("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", u), i.propTypes && S("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", u), i.contextType && S("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", u), t.childContextTypes && !kp.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Wt) === De && (kp.add(t), S(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, u)), t.contextTypes && !kp.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Wt) === De && (kp.add(t), S(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, u)), i.contextTypes && S("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", u), t.contextType && t.contextTypes && !iS.has(t) && (iS.add(t), S("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", u)), typeof i.componentShouldUpdate == "function" && S("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", u), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && S("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Rt(t) || "A pure component"), typeof i.componentDidUnmount == "function" && S("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", u), typeof i.componentDidReceiveProps == "function" && S("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", u), typeof i.componentWillRecieveProps == "function" && S("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", u), typeof i.UNSAFE_componentWillRecieveProps == "function" && S("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", u);
        var f = i.props !== a;
        i.props !== void 0 && f && S("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", u, u), i.defaultProps && S("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", u, u), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !tS.has(t) && (tS.add(t), S("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Rt(t))), typeof i.getDerivedStateFromProps == "function" && S("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", u), typeof i.getDerivedStateFromError == "function" && S("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", u), typeof t.getSnapshotBeforeUpdate == "function" && S("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", u);
        var p = i.state;
        p && (typeof p != "object" || nt(p)) && S("%s.state: must be set to an object or null", u), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && S("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", u);
      }
    }
    function a0(e, t) {
      t.updater = oS, e.stateNode = t, du(t, e), t._reactInternalInstance = Zg;
    }
    function i0(e, t, a) {
      var i = !1, u = ii, s = ii, f = t.contextType;
      if ("contextType" in t) {
        var p = (
          // Allow null for conditional declaration
          f === null || f !== void 0 && f.$$typeof === R && f._context === void 0
        );
        if (!p && !lS.has(t)) {
          lS.add(t);
          var v = "";
          f === void 0 ? v = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof f != "object" ? v = " However, it is set to a " + typeof f + "." : f.$$typeof === di ? v = " Did you accidentally pass the Context.Provider instead?" : f._context !== void 0 ? v = " Did you accidentally pass the Context.Consumer instead?" : v = " However, it is set to an object with keys {" + Object.keys(f).join(", ") + "}.", S("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Rt(t) || "Component", v);
        }
      }
      if (typeof f == "object" && f !== null)
        s = er(f);
      else {
        u = Cf(e, t, !0);
        var y = t.contextTypes;
        i = y != null, s = i ? Rf(e, u) : ii;
      }
      var g = new t(a, s);
      if (e.mode & Wt) {
        mn(!0);
        try {
          g = new t(a, s);
        } finally {
          mn(!1);
        }
      }
      var b = e.memoizedState = g.state !== null && g.state !== void 0 ? g.state : null;
      a0(e, g);
      {
        if (typeof t.getDerivedStateFromProps == "function" && b === null) {
          var w = Rt(t) || "Component";
          eS.has(w) || (eS.add(w), S("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", w, g.state === null ? "null" : "undefined", w));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof g.getSnapshotBeforeUpdate == "function") {
          var z = null, F = null, V = null;
          if (typeof g.componentWillMount == "function" && g.componentWillMount.__suppressDeprecationWarning !== !0 ? z = "componentWillMount" : typeof g.UNSAFE_componentWillMount == "function" && (z = "UNSAFE_componentWillMount"), typeof g.componentWillReceiveProps == "function" && g.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? F = "componentWillReceiveProps" : typeof g.UNSAFE_componentWillReceiveProps == "function" && (F = "UNSAFE_componentWillReceiveProps"), typeof g.componentWillUpdate == "function" && g.componentWillUpdate.__suppressDeprecationWarning !== !0 ? V = "componentWillUpdate" : typeof g.UNSAFE_componentWillUpdate == "function" && (V = "UNSAFE_componentWillUpdate"), z !== null || F !== null || V !== null) {
            var le = Rt(t) || "Component", Le = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            nS.has(le) || (nS.add(le), S(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, le, Le, z !== null ? `
  ` + z : "", F !== null ? `
  ` + F : "", V !== null ? `
  ` + V : ""));
          }
        }
      }
      return i && GE(e, u, s), g;
    }
    function tx(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (S("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Pe(e) || "Component"), oS.enqueueReplaceState(t, t.state, null));
    }
    function l0(e, t, a, i) {
      var u = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, i), t.state !== u) {
        {
          var s = Pe(e) || "Component";
          Jg.has(s) || (Jg.add(s), S("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", s));
        }
        oS.enqueueReplaceState(t, t.state, null);
      }
    }
    function sS(e, t, a, i) {
      ex(e, t, a);
      var u = e.stateNode;
      u.props = a, u.state = e.memoizedState, u.refs = {}, gg(e);
      var s = t.contextType;
      if (typeof s == "object" && s !== null)
        u.context = er(s);
      else {
        var f = Cf(e, t, !0);
        u.context = Rf(e, f);
      }
      {
        if (u.state === a) {
          var p = Rt(t) || "Component";
          aS.has(p) || (aS.add(p), S("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", p));
        }
        e.mode & Wt && nl.recordLegacyContextWarning(e, u), nl.recordUnsafeLifecycleWarnings(e, u);
      }
      u.state = e.memoizedState;
      var v = t.getDerivedStateFromProps;
      if (typeof v == "function" && (uS(e, t, v, a), u.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof u.getSnapshotBeforeUpdate != "function" && (typeof u.UNSAFE_componentWillMount == "function" || typeof u.componentWillMount == "function") && (tx(e, u), em(e, a, u, i), u.state = e.memoizedState), typeof u.componentDidMount == "function") {
        var y = gt;
        y |= Yi, (e.mode & Lt) !== De && (y |= xl), e.flags |= y;
      }
    }
    function nx(e, t, a, i) {
      var u = e.stateNode, s = e.memoizedProps;
      u.props = s;
      var f = u.context, p = t.contextType, v = ii;
      if (typeof p == "object" && p !== null)
        v = er(p);
      else {
        var y = Cf(e, t, !0);
        v = Rf(e, y);
      }
      var g = t.getDerivedStateFromProps, b = typeof g == "function" || typeof u.getSnapshotBeforeUpdate == "function";
      !b && (typeof u.UNSAFE_componentWillReceiveProps == "function" || typeof u.componentWillReceiveProps == "function") && (s !== a || f !== v) && l0(e, u, a, v), CC();
      var w = e.memoizedState, z = u.state = w;
      if (em(e, a, u, i), z = e.memoizedState, s === a && w === z && !Uh() && !tm()) {
        if (typeof u.componentDidMount == "function") {
          var F = gt;
          F |= Yi, (e.mode & Lt) !== De && (F |= xl), e.flags |= F;
        }
        return !1;
      }
      typeof g == "function" && (uS(e, t, g, a), z = e.memoizedState);
      var V = tm() || r0(e, t, s, a, w, z, v);
      if (V) {
        if (!b && (typeof u.UNSAFE_componentWillMount == "function" || typeof u.componentWillMount == "function") && (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function") {
          var le = gt;
          le |= Yi, (e.mode & Lt) !== De && (le |= xl), e.flags |= le;
        }
      } else {
        if (typeof u.componentDidMount == "function") {
          var Le = gt;
          Le |= Yi, (e.mode & Lt) !== De && (Le |= xl), e.flags |= Le;
        }
        e.memoizedProps = a, e.memoizedState = z;
      }
      return u.props = a, u.state = z, u.context = v, V;
    }
    function rx(e, t, a, i, u) {
      var s = t.stateNode;
      EC(e, t);
      var f = t.memoizedProps, p = t.type === t.elementType ? f : il(t.type, f);
      s.props = p;
      var v = t.pendingProps, y = s.context, g = a.contextType, b = ii;
      if (typeof g == "object" && g !== null)
        b = er(g);
      else {
        var w = Cf(t, a, !0);
        b = Rf(t, w);
      }
      var z = a.getDerivedStateFromProps, F = typeof z == "function" || typeof s.getSnapshotBeforeUpdate == "function";
      !F && (typeof s.UNSAFE_componentWillReceiveProps == "function" || typeof s.componentWillReceiveProps == "function") && (f !== v || y !== b) && l0(t, s, i, b), CC();
      var V = t.memoizedState, le = s.state = V;
      if (em(t, i, s, u), le = t.memoizedState, f === v && V === le && !Uh() && !tm() && !Re)
        return typeof s.componentDidUpdate == "function" && (f !== e.memoizedProps || V !== e.memoizedState) && (t.flags |= gt), typeof s.getSnapshotBeforeUpdate == "function" && (f !== e.memoizedProps || V !== e.memoizedState) && (t.flags |= In), !1;
      typeof z == "function" && (uS(t, a, z, i), le = t.memoizedState);
      var Le = tm() || r0(t, a, p, i, V, le, b) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Re;
      return Le ? (!F && (typeof s.UNSAFE_componentWillUpdate == "function" || typeof s.componentWillUpdate == "function") && (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(i, le, b), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(i, le, b)), typeof s.componentDidUpdate == "function" && (t.flags |= gt), typeof s.getSnapshotBeforeUpdate == "function" && (t.flags |= In)) : (typeof s.componentDidUpdate == "function" && (f !== e.memoizedProps || V !== e.memoizedState) && (t.flags |= gt), typeof s.getSnapshotBeforeUpdate == "function" && (f !== e.memoizedProps || V !== e.memoizedState) && (t.flags |= In), t.memoizedProps = i, t.memoizedState = le), s.props = i, s.state = le, s.context = b, Le;
    }
    function Ks(e, t) {
      return {
        value: e,
        source: t,
        stack: Hi(t),
        digest: null
      };
    }
    function cS(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function ax(e, t) {
      return !0;
    }
    function fS(e, t) {
      try {
        var a = ax(e, t);
        if (a === !1)
          return;
        var i = t.value, u = t.source, s = t.stack, f = s !== null ? s : "";
        if (i != null && i._suppressLogging) {
          if (e.tag === ve)
            return;
          console.error(i);
        }
        var p = u ? Pe(u) : null, v = p ? "The above error occurred in the <" + p + "> component:" : "The above error occurred in one of your React components:", y;
        if (e.tag === ee)
          y = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var g = Pe(e) || "Anonymous";
          y = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + g + ".");
        }
        var b = v + `
` + f + `

` + ("" + y);
        console.error(b);
      } catch (w) {
        setTimeout(function() {
          throw w;
        });
      }
    }
    var ix = typeof WeakMap == "function" ? WeakMap : Map;
    function u0(e, t, a) {
      var i = ju(Xt, a);
      i.tag = mg, i.payload = {
        element: null
      };
      var u = t.value;
      return i.callback = function() {
        Kb(u), fS(e, t);
      }, i;
    }
    function dS(e, t, a) {
      var i = ju(Xt, a);
      i.tag = mg;
      var u = e.type.getDerivedStateFromError;
      if (typeof u == "function") {
        var s = t.value;
        i.payload = function() {
          return u(s);
        }, i.callback = function() {
          gR(e), fS(e, t);
        };
      }
      var f = e.stateNode;
      return f !== null && typeof f.componentDidCatch == "function" && (i.callback = function() {
        gR(e), fS(e, t), typeof u != "function" && qb(this);
        var v = t.value, y = t.stack;
        this.componentDidCatch(v, {
          componentStack: y !== null ? y : ""
        }), typeof u != "function" && (Zr(e.lanes, Ae) || S("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Pe(e) || "Unknown"));
      }), i;
    }
    function o0(e, t, a) {
      var i = e.pingCache, u;
      if (i === null ? (i = e.pingCache = new ix(), u = /* @__PURE__ */ new Set(), i.set(t, u)) : (u = i.get(t), u === void 0 && (u = /* @__PURE__ */ new Set(), i.set(t, u))), !u.has(a)) {
        u.add(a);
        var s = Zb.bind(null, e, t, a);
        Xr && Qp(e, a), t.then(s, s);
      }
    }
    function lx(e, t, a, i) {
      var u = e.updateQueue;
      if (u === null) {
        var s = /* @__PURE__ */ new Set();
        s.add(a), e.updateQueue = s;
      } else
        u.add(a);
    }
    function ux(e, t) {
      var a = e.tag;
      if ((e.mode & lt) === De && (a === de || a === Qe || a === Fe)) {
        var i = e.alternate;
        i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function s0(e) {
      var t = e;
      do {
        if (t.tag === be && Pw(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function c0(e, t, a, i, u) {
      if ((e.mode & lt) === De) {
        if (e === t)
          e.flags |= Xn;
        else {
          if (e.flags |= xe, a.flags |= Tc, a.flags &= -52805, a.tag === ve) {
            var s = a.alternate;
            if (s === null)
              a.tag = Ft;
            else {
              var f = ju(Xt, Ae);
              f.tag = Xh, Mo(a, f, Ae);
            }
          }
          a.lanes = Xe(a.lanes, Ae);
        }
        return e;
      }
      return e.flags |= Xn, e.lanes = u, e;
    }
    function ox(e, t, a, i, u) {
      if (a.flags |= ls, Xr && Qp(e, u), i !== null && typeof i == "object" && typeof i.then == "function") {
        var s = i;
        ux(a), Ur() && a.mode & lt && tC();
        var f = s0(t);
        if (f !== null) {
          f.flags &= ~Er, c0(f, t, a, e, u), f.mode & lt && o0(e, s, u), lx(f, e, s);
          return;
        } else {
          if (!Hv(u)) {
            o0(e, s, u), YS();
            return;
          }
          var p = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          i = p;
        }
      } else if (Ur() && a.mode & lt) {
        tC();
        var v = s0(t);
        if (v !== null) {
          (v.flags & Xn) === _e && (v.flags |= Er), c0(v, t, a, e, u), ag(Ks(i, a));
          return;
        }
      }
      i = Ks(i, a), Pb(i);
      var y = t;
      do {
        switch (y.tag) {
          case ee: {
            var g = i;
            y.flags |= Xn;
            var b = Cs(u);
            y.lanes = Xe(y.lanes, b);
            var w = u0(y, g, b);
            Sg(y, w);
            return;
          }
          case ve:
            var z = i, F = y.type, V = y.stateNode;
            if ((y.flags & xe) === _e && (typeof F.getDerivedStateFromError == "function" || V !== null && typeof V.componentDidCatch == "function" && !sR(V))) {
              y.flags |= Xn;
              var le = Cs(u);
              y.lanes = Xe(y.lanes, le);
              var Le = dS(y, z, le);
              Sg(y, Le);
              return;
            }
            break;
        }
        y = y.return;
      } while (y !== null);
    }
    function sx() {
      return null;
    }
    var Op = D.ReactCurrentOwner, ll = !1, pS, Lp, vS, hS, mS, Zs, yS, xm, Mp;
    pS = {}, Lp = {}, vS = {}, hS = {}, mS = {}, Zs = !1, yS = {}, xm = {}, Mp = {};
    function ya(e, t, a, i) {
      e === null ? t.child = pC(t, null, a, i) : t.child = bf(t, e.child, a, i);
    }
    function cx(e, t, a, i) {
      t.child = bf(t, e.child, null, i), t.child = bf(t, null, a, i);
    }
    function f0(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = a.propTypes;
        s && el(
          s,
          i,
          // Resolved props
          "prop",
          Rt(a)
        );
      }
      var f = a.render, p = t.ref, v, y;
      Df(t, u), pa(t);
      {
        if (Op.current = t, $n(!0), v = zf(e, t, f, i, p, u), y = Uf(), t.mode & Wt) {
          mn(!0);
          try {
            v = zf(e, t, f, i, p, u), y = Uf();
          } finally {
            mn(!1);
          }
        }
        $n(!1);
      }
      return va(), e !== null && !ll ? (_C(e, t, u), Hu(e, t, u)) : (Ur() && y && Zy(t), t.flags |= ei, ya(e, t, v, u), t.child);
    }
    function d0(e, t, a, i, u) {
      if (e === null) {
        var s = a.type;
        if (h_(s) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var f = s;
          return f = $f(s), t.tag = Fe, t.type = f, ES(t, s), p0(e, t, f, i, u);
        }
        {
          var p = s.propTypes;
          if (p && el(
            p,
            i,
            // Resolved props
            "prop",
            Rt(s)
          ), a.defaultProps !== void 0) {
            var v = Rt(s) || "Unknown";
            Mp[v] || (S("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", v), Mp[v] = !0);
          }
        }
        var y = nE(a.type, null, i, t, t.mode, u);
        return y.ref = t.ref, y.return = t, t.child = y, y;
      }
      {
        var g = a.type, b = g.propTypes;
        b && el(
          b,
          i,
          // Resolved props
          "prop",
          Rt(g)
        );
      }
      var w = e.child, z = bS(e, u);
      if (!z) {
        var F = w.memoizedProps, V = a.compare;
        if (V = V !== null ? V : ye, V(F, i) && e.ref === t.ref)
          return Hu(e, t, u);
      }
      t.flags |= ei;
      var le = rc(w, i);
      return le.ref = t.ref, le.return = t, t.child = le, le;
    }
    function p0(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = t.elementType;
        if (s.$$typeof === $e) {
          var f = s, p = f._payload, v = f._init;
          try {
            s = v(p);
          } catch {
            s = null;
          }
          var y = s && s.propTypes;
          y && el(
            y,
            i,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Rt(s)
          );
        }
      }
      if (e !== null) {
        var g = e.memoizedProps;
        if (ye(g, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (ll = !1, t.pendingProps = i = g, bS(e, u))
            (e.flags & Tc) !== _e && (ll = !0);
          else return t.lanes = e.lanes, Hu(e, t, u);
      }
      return gS(e, t, a, i, u);
    }
    function v0(e, t, a) {
      var i = t.pendingProps, u = i.children, s = e !== null ? e.memoizedState : null;
      if (i.mode === "hidden" || ne)
        if ((t.mode & lt) === De) {
          var f = {
            baseLanes: Y,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = f, jm(t, a);
        } else if (Zr(a, Kr)) {
          var b = {
            baseLanes: Y,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = b;
          var w = s !== null ? s.baseLanes : a;
          jm(t, w);
        } else {
          var p = null, v;
          if (s !== null) {
            var y = s.baseLanes;
            v = Xe(y, a);
          } else
            v = a;
          t.lanes = t.childLanes = Kr;
          var g = {
            baseLanes: v,
            cachePool: p,
            transitions: null
          };
          return t.memoizedState = g, t.updateQueue = null, jm(t, v), null;
        }
      else {
        var z;
        s !== null ? (z = Xe(s.baseLanes, a), t.memoizedState = null) : z = a, jm(t, z);
      }
      return ya(e, t, u, a), t.child;
    }
    function fx(e, t, a) {
      var i = t.pendingProps;
      return ya(e, t, i, a), t.child;
    }
    function dx(e, t, a) {
      var i = t.pendingProps.children;
      return ya(e, t, i, a), t.child;
    }
    function px(e, t, a) {
      {
        t.flags |= gt;
        {
          var i = t.stateNode;
          i.effectDuration = 0, i.passiveEffectDuration = 0;
        }
      }
      var u = t.pendingProps, s = u.children;
      return ya(e, t, s, a), t.child;
    }
    function h0(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= Sn, t.flags |= po);
    }
    function gS(e, t, a, i, u) {
      if (t.type !== t.elementType) {
        var s = a.propTypes;
        s && el(
          s,
          i,
          // Resolved props
          "prop",
          Rt(a)
        );
      }
      var f;
      {
        var p = Cf(t, a, !0);
        f = Rf(t, p);
      }
      var v, y;
      Df(t, u), pa(t);
      {
        if (Op.current = t, $n(!0), v = zf(e, t, a, i, f, u), y = Uf(), t.mode & Wt) {
          mn(!0);
          try {
            v = zf(e, t, a, i, f, u), y = Uf();
          } finally {
            mn(!1);
          }
        }
        $n(!1);
      }
      return va(), e !== null && !ll ? (_C(e, t, u), Hu(e, t, u)) : (Ur() && y && Zy(t), t.flags |= ei, ya(e, t, v, u), t.child);
    }
    function m0(e, t, a, i, u) {
      {
        switch (O_(t)) {
          case !1: {
            var s = t.stateNode, f = t.type, p = new f(t.memoizedProps, s.context), v = p.state;
            s.updater.enqueueSetState(s, v, null);
            break;
          }
          case !0: {
            t.flags |= xe, t.flags |= Xn;
            var y = new Error("Simulated error coming from DevTools"), g = Cs(u);
            t.lanes = Xe(t.lanes, g);
            var b = dS(t, Ks(y, t), g);
            Sg(t, b);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var w = a.propTypes;
          w && el(
            w,
            i,
            // Resolved props
            "prop",
            Rt(a)
          );
        }
      }
      var z;
      Bl(a) ? (z = !0, Fh(t)) : z = !1, Df(t, u);
      var F = t.stateNode, V;
      F === null ? (_m(e, t), i0(t, a, i), sS(t, a, i, u), V = !0) : e === null ? V = nx(t, a, i, u) : V = rx(e, t, a, i, u);
      var le = SS(e, t, a, V, z, u);
      {
        var Le = t.stateNode;
        V && Le.props !== i && (Zs || S("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Pe(t) || "a component"), Zs = !0);
      }
      return le;
    }
    function SS(e, t, a, i, u, s) {
      h0(e, t);
      var f = (t.flags & xe) !== _e;
      if (!i && !f)
        return u && KE(t, a, !1), Hu(e, t, s);
      var p = t.stateNode;
      Op.current = t;
      var v;
      if (f && typeof a.getDerivedStateFromError != "function")
        v = null, e0();
      else {
        pa(t);
        {
          if ($n(!0), v = p.render(), t.mode & Wt) {
            mn(!0);
            try {
              p.render();
            } finally {
              mn(!1);
            }
          }
          $n(!1);
        }
        va();
      }
      return t.flags |= ei, e !== null && f ? cx(e, t, v, s) : ya(e, t, v, s), t.memoizedState = p.state, u && KE(t, a, !0), t.child;
    }
    function y0(e) {
      var t = e.stateNode;
      t.pendingContext ? qE(e, t.pendingContext, t.pendingContext !== t.context) : t.context && qE(e, t.context, !1), Eg(e, t.containerInfo);
    }
    function vx(e, t, a) {
      if (y0(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var i = t.pendingProps, u = t.memoizedState, s = u.element;
      EC(e, t), em(t, i, null, a);
      var f = t.memoizedState;
      t.stateNode;
      var p = f.element;
      if (u.isDehydrated) {
        var v = {
          element: p,
          isDehydrated: !1,
          cache: f.cache,
          pendingSuspenseBoundaries: f.pendingSuspenseBoundaries,
          transitions: f.transitions
        }, y = t.updateQueue;
        if (y.baseState = v, t.memoizedState = v, t.flags & Er) {
          var g = Ks(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return g0(e, t, p, a, g);
        } else if (p !== s) {
          var b = Ks(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return g0(e, t, p, a, b);
        } else {
          yw(t);
          var w = pC(t, null, p, a);
          t.child = w;
          for (var z = w; z; )
            z.flags = z.flags & ~hn | Wr, z = z.sibling;
        }
      } else {
        if (xf(), p === s)
          return Hu(e, t, a);
        ya(e, t, p, a);
      }
      return t.child;
    }
    function g0(e, t, a, i, u) {
      return xf(), ag(u), t.flags |= Er, ya(e, t, a, i), t.child;
    }
    function hx(e, t, a) {
      wC(t), e === null && rg(t);
      var i = t.type, u = t.pendingProps, s = e !== null ? e.memoizedProps : null, f = u.children, p = jy(i, u);
      return p ? f = null : s !== null && jy(i, s) && (t.flags |= Da), h0(e, t), ya(e, t, f, a), t.child;
    }
    function mx(e, t) {
      return e === null && rg(t), null;
    }
    function yx(e, t, a, i) {
      _m(e, t);
      var u = t.pendingProps, s = a, f = s._payload, p = s._init, v = p(f);
      t.type = v;
      var y = t.tag = m_(v), g = il(v, u), b;
      switch (y) {
        case de:
          return ES(t, v), t.type = v = $f(v), b = gS(null, t, v, g, i), b;
        case ve:
          return t.type = v = XS(v), b = m0(null, t, v, g, i), b;
        case Qe:
          return t.type = v = KS(v), b = f0(null, t, v, g, i), b;
        case ot: {
          if (t.type !== t.elementType) {
            var w = v.propTypes;
            w && el(
              w,
              g,
              // Resolved for outer only
              "prop",
              Rt(v)
            );
          }
          return b = d0(
            null,
            t,
            v,
            il(v.type, g),
            // The inner type can have defaults too
            i
          ), b;
        }
      }
      var z = "";
      throw v !== null && typeof v == "object" && v.$$typeof === $e && (z = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + v + ". " + ("Lazy element type must resolve to a class or function." + z));
    }
    function gx(e, t, a, i, u) {
      _m(e, t), t.tag = ve;
      var s;
      return Bl(a) ? (s = !0, Fh(t)) : s = !1, Df(t, u), i0(t, a, i), sS(t, a, i, u), SS(null, t, a, !0, s, u);
    }
    function Sx(e, t, a, i) {
      _m(e, t);
      var u = t.pendingProps, s;
      {
        var f = Cf(t, a, !1);
        s = Rf(t, f);
      }
      Df(t, i);
      var p, v;
      pa(t);
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var y = Rt(a) || "Unknown";
          pS[y] || (S("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", y, y), pS[y] = !0);
        }
        t.mode & Wt && nl.recordLegacyContextWarning(t, null), $n(!0), Op.current = t, p = zf(null, t, a, u, s, i), v = Uf(), $n(!1);
      }
      if (va(), t.flags |= ei, typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0) {
        var g = Rt(a) || "Unknown";
        Lp[g] || (S("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", g, g, g), Lp[g] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0
      ) {
        {
          var b = Rt(a) || "Unknown";
          Lp[b] || (S("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", b, b, b), Lp[b] = !0);
        }
        t.tag = ve, t.memoizedState = null, t.updateQueue = null;
        var w = !1;
        return Bl(a) ? (w = !0, Fh(t)) : w = !1, t.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, gg(t), a0(t, p), sS(t, a, u, i), SS(null, t, a, !0, w, i);
      } else {
        if (t.tag = de, t.mode & Wt) {
          mn(!0);
          try {
            p = zf(null, t, a, u, s, i), v = Uf();
          } finally {
            mn(!1);
          }
        }
        return Ur() && v && Zy(t), ya(null, t, p, i), ES(t, a), t.child;
      }
    }
    function ES(e, t) {
      {
        if (t && t.childContextTypes && S("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", i = Dr();
          i && (a += `

Check the render method of \`` + i + "`.");
          var u = i || "", s = e._debugSource;
          s && (u = s.fileName + ":" + s.lineNumber), mS[u] || (mS[u] = !0, S("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (t.defaultProps !== void 0) {
          var f = Rt(t) || "Unknown";
          Mp[f] || (S("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", f), Mp[f] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var p = Rt(t) || "Unknown";
          hS[p] || (S("%s: Function components do not support getDerivedStateFromProps.", p), hS[p] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var v = Rt(t) || "Unknown";
          vS[v] || (S("%s: Function components do not support contextType.", v), vS[v] = !0);
        }
      }
    }
    var CS = {
      dehydrated: null,
      treeContext: null,
      retryLane: bt
    };
    function RS(e) {
      return {
        baseLanes: e,
        cachePool: sx(),
        transitions: null
      };
    }
    function Ex(e, t) {
      var a = null;
      return {
        baseLanes: Xe(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function Cx(e, t, a, i) {
      if (t !== null) {
        var u = t.memoizedState;
        if (u === null)
          return !1;
      }
      return Tg(e, Cp);
    }
    function Rx(e, t) {
      return Rs(e.childLanes, t);
    }
    function S0(e, t, a) {
      var i = t.pendingProps;
      L_(t) && (t.flags |= xe);
      var u = rl.current, s = !1, f = (t.flags & xe) !== _e;
      if (f || Cx(u, e) ? (s = !0, t.flags &= ~xe) : (e === null || e.memoizedState !== null) && (u = Vw(u, bC)), u = Of(u), zo(t, u), e === null) {
        rg(t);
        var p = t.memoizedState;
        if (p !== null) {
          var v = p.dehydrated;
          if (v !== null)
            return _x(t, v);
        }
        var y = i.children, g = i.fallback;
        if (s) {
          var b = Tx(t, y, g, a), w = t.child;
          return w.memoizedState = RS(a), t.memoizedState = CS, b;
        } else
          return TS(t, y);
      } else {
        var z = e.memoizedState;
        if (z !== null) {
          var F = z.dehydrated;
          if (F !== null)
            return Dx(e, t, f, i, F, z, a);
        }
        if (s) {
          var V = i.fallback, le = i.children, Le = xx(e, t, le, V, a), we = t.child, Ct = e.child.memoizedState;
          return we.memoizedState = Ct === null ? RS(a) : Ex(Ct, a), we.childLanes = Rx(e, a), t.memoizedState = CS, Le;
        } else {
          var vt = i.children, O = wx(e, t, vt, a);
          return t.memoizedState = null, O;
        }
      }
    }
    function TS(e, t, a) {
      var i = e.mode, u = {
        mode: "visible",
        children: t
      }, s = wS(u, i);
      return s.return = e, e.child = s, s;
    }
    function Tx(e, t, a, i) {
      var u = e.mode, s = e.child, f = {
        mode: "hidden",
        children: t
      }, p, v;
      return (u & lt) === De && s !== null ? (p = s, p.childLanes = Y, p.pendingProps = f, e.mode & Ot && (p.actualDuration = 0, p.actualStartTime = -1, p.selfBaseDuration = 0, p.treeBaseDuration = 0), v = Bo(a, u, i, null)) : (p = wS(f, u), v = Bo(a, u, i, null)), p.return = e, v.return = e, p.sibling = v, e.child = p, v;
    }
    function wS(e, t, a) {
      return ER(e, t, Y, null);
    }
    function E0(e, t) {
      return rc(e, t);
    }
    function wx(e, t, a, i) {
      var u = e.child, s = u.sibling, f = E0(u, {
        mode: "visible",
        children: a
      });
      if ((t.mode & lt) === De && (f.lanes = i), f.return = t, f.sibling = null, s !== null) {
        var p = t.deletions;
        p === null ? (t.deletions = [s], t.flags |= _a) : p.push(s);
      }
      return t.child = f, f;
    }
    function xx(e, t, a, i, u) {
      var s = t.mode, f = e.child, p = f.sibling, v = {
        mode: "hidden",
        children: a
      }, y;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (s & lt) === De && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== f
      ) {
        var g = t.child;
        y = g, y.childLanes = Y, y.pendingProps = v, t.mode & Ot && (y.actualDuration = 0, y.actualStartTime = -1, y.selfBaseDuration = f.selfBaseDuration, y.treeBaseDuration = f.treeBaseDuration), t.deletions = null;
      } else
        y = E0(f, v), y.subtreeFlags = f.subtreeFlags & Nn;
      var b;
      return p !== null ? b = rc(p, i) : (b = Bo(i, s, u, null), b.flags |= hn), b.return = t, y.return = t, y.sibling = b, t.child = y, b;
    }
    function bm(e, t, a, i) {
      i !== null && ag(i), bf(t, e.child, null, a);
      var u = t.pendingProps, s = u.children, f = TS(t, s);
      return f.flags |= hn, t.memoizedState = null, f;
    }
    function bx(e, t, a, i, u) {
      var s = t.mode, f = {
        mode: "visible",
        children: a
      }, p = wS(f, s), v = Bo(i, s, u, null);
      return v.flags |= hn, p.return = t, v.return = t, p.sibling = v, t.child = p, (t.mode & lt) !== De && bf(t, e.child, null, u), v;
    }
    function _x(e, t, a) {
      return (e.mode & lt) === De ? (S("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = Ae) : By(t) ? e.lanes = Cr : e.lanes = Kr, null;
    }
    function Dx(e, t, a, i, u, s, f) {
      if (a)
        if (t.flags & Er) {
          t.flags &= ~Er;
          var O = cS(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return bm(e, t, f, O);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= xe, null;
          var P = i.children, L = i.fallback, X = bx(e, t, P, L, f), fe = t.child;
          return fe.memoizedState = RS(f), t.memoizedState = CS, X;
        }
      else {
        if (hw(), (t.mode & lt) === De)
          return bm(
            e,
            t,
            f,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (By(u)) {
          var p, v, y;
          {
            var g = M1(u);
            p = g.digest, v = g.message, y = g.stack;
          }
          var b;
          v ? b = new Error(v) : b = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var w = cS(b, p, y);
          return bm(e, t, f, w);
        }
        var z = Zr(f, e.childLanes);
        if (ll || z) {
          var F = Fm();
          if (F !== null) {
            var V = Ud(F, f);
            if (V !== bt && V !== s.retryLane) {
              s.retryLane = V;
              var le = Xt;
              Fa(e, V), mr(F, e, V, le);
            }
          }
          YS();
          var Le = cS(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return bm(e, t, f, Le);
        } else if ($E(u)) {
          t.flags |= xe, t.child = e.child;
          var we = Jb.bind(null, e);
          return N1(u, we), null;
        } else {
          gw(t, u, s.treeContext);
          var Ct = i.children, vt = TS(t, Ct);
          return vt.flags |= Wr, vt;
        }
      }
    }
    function C0(e, t, a) {
      e.lanes = Xe(e.lanes, t);
      var i = e.alternate;
      i !== null && (i.lanes = Xe(i.lanes, t)), vg(e.return, t, a);
    }
    function kx(e, t, a) {
      for (var i = t; i !== null; ) {
        if (i.tag === be) {
          var u = i.memoizedState;
          u !== null && C0(i, a, e);
        } else if (i.tag === an)
          C0(i, a, e);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function Ox(e) {
      for (var t = e, a = null; t !== null; ) {
        var i = t.alternate;
        i !== null && am(i) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function Lx(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !yS[e])
        if (yS[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              S('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              S('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              S('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          S('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function Mx(e, t) {
      e !== void 0 && !xm[e] && (e !== "collapsed" && e !== "hidden" ? (xm[e] = !0, S('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (xm[e] = !0, S('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function R0(e, t) {
      {
        var a = nt(e), i = !a && typeof qe(e) == "function";
        if (a || i) {
          var u = a ? "array" : "iterable";
          return S("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", u, t, u), !1;
        }
      }
      return !0;
    }
    function Nx(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (nt(e)) {
          for (var a = 0; a < e.length; a++)
            if (!R0(e[a], a))
              return;
        } else {
          var i = qe(e);
          if (typeof i == "function") {
            var u = i.call(e);
            if (u)
              for (var s = u.next(), f = 0; !s.done; s = u.next()) {
                if (!R0(s.value, f))
                  return;
                f++;
              }
          } else
            S('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function xS(e, t, a, i, u) {
      var s = e.memoizedState;
      s === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: a,
        tailMode: u
      } : (s.isBackwards = t, s.rendering = null, s.renderingStartTime = 0, s.last = i, s.tail = a, s.tailMode = u);
    }
    function T0(e, t, a) {
      var i = t.pendingProps, u = i.revealOrder, s = i.tail, f = i.children;
      Lx(u), Mx(s, u), Nx(f, u), ya(e, t, f, a);
      var p = rl.current, v = Tg(p, Cp);
      if (v)
        p = wg(p, Cp), t.flags |= xe;
      else {
        var y = e !== null && (e.flags & xe) !== _e;
        y && kx(t, t.child, a), p = Of(p);
      }
      if (zo(t, p), (t.mode & lt) === De)
        t.memoizedState = null;
      else
        switch (u) {
          case "forwards": {
            var g = Ox(t.child), b;
            g === null ? (b = t.child, t.child = null) : (b = g.sibling, g.sibling = null), xS(
              t,
              !1,
              // isBackwards
              b,
              g,
              s
            );
            break;
          }
          case "backwards": {
            var w = null, z = t.child;
            for (t.child = null; z !== null; ) {
              var F = z.alternate;
              if (F !== null && am(F) === null) {
                t.child = z;
                break;
              }
              var V = z.sibling;
              z.sibling = w, w = z, z = V;
            }
            xS(
              t,
              !0,
              // isBackwards
              w,
              null,
              // last
              s
            );
            break;
          }
          case "together": {
            xS(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function zx(e, t, a) {
      Eg(t, t.stateNode.containerInfo);
      var i = t.pendingProps;
      return e === null ? t.child = bf(t, null, i, a) : ya(e, t, i, a), t.child;
    }
    var w0 = !1;
    function Ux(e, t, a) {
      var i = t.type, u = i._context, s = t.pendingProps, f = t.memoizedProps, p = s.value;
      {
        "value" in s || w0 || (w0 = !0, S("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var v = t.type.propTypes;
        v && el(v, s, "prop", "Context.Provider");
      }
      if (mC(t, u, p), f !== null) {
        var y = f.value;
        if (G(y, p)) {
          if (f.children === s.children && !Uh())
            return Hu(e, t, a);
        } else
          Lw(t, u, a);
      }
      var g = s.children;
      return ya(e, t, g, a), t.child;
    }
    var x0 = !1;
    function Ax(e, t, a) {
      var i = t.type;
      i._context === void 0 ? i !== i.Consumer && (x0 || (x0 = !0, S("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
      var u = t.pendingProps, s = u.children;
      typeof s != "function" && S("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Df(t, a);
      var f = er(i);
      pa(t);
      var p;
      return Op.current = t, $n(!0), p = s(f), $n(!1), va(), t.flags |= ei, ya(e, t, p, a), t.child;
    }
    function Np() {
      ll = !0;
    }
    function _m(e, t) {
      (t.mode & lt) === De && e !== null && (e.alternate = null, t.alternate = null, t.flags |= hn);
    }
    function Hu(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), e0(), Yp(t.lanes), Zr(a, t.childLanes) ? (kw(e, t), t.child) : null;
    }
    function Fx(e, t, a) {
      {
        var i = t.return;
        if (i === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === i.child)
          i.child = a;
        else {
          var u = i.child;
          if (u === null)
            throw new Error("Expected parent to have a child.");
          for (; u.sibling !== t; )
            if (u = u.sibling, u === null)
              throw new Error("Expected to find the previous sibling.");
          u.sibling = a;
        }
        var s = i.deletions;
        return s === null ? (i.deletions = [e], i.flags |= _a) : s.push(e), a.flags |= hn, a;
      }
    }
    function bS(e, t) {
      var a = e.lanes;
      return !!Zr(a, t);
    }
    function jx(e, t, a) {
      switch (t.tag) {
        case ee:
          y0(t), t.stateNode, xf();
          break;
        case ue:
          wC(t);
          break;
        case ve: {
          var i = t.type;
          Bl(i) && Fh(t);
          break;
        }
        case Ce:
          Eg(t, t.stateNode.containerInfo);
          break;
        case ft: {
          var u = t.memoizedProps.value, s = t.type._context;
          mC(t, s, u);
          break;
        }
        case pt:
          {
            var f = Zr(a, t.childLanes);
            f && (t.flags |= gt);
            {
              var p = t.stateNode;
              p.effectDuration = 0, p.passiveEffectDuration = 0;
            }
          }
          break;
        case be: {
          var v = t.memoizedState;
          if (v !== null) {
            if (v.dehydrated !== null)
              return zo(t, Of(rl.current)), t.flags |= xe, null;
            var y = t.child, g = y.childLanes;
            if (Zr(a, g))
              return S0(e, t, a);
            zo(t, Of(rl.current));
            var b = Hu(e, t, a);
            return b !== null ? b.sibling : null;
          } else
            zo(t, Of(rl.current));
          break;
        }
        case an: {
          var w = (e.flags & xe) !== _e, z = Zr(a, t.childLanes);
          if (w) {
            if (z)
              return T0(e, t, a);
            t.flags |= xe;
          }
          var F = t.memoizedState;
          if (F !== null && (F.rendering = null, F.tail = null, F.lastEffect = null), zo(t, rl.current), z)
            break;
          return null;
        }
        case ke:
        case Ut:
          return t.lanes = Y, v0(e, t, a);
      }
      return Hu(e, t, a);
    }
    function b0(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return Fx(e, t, nE(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var i = e.memoizedProps, u = t.pendingProps;
        if (i !== u || Uh() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          ll = !0;
        else {
          var s = bS(e, a);
          if (!s && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & xe) === _e)
            return ll = !1, jx(e, t, a);
          (e.flags & Tc) !== _e ? ll = !0 : ll = !1;
        }
      } else if (ll = !1, Ur() && sw(t)) {
        var f = t.index, p = cw();
        eC(t, p, f);
      }
      switch (t.lanes = Y, t.tag) {
        case ut:
          return Sx(e, t, t.type, a);
        case rn: {
          var v = t.elementType;
          return yx(e, t, v, a);
        }
        case de: {
          var y = t.type, g = t.pendingProps, b = t.elementType === y ? g : il(y, g);
          return gS(e, t, y, b, a);
        }
        case ve: {
          var w = t.type, z = t.pendingProps, F = t.elementType === w ? z : il(w, z);
          return m0(e, t, w, F, a);
        }
        case ee:
          return vx(e, t, a);
        case ue:
          return hx(e, t, a);
        case Ye:
          return mx(e, t);
        case be:
          return S0(e, t, a);
        case Ce:
          return zx(e, t, a);
        case Qe: {
          var V = t.type, le = t.pendingProps, Le = t.elementType === V ? le : il(V, le);
          return f0(e, t, V, Le, a);
        }
        case yt:
          return fx(e, t, a);
        case dt:
          return dx(e, t, a);
        case pt:
          return px(e, t, a);
        case ft:
          return Ux(e, t, a);
        case cn:
          return Ax(e, t, a);
        case ot: {
          var we = t.type, Ct = t.pendingProps, vt = il(we, Ct);
          if (t.type !== t.elementType) {
            var O = we.propTypes;
            O && el(
              O,
              vt,
              // Resolved for outer only
              "prop",
              Rt(we)
            );
          }
          return vt = il(we.type, vt), d0(e, t, we, vt, a);
        }
        case Fe:
          return p0(e, t, t.type, t.pendingProps, a);
        case Ft: {
          var P = t.type, L = t.pendingProps, X = t.elementType === P ? L : il(P, L);
          return gx(e, t, P, X, a);
        }
        case an:
          return T0(e, t, a);
        case wt:
          break;
        case ke:
          return v0(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Af(e) {
      e.flags |= gt;
    }
    function _0(e) {
      e.flags |= Sn, e.flags |= po;
    }
    var D0, _S, k0, O0;
    D0 = function(e, t, a, i) {
      for (var u = t.child; u !== null; ) {
        if (u.tag === ue || u.tag === Ye)
          l1(e, u.stateNode);
        else if (u.tag !== Ce) {
          if (u.child !== null) {
            u.child.return = u, u = u.child;
            continue;
          }
        }
        if (u === t)
          return;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === t)
            return;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }, _S = function(e, t) {
    }, k0 = function(e, t, a, i, u) {
      var s = e.memoizedProps;
      if (s !== i) {
        var f = t.stateNode, p = Cg(), v = o1(f, a, s, i, u, p);
        t.updateQueue = v, v && Af(t);
      }
    }, O0 = function(e, t, a, i) {
      a !== i && Af(t);
    };
    function zp(e, t) {
      if (!Ur())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, i = null; a !== null; )
              a.alternate !== null && (i = a), a = a.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          }
          case "collapsed": {
            for (var u = e.tail, s = null; u !== null; )
              u.alternate !== null && (s = u), u = u.sibling;
            s === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : s.sibling = null;
            break;
          }
        }
    }
    function Fr(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = Y, i = _e;
      if (t) {
        if ((e.mode & Ot) !== De) {
          for (var v = e.selfBaseDuration, y = e.child; y !== null; )
            a = Xe(a, Xe(y.lanes, y.childLanes)), i |= y.subtreeFlags & Nn, i |= y.flags & Nn, v += y.treeBaseDuration, y = y.sibling;
          e.treeBaseDuration = v;
        } else
          for (var g = e.child; g !== null; )
            a = Xe(a, Xe(g.lanes, g.childLanes)), i |= g.subtreeFlags & Nn, i |= g.flags & Nn, g.return = e, g = g.sibling;
        e.subtreeFlags |= i;
      } else {
        if ((e.mode & Ot) !== De) {
          for (var u = e.actualDuration, s = e.selfBaseDuration, f = e.child; f !== null; )
            a = Xe(a, Xe(f.lanes, f.childLanes)), i |= f.subtreeFlags, i |= f.flags, u += f.actualDuration, s += f.treeBaseDuration, f = f.sibling;
          e.actualDuration = u, e.treeBaseDuration = s;
        } else
          for (var p = e.child; p !== null; )
            a = Xe(a, Xe(p.lanes, p.childLanes)), i |= p.subtreeFlags, i |= p.flags, p.return = e, p = p.sibling;
        e.subtreeFlags |= i;
      }
      return e.childLanes = a, t;
    }
    function Hx(e, t, a) {
      if (Tw() && (t.mode & lt) !== De && (t.flags & xe) === _e)
        return uC(t), xf(), t.flags |= Er | ls | Xn, !1;
      var i = Bh(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!i)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (Cw(t), Fr(t), (t.mode & Ot) !== De) {
            var u = a !== null;
            if (u) {
              var s = t.child;
              s !== null && (t.treeBaseDuration -= s.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (xf(), (t.flags & xe) === _e && (t.memoizedState = null), t.flags |= gt, Fr(t), (t.mode & Ot) !== De) {
            var f = a !== null;
            if (f) {
              var p = t.child;
              p !== null && (t.treeBaseDuration -= p.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return oC(), !0;
    }
    function L0(e, t, a) {
      var i = t.pendingProps;
      switch (Jy(t), t.tag) {
        case ut:
        case rn:
        case Fe:
        case de:
        case Qe:
        case yt:
        case dt:
        case pt:
        case cn:
        case ot:
          return Fr(t), null;
        case ve: {
          var u = t.type;
          return Bl(u) && Ah(t), Fr(t), null;
        }
        case ee: {
          var s = t.stateNode;
          if (kf(t), qy(t), bg(), s.pendingContext && (s.context = s.pendingContext, s.pendingContext = null), e === null || e.child === null) {
            var f = Bh(t);
            if (f)
              Af(t);
            else if (e !== null) {
              var p = e.memoizedState;
              // Check if this is a client root
              (!p.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & Er) !== _e) && (t.flags |= In, oC());
            }
          }
          return _S(e, t), Fr(t), null;
        }
        case ue: {
          Rg(t);
          var v = TC(), y = t.type;
          if (e !== null && t.stateNode != null)
            k0(e, t, y, i, v), e.ref !== t.ref && _0(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Fr(t), null;
            }
            var g = Cg(), b = Bh(t);
            if (b)
              Sw(t, v, g) && Af(t);
            else {
              var w = i1(y, i, v, g, t);
              D0(w, t, !1, !1), t.stateNode = w, u1(w, y, i, v) && Af(t);
            }
            t.ref !== null && _0(t);
          }
          return Fr(t), null;
        }
        case Ye: {
          var z = i;
          if (e && t.stateNode != null) {
            var F = e.memoizedProps;
            O0(e, t, F, z);
          } else {
            if (typeof z != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var V = TC(), le = Cg(), Le = Bh(t);
            Le ? Ew(t) && Af(t) : t.stateNode = s1(z, V, le, t);
          }
          return Fr(t), null;
        }
        case be: {
          Lf(t);
          var we = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var Ct = Hx(e, t, we);
            if (!Ct)
              return t.flags & Xn ? t : null;
          }
          if ((t.flags & xe) !== _e)
            return t.lanes = a, (t.mode & Ot) !== De && Kg(t), t;
          var vt = we !== null, O = e !== null && e.memoizedState !== null;
          if (vt !== O && vt) {
            var P = t.child;
            if (P.flags |= Mn, (t.mode & lt) !== De) {
              var L = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              L || Tg(rl.current, bC) ? Vb() : YS();
            }
          }
          var X = t.updateQueue;
          if (X !== null && (t.flags |= gt), Fr(t), (t.mode & Ot) !== De && vt) {
            var fe = t.child;
            fe !== null && (t.treeBaseDuration -= fe.treeBaseDuration);
          }
          return null;
        }
        case Ce:
          return kf(t), _S(e, t), e === null && nw(t.stateNode.containerInfo), Fr(t), null;
        case ft:
          var oe = t.type._context;
          return pg(oe, t), Fr(t), null;
        case Ft: {
          var He = t.type;
          return Bl(He) && Ah(t), Fr(t), null;
        }
        case an: {
          Lf(t);
          var We = t.memoizedState;
          if (We === null)
            return Fr(t), null;
          var qt = (t.flags & xe) !== _e, Nt = We.rendering;
          if (Nt === null)
            if (qt)
              zp(We, !1);
            else {
              var Wn = Bb() && (e === null || (e.flags & xe) === _e);
              if (!Wn)
                for (var zt = t.child; zt !== null; ) {
                  var Hn = am(zt);
                  if (Hn !== null) {
                    qt = !0, t.flags |= xe, zp(We, !1);
                    var ia = Hn.updateQueue;
                    return ia !== null && (t.updateQueue = ia, t.flags |= gt), t.subtreeFlags = _e, Ow(t, a), zo(t, wg(rl.current, Cp)), t.child;
                  }
                  zt = zt.sibling;
                }
              We.tail !== null && Yn() > Z0() && (t.flags |= xe, qt = !0, zp(We, !1), t.lanes = bd);
            }
          else {
            if (!qt) {
              var Br = am(Nt);
              if (Br !== null) {
                t.flags |= xe, qt = !0;
                var ui = Br.updateQueue;
                if (ui !== null && (t.updateQueue = ui, t.flags |= gt), zp(We, !0), We.tail === null && We.tailMode === "hidden" && !Nt.alternate && !Ur())
                  return Fr(t), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Yn() * 2 - We.renderingStartTime > Z0() && a !== Kr && (t.flags |= xe, qt = !0, zp(We, !1), t.lanes = bd);
            }
            if (We.isBackwards)
              Nt.sibling = t.child, t.child = Nt;
            else {
              var Ea = We.last;
              Ea !== null ? Ea.sibling = Nt : t.child = Nt, We.last = Nt;
            }
          }
          if (We.tail !== null) {
            var Ca = We.tail;
            We.rendering = Ca, We.tail = Ca.sibling, We.renderingStartTime = Yn(), Ca.sibling = null;
            var la = rl.current;
            return qt ? la = wg(la, Cp) : la = Of(la), zo(t, la), Ca;
          }
          return Fr(t), null;
        }
        case wt:
          break;
        case ke:
        case Ut: {
          IS(t);
          var Iu = t.memoizedState, If = Iu !== null;
          if (e !== null) {
            var Xp = e.memoizedState, Xl = Xp !== null;
            Xl !== If && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !ne && (t.flags |= Mn);
          }
          return !If || (t.mode & lt) === De ? Fr(t) : Zr(ql, Kr) && (Fr(t), t.subtreeFlags & (hn | gt) && (t.flags |= Mn)), null;
        }
        case xt:
          return null;
        case Dt:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Vx(e, t, a) {
      switch (Jy(t), t.tag) {
        case ve: {
          var i = t.type;
          Bl(i) && Ah(t);
          var u = t.flags;
          return u & Xn ? (t.flags = u & ~Xn | xe, (t.mode & Ot) !== De && Kg(t), t) : null;
        }
        case ee: {
          t.stateNode, kf(t), qy(t), bg();
          var s = t.flags;
          return (s & Xn) !== _e && (s & xe) === _e ? (t.flags = s & ~Xn | xe, t) : null;
        }
        case ue:
          return Rg(t), null;
        case be: {
          Lf(t);
          var f = t.memoizedState;
          if (f !== null && f.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            xf();
          }
          var p = t.flags;
          return p & Xn ? (t.flags = p & ~Xn | xe, (t.mode & Ot) !== De && Kg(t), t) : null;
        }
        case an:
          return Lf(t), null;
        case Ce:
          return kf(t), null;
        case ft:
          var v = t.type._context;
          return pg(v, t), null;
        case ke:
        case Ut:
          return IS(t), null;
        case xt:
          return null;
        default:
          return null;
      }
    }
    function M0(e, t, a) {
      switch (Jy(t), t.tag) {
        case ve: {
          var i = t.type.childContextTypes;
          i != null && Ah(t);
          break;
        }
        case ee: {
          t.stateNode, kf(t), qy(t), bg();
          break;
        }
        case ue: {
          Rg(t);
          break;
        }
        case Ce:
          kf(t);
          break;
        case be:
          Lf(t);
          break;
        case an:
          Lf(t);
          break;
        case ft:
          var u = t.type._context;
          pg(u, t);
          break;
        case ke:
        case Ut:
          IS(t);
          break;
      }
    }
    var N0 = null;
    N0 = /* @__PURE__ */ new Set();
    var Dm = !1, jr = !1, Px = typeof WeakSet == "function" ? WeakSet : Set, ge = null, Ff = null, jf = null;
    function Bx(e) {
      wl(null, function() {
        throw e;
      }), is();
    }
    var $x = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Ot)
        try {
          Wl(), t.componentWillUnmount();
        } finally {
          Ql(e);
        }
      else
        t.componentWillUnmount();
    };
    function z0(e, t) {
      try {
        Fo(cr, e);
      } catch (a) {
        sn(e, t, a);
      }
    }
    function DS(e, t, a) {
      try {
        $x(e, a);
      } catch (i) {
        sn(e, t, i);
      }
    }
    function Ix(e, t, a) {
      try {
        a.componentDidMount();
      } catch (i) {
        sn(e, t, i);
      }
    }
    function U0(e, t) {
      try {
        F0(e);
      } catch (a) {
        sn(e, t, a);
      }
    }
    function Hf(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var i;
          try {
            if (Ue && rt && e.mode & Ot)
              try {
                Wl(), i = a(null);
              } finally {
                Ql(e);
              }
            else
              i = a(null);
          } catch (u) {
            sn(e, t, u);
          }
          typeof i == "function" && S("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Pe(e));
        } else
          a.current = null;
    }
    function km(e, t, a) {
      try {
        a();
      } catch (i) {
        sn(e, t, i);
      }
    }
    var A0 = !1;
    function Yx(e, t) {
      r1(e.containerInfo), ge = t, Qx();
      var a = A0;
      return A0 = !1, a;
    }
    function Qx() {
      for (; ge !== null; ) {
        var e = ge, t = e.child;
        (e.subtreeFlags & bl) !== _e && t !== null ? (t.return = e, ge = t) : Wx();
      }
    }
    function Wx() {
      for (; ge !== null; ) {
        var e = ge;
        It(e);
        try {
          Gx(e);
        } catch (a) {
          sn(e, e.return, a);
        }
        on();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ge = t;
          return;
        }
        ge = e.return;
      }
    }
    function Gx(e) {
      var t = e.alternate, a = e.flags;
      if ((a & In) !== _e) {
        switch (It(e), e.tag) {
          case de:
          case Qe:
          case Fe:
            break;
          case ve: {
            if (t !== null) {
              var i = t.memoizedProps, u = t.memoizedState, s = e.stateNode;
              e.type === e.elementType && !Zs && (s.props !== e.memoizedProps && S("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Pe(e) || "instance"), s.state !== e.memoizedState && S("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Pe(e) || "instance"));
              var f = s.getSnapshotBeforeUpdate(e.elementType === e.type ? i : il(e.type, i), u);
              {
                var p = N0;
                f === void 0 && !p.has(e.type) && (p.add(e.type), S("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Pe(e)));
              }
              s.__reactInternalSnapshotBeforeUpdate = f;
            }
            break;
          }
          case ee: {
            {
              var v = e.stateNode;
              D1(v.containerInfo);
            }
            break;
          }
          case ue:
          case Ye:
          case Ce:
          case Ft:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        on();
      }
    }
    function ul(e, t, a) {
      var i = t.updateQueue, u = i !== null ? i.lastEffect : null;
      if (u !== null) {
        var s = u.next, f = s;
        do {
          if ((f.tag & e) === e) {
            var p = f.destroy;
            f.destroy = void 0, p !== void 0 && ((e & Ar) !== ja ? Gi(t) : (e & cr) !== ja && os(t), (e & $l) !== ja && Wp(!0), km(t, a, p), (e & $l) !== ja && Wp(!1), (e & Ar) !== ja ? Ol() : (e & cr) !== ja && wd());
          }
          f = f.next;
        } while (f !== s);
      }
    }
    function Fo(e, t) {
      var a = t.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var u = i.next, s = u;
        do {
          if ((s.tag & e) === e) {
            (e & Ar) !== ja ? Td(t) : (e & cr) !== ja && kc(t);
            var f = s.create;
            (e & $l) !== ja && Wp(!0), s.destroy = f(), (e & $l) !== ja && Wp(!1), (e & Ar) !== ja ? zv() : (e & cr) !== ja && Uv();
            {
              var p = s.destroy;
              if (p !== void 0 && typeof p != "function") {
                var v = void 0;
                (s.tag & cr) !== _e ? v = "useLayoutEffect" : (s.tag & $l) !== _e ? v = "useInsertionEffect" : v = "useEffect";
                var y = void 0;
                p === null ? y = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof p.then == "function" ? y = `

It looks like you wrote ` + v + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + v + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : y = " You returned: " + p, S("%s must not return anything besides a function, which is used for clean-up.%s", v, y);
              }
            }
          }
          s = s.next;
        } while (s !== u);
      }
    }
    function qx(e, t) {
      if ((t.flags & gt) !== _e)
        switch (t.tag) {
          case pt: {
            var a = t.stateNode.passiveEffectDuration, i = t.memoizedProps, u = i.id, s = i.onPostCommit, f = ZC(), p = t.alternate === null ? "mount" : "update";
            KC() && (p = "nested-update"), typeof s == "function" && s(u, p, a, f);
            var v = t.return;
            e: for (; v !== null; ) {
              switch (v.tag) {
                case ee:
                  var y = v.stateNode;
                  y.passiveEffectDuration += a;
                  break e;
                case pt:
                  var g = v.stateNode;
                  g.passiveEffectDuration += a;
                  break e;
              }
              v = v.return;
            }
            break;
          }
        }
    }
    function Xx(e, t, a, i) {
      if ((a.flags & Dl) !== _e)
        switch (a.tag) {
          case de:
          case Qe:
          case Fe: {
            if (!jr)
              if (a.mode & Ot)
                try {
                  Wl(), Fo(cr | sr, a);
                } finally {
                  Ql(a);
                }
              else
                Fo(cr | sr, a);
            break;
          }
          case ve: {
            var u = a.stateNode;
            if (a.flags & gt && !jr)
              if (t === null)
                if (a.type === a.elementType && !Zs && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Pe(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Pe(a) || "instance")), a.mode & Ot)
                  try {
                    Wl(), u.componentDidMount();
                  } finally {
                    Ql(a);
                  }
                else
                  u.componentDidMount();
              else {
                var s = a.elementType === a.type ? t.memoizedProps : il(a.type, t.memoizedProps), f = t.memoizedState;
                if (a.type === a.elementType && !Zs && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Pe(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Pe(a) || "instance")), a.mode & Ot)
                  try {
                    Wl(), u.componentDidUpdate(s, f, u.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Ql(a);
                  }
                else
                  u.componentDidUpdate(s, f, u.__reactInternalSnapshotBeforeUpdate);
              }
            var p = a.updateQueue;
            p !== null && (a.type === a.elementType && !Zs && (u.props !== a.memoizedProps && S("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Pe(a) || "instance"), u.state !== a.memoizedState && S("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Pe(a) || "instance")), RC(a, p, u));
            break;
          }
          case ee: {
            var v = a.updateQueue;
            if (v !== null) {
              var y = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case ue:
                    y = a.child.stateNode;
                    break;
                  case ve:
                    y = a.child.stateNode;
                    break;
                }
              RC(a, v, y);
            }
            break;
          }
          case ue: {
            var g = a.stateNode;
            if (t === null && a.flags & gt) {
              var b = a.type, w = a.memoizedProps;
              v1(g, b, w);
            }
            break;
          }
          case Ye:
            break;
          case Ce:
            break;
          case pt: {
            {
              var z = a.memoizedProps, F = z.onCommit, V = z.onRender, le = a.stateNode.effectDuration, Le = ZC(), we = t === null ? "mount" : "update";
              KC() && (we = "nested-update"), typeof V == "function" && V(a.memoizedProps.id, we, a.actualDuration, a.treeBaseDuration, a.actualStartTime, Le);
              {
                typeof F == "function" && F(a.memoizedProps.id, we, le, Le), Wb(a);
                var Ct = a.return;
                e: for (; Ct !== null; ) {
                  switch (Ct.tag) {
                    case ee:
                      var vt = Ct.stateNode;
                      vt.effectDuration += le;
                      break e;
                    case pt:
                      var O = Ct.stateNode;
                      O.effectDuration += le;
                      break e;
                  }
                  Ct = Ct.return;
                }
              }
            }
            break;
          }
          case be: {
            ab(e, a);
            break;
          }
          case an:
          case Ft:
          case wt:
          case ke:
          case Ut:
          case Dt:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      jr || a.flags & Sn && F0(a);
    }
    function Kx(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          if (e.mode & Ot)
            try {
              Wl(), z0(e, e.return);
            } finally {
              Ql(e);
            }
          else
            z0(e, e.return);
          break;
        }
        case ve: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && Ix(e, e.return, t), U0(e, e.return);
          break;
        }
        case ue: {
          U0(e, e.return);
          break;
        }
      }
    }
    function Zx(e, t) {
      for (var a = null, i = e; ; ) {
        if (i.tag === ue) {
          if (a === null) {
            a = i;
            try {
              var u = i.stateNode;
              t ? w1(u) : b1(i.stateNode, i.memoizedProps);
            } catch (f) {
              sn(e, e.return, f);
            }
          }
        } else if (i.tag === Ye) {
          if (a === null)
            try {
              var s = i.stateNode;
              t ? x1(s) : _1(s, i.memoizedProps);
            } catch (f) {
              sn(e, e.return, f);
            }
        } else if (!((i.tag === ke || i.tag === Ut) && i.memoizedState !== null && i !== e)) {
          if (i.child !== null) {
            i.child.return = i, i = i.child;
            continue;
          }
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          a === i && (a = null), i = i.return;
        }
        a === i && (a = null), i.sibling.return = i.return, i = i.sibling;
      }
    }
    function F0(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, i;
        if (e.tag === ue ? i = a : i = a, typeof t == "function") {
          var u;
          if (e.mode & Ot)
            try {
              Wl(), u = t(i);
            } finally {
              Ql(e);
            }
          else
            u = t(i);
          typeof u == "function" && S("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Pe(e));
        } else
          t.hasOwnProperty("current") || S("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Pe(e)), t.current = i;
      }
    }
    function Jx(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function j0(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, j0(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === ue) {
          var a = e.stateNode;
          a !== null && iw(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function eb(e) {
      for (var t = e.return; t !== null; ) {
        if (H0(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function H0(e) {
      return e.tag === ue || e.tag === ee || e.tag === Ce;
    }
    function V0(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || H0(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== ue && t.tag !== Ye && t.tag !== Kt; ) {
          if (t.flags & hn || t.child === null || t.tag === Ce)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & hn))
          return t.stateNode;
      }
    }
    function tb(e) {
      var t = eb(e);
      switch (t.tag) {
        case ue: {
          var a = t.stateNode;
          t.flags & Da && (BE(a), t.flags &= ~Da);
          var i = V0(e);
          OS(e, i, a);
          break;
        }
        case ee:
        case Ce: {
          var u = t.stateNode.containerInfo, s = V0(e);
          kS(e, s, u);
          break;
        }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function kS(e, t, a) {
      var i = e.tag, u = i === ue || i === Ye;
      if (u) {
        var s = e.stateNode;
        t ? E1(a, s, t) : g1(a, s);
      } else if (i !== Ce) {
        var f = e.child;
        if (f !== null) {
          kS(f, t, a);
          for (var p = f.sibling; p !== null; )
            kS(p, t, a), p = p.sibling;
        }
      }
    }
    function OS(e, t, a) {
      var i = e.tag, u = i === ue || i === Ye;
      if (u) {
        var s = e.stateNode;
        t ? S1(a, s, t) : y1(a, s);
      } else if (i !== Ce) {
        var f = e.child;
        if (f !== null) {
          OS(f, t, a);
          for (var p = f.sibling; p !== null; )
            OS(p, t, a), p = p.sibling;
        }
      }
    }
    var Hr = null, ol = !1;
    function nb(e, t, a) {
      {
        var i = t;
        e: for (; i !== null; ) {
          switch (i.tag) {
            case ue: {
              Hr = i.stateNode, ol = !1;
              break e;
            }
            case ee: {
              Hr = i.stateNode.containerInfo, ol = !0;
              break e;
            }
            case Ce: {
              Hr = i.stateNode.containerInfo, ol = !0;
              break e;
            }
          }
          i = i.return;
        }
        if (Hr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        P0(e, t, a), Hr = null, ol = !1;
      }
      Jx(a);
    }
    function jo(e, t, a) {
      for (var i = a.child; i !== null; )
        P0(e, t, i), i = i.sibling;
    }
    function P0(e, t, a) {
      switch (Ed(a), a.tag) {
        case ue:
          jr || Hf(a, t);
        // eslint-disable-next-line-no-fallthrough
        case Ye: {
          {
            var i = Hr, u = ol;
            Hr = null, jo(e, t, a), Hr = i, ol = u, Hr !== null && (ol ? R1(Hr, a.stateNode) : C1(Hr, a.stateNode));
          }
          return;
        }
        case Kt: {
          Hr !== null && (ol ? T1(Hr, a.stateNode) : Py(Hr, a.stateNode));
          return;
        }
        case Ce: {
          {
            var s = Hr, f = ol;
            Hr = a.stateNode.containerInfo, ol = !0, jo(e, t, a), Hr = s, ol = f;
          }
          return;
        }
        case de:
        case Qe:
        case ot:
        case Fe: {
          if (!jr) {
            var p = a.updateQueue;
            if (p !== null) {
              var v = p.lastEffect;
              if (v !== null) {
                var y = v.next, g = y;
                do {
                  var b = g, w = b.destroy, z = b.tag;
                  w !== void 0 && ((z & $l) !== ja ? km(a, t, w) : (z & cr) !== ja && (os(a), a.mode & Ot ? (Wl(), km(a, t, w), Ql(a)) : km(a, t, w), wd())), g = g.next;
                } while (g !== y);
              }
            }
          }
          jo(e, t, a);
          return;
        }
        case ve: {
          if (!jr) {
            Hf(a, t);
            var F = a.stateNode;
            typeof F.componentWillUnmount == "function" && DS(a, t, F);
          }
          jo(e, t, a);
          return;
        }
        case wt: {
          jo(e, t, a);
          return;
        }
        case ke: {
          if (
            // TODO: Remove this dead flag
            a.mode & lt
          ) {
            var V = jr;
            jr = V || a.memoizedState !== null, jo(e, t, a), jr = V;
          } else
            jo(e, t, a);
          break;
        }
        default: {
          jo(e, t, a);
          return;
        }
      }
    }
    function rb(e) {
      e.memoizedState;
    }
    function ab(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var i = t.alternate;
        if (i !== null) {
          var u = i.memoizedState;
          if (u !== null) {
            var s = u.dehydrated;
            s !== null && B1(s);
          }
        }
      }
    }
    function B0(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new Px()), t.forEach(function(i) {
          var u = e_.bind(null, e, i);
          if (!a.has(i)) {
            if (a.add(i), Xr)
              if (Ff !== null && jf !== null)
                Qp(jf, Ff);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            i.then(u, u);
          }
        });
      }
    }
    function ib(e, t, a) {
      Ff = a, jf = e, It(t), $0(t, e), It(t), Ff = null, jf = null;
    }
    function sl(e, t, a) {
      var i = t.deletions;
      if (i !== null)
        for (var u = 0; u < i.length; u++) {
          var s = i[u];
          try {
            nb(e, t, s);
          } catch (v) {
            sn(s, t, v);
          }
        }
      var f = yl();
      if (t.subtreeFlags & _l)
        for (var p = t.child; p !== null; )
          It(p), $0(p, e), p = p.sibling;
      It(f);
    }
    function $0(e, t, a) {
      var i = e.alternate, u = e.flags;
      switch (e.tag) {
        case de:
        case Qe:
        case ot:
        case Fe: {
          if (sl(t, e), Gl(e), u & gt) {
            try {
              ul($l | sr, e, e.return), Fo($l | sr, e);
            } catch (He) {
              sn(e, e.return, He);
            }
            if (e.mode & Ot) {
              try {
                Wl(), ul(cr | sr, e, e.return);
              } catch (He) {
                sn(e, e.return, He);
              }
              Ql(e);
            } else
              try {
                ul(cr | sr, e, e.return);
              } catch (He) {
                sn(e, e.return, He);
              }
          }
          return;
        }
        case ve: {
          sl(t, e), Gl(e), u & Sn && i !== null && Hf(i, i.return);
          return;
        }
        case ue: {
          sl(t, e), Gl(e), u & Sn && i !== null && Hf(i, i.return);
          {
            if (e.flags & Da) {
              var s = e.stateNode;
              try {
                BE(s);
              } catch (He) {
                sn(e, e.return, He);
              }
            }
            if (u & gt) {
              var f = e.stateNode;
              if (f != null) {
                var p = e.memoizedProps, v = i !== null ? i.memoizedProps : p, y = e.type, g = e.updateQueue;
                if (e.updateQueue = null, g !== null)
                  try {
                    h1(f, g, y, v, p, e);
                  } catch (He) {
                    sn(e, e.return, He);
                  }
              }
            }
          }
          return;
        }
        case Ye: {
          if (sl(t, e), Gl(e), u & gt) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var b = e.stateNode, w = e.memoizedProps, z = i !== null ? i.memoizedProps : w;
            try {
              m1(b, z, w);
            } catch (He) {
              sn(e, e.return, He);
            }
          }
          return;
        }
        case ee: {
          if (sl(t, e), Gl(e), u & gt && i !== null) {
            var F = i.memoizedState;
            if (F.isDehydrated)
              try {
                P1(t.containerInfo);
              } catch (He) {
                sn(e, e.return, He);
              }
          }
          return;
        }
        case Ce: {
          sl(t, e), Gl(e);
          return;
        }
        case be: {
          sl(t, e), Gl(e);
          var V = e.child;
          if (V.flags & Mn) {
            var le = V.stateNode, Le = V.memoizedState, we = Le !== null;
            if (le.isHidden = we, we) {
              var Ct = V.alternate !== null && V.alternate.memoizedState !== null;
              Ct || Hb();
            }
          }
          if (u & gt) {
            try {
              rb(e);
            } catch (He) {
              sn(e, e.return, He);
            }
            B0(e);
          }
          return;
        }
        case ke: {
          var vt = i !== null && i.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & lt
          ) {
            var O = jr;
            jr = O || vt, sl(t, e), jr = O;
          } else
            sl(t, e);
          if (Gl(e), u & Mn) {
            var P = e.stateNode, L = e.memoizedState, X = L !== null, fe = e;
            if (P.isHidden = X, X && !vt && (fe.mode & lt) !== De) {
              ge = fe;
              for (var oe = fe.child; oe !== null; )
                ge = oe, ub(oe), oe = oe.sibling;
            }
            Zx(fe, X);
          }
          return;
        }
        case an: {
          sl(t, e), Gl(e), u & gt && B0(e);
          return;
        }
        case wt:
          return;
        default: {
          sl(t, e), Gl(e);
          return;
        }
      }
    }
    function Gl(e) {
      var t = e.flags;
      if (t & hn) {
        try {
          tb(e);
        } catch (a) {
          sn(e, e.return, a);
        }
        e.flags &= ~hn;
      }
      t & Wr && (e.flags &= ~Wr);
    }
    function lb(e, t, a) {
      Ff = a, jf = t, ge = e, I0(e, t, a), Ff = null, jf = null;
    }
    function I0(e, t, a) {
      for (var i = (e.mode & lt) !== De; ge !== null; ) {
        var u = ge, s = u.child;
        if (u.tag === ke && i) {
          var f = u.memoizedState !== null, p = f || Dm;
          if (p) {
            LS(e, t, a);
            continue;
          } else {
            var v = u.alternate, y = v !== null && v.memoizedState !== null, g = y || jr, b = Dm, w = jr;
            Dm = p, jr = g, jr && !w && (ge = u, ob(u));
            for (var z = s; z !== null; )
              ge = z, I0(
                z,
                // New root; bubble back up to here and stop.
                t,
                a
              ), z = z.sibling;
            ge = u, Dm = b, jr = w, LS(e, t, a);
            continue;
          }
        }
        (u.subtreeFlags & Dl) !== _e && s !== null ? (s.return = u, ge = s) : LS(e, t, a);
      }
    }
    function LS(e, t, a) {
      for (; ge !== null; ) {
        var i = ge;
        if ((i.flags & Dl) !== _e) {
          var u = i.alternate;
          It(i);
          try {
            Xx(t, u, i, a);
          } catch (f) {
            sn(i, i.return, f);
          }
          on();
        }
        if (i === e) {
          ge = null;
          return;
        }
        var s = i.sibling;
        if (s !== null) {
          s.return = i.return, ge = s;
          return;
        }
        ge = i.return;
      }
    }
    function ub(e) {
      for (; ge !== null; ) {
        var t = ge, a = t.child;
        switch (t.tag) {
          case de:
          case Qe:
          case ot:
          case Fe: {
            if (t.mode & Ot)
              try {
                Wl(), ul(cr, t, t.return);
              } finally {
                Ql(t);
              }
            else
              ul(cr, t, t.return);
            break;
          }
          case ve: {
            Hf(t, t.return);
            var i = t.stateNode;
            typeof i.componentWillUnmount == "function" && DS(t, t.return, i);
            break;
          }
          case ue: {
            Hf(t, t.return);
            break;
          }
          case ke: {
            var u = t.memoizedState !== null;
            if (u) {
              Y0(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, ge = a) : Y0(e);
      }
    }
    function Y0(e) {
      for (; ge !== null; ) {
        var t = ge;
        if (t === e) {
          ge = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ge = a;
          return;
        }
        ge = t.return;
      }
    }
    function ob(e) {
      for (; ge !== null; ) {
        var t = ge, a = t.child;
        if (t.tag === ke) {
          var i = t.memoizedState !== null;
          if (i) {
            Q0(e);
            continue;
          }
        }
        a !== null ? (a.return = t, ge = a) : Q0(e);
      }
    }
    function Q0(e) {
      for (; ge !== null; ) {
        var t = ge;
        It(t);
        try {
          Kx(t);
        } catch (i) {
          sn(t, t.return, i);
        }
        if (on(), t === e) {
          ge = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ge = a;
          return;
        }
        ge = t.return;
      }
    }
    function sb(e, t, a, i) {
      ge = t, cb(t, e, a, i);
    }
    function cb(e, t, a, i) {
      for (; ge !== null; ) {
        var u = ge, s = u.child;
        (u.subtreeFlags & Qi) !== _e && s !== null ? (s.return = u, ge = s) : fb(e, t, a, i);
      }
    }
    function fb(e, t, a, i) {
      for (; ge !== null; ) {
        var u = ge;
        if ((u.flags & Qr) !== _e) {
          It(u);
          try {
            db(t, u, a, i);
          } catch (f) {
            sn(u, u.return, f);
          }
          on();
        }
        if (u === e) {
          ge = null;
          return;
        }
        var s = u.sibling;
        if (s !== null) {
          s.return = u.return, ge = s;
          return;
        }
        ge = u.return;
      }
    }
    function db(e, t, a, i) {
      switch (t.tag) {
        case de:
        case Qe:
        case Fe: {
          if (t.mode & Ot) {
            Xg();
            try {
              Fo(Ar | sr, t);
            } finally {
              qg(t);
            }
          } else
            Fo(Ar | sr, t);
          break;
        }
      }
    }
    function pb(e) {
      ge = e, vb();
    }
    function vb() {
      for (; ge !== null; ) {
        var e = ge, t = e.child;
        if ((ge.flags & _a) !== _e) {
          var a = e.deletions;
          if (a !== null) {
            for (var i = 0; i < a.length; i++) {
              var u = a[i];
              ge = u, yb(u, e);
            }
            {
              var s = e.alternate;
              if (s !== null) {
                var f = s.child;
                if (f !== null) {
                  s.child = null;
                  do {
                    var p = f.sibling;
                    f.sibling = null, f = p;
                  } while (f !== null);
                }
              }
            }
            ge = e;
          }
        }
        (e.subtreeFlags & Qi) !== _e && t !== null ? (t.return = e, ge = t) : hb();
      }
    }
    function hb() {
      for (; ge !== null; ) {
        var e = ge;
        (e.flags & Qr) !== _e && (It(e), mb(e), on());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ge = t;
          return;
        }
        ge = e.return;
      }
    }
    function mb(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          e.mode & Ot ? (Xg(), ul(Ar | sr, e, e.return), qg(e)) : ul(Ar | sr, e, e.return);
          break;
        }
      }
    }
    function yb(e, t) {
      for (; ge !== null; ) {
        var a = ge;
        It(a), Sb(a, t), on();
        var i = a.child;
        i !== null ? (i.return = a, ge = i) : gb(e);
      }
    }
    function gb(e) {
      for (; ge !== null; ) {
        var t = ge, a = t.sibling, i = t.return;
        if (j0(t), t === e) {
          ge = null;
          return;
        }
        if (a !== null) {
          a.return = i, ge = a;
          return;
        }
        ge = i;
      }
    }
    function Sb(e, t) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          e.mode & Ot ? (Xg(), ul(Ar, e, t), qg(e)) : ul(Ar, e, t);
          break;
        }
      }
    }
    function Eb(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          try {
            Fo(cr | sr, e);
          } catch (a) {
            sn(e, e.return, a);
          }
          break;
        }
        case ve: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            sn(e, e.return, a);
          }
          break;
        }
      }
    }
    function Cb(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          try {
            Fo(Ar | sr, e);
          } catch (t) {
            sn(e, e.return, t);
          }
          break;
        }
      }
    }
    function Rb(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe: {
          try {
            ul(cr | sr, e, e.return);
          } catch (a) {
            sn(e, e.return, a);
          }
          break;
        }
        case ve: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && DS(e, e.return, t);
          break;
        }
      }
    }
    function Tb(e) {
      switch (e.tag) {
        case de:
        case Qe:
        case Fe:
          try {
            ul(Ar | sr, e, e.return);
          } catch (t) {
            sn(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Up = Symbol.for;
      Up("selector.component"), Up("selector.has_pseudo_class"), Up("selector.role"), Up("selector.test_id"), Up("selector.text");
    }
    var wb = [];
    function xb() {
      wb.forEach(function(e) {
        return e();
      });
    }
    var bb = D.ReactCurrentActQueue;
    function _b(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function W0() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && bb.current !== null && S("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var Db = Math.ceil, MS = D.ReactCurrentDispatcher, NS = D.ReactCurrentOwner, Vr = D.ReactCurrentBatchConfig, cl = D.ReactCurrentActQueue, pr = (
      /*             */
      0
    ), G0 = (
      /*               */
      1
    ), Pr = (
      /*                */
      2
    ), Ui = (
      /*                */
      4
    ), Vu = 0, Ap = 1, Js = 2, Om = 3, Fp = 4, q0 = 5, zS = 6, Et = pr, ga = null, Dn = null, vr = Y, ql = Y, US = Do(Y), hr = Vu, jp = null, Lm = Y, Hp = Y, Mm = Y, Vp = null, Ha = null, AS = 0, X0 = 500, K0 = 1 / 0, kb = 500, Pu = null;
    function Pp() {
      K0 = Yn() + kb;
    }
    function Z0() {
      return K0;
    }
    var Nm = !1, FS = null, Vf = null, ec = !1, Ho = null, Bp = Y, jS = [], HS = null, Ob = 50, $p = 0, VS = null, PS = !1, zm = !1, Lb = 50, Pf = 0, Um = null, Ip = Xt, Am = Y, J0 = !1;
    function Fm() {
      return ga;
    }
    function Sa() {
      return (Et & (Pr | Ui)) !== pr ? Yn() : (Ip !== Xt || (Ip = Yn()), Ip);
    }
    function Vo(e) {
      var t = e.mode;
      if ((t & lt) === De)
        return Ae;
      if ((Et & Pr) !== pr && vr !== Y)
        return Cs(vr);
      var a = bw() !== xw;
      if (a) {
        if (Vr.transition !== null) {
          var i = Vr.transition;
          i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
        }
        return Am === bt && (Am = Md()), Am;
      }
      var u = za();
      if (u !== bt)
        return u;
      var s = c1();
      return s;
    }
    function Mb(e) {
      var t = e.mode;
      return (t & lt) === De ? Ae : Pv();
    }
    function mr(e, t, a, i) {
      n_(), J0 && S("useInsertionEffect must not schedule updates."), PS && (zm = !0), yo(e, a, i), (Et & Pr) !== Y && e === ga ? i_(t) : (Xr && ws(e, t, a), l_(t), e === ga && ((Et & Pr) === pr && (Hp = Xe(Hp, a)), hr === Fp && Po(e, vr)), Va(e, i), a === Ae && Et === pr && (t.mode & lt) === De && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !cl.isBatchingLegacy && (Pp(), JE()));
    }
    function Nb(e, t, a) {
      var i = e.current;
      i.lanes = t, yo(e, t, a), Va(e, a);
    }
    function zb(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Et & Pr) !== pr
      );
    }
    function Va(e, t) {
      var a = e.callbackNode;
      qc(e, t);
      var i = Gc(e, e === ga ? vr : Y);
      if (i === Y) {
        a !== null && hR(a), e.callbackNode = null, e.callbackPriority = bt;
        return;
      }
      var u = Nl(i), s = e.callbackPriority;
      if (s === u && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(cl.current !== null && a !== GS)) {
        a == null && s !== Ae && S("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && hR(a);
      var f;
      if (u === Ae)
        e.tag === ko ? (cl.isBatchingLegacy !== null && (cl.didScheduleLegacyUpdate = !0), ow(nR.bind(null, e))) : ZE(nR.bind(null, e)), cl.current !== null ? cl.current.push(Oo) : d1(function() {
          (Et & (Pr | Ui)) === pr && Oo();
        }), f = null;
      else {
        var p;
        switch (Gv(i)) {
          case Or:
            p = us;
            break;
          case xi:
            p = kl;
            break;
          case Ma:
            p = Wi;
            break;
          case Na:
            p = vu;
            break;
          default:
            p = Wi;
            break;
        }
        f = qS(p, eR.bind(null, e));
      }
      e.callbackPriority = u, e.callbackNode = f;
    }
    function eR(e, t) {
      if (Zw(), Ip = Xt, Am = Y, (Et & (Pr | Ui)) !== pr)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, i = $u();
      if (i && e.callbackNode !== a)
        return null;
      var u = Gc(e, e === ga ? vr : Y);
      if (u === Y)
        return null;
      var s = !Kc(e, u) && !Vv(e, u) && !t, f = s ? Ib(e, u) : Hm(e, u);
      if (f !== Vu) {
        if (f === Js) {
          var p = Xc(e);
          p !== Y && (u = p, f = BS(e, p));
        }
        if (f === Ap) {
          var v = jp;
          throw tc(e, Y), Po(e, u), Va(e, Yn()), v;
        }
        if (f === zS)
          Po(e, u);
        else {
          var y = !Kc(e, u), g = e.current.alternate;
          if (y && !Ab(g)) {
            if (f = Hm(e, u), f === Js) {
              var b = Xc(e);
              b !== Y && (u = b, f = BS(e, b));
            }
            if (f === Ap) {
              var w = jp;
              throw tc(e, Y), Po(e, u), Va(e, Yn()), w;
            }
          }
          e.finishedWork = g, e.finishedLanes = u, Ub(e, f, u);
        }
      }
      return Va(e, Yn()), e.callbackNode === a ? eR.bind(null, e) : null;
    }
    function BS(e, t) {
      var a = Vp;
      if (ef(e)) {
        var i = tc(e, t);
        i.flags |= Er, tw(e.containerInfo);
      }
      var u = Hm(e, t);
      if (u !== Js) {
        var s = Ha;
        Ha = a, s !== null && tR(s);
      }
      return u;
    }
    function tR(e) {
      Ha === null ? Ha = e : Ha.push.apply(Ha, e);
    }
    function Ub(e, t, a) {
      switch (t) {
        case Vu:
        case Ap:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Js: {
          nc(e, Ha, Pu);
          break;
        }
        case Om: {
          if (Po(e, a), xu(a) && // do not delay if we're inside an act() scope
          !mR()) {
            var i = AS + X0 - Yn();
            if (i > 10) {
              var u = Gc(e, Y);
              if (u !== Y)
                break;
              var s = e.suspendedLanes;
              if (!bu(s, a)) {
                Sa(), Zc(e, s);
                break;
              }
              e.timeoutHandle = Hy(nc.bind(null, e, Ha, Pu), i);
              break;
            }
          }
          nc(e, Ha, Pu);
          break;
        }
        case Fp: {
          if (Po(e, a), Od(a))
            break;
          if (!mR()) {
            var f = ni(e, a), p = f, v = Yn() - p, y = t_(v) - v;
            if (y > 10) {
              e.timeoutHandle = Hy(nc.bind(null, e, Ha, Pu), y);
              break;
            }
          }
          nc(e, Ha, Pu);
          break;
        }
        case q0: {
          nc(e, Ha, Pu);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function Ab(e) {
      for (var t = e; ; ) {
        if (t.flags & fo) {
          var a = t.updateQueue;
          if (a !== null) {
            var i = a.stores;
            if (i !== null)
              for (var u = 0; u < i.length; u++) {
                var s = i[u], f = s.getSnapshot, p = s.value;
                try {
                  if (!G(f(), p))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var v = t.child;
        if (t.subtreeFlags & fo && v !== null) {
          v.return = t, t = v;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function Po(e, t) {
      t = Rs(t, Mm), t = Rs(t, Hp), Iv(e, t);
    }
    function nR(e) {
      if (Jw(), (Et & (Pr | Ui)) !== pr)
        throw new Error("Should not already be working.");
      $u();
      var t = Gc(e, Y);
      if (!Zr(t, Ae))
        return Va(e, Yn()), null;
      var a = Hm(e, t);
      if (e.tag !== ko && a === Js) {
        var i = Xc(e);
        i !== Y && (t = i, a = BS(e, i));
      }
      if (a === Ap) {
        var u = jp;
        throw tc(e, Y), Po(e, t), Va(e, Yn()), u;
      }
      if (a === zS)
        throw new Error("Root did not complete. This is a bug in React.");
      var s = e.current.alternate;
      return e.finishedWork = s, e.finishedLanes = t, nc(e, Ha, Pu), Va(e, Yn()), null;
    }
    function Fb(e, t) {
      t !== Y && (Jc(e, Xe(t, Ae)), Va(e, Yn()), (Et & (Pr | Ui)) === pr && (Pp(), Oo()));
    }
    function $S(e, t) {
      var a = Et;
      Et |= G0;
      try {
        return e(t);
      } finally {
        Et = a, Et === pr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !cl.isBatchingLegacy && (Pp(), JE());
      }
    }
    function jb(e, t, a, i, u) {
      var s = za(), f = Vr.transition;
      try {
        return Vr.transition = null, An(Or), e(t, a, i, u);
      } finally {
        An(s), Vr.transition = f, Et === pr && Pp();
      }
    }
    function Bu(e) {
      Ho !== null && Ho.tag === ko && (Et & (Pr | Ui)) === pr && $u();
      var t = Et;
      Et |= G0;
      var a = Vr.transition, i = za();
      try {
        return Vr.transition = null, An(Or), e ? e() : void 0;
      } finally {
        An(i), Vr.transition = a, Et = t, (Et & (Pr | Ui)) === pr && Oo();
      }
    }
    function rR() {
      return (Et & (Pr | Ui)) !== pr;
    }
    function jm(e, t) {
      ra(US, ql, e), ql = Xe(ql, t);
    }
    function IS(e) {
      ql = US.current, na(US, e);
    }
    function tc(e, t) {
      e.finishedWork = null, e.finishedLanes = Y;
      var a = e.timeoutHandle;
      if (a !== Vy && (e.timeoutHandle = Vy, f1(a)), Dn !== null)
        for (var i = Dn.return; i !== null; ) {
          var u = i.alternate;
          M0(u, i), i = i.return;
        }
      ga = e;
      var s = rc(e.current, null);
      return Dn = s, vr = ql = t, hr = Vu, jp = null, Lm = Y, Hp = Y, Mm = Y, Vp = null, Ha = null, Nw(), nl.discardPendingWarnings(), s;
    }
    function aR(e, t) {
      do {
        var a = Dn;
        try {
          if (Gh(), DC(), on(), NS.current = null, a === null || a.return === null) {
            hr = Ap, jp = t, Dn = null;
            return;
          }
          if (Ue && a.mode & Ot && Tm(a, !0), je)
            if (va(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var i = t;
              wi(a, i, vr);
            } else
              ss(a, t, vr);
          ox(e, a.return, a, t, vr), oR(a);
        } catch (u) {
          t = u, Dn === a && a !== null ? (a = a.return, Dn = a) : a = Dn;
          continue;
        }
        return;
      } while (!0);
    }
    function iR() {
      var e = MS.current;
      return MS.current = gm, e === null ? gm : e;
    }
    function lR(e) {
      MS.current = e;
    }
    function Hb() {
      AS = Yn();
    }
    function Yp(e) {
      Lm = Xe(e, Lm);
    }
    function Vb() {
      hr === Vu && (hr = Om);
    }
    function YS() {
      (hr === Vu || hr === Om || hr === Js) && (hr = Fp), ga !== null && (Es(Lm) || Es(Hp)) && Po(ga, vr);
    }
    function Pb(e) {
      hr !== Fp && (hr = Js), Vp === null ? Vp = [e] : Vp.push(e);
    }
    function Bb() {
      return hr === Vu;
    }
    function Hm(e, t) {
      var a = Et;
      Et |= Pr;
      var i = iR();
      if (ga !== e || vr !== t) {
        if (Xr) {
          var u = e.memoizedUpdaters;
          u.size > 0 && (Qp(e, vr), u.clear()), Yv(e, t);
        }
        Pu = Ad(), tc(e, t);
      }
      gu(t);
      do
        try {
          $b();
          break;
        } catch (s) {
          aR(e, s);
        }
      while (!0);
      if (Gh(), Et = a, lR(i), Dn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Oc(), ga = null, vr = Y, hr;
    }
    function $b() {
      for (; Dn !== null; )
        uR(Dn);
    }
    function Ib(e, t) {
      var a = Et;
      Et |= Pr;
      var i = iR();
      if (ga !== e || vr !== t) {
        if (Xr) {
          var u = e.memoizedUpdaters;
          u.size > 0 && (Qp(e, vr), u.clear()), Yv(e, t);
        }
        Pu = Ad(), Pp(), tc(e, t);
      }
      gu(t);
      do
        try {
          Yb();
          break;
        } catch (s) {
          aR(e, s);
        }
      while (!0);
      return Gh(), lR(i), Et = a, Dn !== null ? (Av(), Vu) : (Oc(), ga = null, vr = Y, hr);
    }
    function Yb() {
      for (; Dn !== null && !hd(); )
        uR(Dn);
    }
    function uR(e) {
      var t = e.alternate;
      It(e);
      var a;
      (e.mode & Ot) !== De ? (Gg(e), a = QS(t, e, ql), Tm(e, !0)) : a = QS(t, e, ql), on(), e.memoizedProps = e.pendingProps, a === null ? oR(e) : Dn = a, NS.current = null;
    }
    function oR(e) {
      var t = e;
      do {
        var a = t.alternate, i = t.return;
        if ((t.flags & ls) === _e) {
          It(t);
          var u = void 0;
          if ((t.mode & Ot) === De ? u = L0(a, t, ql) : (Gg(t), u = L0(a, t, ql), Tm(t, !1)), on(), u !== null) {
            Dn = u;
            return;
          }
        } else {
          var s = Vx(a, t);
          if (s !== null) {
            s.flags &= Ov, Dn = s;
            return;
          }
          if ((t.mode & Ot) !== De) {
            Tm(t, !1);
            for (var f = t.actualDuration, p = t.child; p !== null; )
              f += p.actualDuration, p = p.sibling;
            t.actualDuration = f;
          }
          if (i !== null)
            i.flags |= ls, i.subtreeFlags = _e, i.deletions = null;
          else {
            hr = zS, Dn = null;
            return;
          }
        }
        var v = t.sibling;
        if (v !== null) {
          Dn = v;
          return;
        }
        t = i, Dn = t;
      } while (t !== null);
      hr === Vu && (hr = q0);
    }
    function nc(e, t, a) {
      var i = za(), u = Vr.transition;
      try {
        Vr.transition = null, An(Or), Qb(e, t, a, i);
      } finally {
        Vr.transition = u, An(i);
      }
      return null;
    }
    function Qb(e, t, a, i) {
      do
        $u();
      while (Ho !== null);
      if (r_(), (Et & (Pr | Ui)) !== pr)
        throw new Error("Should not already be working.");
      var u = e.finishedWork, s = e.finishedLanes;
      if (Cd(s), u === null)
        return Rd(), null;
      if (s === Y && S("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = Y, u === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = bt;
      var f = Xe(u.lanes, u.childLanes);
      zd(e, f), e === ga && (ga = null, Dn = null, vr = Y), ((u.subtreeFlags & Qi) !== _e || (u.flags & Qi) !== _e) && (ec || (ec = !0, HS = a, qS(Wi, function() {
        return $u(), null;
      })));
      var p = (u.subtreeFlags & (bl | _l | Dl | Qi)) !== _e, v = (u.flags & (bl | _l | Dl | Qi)) !== _e;
      if (p || v) {
        var y = Vr.transition;
        Vr.transition = null;
        var g = za();
        An(Or);
        var b = Et;
        Et |= Ui, NS.current = null, Yx(e, u), JC(), ib(e, u, s), a1(e.containerInfo), e.current = u, cs(s), lb(u, e, s), fs(), md(), Et = b, An(g), Vr.transition = y;
      } else
        e.current = u, JC();
      var w = ec;
      if (ec ? (ec = !1, Ho = e, Bp = s) : (Pf = 0, Um = null), f = e.pendingLanes, f === Y && (Vf = null), w || dR(e.current, !1), gd(u.stateNode, i), Xr && e.memoizedUpdaters.clear(), xb(), Va(e, Yn()), t !== null)
        for (var z = e.onRecoverableError, F = 0; F < t.length; F++) {
          var V = t[F], le = V.stack, Le = V.digest;
          z(V.value, {
            componentStack: le,
            digest: Le
          });
        }
      if (Nm) {
        Nm = !1;
        var we = FS;
        throw FS = null, we;
      }
      return Zr(Bp, Ae) && e.tag !== ko && $u(), f = e.pendingLanes, Zr(f, Ae) ? (Kw(), e === VS ? $p++ : ($p = 0, VS = e)) : $p = 0, Oo(), Rd(), null;
    }
    function $u() {
      if (Ho !== null) {
        var e = Gv(Bp), t = bs(Ma, e), a = Vr.transition, i = za();
        try {
          return Vr.transition = null, An(t), Gb();
        } finally {
          An(i), Vr.transition = a;
        }
      }
      return !1;
    }
    function Wb(e) {
      jS.push(e), ec || (ec = !0, qS(Wi, function() {
        return $u(), null;
      }));
    }
    function Gb() {
      if (Ho === null)
        return !1;
      var e = HS;
      HS = null;
      var t = Ho, a = Bp;
      if (Ho = null, Bp = Y, (Et & (Pr | Ui)) !== pr)
        throw new Error("Cannot flush passive effects while already rendering.");
      PS = !0, zm = !1, yu(a);
      var i = Et;
      Et |= Ui, pb(t.current), sb(t, t.current, a, e);
      {
        var u = jS;
        jS = [];
        for (var s = 0; s < u.length; s++) {
          var f = u[s];
          qx(t, f);
        }
      }
      xd(), dR(t.current, !0), Et = i, Oo(), zm ? t === Um ? Pf++ : (Pf = 0, Um = t) : Pf = 0, PS = !1, zm = !1, Sd(t);
      {
        var p = t.current.stateNode;
        p.effectDuration = 0, p.passiveEffectDuration = 0;
      }
      return !0;
    }
    function sR(e) {
      return Vf !== null && Vf.has(e);
    }
    function qb(e) {
      Vf === null ? Vf = /* @__PURE__ */ new Set([e]) : Vf.add(e);
    }
    function Xb(e) {
      Nm || (Nm = !0, FS = e);
    }
    var Kb = Xb;
    function cR(e, t, a) {
      var i = Ks(a, t), u = u0(e, i, Ae), s = Mo(e, u, Ae), f = Sa();
      s !== null && (yo(s, Ae, f), Va(s, f));
    }
    function sn(e, t, a) {
      if (Bx(a), Wp(!1), e.tag === ee) {
        cR(e, e, a);
        return;
      }
      var i = null;
      for (i = t; i !== null; ) {
        if (i.tag === ee) {
          cR(i, e, a);
          return;
        } else if (i.tag === ve) {
          var u = i.type, s = i.stateNode;
          if (typeof u.getDerivedStateFromError == "function" || typeof s.componentDidCatch == "function" && !sR(s)) {
            var f = Ks(a, e), p = dS(i, f, Ae), v = Mo(i, p, Ae), y = Sa();
            v !== null && (yo(v, Ae, y), Va(v, y));
            return;
          }
        }
        i = i.return;
      }
      S(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function Zb(e, t, a) {
      var i = e.pingCache;
      i !== null && i.delete(t);
      var u = Sa();
      Zc(e, a), u_(e), ga === e && bu(vr, a) && (hr === Fp || hr === Om && xu(vr) && Yn() - AS < X0 ? tc(e, Y) : Mm = Xe(Mm, a)), Va(e, u);
    }
    function fR(e, t) {
      t === bt && (t = Mb(e));
      var a = Sa(), i = Fa(e, t);
      i !== null && (yo(i, t, a), Va(i, a));
    }
    function Jb(e) {
      var t = e.memoizedState, a = bt;
      t !== null && (a = t.retryLane), fR(e, a);
    }
    function e_(e, t) {
      var a = bt, i;
      switch (e.tag) {
        case be:
          i = e.stateNode;
          var u = e.memoizedState;
          u !== null && (a = u.retryLane);
          break;
        case an:
          i = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      i !== null && i.delete(t), fR(e, a);
    }
    function t_(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : Db(e / 1960) * 1960;
    }
    function n_() {
      if ($p > Ob)
        throw $p = 0, VS = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Pf > Lb && (Pf = 0, Um = null, S("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function r_() {
      nl.flushLegacyContextWarning(), nl.flushPendingUnsafeLifecycleWarnings();
    }
    function dR(e, t) {
      It(e), Vm(e, xl, Rb), t && Vm(e, Ci, Tb), Vm(e, xl, Eb), t && Vm(e, Ci, Cb), on();
    }
    function Vm(e, t, a) {
      for (var i = e, u = null; i !== null; ) {
        var s = i.subtreeFlags & t;
        i !== u && i.child !== null && s !== _e ? i = i.child : ((i.flags & t) !== _e && a(i), i.sibling !== null ? i = i.sibling : i = u = i.return);
      }
    }
    var Pm = null;
    function pR(e) {
      {
        if ((Et & Pr) !== pr || !(e.mode & lt))
          return;
        var t = e.tag;
        if (t !== ut && t !== ee && t !== ve && t !== de && t !== Qe && t !== ot && t !== Fe)
          return;
        var a = Pe(e) || "ReactComponent";
        if (Pm !== null) {
          if (Pm.has(a))
            return;
          Pm.add(a);
        } else
          Pm = /* @__PURE__ */ new Set([a]);
        var i = ar;
        try {
          It(e), S("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          i ? It(e) : on();
        }
      }
    }
    var QS;
    {
      var a_ = null;
      QS = function(e, t, a) {
        var i = CR(a_, t);
        try {
          return b0(e, t, a);
        } catch (s) {
          if (mw() || s !== null && typeof s == "object" && typeof s.then == "function")
            throw s;
          if (Gh(), DC(), M0(e, t), CR(t, i), t.mode & Ot && Gg(t), wl(null, b0, null, e, t, a), Ii()) {
            var u = is();
            typeof u == "object" && u !== null && u._suppressLogging && typeof s == "object" && s !== null && !s._suppressLogging && (s._suppressLogging = !0);
          }
          throw s;
        }
      };
    }
    var vR = !1, WS;
    WS = /* @__PURE__ */ new Set();
    function i_(e) {
      if (vi && !Gw())
        switch (e.tag) {
          case de:
          case Qe:
          case Fe: {
            var t = Dn && Pe(Dn) || "Unknown", a = t;
            if (!WS.has(a)) {
              WS.add(a);
              var i = Pe(e) || "Unknown";
              S("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
            }
            break;
          }
          case ve: {
            vR || (S("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), vR = !0);
            break;
          }
        }
    }
    function Qp(e, t) {
      if (Xr) {
        var a = e.memoizedUpdaters;
        a.forEach(function(i) {
          ws(e, i, t);
        });
      }
    }
    var GS = {};
    function qS(e, t) {
      {
        var a = cl.current;
        return a !== null ? (a.push(t), GS) : vd(e, t);
      }
    }
    function hR(e) {
      if (e !== GS)
        return Mv(e);
    }
    function mR() {
      return cl.current !== null;
    }
    function l_(e) {
      {
        if (e.mode & lt) {
          if (!W0())
            return;
        } else if (!_b() || Et !== pr || e.tag !== de && e.tag !== Qe && e.tag !== Fe)
          return;
        if (cl.current === null) {
          var t = ar;
          try {
            It(e), S(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Pe(e));
          } finally {
            t ? It(e) : on();
          }
        }
      }
    }
    function u_(e) {
      e.tag !== ko && W0() && cl.current === null && S(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Wp(e) {
      J0 = e;
    }
    var Ai = null, Bf = null, o_ = function(e) {
      Ai = e;
    };
    function $f(e) {
      {
        if (Ai === null)
          return e;
        var t = Ai(e);
        return t === void 0 ? e : t.current;
      }
    }
    function XS(e) {
      return $f(e);
    }
    function KS(e) {
      {
        if (Ai === null)
          return e;
        var t = Ai(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = $f(e.render);
            if (e.render !== a) {
              var i = {
                $$typeof: I,
                render: a
              };
              return e.displayName !== void 0 && (i.displayName = e.displayName), i;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function yR(e, t) {
      {
        if (Ai === null)
          return !1;
        var a = e.elementType, i = t.type, u = !1, s = typeof i == "object" && i !== null ? i.$$typeof : null;
        switch (e.tag) {
          case ve: {
            typeof i == "function" && (u = !0);
            break;
          }
          case de: {
            (typeof i == "function" || s === $e) && (u = !0);
            break;
          }
          case Qe: {
            (s === I || s === $e) && (u = !0);
            break;
          }
          case ot:
          case Fe: {
            (s === Ge || s === $e) && (u = !0);
            break;
          }
          default:
            return !1;
        }
        if (u) {
          var f = Ai(a);
          if (f !== void 0 && f === Ai(i))
            return !0;
        }
        return !1;
      }
    }
    function gR(e) {
      {
        if (Ai === null || typeof WeakSet != "function")
          return;
        Bf === null && (Bf = /* @__PURE__ */ new WeakSet()), Bf.add(e);
      }
    }
    var s_ = function(e, t) {
      {
        if (Ai === null)
          return;
        var a = t.staleFamilies, i = t.updatedFamilies;
        $u(), Bu(function() {
          ZS(e.current, i, a);
        });
      }
    }, c_ = function(e, t) {
      {
        if (e.context !== ii)
          return;
        $u(), Bu(function() {
          Gp(t, e, null, null);
        });
      }
    };
    function ZS(e, t, a) {
      {
        var i = e.alternate, u = e.child, s = e.sibling, f = e.tag, p = e.type, v = null;
        switch (f) {
          case de:
          case Fe:
          case ve:
            v = p;
            break;
          case Qe:
            v = p.render;
            break;
        }
        if (Ai === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var y = !1, g = !1;
        if (v !== null) {
          var b = Ai(v);
          b !== void 0 && (a.has(b) ? g = !0 : t.has(b) && (f === ve ? g = !0 : y = !0));
        }
        if (Bf !== null && (Bf.has(e) || i !== null && Bf.has(i)) && (g = !0), g && (e._debugNeedsRemount = !0), g || y) {
          var w = Fa(e, Ae);
          w !== null && mr(w, e, Ae, Xt);
        }
        u !== null && !g && ZS(u, t, a), s !== null && ZS(s, t, a);
      }
    }
    var f_ = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), i = new Set(t.map(function(u) {
          return u.current;
        }));
        return JS(e.current, i, a), a;
      }
    };
    function JS(e, t, a) {
      {
        var i = e.child, u = e.sibling, s = e.tag, f = e.type, p = null;
        switch (s) {
          case de:
          case Fe:
          case ve:
            p = f;
            break;
          case Qe:
            p = f.render;
            break;
        }
        var v = !1;
        p !== null && t.has(p) && (v = !0), v ? d_(e, a) : i !== null && JS(i, t, a), u !== null && JS(u, t, a);
      }
    }
    function d_(e, t) {
      {
        var a = p_(e, t);
        if (a)
          return;
        for (var i = e; ; ) {
          switch (i.tag) {
            case ue:
              t.add(i.stateNode);
              return;
            case Ce:
              t.add(i.stateNode.containerInfo);
              return;
            case ee:
              t.add(i.stateNode.containerInfo);
              return;
          }
          if (i.return === null)
            throw new Error("Expected to reach root first.");
          i = i.return;
        }
      }
    }
    function p_(e, t) {
      for (var a = e, i = !1; ; ) {
        if (a.tag === ue)
          i = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return i;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return i;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var eE;
    {
      eE = !1;
      try {
        var SR = Object.preventExtensions({});
      } catch {
        eE = !0;
      }
    }
    function v_(e, t, a, i) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = _e, this.subtreeFlags = _e, this.deletions = null, this.lanes = Y, this.childLanes = Y, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !eE && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var li = function(e, t, a, i) {
      return new v_(e, t, a, i);
    };
    function tE(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function h_(e) {
      return typeof e == "function" && !tE(e) && e.defaultProps === void 0;
    }
    function m_(e) {
      if (typeof e == "function")
        return tE(e) ? ve : de;
      if (e != null) {
        var t = e.$$typeof;
        if (t === I)
          return Qe;
        if (t === Ge)
          return ot;
      }
      return ut;
    }
    function rc(e, t) {
      var a = e.alternate;
      a === null ? (a = li(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = _e, a.subtreeFlags = _e, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & Nn, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var i = e.dependencies;
      switch (a.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case ut:
        case de:
        case Fe:
          a.type = $f(e.type);
          break;
        case ve:
          a.type = XS(e.type);
          break;
        case Qe:
          a.type = KS(e.type);
          break;
      }
      return a;
    }
    function y_(e, t) {
      e.flags &= Nn | hn;
      var a = e.alternate;
      if (a === null)
        e.childLanes = Y, e.lanes = t, e.child = null, e.subtreeFlags = _e, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = _e, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var i = a.dependencies;
        e.dependencies = i === null ? null : {
          lanes: i.lanes,
          firstContext: i.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function g_(e, t, a) {
      var i;
      return e === jh ? (i = lt, t === !0 && (i |= Wt, i |= Lt)) : i = De, Xr && (i |= Ot), li(ee, null, null, i);
    }
    function nE(e, t, a, i, u, s) {
      var f = ut, p = e;
      if (typeof e == "function")
        tE(e) ? (f = ve, p = XS(p)) : p = $f(p);
      else if (typeof e == "string")
        f = ue;
      else
        e: switch (e) {
          case ci:
            return Bo(a.children, u, s, t);
          case Ya:
            f = dt, u |= Wt, (u & lt) !== De && (u |= Lt);
            break;
          case fi:
            return S_(a, u, s, t);
          case ae:
            return E_(a, u, s, t);
          case he:
            return C_(a, u, s, t);
          case Rn:
            return ER(a, u, s, t);
          case en:
          // eslint-disable-next-line no-fallthrough
          case st:
          // eslint-disable-next-line no-fallthrough
          case un:
          // eslint-disable-next-line no-fallthrough
          case rr:
          // eslint-disable-next-line no-fallthrough
          case it:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case di:
                  f = ft;
                  break e;
                case R:
                  f = cn;
                  break e;
                case I:
                  f = Qe, p = KS(p);
                  break e;
                case Ge:
                  f = ot;
                  break e;
                case $e:
                  f = rn, p = null;
                  break e;
              }
            var v = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var y = i ? Pe(i) : null;
              y && (v += `

Check the render method of \`` + y + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + v));
          }
        }
      var g = li(f, a, t, u);
      return g.elementType = e, g.type = p, g.lanes = s, g._debugOwner = i, g;
    }
    function rE(e, t, a) {
      var i = null;
      i = e._owner;
      var u = e.type, s = e.key, f = e.props, p = nE(u, s, f, i, t, a);
      return p._debugSource = e._source, p._debugOwner = e._owner, p;
    }
    function Bo(e, t, a, i) {
      var u = li(yt, e, i, t);
      return u.lanes = a, u;
    }
    function S_(e, t, a, i) {
      typeof e.id != "string" && S('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var u = li(pt, e, i, t | Ot);
      return u.elementType = fi, u.lanes = a, u.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, u;
    }
    function E_(e, t, a, i) {
      var u = li(be, e, i, t);
      return u.elementType = ae, u.lanes = a, u;
    }
    function C_(e, t, a, i) {
      var u = li(an, e, i, t);
      return u.elementType = he, u.lanes = a, u;
    }
    function ER(e, t, a, i) {
      var u = li(ke, e, i, t);
      u.elementType = Rn, u.lanes = a;
      var s = {
        isHidden: !1
      };
      return u.stateNode = s, u;
    }
    function aE(e, t, a) {
      var i = li(Ye, e, null, t);
      return i.lanes = a, i;
    }
    function R_() {
      var e = li(ue, null, null, De);
      return e.elementType = "DELETED", e;
    }
    function T_(e) {
      var t = li(Kt, null, null, De);
      return t.stateNode = e, t;
    }
    function iE(e, t, a) {
      var i = e.children !== null ? e.children : [], u = li(Ce, i, e.key, t);
      return u.lanes = a, u.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, u;
    }
    function CR(e, t) {
      return e === null && (e = li(ut, null, null, De)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function w_(e, t, a, i, u) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Vy, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = bt, this.eventTimes = Ts(Y), this.expirationTimes = Ts(Xt), this.pendingLanes = Y, this.suspendedLanes = Y, this.pingedLanes = Y, this.expiredLanes = Y, this.mutableReadLanes = Y, this.finishedLanes = Y, this.entangledLanes = Y, this.entanglements = Ts(Y), this.identifierPrefix = i, this.onRecoverableError = u, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var s = this.pendingUpdatersLaneMap = [], f = 0; f < Su; f++)
          s.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case jh:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case ko:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function RR(e, t, a, i, u, s, f, p, v, y) {
      var g = new w_(e, t, a, p, v), b = g_(t, s);
      g.current = b, b.stateNode = g;
      {
        var w = {
          element: i,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        b.memoizedState = w;
      }
      return gg(b), g;
    }
    var lE = "18.3.1";
    function x_(e, t, a) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return $r(i), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: nr,
        key: i == null ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var uE, oE;
    uE = !1, oE = {};
    function TR(e) {
      if (!e)
        return ii;
      var t = co(e), a = uw(t);
      if (t.tag === ve) {
        var i = t.type;
        if (Bl(i))
          return XE(t, i, a);
      }
      return a;
    }
    function b_(e, t) {
      {
        var a = co(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var i = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
        }
        var u = Gr(a);
        if (u === null)
          return null;
        if (u.mode & Wt) {
          var s = Pe(a) || "Component";
          if (!oE[s]) {
            oE[s] = !0;
            var f = ar;
            try {
              It(u), a.mode & Wt ? S("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, s) : S("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, s);
            } finally {
              f ? It(f) : on();
            }
          }
        }
        return u.stateNode;
      }
    }
    function wR(e, t, a, i, u, s, f, p) {
      var v = !1, y = null;
      return RR(e, t, v, y, a, i, u, s, f);
    }
    function xR(e, t, a, i, u, s, f, p, v, y) {
      var g = !0, b = RR(a, i, g, e, u, s, f, p, v);
      b.context = TR(null);
      var w = b.current, z = Sa(), F = Vo(w), V = ju(z, F);
      return V.callback = t ?? null, Mo(w, V, F), Nb(b, F, z), b;
    }
    function Gp(e, t, a, i) {
      yd(t, e);
      var u = t.current, s = Sa(), f = Vo(u);
      yn(f);
      var p = TR(a);
      t.context === null ? t.context = p : t.pendingContext = p, vi && ar !== null && !uE && (uE = !0, S(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Pe(ar) || "Unknown"));
      var v = ju(s, f);
      v.payload = {
        element: e
      }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && S("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), v.callback = i);
      var y = Mo(u, v, f);
      return y !== null && (mr(y, u, f, s), Jh(y, u, f)), f;
    }
    function Bm(e) {
      var t = e.current;
      return t.child ? t.child.tag === ue ? t.child.stateNode : t.child.stateNode : null;
    }
    function __(e) {
      switch (e.tag) {
        case ee: {
          var t = e.stateNode;
          if (ef(t)) {
            var a = jv(t);
            Fb(t, a);
          }
          break;
        }
        case be: {
          Bu(function() {
            var u = Fa(e, Ae);
            if (u !== null) {
              var s = Sa();
              mr(u, e, Ae, s);
            }
          });
          var i = Ae;
          sE(e, i);
          break;
        }
      }
    }
    function bR(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = $v(a.retryLane, t));
    }
    function sE(e, t) {
      bR(e, t);
      var a = e.alternate;
      a && bR(a, t);
    }
    function D_(e) {
      if (e.tag === be) {
        var t = ys, a = Fa(e, t);
        if (a !== null) {
          var i = Sa();
          mr(a, e, t, i);
        }
        sE(e, t);
      }
    }
    function k_(e) {
      if (e.tag === be) {
        var t = Vo(e), a = Fa(e, t);
        if (a !== null) {
          var i = Sa();
          mr(a, e, t, i);
        }
        sE(e, t);
      }
    }
    function _R(e) {
      var t = fn(e);
      return t === null ? null : t.stateNode;
    }
    var DR = function(e) {
      return null;
    };
    function O_(e) {
      return DR(e);
    }
    var kR = function(e) {
      return !1;
    };
    function L_(e) {
      return kR(e);
    }
    var OR = null, LR = null, MR = null, NR = null, zR = null, UR = null, AR = null, FR = null, jR = null;
    {
      var HR = function(e, t, a) {
        var i = t[a], u = nt(e) ? e.slice() : Ze({}, e);
        return a + 1 === t.length ? (nt(u) ? u.splice(i, 1) : delete u[i], u) : (u[i] = HR(e[i], t, a + 1), u);
      }, VR = function(e, t) {
        return HR(e, t, 0);
      }, PR = function(e, t, a, i) {
        var u = t[i], s = nt(e) ? e.slice() : Ze({}, e);
        if (i + 1 === t.length) {
          var f = a[i];
          s[f] = s[u], nt(s) ? s.splice(u, 1) : delete s[u];
        } else
          s[u] = PR(
            // $FlowFixMe number or string is fine here
            e[u],
            t,
            a,
            i + 1
          );
        return s;
      }, BR = function(e, t, a) {
        if (t.length !== a.length) {
          _t("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var i = 0; i < a.length - 1; i++)
            if (t[i] !== a[i]) {
              _t("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return PR(e, t, a, 0);
      }, $R = function(e, t, a, i) {
        if (a >= t.length)
          return i;
        var u = t[a], s = nt(e) ? e.slice() : Ze({}, e);
        return s[u] = $R(e[u], t, a + 1, i), s;
      }, IR = function(e, t, a) {
        return $R(e, t, 0, a);
      }, cE = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      OR = function(e, t, a, i) {
        var u = cE(e, t);
        if (u !== null) {
          var s = IR(u.memoizedState, a, i);
          u.memoizedState = s, u.baseState = s, e.memoizedProps = Ze({}, e.memoizedProps);
          var f = Fa(e, Ae);
          f !== null && mr(f, e, Ae, Xt);
        }
      }, LR = function(e, t, a) {
        var i = cE(e, t);
        if (i !== null) {
          var u = VR(i.memoizedState, a);
          i.memoizedState = u, i.baseState = u, e.memoizedProps = Ze({}, e.memoizedProps);
          var s = Fa(e, Ae);
          s !== null && mr(s, e, Ae, Xt);
        }
      }, MR = function(e, t, a, i) {
        var u = cE(e, t);
        if (u !== null) {
          var s = BR(u.memoizedState, a, i);
          u.memoizedState = s, u.baseState = s, e.memoizedProps = Ze({}, e.memoizedProps);
          var f = Fa(e, Ae);
          f !== null && mr(f, e, Ae, Xt);
        }
      }, NR = function(e, t, a) {
        e.pendingProps = IR(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Fa(e, Ae);
        i !== null && mr(i, e, Ae, Xt);
      }, zR = function(e, t) {
        e.pendingProps = VR(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = Fa(e, Ae);
        a !== null && mr(a, e, Ae, Xt);
      }, UR = function(e, t, a) {
        e.pendingProps = BR(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = Fa(e, Ae);
        i !== null && mr(i, e, Ae, Xt);
      }, AR = function(e) {
        var t = Fa(e, Ae);
        t !== null && mr(t, e, Ae, Xt);
      }, FR = function(e) {
        DR = e;
      }, jR = function(e) {
        kR = e;
      };
    }
    function M_(e) {
      var t = Gr(e);
      return t === null ? null : t.stateNode;
    }
    function N_(e) {
      return null;
    }
    function z_() {
      return ar;
    }
    function U_(e) {
      var t = e.findFiberByHostInstance, a = D.ReactCurrentDispatcher;
      return vo({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: OR,
        overrideHookStateDeletePath: LR,
        overrideHookStateRenamePath: MR,
        overrideProps: NR,
        overridePropsDeletePath: zR,
        overridePropsRenamePath: UR,
        setErrorHandler: FR,
        setSuspenseHandler: jR,
        scheduleUpdate: AR,
        currentDispatcherRef: a,
        findHostInstanceByFiber: M_,
        findFiberByHostInstance: t || N_,
        // React Refresh
        findHostInstancesForRefresh: f_,
        scheduleRefresh: s_,
        scheduleRoot: c_,
        setRefreshHandler: o_,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: z_,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: lE
      });
    }
    var YR = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function fE(e) {
      this._internalRoot = e;
    }
    $m.prototype.render = fE.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? S("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Im(arguments[1]) ? S("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && S("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== Ln) {
          var i = _R(t.current);
          i && i.parentNode !== a && S("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Gp(e, t, null, null);
    }, $m.prototype.unmount = fE.prototype.unmount = function() {
      typeof arguments[0] == "function" && S("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        rR() && S("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Bu(function() {
          Gp(null, e, null, null);
        }), YE(t);
      }
    };
    function A_(e, t) {
      if (!Im(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      QR(e);
      var a = !1, i = !1, u = "", s = YR;
      t != null && (t.hydrate ? _t("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === br && S(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (u = t.identifierPrefix), t.onRecoverableError !== void 0 && (s = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var f = wR(e, jh, null, a, i, u, s);
      Lh(f.current, e);
      var p = e.nodeType === Ln ? e.parentNode : e;
      return ep(p), new fE(f);
    }
    function $m(e) {
      this._internalRoot = e;
    }
    function F_(e) {
      e && Jv(e);
    }
    $m.prototype.unstable_scheduleHydration = F_;
    function j_(e, t, a) {
      if (!Im(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      QR(e), t === void 0 && S("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var i = a ?? null, u = a != null && a.hydratedSources || null, s = !1, f = !1, p = "", v = YR;
      a != null && (a.unstable_strictMode === !0 && (s = !0), a.identifierPrefix !== void 0 && (p = a.identifierPrefix), a.onRecoverableError !== void 0 && (v = a.onRecoverableError));
      var y = xR(t, null, e, jh, i, s, f, p, v);
      if (Lh(y.current, e), ep(e), u)
        for (var g = 0; g < u.length; g++) {
          var b = u[g];
          Bw(y, b);
        }
      return new $m(y);
    }
    function Im(e) {
      return !!(e && (e.nodeType === Yr || e.nodeType === $i || e.nodeType === nd));
    }
    function qp(e) {
      return !!(e && (e.nodeType === Yr || e.nodeType === $i || e.nodeType === nd || e.nodeType === Ln && e.nodeValue === " react-mount-point-unstable "));
    }
    function QR(e) {
      e.nodeType === Yr && e.tagName && e.tagName.toUpperCase() === "BODY" && S("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), fp(e) && (e._reactRootContainer ? S("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : S("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var H_ = D.ReactCurrentOwner, WR;
    WR = function(e) {
      if (e._reactRootContainer && e.nodeType !== Ln) {
        var t = _R(e._reactRootContainer.current);
        t && t.parentNode !== e && S("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, i = dE(e), u = !!(i && _o(i));
      u && !a && S("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Yr && e.tagName && e.tagName.toUpperCase() === "BODY" && S("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function dE(e) {
      return e ? e.nodeType === $i ? e.documentElement : e.firstChild : null;
    }
    function GR() {
    }
    function V_(e, t, a, i, u) {
      if (u) {
        if (typeof i == "function") {
          var s = i;
          i = function() {
            var w = Bm(f);
            s.call(w);
          };
        }
        var f = xR(
          t,
          i,
          e,
          ko,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          GR
        );
        e._reactRootContainer = f, Lh(f.current, e);
        var p = e.nodeType === Ln ? e.parentNode : e;
        return ep(p), Bu(), f;
      } else {
        for (var v; v = e.lastChild; )
          e.removeChild(v);
        if (typeof i == "function") {
          var y = i;
          i = function() {
            var w = Bm(g);
            y.call(w);
          };
        }
        var g = wR(
          e,
          ko,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          GR
        );
        e._reactRootContainer = g, Lh(g.current, e);
        var b = e.nodeType === Ln ? e.parentNode : e;
        return ep(b), Bu(function() {
          Gp(t, g, a, i);
        }), g;
      }
    }
    function P_(e, t) {
      e !== null && typeof e != "function" && S("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function Ym(e, t, a, i, u) {
      WR(a), P_(u === void 0 ? null : u, "render");
      var s = a._reactRootContainer, f;
      if (!s)
        f = V_(a, t, e, u, i);
      else {
        if (f = s, typeof u == "function") {
          var p = u;
          u = function() {
            var v = Bm(f);
            p.call(v);
          };
        }
        Gp(t, f, e, u);
      }
      return Bm(f);
    }
    var qR = !1;
    function B_(e) {
      {
        qR || (qR = !0, S("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = H_.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || S("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Rt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Yr ? e : b_(e, "findDOMNode");
    }
    function $_(e, t, a) {
      if (S("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !qp(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = fp(t) && t._reactRootContainer === void 0;
        i && S("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Ym(null, e, t, !0, a);
    }
    function I_(e, t, a) {
      if (S("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !qp(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = fp(t) && t._reactRootContainer === void 0;
        i && S("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Ym(null, e, t, !1, a);
    }
    function Y_(e, t, a, i) {
      if (S("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !qp(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !sy(e))
        throw new Error("parentComponent must be a valid React Component");
      return Ym(e, t, a, !1, i);
    }
    var XR = !1;
    function Q_(e) {
      if (XR || (XR = !0, S("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !qp(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = fp(e) && e._reactRootContainer === void 0;
        t && S("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = dE(e), i = a && !_o(a);
          i && S("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Bu(function() {
          Ym(null, null, e, !1, function() {
            e._reactRootContainer = null, YE(e);
          });
        }), !0;
      } else {
        {
          var u = dE(e), s = !!(u && _o(u)), f = e.nodeType === Yr && qp(e.parentNode) && !!e.parentNode._reactRootContainer;
          s && S("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", f ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Rr(__), go(D_), qv(k_), Ds(za), Fd(Qv), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && S("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), yc(GT), oy($S, jb, Bu);
    function W_(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Im(t))
        throw new Error("Target container is not a DOM element.");
      return x_(e, t, null, a);
    }
    function G_(e, t, a, i) {
      return Y_(e, t, a, i);
    }
    var pE = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [_o, Ef, Mh, lo, gc, $S]
    };
    function q_(e, t) {
      return pE.usingClientEntryPoint || S('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), A_(e, t);
    }
    function X_(e, t, a) {
      return pE.usingClientEntryPoint || S('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), j_(e, t, a);
    }
    function K_(e) {
      return rR() && S("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Bu(e);
    }
    var Z_ = U_({
      findFiberByHostInstance: Bs,
      bundleType: 1,
      version: lE,
      rendererPackageName: "react-dom"
    });
    if (!Z_ && kn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var KR = window.location.protocol;
      /^(https?|file):$/.test(KR) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (KR === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pE, Ba.createPortal = W_, Ba.createRoot = q_, Ba.findDOMNode = B_, Ba.flushSync = K_, Ba.hydrate = $_, Ba.hydrateRoot = X_, Ba.render = I_, Ba.unmountComponentAtNode = Q_, Ba.unstable_batchedUpdates = $S, Ba.unstable_renderSubtreeIntoContainer = G_, Ba.version = lE, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })()), Ba;
}
var cT;
function dD() {
  if (cT) return Gm.exports;
  cT = 1;
  function M() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(M);
      } catch (j) {
        console.error(j);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (M(), Gm.exports = cD()) : Gm.exports = fD(), Gm.exports;
}
var fT;
function pD() {
  if (fT) return Yf;
  fT = 1;
  var M = dD();
  if (process.env.NODE_ENV === "production")
    Yf.createRoot = M.createRoot, Yf.hydrateRoot = M.hydrateRoot;
  else {
    var j = M.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    Yf.createRoot = function(D, Be) {
      j.usingClientEntryPoint = !0;
      try {
        return M.createRoot(D, Be);
      } finally {
        j.usingClientEntryPoint = !1;
      }
    }, Yf.hydrateRoot = function(D, Be, ht) {
      j.usingClientEntryPoint = !0;
      try {
        return M.hydrateRoot(D, Be, ht);
      } finally {
        j.usingClientEntryPoint = !1;
      }
    };
  }
  return Yf;
}
var vD = pD();
class hD {
  _context = void 0;
  _getContextCallbacks = [];
  async getContext() {
    return this._context ? this._context : new Promise((j) => {
      this._getContextCallbacks.push(j);
    });
  }
  setContext(j) {
    this._context = j, this._getContextCallbacks.forEach((D) => D(j)), this._getContextCallbacks = [];
  }
  configureClient(j) {
    console.log("Client configured");
  }
  themeLoaded() {
    console.log("Theme loaded");
  }
  close() {
    console.log("Theme closed");
  }
  addToEcommerceCart(j) {
    console.log("Add to cart", j);
  }
  completeQuote() {
    console.log("Complete quote");
  }
  navigateToCustomerPortal() {
    console.log("Navigating to customer portal");
  }
}
let Km;
const mD = ({ context: M }) => {
  const [j, D] = aT.useState(null);
  return aT.useEffect(() => {
    if (j) {
      if (Km === void 0)
        throw new Error("Please call setSpiffDevOptions before requesting the context.");
      Km.setContext({
        ...M,
        container: j
      });
    }
  }, [j, M]), /* @__PURE__ */ pT.jsx("div", { ref: D, id: "spiffThemeWrapper", className: "spiffThemeWrapper_DEV" });
};
function bD(M, j) {
  Km = new hD(), window.SpiffThemeLoader = Km;
  let D;
  typeof M == "string" ? D = document.getElementById(M) : D = M, vD.createRoot(D).render(/* @__PURE__ */ pT.jsx(mD, { context: j }));
}
function _D(M) {
  return {
    id: "example",
    themeInstallId: M?.themeInstallId ?? "example",
    name: "Example Configuration",
    createdAt: "2021-01-01T00:00:00Z",
    updatedAt: "2021-01-01T00:00:00Z",
    themeVersion: {
      id: "example",
      version: "1.0.0",
      createdAt: "2021-01-01T00:00:00Z",
      updatedAt: "2021-01-01T00:00:00Z",
      configurationSchema: {
        fields: []
      },
      launchData: {
        targetFiles: []
      },
      theme: {
        id: "example",
        name: "Example Theme",
        createdAt: "2021-01-01T00:00:00Z",
        updatedAt: "2021-01-01T00:00:00Z"
      }
    },
    fields: [],
    ...M
  };
}
const yD = (M) => {
  if (Object.keys(M).includes("defaultValue"))
    return M.defaultValue;
};
function DD(M, ...j) {
  return M.fields.filter((D) => !D.key || !j.includes(D.key)).map((D) => ({
    key: D.key,
    fallbackToDefaultConfiguration: !1,
    value: yD(D),
    type: D.type,
    asset: void 0
  }));
}
export {
  LD as AssetType,
  UD as ConversionDataType,
  tD as ConversionLocation,
  MD as CustomSchemaType,
  ac as FieldType,
  ND as ThemeFileType,
  _D as exampleThemeInstallConfig,
  DD as getDefaultsForSchema,
  bD as setSpiffDevOptions,
  RD as themeInstallConfigurationFieldsToRecordObject,
  xD as themeInstallConfigurationGraphQlToResource,
  TD as themeInstallConfigurationToRecordObject,
  nD as themeVersionConfigurationGraphQlToResource,
  wD as themeVersionGraphQlToResource
};
//# sourceMappingURL=index.js.map
